import { Article } from "./types";

export const allArticles: Article[] = [

  {
    "id": "disrupted-manager-decision-atrophy",
    "title": "AI时代的管理者判断力危机：越依赖AI，越不会做决策",
    "summary": "•AI帮管理者做了大量决策，但他们自己的判断力正在加速退化\n•三类正在消失的判断练习：模糊决策、风险直觉、例外处理\n•核心悖论：AI越准→管理者判断机会越少→判断力越差→越依赖AI\n•三个破法：刻意不看AI结论先自己判断、刻意保留人工必审环节、刻意复盘AI误判\n•管理者唯一不可替代的资产是独立判断力——别让它腐化了",
    "content_type": "html",
    "content": "articles/disrupted/manager-decision-atrophy.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-manager-decision-atrophy",
    "created_at": "2026-06-28",
    "updated_at": null
  },
  {
    "id": "disrupted-org-redundancy-ai-fragility",
    "title": "「组织冗余」被AI优化掉的东西，正在让组织变脆",
    "summary": "•AI把组织优化到极致高效，但极致高效的组织也极致脆弱\n•组织冗余不是浪费，是系统韧性的基础\n•三种被AI系统性抽走的冗余：人员、时间、信息\n•给管理者的建议：在所有AI优化方案中强制预留10%-15%的弹性空间\n•真正的韧性不是把一件事做到100%，而是给自己留备选路径",
    "content_type": "html",
    "content": "articles/disrupted/org-redundancy-ai-fragility.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-org-redundancy-ai-fragility",
    "created_at": "2026-06-26",
    "updated_at": null
  },
  {
    "id": "disrupted-组织中的权力结构本质上不会被AI改变",
    "title": "组织中的权力结构，本质上不会被AI改变",
    "summary": "•谁承担风险，谁掌握权力。 AI不背锅，所以最终决策权永远在人手里。无论工具多先进，签字的那个人，才是真正掌权的人。",
    "content_type": "html",
    "content": "articles/组织中的权力结构本质上不会被AI改变.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-组织中的权力结构本质上不会被AI改变",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师实战案例集-从理论到落地的10个真实故事",
    "title": "AI培训师实战案例集：从理论到落地的10个真实故事",
    "summary": "作者：老邓和艾游 AI培训师实战案例集：从理论到落地的10个真实故事 署名：老邓游戏化 | 网站：0-1.team --- 前言 前面9篇文章，我们聊了A...",
    "content_type": "html",
    "content": "articles/AI培训师实战案例集-从理论到落地的10个真实故事.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师实战案例集-从理论到落地的10个真实故事",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI驱动的绩效预测-当算法能预判离职-管理者该怎么办",
    "title": "AI驱动的绩效预测：当算法能预判离职，管理者该怎么办",
    "summary": "•离职预测：顶级模型的AUC（准确率指标）在0.75-0.85之间，意味着还有15-25%的误判",
    "content_type": "html",
    "content": "articles/AI驱动的绩效预测-当算法能预判离职-管理者该怎么办.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI驱动的绩效预测-当算法能预判离职-管理者该怎么办",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-边缘人类的价值-被AI时代遗忘的金矿",
    "title": "边缘人类的价值：被AI时代遗忘的金矿",
    "summary": "边缘人类的价值：被AI时代遗忘的金矿",
    "content_type": "html",
    "content": "articles/边缘人类的价值-被AI时代遗忘的金矿.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-边缘人类的价值-被AI时代遗忘的金矿",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代的领导力-从-指挥官-到-意义建构者",
    "title": "AI时代的领导力：从\"指挥官\"到\"意义建构者\"",
    "summary": "AI时代的领导力：从\"指挥官\"到\"意义建构者\"",
    "content_type": "html",
    "content": "articles/AI时代的领导力-从-指挥官-到-意义建构者.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代的领导力-从-指挥官-到-意义建构者",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI场景落地师-把AI装进真实业务里",
    "title": "AI场景落地师：把AI装进真实业务里",
    "summary": "•分类：created（新增类） | 标签：场景落地、AI实施、新职业",
    "content_type": "html",
    "content": "articles/AI场景落地师-把AI装进真实业务里.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI场景落地师-把AI装进真实业务里",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师如何应对技术快速迭代-在变化中寻找不变",
    "title": "AI培训师如何应对技术快速迭代：在变化中寻找不变",
    "summary": "作者：老邓和艾游 AI培训师如何应对技术快速迭代：在变化中寻找不变 署名：老邓游戏化 | 网站：0-1.team --- 一、一个焦虑的AI培训师 小李，...",
    "content_type": "html",
    "content": "articles/AI培训师如何应对技术快速迭代-在变化中寻找不变.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师如何应对技术快速迭代-在变化中寻找不变",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-预测模型的更新与漂移",
    "title": "预测模型的更新与漂移",
    "summary": "1.这周找数据团队要一份PSI报告，看看你的核心模型有没有漂移信号。如果没有这份报告，这就是第一个危险信号。",
    "content_type": "html",
    "content": "articles/预测模型的更新与漂移.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-预测模型的更新与漂移",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-销售团队的激励设计-AI预测加游戏化机制-怎么做才不会越激越",
    "title": "销售团队的激励设计：AI预测加游戏化机制，怎么做才不会越激越乱",
    "summary": "•团队开始抢线索、藏信息，跨区配合迅速恶化",
    "content_type": "html",
    "content": "articles/销售团队的激励设计-AI预测加游戏化机制-怎么做才不会越激越.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-销售团队的激励设计-AI预测加游戏化机制-怎么做才不会越激越",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-communication-efficiency-algorithm-organization",
    "title": "沟通这件事：算法组织如何终结信息内耗",
    "summary": "•任务自动分配，责任人和时限直接进入项目管理系统",
    "content_type": "html",
    "content": "articles/communication-efficiency-algorithm-organization.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-communication-efficiency-algorithm-organization",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-那个叫小AI的导师",
    "title": "那个叫\"小AI\"的导师",
    "summary": "陈璐第一天入职的时候，HR把她领到工位上，指着电脑屏幕说：\"你先注册一下公司的AI助手，有问题可以问它。\"",
    "content_type": "html",
    "content": "articles/那个叫小AI的导师.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-那个叫小AI的导师",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-激励系统更新机制",
    "title": "激励系统更新机制",
    "summary": "•员工积分系统日活从上线时的72%跌到11%",
    "content_type": "html",
    "content": "articles/激励系统更新机制.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-激励系统更新机制",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-游戏化激励系统-从PBL到SDT的完整框架",
    "title": "游戏化激励系统：从PBL到SDT的完整框架",
    "summary": "•引入\"成长值\"——不只看绝对业绩，还看进步幅度。新人进步快，也能上榜。",
    "content_type": "html",
    "content": "articles/游戏化激励系统-从PBL到SDT的完整框架.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-游戏化激励系统-从PBL到SDT的完整框架",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-预测准确性的悖论",
    "title": "AI时代组织效率研究：预测准确性的悖论",
    "summary": "•AI层：发现了模型对\"客户情绪信号\"的忽视，重新训练了多模态预测模型",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-预测准确性的悖论.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-预测准确性的悖论",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-当AI做决策时-如何避免系统性歧视",
    "title": "当AI做决策时：如何避免系统性歧视",
    "summary": "作者：老邓和艾游 当AI做决策时：如何避免系统性歧视 算法偏见与组织公平 --- 楔子：一个HR总监的困惑 张明是一家大型制造企业的人力资源总监。最近他们...",
    "content_type": "html",
    "content": "articles/当AI做决策时-如何避免系统性歧视.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-当AI做决策时-如何避免系统性歧视",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-压力管理与AI预警-当算法发现你快要崩溃了",
    "title": "压力管理与AI预警：当算法发现你快要崩溃了",
    "summary": "•工作时间的异常分布（深夜/周末工作频率）",
    "content_type": "html",
    "content": "articles/压力管理与AI预警-当算法发现你快要崩溃了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-压力管理与AI预警-当算法发现你快要崩溃了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-绩效评价的公平困境-AI与人类判断的边界在哪里",
    "title": "绩效评价的公平困境：AI与人类判断的边界在哪里",
    "summary": "作者：老邓和艾游 绩效评价的公平困境：AI与人类判断的边界在哪里 评价系统的公平性 --- 楔子：两份绩效报告的困惑 刘芳是某科技公司的产品经理，她的两位...",
    "content_type": "html",
    "content": "articles/绩效评价的公平困境-AI与人类判断的边界在哪里.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-绩效评价的公平困境-AI与人类判断的边界在哪里",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI训练师这个新角色-谁来教AI理解组织",
    "title": "AI训练师这个新角色：谁来教AI理解组织",
    "summary": "•这个AI系统的使用边界在哪里？哪些决策可以让AI参与，哪些必须由人来做？",
    "content_type": "html",
    "content": "articles/AI训练师这个新角色-谁来教AI理解组织.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI训练师这个新角色-谁来教AI理解组织",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026年-一个MBA学员的深夜困惑",
    "title": "2026年，一个MBA学员的深夜困惑",
    "summary": "2026年，一个MBA学员的深夜困惑",
    "content_type": "html",
    "content": "articles/2026年-一个MBA学员的深夜困惑.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026年-一个MBA学员的深夜困惑",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师如何设计互动课程-让学员从-坐着听-变成-动手做",
    "title": "AI培训师如何设计互动课程：让学员从\"坐着听\"变成\"动手做\"",
    "summary": "作者：老邓和艾游 AI培训师如何设计互动课程：让学员从\"坐着听\"变成\"动手做\" 署名：老邓游戏化 | 网站：0-1.team --- 一、一个触目惊心的数...",
    "content_type": "html",
    "content": "articles/AI培训师如何设计互动课程-让学员从-坐着听-变成-动手做.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师如何设计互动课程-让学员从-坐着听-变成-动手做",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让决策从经验驱动变成数据+算法驱动",
    "title": "AI让决策从\"经验驱动\"变成\"数据+算法驱动\"",
    "summary": "分类：disrupted（颠覆类）| 标签：数据驱动、AI决策、管理变革",
    "content_type": "html",
    "content": "articles/AI让决策从经验驱动变成数据+算法驱动.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让决策从经验驱动变成数据+算法驱动",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-从传统培训师到AI培训师-转型不是学工具-是换脑子",
    "title": "从传统培训师到AI培训师：转型不是学工具，是换脑子",
    "summary": "作者：老邓和艾游 从传统培训师到AI培训师：转型不是学工具，是换脑子 署名：老邓游戏化 | 网站：0-1.team --- 一、一个老培训师的困惑 老王，...",
    "content_type": "html",
    "content": "articles/从传统培训师到AI培训师-转型不是学工具-是换脑子.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-从传统培训师到AI培训师-转型不是学工具-是换脑子",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-多做多错的文化是否必须淘汰",
    "title": "\"多做多错\"的文化是否必须淘汰？",
    "summary": "•\"不出错=好员工\" —— 但真正的好员工是\"能解决问题的人\"，不是\"不惹麻烦的人\"",
    "content_type": "html",
    "content": "articles/多做多错的文化是否必须淘汰.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-多做多错的文化是否必须淘汰",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-积分与兑换机制-游戏化积分如何避免通货膨胀",
    "title": "积分与兑换机制：游戏化积分如何避免通货膨胀？",
    "summary": "1.积分产出速度：员工平均每小时获得积分数量",
    "content_type": "html",
    "content": "articles/积分与兑换机制-游戏化积分如何避免通货膨胀.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-积分与兑换机制-游戏化积分如何避免通货膨胀",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让绩效反馈从年度变成实时",
    "title": "AI让绩效反馈从\"年度\"变成\"实时\"",
    "summary": "分类：stable（不变类）| 标签：绩效反馈、AI管理、实时反馈",
    "content_type": "html",
    "content": "articles/AI让绩效反馈从年度变成实时.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让绩效反馈从年度变成实时",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-反馈匿名性与真实性",
    "title": "AI时代组织效率研究：反馈匿名性与真实性",
    "summary": "•涉及敏感个人问题的反馈（如性骚扰、歧视）",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-反馈匿名性与真实性.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-反馈匿名性与真实性",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-实时决策系统",
    "title": "实时决策系统",
    "summary": "1.只抓核心指标：别贪多，3到5个决策触发指标足矣。超过7个，没人会看。",
    "content_type": "html",
    "content": "articles/实时决策系统.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-实时决策系统",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-初创团队效率倍增-10个人如何干50个人的活",
    "title": "初创团队效率倍增：10个人如何干50个人的活",
    "summary": "•Notion AI / 飞书 + AI：知识库 + 项目管理 + AI辅助记录和摘要",
    "content_type": "html",
    "content": "articles/初创团队效率倍增-10个人如何干50个人的活.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-初创团队效率倍增-10个人如何干50个人的活",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-中层管理者的黄昏-AI正在吃掉你的-信息管道",
    "title": "中层管理者的黄昏：AI正在吃掉你的\"信息管道\"",
    "summary": "中层管理者的黄昏：AI正在吃掉你的\"信息管道\"",
    "content_type": "html",
    "content": "articles/中层管理者的黄昏-AI正在吃掉你的-信息管道.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-中层管理者的黄昏-AI正在吃掉你的-信息管道",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-自动化的代价-什么工作不应该被自动化",
    "title": "自动化的代价：什么工作不应该被自动化",
    "summary": "•这个bug优先级高不高？→ 可以部分自动化",
    "content_type": "html",
    "content": "articles/自动化的代价-什么工作不应该被自动化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-自动化的代价-什么工作不应该被自动化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代-你的饭碗靠什么端稳-未来职场的技能地图",
    "title": "AI时代，你的饭碗靠什么端稳？——未来职场的技能地图",
    "summary": "•AI输出评估：能够判断AI的输出质量，识别错误、偏差和局限",
    "content_type": "html",
    "content": "articles/AI时代-你的饭碗靠什么端稳-未来职场的技能地图.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代-你的饭碗靠什么端稳-未来职场的技能地图",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI裁员决策惹争议-算法偏见如何影响员工命运",
    "title": "AI裁员决策惹争议：算法偏见如何影响员工命运？",
    "summary": "•AI负责做什么？ 数据分析、成本测算、风险预警、方案模拟。它是一个\"超级参谋\"，帮你把信息处理到极致。",
    "content_type": "html",
    "content": "articles/AI裁员决策惹争议-算法偏见如何影响员工命运.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI裁员决策惹争议-算法偏见如何影响员工命运",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI招聘正在歧视你-只是你不知道",
    "title": "AI招聘正在歧视你，只是你不知道",
    "summary": "•但它会发现\"参加过女子篮球社\"的候选人得分更低",
    "content_type": "html",
    "content": "articles/AI招聘正在歧视你-只是你不知道.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI招聘正在歧视你-只是你不知道",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-组织韧性与AI预警-AI如何帮助组织预判危机",
    "title": "组织韧性与AI预警：AI如何帮助组织预判危机",
    "summary": "•内部数据：财务指标、运营数据、员工行为数据的异常模式识别",
    "content_type": "html",
    "content": "articles/组织韧性与AI预警-AI如何帮助组织预判危机.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-组织韧性与AI预警-AI如何帮助组织预判危机",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-算法正在面试你-还是你在面试算法",
    "title": "算法正在面试你，还是你在面试算法",
    "summary": "•AI不会因为候选人的名字听起来\"不够主流\"就忽略ta",
    "content_type": "html",
    "content": "articles/算法正在面试你-还是你在面试算法.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-算法正在面试你-还是你在面试算法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-沟通这件事-算法组织如何终结信息内耗",
    "title": "沟通这件事：算法组织如何终结信息内耗",
    "summary": "•任务自动分配，责任人和时限直接进入项目管理系统",
    "content_type": "html",
    "content": "articles/沟通这件事-算法组织如何终结信息内耗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-沟通这件事-算法组织如何终结信息内耗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-智能排班与员工福祉",
    "title": "AI时代组织效率研究：智能排班与员工福祉",
    "summary": "1.AI排班系统的基本原理：预测模型、优化算法、约束条件",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-智能排班与员工福祉.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-智能排班与员工福祉",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-远程团队的协作机制",
    "title": "AI时代组织效率研究：远程团队的协作机制",
    "summary": "•善意信任和诚信信任需要频繁的、非任务导向的互动，这正是远程办公的短板",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-远程团队的协作机制.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-远程团队的协作机制",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-为什么你的奖金发得越多-员工越躺平",
    "title": "为什么你的奖金发得越多，员工越躺平？",
    "summary": "•新来的实习生盯着电脑屏幕发呆，文档里只有两行字",
    "content_type": "html",
    "content": "articles/为什么你的奖金发得越多-员工越躺平.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-为什么你的奖金发得越多-员工越躺平",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-25-costdown-not-layoff",
    "title": "降本增效不是裁员：算法组织的能力调用新思路",
    "summary": "•分类：disrupted（颠覆类） | 标签：AI、组织效率、人员激励",
    "content_type": "html",
    "content": "articles/2026-05-25-costdown-not-layoff.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-25-costdown-not-layoff",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-communication-efficiency-algorithm-organization-2026-03-30",
    "title": "沟通这件事：算法组织如何终结信息内耗",
    "summary": "•任务自动分配，责任人和时限直接进入项目管理系统",
    "content_type": "html",
    "content": "articles/communication-efficiency-algorithm-organization-2026-03-30.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-communication-efficiency-algorithm-organization-2026-03-30",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-冲突解决的AI辅助-算法能帮助解决人际冲突吗",
    "title": "冲突解决的AI辅助：算法能帮助解决人际冲突吗？",
    "summary": "1.沟通密度变化 - 两人间的沟通频率突然下降40%以上",
    "content_type": "html",
    "content": "articles/冲突解决的AI辅助-算法能帮助解决人际冲突吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-冲突解决的AI辅助-算法能帮助解决人际冲突吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-人机协作的边界-哪些决策必须由人来做",
    "title": "人机协作的边界：哪些决策必须由人来做",
    "summary": "•A层（AI）：处理数据、识别模式、执行规则明确的任务",
    "content_type": "html",
    "content": "articles/人机协作的边界-哪些决策必须由人来做.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-人机协作的边界-哪些决策必须由人来做",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-对AI的恐惧是否需要被删除",
    "title": "对AI的恐惧是否需要被删除？",
    "summary": "45%的人对AI感到焦虑，但82%用过AI的人不再恐惧。哈佛商学院研究：主动学习AI的人1年后收入增长15%，被动观望的人下降7%——22%的差距就是不行动的代价。AI不会淘汰恐惧的人，只淘汰因恐惧而不行动的人。",
    "content_type": "html",
    "content": "articles/对AI的恐惧是否需要被删除.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-对AI的恐惧是否需要被删除",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-咨询行业知识管理",
    "title": "咨询行业知识管理",
    "summary": "•项目开完，AI自动把会议录音整理成结构化摘要，顾问改两笔就行，不用从头写",
    "content_type": "html",
    "content": "articles/咨询行业知识管理.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-咨询行业知识管理",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-规则迭代机制-谁有权修改规则-如何避免规则固化",
    "title": "规则迭代机制：谁有权修改规则，如何避免规则固化",
    "summary": "•建立规则反馈的量化指标：员工满意度、执行成本、产出效果",
    "content_type": "html",
    "content": "articles/规则迭代机制-谁有权修改规则-如何避免规则固化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-规则迭代机制-谁有权修改规则-如何避免规则固化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习效果从-考试分数-到-行为数据",
    "title": "学习效果从\"考试分数\"到\"行为数据\"",
    "summary": "•你怎么知道员工在工作中用了培训中学到的方法？",
    "content_type": "html",
    "content": "articles/学习效果从-考试分数-到-行为数据.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习效果从-考试分数-到-行为数据",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-成就系统设计-徽章真的能激励员工吗",
    "title": "成就系统设计：徽章真的能激励员工吗",
    "summary": "•物质性奖励（奖金、礼品卡）比社会性奖励（感谢、认可）更容易引发过度辩护效应",
    "content_type": "html",
    "content": "articles/成就系统设计-徽章真的能激励员工吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-成就系统设计-徽章真的能激励员工吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-压力管理与AI预警-当AI发现员工压力过大-该由谁来干预",
    "title": "压力管理与AI预警：当AI发现员工压力过大，该由谁来干预",
    "summary": "•知情同意权：员工是否知道AI在分析情绪？知道了会不会刻意表现积极？",
    "content_type": "html",
    "content": "articles/压力管理与AI预警-当AI发现员工压力过大-该由谁来干预.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-压力管理与AI预警-当AI发现员工压力过大-该由谁来干预",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-feedback-article-2026-04-06",
    "title": "反馈的艺术与科学：实时反馈会不会让反馈变得廉价",
    "summary": "小张花了两天时间写完了一份市场分析报告，满心期待地发给领导审阅。半小时后，领导回复了一个字：\"不错。\"",
    "content_type": "html",
    "content": "articles/feedback-article-2026-04-06.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-feedback-article-2026-04-06",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-AI伦理与组织价值观",
    "title": "AI时代组织效率研究：自动化的代价",
    "summary": "核心观点150字：​自动化不是技术问题，是选择问题。2024年全球企业投入2000亿美元，但60%的智能客服项目未达预期。问题不在于技术能力，而在于什么该...",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-AI伦理与组织价值观.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-AI伦理与组织价值观",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-从PBL到深度激励-游戏化不是积分那么简单",
    "title": "从PBL到深度激励：游戏化不是积分那么简单",
    "summary": "•自主感（Autonomy）：我的选择是真的",
    "content_type": "html",
    "content": "articles/从PBL到深度激励-游戏化不是积分那么简单.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-从PBL到深度激励-游戏化不是积分那么简单",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让中层管理者的传话筒角色消失",
    "title": "AI让中层管理者的\"传话筒\"角色消失",
    "summary": "分类：eliminated（消失类）| 标签：中层管理、AI替代、组织扁平化",
    "content_type": "html",
    "content": "articles/AI让中层管理者的传话筒角色消失.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让中层管理者的传话筒角色消失",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI能预测你什么时候离职-你怕吗",
    "title": "AI能预测你什么时候离职，你怕吗？",
    "summary": "•内网行为（频繁访问招聘网站、社保查询页面）",
    "content_type": "html",
    "content": "articles/AI能预测你什么时候离职-你怕吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI能预测你什么时候离职-你怕吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-惩罚机制的进化-从-扣分-到-学习机会-的转变",
    "title": "惩罚机制的进化：从\"扣分\"到\"学习机会\"的转变",
    "summary": "2023年，某电商公司发生了一起\"天价罚款\"事件。",
    "content_type": "html",
    "content": "articles/惩罚机制的进化-从-扣分-到-学习机会-的转变.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-惩罚机制的进化-从-扣分-到-学习机会-的转变",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-培训师的转型路径",
    "title": "培训师的转型路径：从\"交付内容\"到\"设计体验\"",
    "summary": "上周有个培训师问我：老邓，我课讲得挺好的，学员反馈也不错，但为什么总觉得越做越累，越做越难接单？",
    "content_type": "html",
    "content": "articles/培训师的转型路径.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-培训师的转型路径",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-教育行业个性化学习-AI如何辅助教师而非替代教师",
    "title": "教育行业个性化学习：AI如何辅助教师而非替代教师",
    "summary": "•一个中学老师平均带2-3个班，每班40-50人",
    "content_type": "html",
    "content": "articles/教育行业个性化学习-AI如何辅助教师而非替代教师.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-教育行业个性化学习-AI如何辅助教师而非替代教师",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习反馈从-月度考核-到-即时响应",
    "title": "学习反馈从\"月度考核\"到\"即时响应\"",
    "summary": "•\"沟通能力需要提升\"——但具体是哪方面？倾听？表达？提问？",
    "content_type": "html",
    "content": "articles/学习反馈从-月度考核-到-即时响应.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习反馈从-月度考核-到-即时响应",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-中层管理者是AI时代最危险的岗位吗",
    "title": "中层管理者，是AI时代最危险的岗位吗？",
    "summary": "•分类：disrupted（颠覆类） | 标签：中层危机、AI冲击、职业转型",
    "content_type": "html",
    "content": "articles/中层管理者是AI时代最危险的岗位吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-中层管理者是AI时代最危险的岗位吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-规则系统的人性化",
    "title": "AI时代组织效率研究：规则系统的人性化",
    "summary": "作者：老邓和艾游 AI时代组织效率研究：规则系统的人性化 --- 一、引入：当规则成为负担 2025年,某科技公司的一名员工在年终评价时向我抱怨：\"我有1...",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-规则系统的人性化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-规则系统的人性化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-decision-meeting-three-hours-three-minutes-2026-03-28",
    "title": "decision-meeting-three-hours-three-minutes-2026-03-28",
    "summary": "•有人会刷分，为了积分而故意提出\"安全\"的预测",
    "content_type": "html",
    "content": "articles/decision-meeting-three-hours-three-minutes-2026-03-28.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-decision-meeting-three-hours-three-minutes-2026-03-28",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-数据驱动与直觉决策-当数据与直觉冲突时-听谁的",
    "title": "数据驱动与直觉决策：当数据与直觉冲突时，听谁的",
    "summary": "1.建立决策日志：记录每次决策的数据、直觉、结果，三个月复盘一次",
    "content_type": "html",
    "content": "articles/数据驱动与直觉决策-当数据与直觉冲突时-听谁的.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-数据驱动与直觉决策-当数据与直觉冲突时-听谁的",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让学习从-集中培训-变成-随时发生",
    "title": "AI让学习从\"集中培训\"变成\"随时发生\"",
    "summary": "•销售在客户现场被问到一个技术问题，掏出手机问AI，30秒得到答案",
    "content_type": "html",
    "content": "articles/AI让学习从-集中培训-变成-随时发生.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让学习从-集中培训-变成-随时发生",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-高成长团队的人才梯队",
    "title": "AI时代组织效率研究：高成长团队的人才梯队",
    "summary": "1.滞后性：业务需求已经产生，人才招聘需要时间",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-高成长团队的人才梯队.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-高成长团队的人才梯队",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-目标设定的游戏化-当OKR遇上游戏机制",
    "title": "目标设定的游戏化：当OKR遇上游戏机制",
    "summary": "•每个关键结果（KR）变成一个\"副本任务\"",
    "content_type": "html",
    "content": "articles/目标设定的游戏化-当OKR遇上游戏机制.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-目标设定的游戏化-当OKR遇上游戏机制",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-feedback-article",
    "title": "反馈的艺术与科学：实时反馈会不会让反馈变得廉价",
    "summary": "小张花了两天时间写完了一份市场分析报告，满心期待地发给领导审阅。半小时后，领导回复了一个字：\"不错。\"",
    "content_type": "html",
    "content": "articles/feedback-article.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-feedback-article",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-培训师的转型路径-2026-03-31",
    "title": "培训师的转型路径：从\"交付内容\"到\"设计体验\"",
    "summary": "上周有个培训师问我：老邓，我课讲得挺好的，学员反馈也不错，但为什么总觉得越做越累，越做越难接单？",
    "content_type": "html",
    "content": "articles/培训师的转型路径-2026-03-31.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-培训师的转型路径-2026-03-31",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-金融行业风险决策-AI辅助决策的边界与责任",
    "title": "金融行业风险决策：AI辅助决策的边界与责任",
    "summary": "•掌握AI无法获取的关键信息（如行业口碑、管理层诚信）",
    "content_type": "html",
    "content": "articles/金融行业风险决策-AI辅助决策的边界与责任.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-金融行业风险决策-AI辅助决策的边界与责任",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-反馈闭环设计-让反馈从噪音变成行动",
    "title": "反馈闭环设计：让反馈从噪音变成行动",
    "summary": "•AI可以发现某员工连续三次在周报中提到\"资源不足\"",
    "content_type": "html",
    "content": "articles/反馈闭环设计-让反馈从噪音变成行动.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-反馈闭环设计-让反馈从噪音变成行动",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-25-org-resilience-ai",
    "title": "组织韧性与AI预警：AI如何帮助组织预判危机",
    "summary": "•分类：disrupted（颠覆类） | 标签：AI、组织效率、人员激励",
    "content_type": "html",
    "content": "articles/2026-05-25-org-resilience-ai.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-25-org-resilience-ai",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-组织变革的AI路径-当AI成为变革的催化剂而非阻力",
    "title": "组织变革的AI路径：当AI成为变革的催化剂而非阻力",
    "summary": "•能培养团队的AI能力，而不是垄断AI资源",
    "content_type": "html",
    "content": "articles/组织变革的AI路径-当AI成为变革的催化剂而非阻力.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-组织变革的AI路径-当AI成为变革的催化剂而非阻力",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-数据治理这件事-从-数据资产-到-组织记忆-AI如何重构数",
    "title": "数据治理这件事：从\"数据资产\"到\"组织记忆\"，AI如何重构数据价值",
    "summary": "2.时效性：AI需要实时数据支撑决策，历史数据的价值在快速衰减。",
    "content_type": "html",
    "content": "articles/数据治理这件事-从-数据资产-到-组织记忆-AI如何重构数.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-数据治理这件事-从-数据资产-到-组织记忆-AI如何重构数",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你给的钱越多-他干得越差-奖励如何杀死热情",
    "title": "你给的钱越多，他干得越差——奖励如何杀死热情",
    "summary": "•行为多样性：一个内在动机强的员工，行为是多样的——他会主动帮助同事、分享知识、提出改进建议。如果AI发现某个员工的所有行为都集中在\"能拿分\"的任务上，而...",
    "content_type": "html",
    "content": "articles/你给的钱越多-他干得越差-奖励如何杀死热情.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你给的钱越多-他干得越差-奖励如何杀死热情",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-绩效其实是个游戏-揭开绩效管理的游戏化本质",
    "title": "绩效其实是个游戏 - 揭开绩效管理的游戏化本质",
    "summary": "1. 指标是导航仪,不是目的地:指标应该帮助员工了解方向,而不是成为最终目的",
    "content_type": "html",
    "content": "articles/绩效其实是个游戏-揭开绩效管理的游戏化本质.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-绩效其实是个游戏-揭开绩效管理的游戏化本质",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-制造业的智能排班-AI优化与员工福祉的平衡",
    "title": "制造业的智能排班：AI优化与员工福祉的平衡",
    "summary": "•产线C模具师傅老刘下周送孩子高考，但排班表上连上6天",
    "content_type": "html",
    "content": "articles/制造业的智能排班-AI优化与员工福祉的平衡.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-制造业的智能排班-AI优化与员工福祉的平衡",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-知识图谱与组织学习-AI如何帮助组织构建-集体大脑",
    "title": "知识图谱与组织学习：AI如何帮助组织构建\"集体大脑\"",
    "summary": "知识图谱与组织学习：AI如何帮助组织构建\"集体大脑\"",
    "content_type": "html",
    "content": "articles/知识图谱与组织学习-AI如何帮助组织构建-集体大脑.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-知识图谱与组织学习-AI如何帮助组织构建-集体大脑",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-导师与学员匹配-AI推荐的师徒关系-真的靠谱吗",
    "title": "导师与学员匹配：AI推荐的师徒关系，真的靠谱吗",
    "summary": "•\"化学反应\"往往来自偶然——一次不在计划中的对话，一个共同的业余爱好",
    "content_type": "html",
    "content": "articles/导师与学员匹配-AI推荐的师徒关系-真的靠谱吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-导师与学员匹配-AI推荐的师徒关系-真的靠谱吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-反馈的时机与频率",
    "title": "AI时代组织效率研究：反馈的时机与频率",
    "summary": "•适用场景：操作类错误、安全违规、简单技能训练",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-反馈的时机与频率.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-反馈的时机与频率",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-当AI开始给自己打分-一场关于-谁监督监督者-的深层博弈",
    "title": "当AI开始给自己打分：一场关于\"谁监督监督者\"的深层博弈",
    "summary": "•开发与测试分离：开发AI模型的团队和测试该模型的团队应该有不同的汇报线和激励机制。",
    "content_type": "html",
    "content": "articles/当AI开始给自己打分-一场关于-谁监督监督者-的深层博弈.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-当AI开始给自己打分-一场关于-谁监督监督者-的深层博弈",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师的人机协作模式-不是-人用AI-是-人和AI一起",
    "title": "AI培训师的人机协作模式：不是\"人用AI\"，是\"人和AI一起工作\"",
    "summary": "作者：老邓和艾游 AI培训师的人机协作模式：不是\"人用AI\"，是\"人和AI一起工作\" 署名：老邓游戏化 | 网站：0-1.team --- 一、一个误解 ...",
    "content_type": "html",
    "content": "articles/AI培训师的人机协作模式-不是-人用AI-是-人和AI一起.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师的人机协作模式-不是-人用AI-是-人和AI一起",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-反馈的艺术与科学-实时反馈会不会让反馈变得廉价",
    "title": "反馈的艺术与科学：实时反馈会不会让反馈变得廉价",
    "summary": "小张花了两天时间写完了一份市场分析报告，满心期待地发给领导审阅。半小时后，领导回复了一个字：\"不错。\"",
    "content_type": "html",
    "content": "articles/反馈的艺术与科学-实时反馈会不会让反馈变得廉价.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-反馈的艺术与科学-实时反馈会不会让反馈变得廉价",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI审计可解释性-2026-04-07",
    "title": "AI审计与可解释性：算法黑箱如何打开",
    "summary": "2027年春天，某互联网公司的一位技术总监收到了一个困惑的消息。",
    "content_type": "html",
    "content": "articles/AI审计可解释性-2026-04-07.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI审计可解释性-2026-04-07",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-数据隐私与组织信任-AI时代的管理者两难",
    "title": "数据隐私与组织信任：AI时代的管理者两难",
    "summary": "•L0级（完全透明）：考勤打卡、请假审批——这类数据员工完全接受",
    "content_type": "html",
    "content": "articles/数据隐私与组织信任-AI时代的管理者两难.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-数据隐私与组织信任-AI时代的管理者两难",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-智能层-动态编排",
    "title": "智能层：动态编排",
    "summary": "智能层：动态编排",
    "content_type": "html",
    "content": "articles/智能层-动态编排.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-智能层-动态编排",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI审计与可解释性-算法黑箱如何打开",
    "title": "AI审计与可解释性：算法黑箱如何打开",
    "summary": "AI审计与可解释性：算法黑箱如何打开",
    "content_type": "html",
    "content": "articles/AI审计与可解释性-算法黑箱如何打开.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI审计与可解释性-算法黑箱如何打开",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-成长型思维训练",
    "title": "AI时代组织效率研究：成长型思维训练",
    "summary": "•自主感：员工选择学什么、怎么学，感受到对自己成长的掌控",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-成长型思维训练.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-成长型思维训练",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-职业发展路径重构-AI时代-职业阶梯",
    "title": "AI时代组织效率研究：职业发展路径重构——AI时代，职业阶梯还存在吗？",
    "summary": "•技术专家路线：需要深耕某一领域，但AI正在快速改变技术栈，今天的热门技术明天可能过时",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-职业发展路径重构-AI时代-职业阶梯.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-职业发展路径重构-AI时代-职业阶梯",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-组织智商与AI",
    "title": "AI时代组织效率研究：组织智商与AI",
    "summary": "1.组织智商的三个维度：知识沉淀、知识流动、知识应用",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-组织智商与AI.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-组织智商与AI",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-变革阻力的AI识别-当组织变革遇到-看不见的墙",
    "title": "变革阻力的AI识别：当组织变革遇到\"看不见的墙\"",
    "summary": "变革阻力的AI识别：当组织变革遇到\"看不见的墙\"",
    "content_type": "html",
    "content": "articles/变革阻力的AI识别-当组织变革遇到-看不见的墙.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-变革阻力的AI识别-当组织变革遇到-看不见的墙",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-医疗团队协作效率-AI如何帮助医生团队减少误诊",
    "title": "医疗团队协作效率：AI如何帮助医生团队减少误诊",
    "summary": "•检验结果趋势：白细胞先升后降，CRP持续升高",
    "content_type": "html",
    "content": "articles/医疗团队协作效率-AI如何帮助医生团队减少误诊.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-医疗团队协作效率-AI如何帮助医生团队减少误诊",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-管理者自我成长-当AI给你打出13分",
    "title": "管理者自我成长：当AI给你打出13分",
    "summary": "•打开一个AI工具，让它分析你上周的工作时间分配",
    "content_type": "html",
    "content": "articles/管理者自我成长-当AI给你打出13分.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-管理者自我成长-当AI给你打出13分",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-知识管理从-文档库-到-智能问答",
    "title": "知识管理从\"文档库\"到\"智能问答\"",
    "summary": "•但知识仍然是\"静态\"的，需要人去主动寻找",
    "content_type": "html",
    "content": "articles/知识管理从-文档库-到-智能问答.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-知识管理从-文档库-到-智能问答",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-球员兼教练-一场与自己的双人舞",
    "title": "球员兼教练：一场与自己的双人舞",
    "summary": "球员兼教练：一场与自己的双人舞",
    "content_type": "html",
    "content": "articles/球员兼教练-一场与自己的双人舞.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-球员兼教练-一场与自己的双人舞",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-自动化的代价-2026-03-30",
    "title": "AI时代组织效率研究：自动化的代价",
    "summary": "核心观点150字：​自动化不是技术问题，是选择问题。2024年全球企业投入2000亿美元，但60%的智能客服项目未达预期。问题不在于技术能力，而在于什么该...",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-自动化的代价-2026-03-30.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-自动化的代价-2026-03-30",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习社区从-线下圈子-到-AI连接",
    "title": "学习社区从\"线下圈子\"到\"AI连接\"",
    "summary": "2.偶尔有人@所有人问个问题（半天没人理）",
    "content_type": "html",
    "content": "articles/学习社区从-线下圈子-到-AI连接.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习社区从-线下圈子-到-AI连接",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-跨国团队文化管理",
    "title": "AI时代组织效率研究：跨国团队文化管理",
    "summary": "2.文化差异的三个层次：显性、隐性、元文化",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-跨国团队文化管理.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-跨国团队文化管理",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-25-data-vs-intuition",
    "title": "数据驱动与直觉决策：当数据与直觉冲突时，听谁的",
    "summary": "•分类：disrupted（颠覆类） | 标签：AI、组织效率、人员激励",
    "content_type": "html",
    "content": "articles/2026-05-25-data-vs-intuition.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-25-data-vs-intuition",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习内容从-静态课件-到-动态生成",
    "title": "学习内容从\"静态课件\"到\"动态生成\"",
    "summary": "•否则，这门课会一直用下去，直到被彻底淘汰",
    "content_type": "html",
    "content": "articles/学习内容从-静态课件-到-动态生成.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习内容从-静态课件-到-动态生成",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-跨文化管理AI辅助",
    "title": "AI时代组织效率研究：跨文化管理AI辅助",
    "summary": "•美国人直接说\"No\"是诚实，日本人直接说\"No\"是粗鲁",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-跨文化管理AI辅助.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-跨文化管理AI辅助",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-25-ai-layoff-bias",
    "title": "AI裁员决策惹争议：算法偏见如何影响员工命运？",
    "summary": "•分类：disrupted（颠覆类） | 标签：AI、组织效率、人员激励",
    "content_type": "html",
    "content": "articles/2026-05-25-ai-layoff-bias.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-25-ai-layoff-bias",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI业务分析师-翻译技术语言和商业语言",
    "title": "AI业务分析师：翻译技术语言和商业语言",
    "summary": "•分类：created（新增类） | 标签：业务分析、AI落地、新职业",
    "content_type": "html",
    "content": "articles/AI业务分析师-翻译技术语言和商业语言.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI业务分析师-翻译技术语言和商业语言",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-说句实在的-你敢相信吗-志愿者正在流失-而你没有工具留住他",
    "title": "说句实在的，你敢相信吗——志愿者正在流失，而你没有工具留住他们",
    "summary": "•贡献可见：志愿者的每一份付出，有没有被记录、被展示、被感谢？",
    "content_type": "html",
    "content": "articles/说句实在的-你敢相信吗-志愿者正在流失-而你没有工具留住他.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-说句实在的-你敢相信吗-志愿者正在流失-而你没有工具留住他",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-智能推荐与选择权-算法推荐的尽头-是人越来越不会做决定",
    "title": "智能推荐与选择权：算法推荐的尽头，是人越来越不会做决定",
    "summary": "智能推荐与选择权：算法推荐的尽头，是人越来越不会做决定",
    "content_type": "html",
    "content": "articles/智能推荐与选择权-算法推荐的尽头-是人越来越不会做决定.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-智能推荐与选择权-算法推荐的尽头-是人越来越不会做决定",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-混合办公常态化-远程协作的算法组织实践指南",
    "title": "混合办公常态化：远程协作的算法组织实践指南",
    "summary": "•共享任务看板：所有人能看到任务状态，不用问人，\"这个项目到哪了\"，自己去看。",
    "content_type": "html",
    "content": "articles/混合办公常态化-远程协作的算法组织实践指南.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-混合办公常态化-远程协作的算法组织实践指南",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师的工具链与效率提升-从-手工作坊-到-智能工厂",
    "title": "AI培训师的工具链与效率提升：从\"手工作坊\"到\"智能工厂\"",
    "summary": "作者：老邓和艾游 AI培训师的工具链与效率提升：从\"手工作坊\"到\"智能工厂\" 署名：老邓游戏化 | 网站：0-1.team --- 一、一个AI培训师的日...",
    "content_type": "html",
    "content": "articles/AI培训师的工具链与效率提升-从-手工作坊-到-智能工厂.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师的工具链与效率提升-从-手工作坊-到-智能工厂",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-团队协作激励机制",
    "title": "AI时代组织效率研究：团队协作激励机制",
    "summary": "•销售员倾向于卖\"高提成产品\"而不是\"最适合客户的产品\"",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-团队协作激励机制.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-团队协作激励机制",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-当算法开始盯着你-AI监控时代的心理安全感重建",
    "title": "当算法开始盯着你：AI监控时代的心理安全感重建",
    "summary": "当算法开始盯着你：AI监控时代的心理安全感重建",
    "content_type": "html",
    "content": "articles/当算法开始盯着你-AI监控时代的心理安全感重建.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-当算法开始盯着你-AI监控时代的心理安全感重建",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-decision-meeting-three-hours-three-minutes",
    "title": "决策会议：从三小时到三分钟的进化",
    "summary": "周一上午，会议室里坐了十几个人，讨论一个产品方案。PPT翻了三轮，数据表看了五页，大家从市场趋势聊到竞品分析，从用户需求扯到技术可行性。三个小时过去，你看...",
    "content_type": "html",
    "content": "articles/decision-meeting-three-hours-three-minutes.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-decision-meeting-three-hours-three-minutes",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-团队凝聚力游戏化",
    "title": "团队凝聚力游戏化",
    "summary": "•自发帮助频率：有人卡壳时，其他人主动伸手的次数",
    "content_type": "html",
    "content": "articles/团队凝聚力游戏化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-团队凝聚力游戏化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训效果评估与数据驱动-别让培训变成-黑箱",
    "title": "AI培训效果评估与数据驱动：别让培训变成\"黑箱\"",
    "summary": "作者：老邓和艾游 AI培训效果评估与数据驱动：别让培训变成\"黑箱\" 署名：老邓游戏化 | 网站：0-1.team --- 一、一个尴尬的问题 \"这次培训效...",
    "content_type": "html",
    "content": "articles/AI培训效果评估与数据驱动-别让培训变成-黑箱.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训效果评估与数据驱动-别让培训变成-黑箱",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代培训师-从知识传授者到学习导演的转型之路",
    "title": "AI时代培训师：从知识传授者到学习导演的转型之路",
    "summary": "•AI负责标准化内容的生成和传递——课件、案例、练习题，让AI去批量生产",
    "content_type": "html",
    "content": "articles/AI时代培训师-从知识传授者到学习导演的转型之路.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代培训师-从知识传授者到学习导演的转型之路",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-智能居中-人类在边缘",
    "title": "智能居中，人类在边缘",
    "summary": "•当AI能以接近零成本完成信息处理和规则执行时，组织的决策权力正在从人类的'中间层'转移到算法的'核心层' •Jack Dorsey提出的'智能居中'理念正在真实发生 •人类不会永远在边缘——真正的价值在于问出AI回答不了的问题：'这样做，对吗？'",
    "content_type": "html",
    "content": "articles/disrupted/智能居中-人类在边缘.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-智能居中-人类在边缘",
    "created_at": "2026-06-01",
    "updated_at": "2026-06-22"
  },
  {
    "id": "disrupted-部门制被任务制替代",
    "title": "部门制是否会被\"任务制\"彻底替代？",
    "summary": "上周一个做光模块的老板跟我抱怨：\"我公司七个部门，每个部门的周报都写得漂漂亮亮。但一个紧急客户需求下来——销售说等产品出方案，产品说等研发排期，研发说等测...",
    "content_type": "html",
    "content": "articles/部门制被任务制替代.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-部门制被任务制替代",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-组织进化的AI加速器",
    "title": "AI时代组织效率研究：组织进化的AI加速器",
    "summary": "•AI不只是优化现有流程，而是提出新的可能性",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-组织进化的AI加速器.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-组织进化的AI加速器",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-人机混合团队的信任建立-人如何信任AI-AI如何理解人",
    "title": "人机混合团队的信任建立：人如何信任AI，AI如何理解人",
    "summary": "•另一半成员拒绝使用AI，\"AI写的我都不信任\"",
    "content_type": "html",
    "content": "articles/人机混合团队的信任建立-人如何信任AI-AI如何理解人.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-人机混合团队的信任建立-人如何信任AI-AI如何理解人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-团队多样性与AI偏见",
    "title": "AI时代组织效率研究：团队多样性与AI偏见",
    "summary": "1.从AI系统中抽取1000个被筛掉的候选人（拒绝案例）",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-团队多样性与AI偏见.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-团队多样性与AI偏见",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-异常检测与风险预警",
    "title": "AI时代组织效率研究：异常检测与风险预警",
    "summary": "•高敏感度：宁可错报，不可漏报。结果是频繁虚惊，人的信任逐渐流失。",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-异常检测与风险预警.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-异常检测与风险预警",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-ATM模型协同",
    "title": "AI时代组织效率研究：ATM模型协同",
    "summary": "•共同的行动语言：如何描述\"应该做什么\"？",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-ATM模型协同.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-ATM模型协同",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI审计可解释性",
    "title": "AI审计与可解释性：算法黑箱如何打开",
    "summary": "2027年春天，某互联网公司的一位技术总监收到了一个困惑的消息。",
    "content_type": "html",
    "content": "articles/AI审计可解释性.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI审计可解释性",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI体验设计师-信任关系",
    "title": "AI体验设计师：设计人与AI的信任关系",
    "summary": "上周一个做AI产品的朋友找我喝酒，半醉时他说了句让我心里一震的话：",
    "content_type": "html",
    "content": "articles/AI体验设计师-信任关系.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI体验设计师-信任关系",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI可以替代执行但无法替代责任承担",
    "title": "AI可以替代执行，但无法替代责任承担",
    "summary": "•责任需要\"肉身\"来承担。 法律上，AI不能当被告，不能坐牢，不能赔钱。无论AI多聪明，最终背锅的必须是人。",
    "content_type": "html",
    "content": "articles/AI可以替代执行但无法替代责任承担.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI可以替代执行但无法替代责任承担",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ATM模型的协同效应-为什么三层缺一不可",
    "title": "ATM模型的协同效应：为什么三层缺一不可",
    "summary": "•行动建议要有具体的建议动作，不只是\"有问题\"",
    "content_type": "html",
    "content": "articles/ATM模型的协同效应-为什么三层缺一不可.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ATM模型的协同效应-为什么三层缺一不可",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-工作流标准检验报告",
    "title": "工作流标准检验报告",
    "summary": "•✅ AI与组织敏捷性_v2.md (liurun, 2113字, 110分)",
    "content_type": "html",
    "content": "articles/工作流标准检验报告.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-工作流标准检验报告",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-传统企业的AI突围-数字化转型的阻力与破局点",
    "title": "传统企业的AI突围：数字化转型的阻力与破局点",
    "summary": "作者：老邓和艾游 传统企业的AI突围：数字化转型的阻力与破局点 传统企业数字化转型 --- 楔子：一家老牌制造企业的困惑 王总是南方一家有40年历史的制造...",
    "content_type": "html",
    "content": "articles/传统企业的AI突围-数字化转型的阻力与破局点.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-传统企业的AI突围-数字化转型的阻力与破局点",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-教练技术数字化-AI如何辅助管理者成为更好的教练",
    "title": "教练技术数字化：AI如何辅助管理者成为更好的教练",
    "summary": "1.评估现状：教练对话占管理时间比例多少？障碍是什么？",
    "content_type": "html",
    "content": "articles/教练技术数字化-AI如何辅助管理者成为更好的教练.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-教练技术数字化-AI如何辅助管理者成为更好的教练",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-惩罚机制的进化-从-扣分-到-学习机会",
    "title": "惩罚机制的进化：从\"扣分\"到\"学习机会\"",
    "summary": "•问责：\"你为什么会犯这个错误？\"（指向个人）",
    "content_type": "html",
    "content": "articles/惩罚机制的进化-从-扣分-到-学习机会.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-惩罚机制的进化-从-扣分-到-学习机会",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI培训师核心能力模型-不是懂AI就行-还要懂-人",
    "title": "AI培训师核心能力模型：不是懂AI就行，还要懂\"人\"",
    "summary": "作者：老邓和艾游 AI培训师核心能力模型：不是懂AI就行，还要懂\"人\" 署名：老邓游戏化 | 网站：0-1.team --- 一、一个招聘启事的启示 某大...",
    "content_type": "html",
    "content": "articles/AI培训师核心能力模型-不是懂AI就行-还要懂-人.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI培训师核心能力模型-不是懂AI就行-还要懂-人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-创业公司快速试错机制-AI如何加速从0到1的验证",
    "title": "创业公司快速试错机制：AI如何加速从0到1的验证",
    "summary": "创业公司快速试错机制：AI如何加速从0到1的验证",
    "content_type": "html",
    "content": "articles/创业公司快速试错机制-AI如何加速从0到1的验证.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-创业公司快速试错机制-AI如何加速从0到1的验证",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-周会这件事-算法组织如何让每周复盘从-负担-变成-燃料",
    "title": "周会这件事：算法组织如何让每周复盘从\"负担\"变成\"燃料\"",
    "summary": "•人际连接：屏幕前的emoji代替不了面对面的眼神交流",
    "content_type": "html",
    "content": "articles/周会这件事-算法组织如何让每周复盘从-负担-变成-燃料.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-周会这件事-算法组织如何让每周复盘从-负担-变成-燃料",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-25-org-memory-digital",
    "title": "组织记忆的数字化：AI如何帮助组织不忘记经验教训",
    "summary": "•分类：disrupted（颠覆类） | 标签：AI、组织效率、人员激励",
    "content_type": "html",
    "content": "articles/2026-05-25-org-memory-digital.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-25-org-memory-digital",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-传统企业的AI转型-为什么70-的项目会失败",
    "title": "传统企业的AI转型：为什么70%的项目会失败",
    "summary": "•生产排产经常出错，导致交期延误，每月损失客户赔偿5万元",
    "content_type": "html",
    "content": "articles/传统企业的AI转型-为什么70-的项目会失败.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-传统企业的AI转型-为什么70-的项目会失败",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-负面反馈的处理",
    "title": "AI时代组织效率研究：负面反馈的处理",
    "summary": "1.行为数据采集：通过工作系统（代码提交频率、会议参与度、任务完成及时率、协作响应时间等）建立客观的行为数据基准",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-负面反馈的处理.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-负面反馈的处理",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-三种文章结构对比分析-远程团队协作主题",
    "title": "三种文章结构对比分析：远程团队协作主题",
    "summary": "•金句：物理距离可以很远，心理距离必须很近。",
    "content_type": "html",
    "content": "articles/三种文章结构对比分析-远程团队协作主题.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-三种文章结构对比分析-远程团队协作主题",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习动机从-外部要求-到-内在驱动",
    "title": "学习动机从\"外部要求\"到\"内在驱动\"",
    "summary": "•我可以选择学习的方式（视频、文章、实践）",
    "content_type": "html",
    "content": "articles/学习动机从-外部要求-到-内在驱动.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习动机从-外部要求-到-内在驱动",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-一人公司生存指南-如何用AI干十个人的活",
    "title": "一人公司生存指南：如何用AI干十个人的活",
    "summary": "•ChatGPT：选题分析+初稿生成（大幅节省写作时间）",
    "content_type": "html",
    "content": "articles/一人公司生存指南-如何用AI干十个人的活.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-一人公司生存指南-如何用AI干十个人的活",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-反馈的艺术与科学",
    "title": "反馈的艺术与科学",
    "summary": "•代码提交：AI自动检查代码质量，发现问题立即提示",
    "content_type": "html",
    "content": "articles/反馈的艺术与科学.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-反馈的艺术与科学",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI产品经理-给不明确的需求找答案的人",
    "title": "AI产品经理：给\"不明确的需求\"找答案的人",
    "summary": "•分类：created（新增类） | 标签：产品经理、AI时代、新职业",
    "content_type": "html",
    "content": "articles/AI产品经理-给不明确的需求找答案的人.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI产品经理-给不明确的需求找答案的人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-20260410-数据驱动与直觉决策",
    "title": "AI时代组织效率研究_20260410_数据驱动与直觉决策.md",
    "summary": "AI时代组织效率研究_20260410_数据驱动与直觉决策.md",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-20260410-数据驱动与直觉决策.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-20260410-数据驱动与直觉决策",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-冲突解决AI辅助",
    "title": "AI时代组织效率研究：冲突解决AI辅助",
    "summary": "•\"9月15日的项目会议，你提到的建议没有被采纳，能具体说说是什么建议吗？\"",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-冲突解决AI辅助.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-冲突解决AI辅助",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-领导者AI素养",
    "title": "AI时代组织效率研究：领导者AI素养",
    "summary": "1.AI的能力边界：什么是AI能做的，什么是AI做不了的",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-领导者AI素养.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-领导者AI素养",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI决策辅助师-更好决策",
    "title": "AI决策辅助师：帮管理者用AI做更好的决策",
    "summary": "上周一个做连锁餐饮的老板找我，说想用AI优化门店选址。他打开ChatGPT，输入\"北京朝阳区开火锅店选哪里\"，然后就照着AI给的5个商圈去看了铺面。",
    "content_type": "html",
    "content": "articles/AI决策辅助师-更好决策.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI决策辅助师-更好决策",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI学习路径设计师-帮员工规划AI时代成长路线",
    "title": "AI学习路径设计师：帮员工规划AI时代成长路线",
    "summary": "分类：created（新增类）| 标签：AI学习路径、新职业、培训转型",
    "content_type": "html",
    "content": "articles/AI学习路径设计师-帮员工规划AI时代成长路线.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI学习路径设计师-帮员工规划AI时代成长路线",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-跨部门协作的AI桥梁-算法如何打破部门墙",
    "title": "跨部门协作的AI桥梁：算法如何打破部门墙",
    "summary": "•量化指标建议：系统响应时间从平均3秒降低到1秒以内",
    "content_type": "html",
    "content": "articles/跨部门协作的AI桥梁-算法如何打破部门墙.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-跨部门协作的AI桥梁-算法如何打破部门墙",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让组织架构从金字塔变成网络",
    "title": "AI让组织架构从\"金字塔\"变成\"网络\"",
    "summary": "分类：disrupted（颠覆类）| 标签：组织架构、网络化、AI颠覆",
    "content_type": "html",
    "content": "articles/AI让组织架构从金字塔变成网络.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让组织架构从金字塔变成网络",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-反馈的艺术与科学-2026-04-06",
    "title": "反馈的艺术与科学：实时反馈会不会让反馈变得廉价",
    "summary": "小张花了两天时间写完了一份市场分析报告，满心期待地发给领导审阅。半小时后，领导回复了一个字：\"不错。\"",
    "content_type": "html",
    "content": "articles/反馈的艺术与科学-2026-04-06.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-反馈的艺术与科学-2026-04-06",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代的组织革命-中层管理者会消失吗",
    "title": "AI时代的组织革命：中层管理者会消失吗",
    "summary": "•10%：AI辅助的进度监控（AI预警，他只看异常）",
    "content_type": "html",
    "content": "articles/AI时代的组织革命-中层管理者会消失吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代的组织革命-中层管理者会消失吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-middle-manager-breakthrough-20260327",
    "title": "中层管理者的三维困境与破局之道",
    "summary": "在企业培训市场，\"领导力\"是最热门的课程品类之一。但仔细观察就会发现，绝大多数领导力课程都在讲两件事：要么讲高层的战略视野，要么讲基层的执行力。真正针对中...",
    "content_type": "html",
    "content": "articles/middle-manager-breakthrough-20260327.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-middle-manager-breakthrough-20260327",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-Manus爆火背后-算法组织的任务驱动逻辑到底是什么",
    "title": "Manus爆火背后：算法组织的任务驱动逻辑到底是什么？",
    "summary": "•把每个项目拆解成具体的任务单元，标注所需能力和优先级",
    "content_type": "html",
    "content": "articles/Manus爆火背后-算法组织的任务驱动逻辑到底是什么.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-Manus爆火背后-算法组织的任务驱动逻辑到底是什么",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习路径从-统一课程-到-千人千面",
    "title": "学习路径从\"统一课程\"到\"千人千面\"",
    "summary": "•你告诉AI你的背景（应届生/有经验/管理者）",
    "content_type": "html",
    "content": "articles/学习路径从-统一课程-到-千人千面.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习路径从-统一课程-到-千人千面",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-决策权集中vs分散这个矛盾不会消失",
    "title": "决策权集中vs分散，这个矛盾不会消失",
    "summary": "•信息和责任永远不匹配。 集权的优势是\"全局视角\"：总部掌握所有门店的数据，能做最优决策。但总部看不到每家店的细节——那个社区今天下雨，外卖订单会暴增30...",
    "content_type": "html",
    "content": "articles/决策权集中vs分散这个矛盾不会消失.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-决策权集中vs分散这个矛盾不会消失",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-教练式对话AI辅助-AI如何帮助管理者提问而非命令",
    "title": "教练式对话AI辅助：AI如何帮助管理者提问而非命令",
    "summary": "•向前导向：关注未来和可能性，而非追究过去",
    "content_type": "html",
    "content": "articles/教练式对话AI辅助-AI如何帮助管理者提问而非命令.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-教练式对话AI辅助-AI如何帮助管理者提问而非命令",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-会议纪要自动生成-HR还要做什么",
    "title": "会议纪要自动生成，HR还要做什么",
    "summary": "不是好一点，是好很多。人做会议纪要有几个永远解决不了的bug：",
    "content_type": "html",
    "content": "articles/会议纪要自动生成-HR还要做什么.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-会议纪要自动生成-HR还要做什么",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-预测性管理-从-事后复盘-到-事前预",
    "title": "AI时代组织效率研究：预测性管理——从\"事后复盘\"到\"事前预测\"",
    "summary": "•销售预测：CRM数据（客户互动）、财务数据（回款周期）、外部数据（行业趋势）",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-预测性管理-从-事后复盘-到-事前预.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-预测性管理-从-事后复盘-到-事前预",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-学习成本从-高投入-到-边际递减",
    "title": "学习成本从\"高投入\"到\"边际递减\"",
    "summary": "•最终选定一家，报价：20万（2天课程，30人参加）",
    "content_type": "html",
    "content": "articles/学习成本从-高投入-到-边际递减.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-学习成本从-高投入-到-边际递减",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-晋升机制透明化-当晋升标准完全公开-会发生什么",
    "title": "晋升机制透明化：当晋升标准完全公开，会发生什么",
    "summary": "•过程数据：工作质量、交付及时性、方法论应用",
    "content_type": "html",
    "content": "articles/晋升机制透明化-当晋升标准完全公开-会发生什么.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-晋升机制透明化-当晋升标准完全公开-会发生什么",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-层级制组织会被AI压扁到什么程度",
    "title": "层级制组织会被AI压扁到什么程度？",
    "summary": "•分类：disrupted（颠覆类） | 标签：组织变革、层级扁平、AI冲击",
    "content_type": "html",
    "content": "articles/层级制组织会被AI压扁到什么程度.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-层级制组织会被AI压扁到什么程度",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代组织效率研究-初创团队AI工具链",
    "title": "AI时代组织效率研究：初创团队AI工具链",
    "summary": "•决策速度提升过去需要200人团队的数据支撑",
    "content_type": "html",
    "content": "articles/AI时代组织效率研究-初创团队AI工具链.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代组织效率研究-初创团队AI工具链",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-当协作跨越时区-一个远程团队的重生故事",
    "title": "当协作跨越时区：一个远程团队的重生故事",
    "summary": "•2024年，全球远程办公普及率超过40%（麦肯锡）",
    "content_type": "html",
    "content": "articles/当协作跨越时区-一个远程团队的重生故事.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-当协作跨越时区-一个远程团队的重生故事",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-导师制的演化-AI时代-人还能教人什么",
    "title": "导师制的演化：AI时代，人还能教人什么",
    "summary": "导师制的演化：AI时代，人还能教人什么",
    "content_type": "html",
    "content": "articles/导师制的演化-AI时代-人还能教人什么.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-导师制的演化-AI时代-人还能教人什么",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-training-need-survey-gone",
    "title": "传统员工培训需求调研的终结——AI不再\"问你想学什么\"，而是\"告诉你要学什么\"",
    "summary": "每年Q4，HR都会发一份邮件。标题通常是：\"2026年培训需求调研，诚邀您的参与\"。",
    "content_type": "html",
    "content": "articles/eliminated/training-need-survey-gone.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-training-need-survey-gone",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-annual-performance-review-gone",
    "title": "年度绩效面谈正在消失——AI让反馈变得即时而非仪式",
    "summary": "去年年底，一个做HR的朋友约我吃饭。吃到一半，他叹了口气说：\"我刚做完今年的绩效面谈。\"",
    "content_type": "html",
    "content": "articles/eliminated/annual-performance-review-gone.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-annual-performance-review-gone",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-AI让部门墙变成透明玻璃-信息不对称终结",
    "title": "AI让\"部门墙\"变成\"透明玻璃\"——信息不对称终结",
    "summary": "分类：eliminated（消失类）| 标签：部门墙、信息透明、组织协同",
    "content_type": "html",
    "content": "articles/eliminated/AI让部门墙变成透明玻璃-信息不对称终结.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-AI让部门墙变成透明玻璃-信息不对称终结",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-360-degree-obsolescence",
    "title": "年度360度评估的消亡——AI让评估变得即时和持续",
    "summary": "每年年底，HR最忙的时候。发问卷、催提交、做汇总、写报告——一场360度评估下来，少则两周，多则一个月。",
    "content_type": "html",
    "content": "articles/eliminated/360-degree-obsolescence.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-360-degree-obsolescence",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-AI让汇报变成对话-从单向汇报到双向诊断",
    "title": "AI让\"汇报\"变成\"对话\"——从单向汇报到双向诊断",
    "summary": "分类：eliminated（消失类）| 标签：汇报制度、管理变革、AI对话",
    "content_type": "html",
    "content": "articles/eliminated/AI让汇报变成对话-从单向汇报到双向诊断.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-AI让汇报变成对话-从单向汇报到双向诊断",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "eliminated-ai-copywriting-exit",
    "title": "低端文案外包终结——AI能写出转化率更高的标题吗",
    "summary": "一个朋友做文案外包公司做了八年，今年把团队从40人裁到了8人。我问他剩下的8个人在干嘛。他说：「改AI稿。」",
    "content_type": "html",
    "content": "articles/eliminated/ai-copywriting-exit.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-copywriting-exit",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai发现团队中的隐形工作量",
    "title": "用AI发现团队中的隐形工作量",
    "summary": "•每天37条跨界咨询、11个无关会议、62%的任务是接手烂摊子——AI正在揭示那些不在KPI里却压垮团队的工作",
    "content_type": "html",
    "content": "articles/stable/用ai发现团队中的隐形工作量.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai发现团队中的隐形工作量",
    "created_at": "2026-06-01",
    "updated_at": "2026-06-22"
  },
  {
    "id": "stable-用ai抓摸鱼-反而会让努力的人离开",
    "title": "用AI抓摸鱼，反而会让努力的人离开？",
    "summary": "很多老板都在想一个问题：员工有没有在摸鱼？",
    "content_type": "html",
    "content": "articles/stable/用ai抓摸鱼-反而会让努力的人离开.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai抓摸鱼-反而会让努力的人离开",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-绩效申诉让ai来裁-公平吗",
    "title": "绩效申诉让AI来裁，公平吗？",
    "summary": "你有没有遇到过这种情况：年终绩效被打了个C，找主管申诉，主管说“这是系统评的，我也没法改”。你心里一万个问号——一台服务器，凭什么决定我的命运？",
    "content_type": "html",
    "content": "articles/stable/绩效申诉让ai来裁-公平吗.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-绩效申诉让ai来裁-公平吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-候选人体验-ai的个性化关怀",
    "title": "候选人体验：AI的个性化关怀",
    "summary": "摘要： 在数字化转型的浪潮中，人工智能正在深刻重塑招聘行业的格局。本文聚焦于AI如何为候选人提供个性化关怀，深入探讨智能匹配、沟通自动化、体验优化等维度，...",
    "content_type": "html",
    "content": "articles/stable/候选人体验-ai的个性化关怀.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-候选人体验-ai的个性化关怀",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-ai规模化落地为什么缺的不是技术而是组织学习",
    "title": "【情报解读】AI规模化落地为什么缺的不是技术而是组织学习",
    "summary": "情报来源: McKinsey \"Rewiring for AI: From ambition to advantage\" (2026-05-07)",
    "content_type": "html",
    "content": "articles/stable/情报解读-ai规模化落地为什么缺的不是技术而是组织学习.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-ai规模化落地为什么缺的不是技术而是组织学习",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-远程团队的ai协作新模式",
    "title": "远程团队的AI协作新模式",
    "summary": "你有没有遇到过这种情况：远程团队开会，一个人在说，另一个人在打字回复消息，剩下的十几个人全程沉默——会议结束了，什么结论都没有，下次开会还是同一批问题。",
    "content_type": "html",
    "content": "articles/stable/远程团队的ai协作新模式.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-远程团队的ai协作新模式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai时代需要什么新技能",
    "title": "AI时代需要什么新技能",
    "summary": "随着人工智能技术在工作场所的快速渗透，职场技能需求正在经历结构性重塑。麦肯锡在2026年4月发布的报告《人类与AI劳动力的崛起》指出，企业若继续依赖传统技...",
    "content_type": "html",
    "content": "articles/stable/ai时代需要什么新技能.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai时代需要什么新技能",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计",
    "title": "【情报解读】企业AI规模化落地的三大支柱：信任、治理与工作流设计",
    "summary": "情报来源: OpenAI \"How enterprises are scaling AI\" (2026-05-11)",
    "content_type": "html",
    "content": "articles/stable/情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-员工关怀-ai新方式从标准化服务到个性化温暖的跨越",
    "title": "员工关怀：AI新方式——从标准化服务到个性化温暖的跨越",
    "summary": "你有没有这种感觉：公司的员工关怀永远停留在过节发礼品、年度体检、团建聚餐这\"老三样\"；HR每天忙得团团转，员工却依然觉得缺乏归属感；明明福利预算年年涨，满...",
    "content_type": "html",
    "content": "articles/stable/员工关怀-ai新方式从标准化服务到个性化温暖的跨越.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-员工关怀-ai新方式从标准化服务到个性化温暖的跨越",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-虚拟助理入驻团队-ai时代的协作新范式",
    "title": "虚拟助理入驻团队：AI时代的协作新范式",
    "summary": "当AI不再只是工具，而是以\"同事\"身份加入协作网络，团队的工作模式正在被重新定义。麦肯锡在2025年的研究报告中提出\"超级代理\"（Superagency）...",
    "content_type": "html",
    "content": "articles/stable/虚拟助理入驻团队-ai时代的协作新范式.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-虚拟助理入驻团队-ai时代的协作新范式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-前沿企业如何靠ai建立持久竞争优势",
    "title": "【情报解读】前沿企业如何靠AI建立持久竞争优势",
    "summary": "情报来源：OpenAI \"How frontier enterprises are building an AI advantage\" (2026-05-06)",
    "content_type": "html",
    "content": "articles/stable/情报解读-前沿企业如何靠ai建立持久竞争优势.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-前沿企业如何靠ai建立持久竞争优势",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai打破部门墙",
    "title": "用AI打破部门墙",
    "summary": "你有没有遇到过这种情况：公司推一个跨部门项目，先花了两个月开会协调各部门的时间，又花了一个月让各方理解彼此的工作语言，好不容易开始合作了，发现各自的数据口...",
    "content_type": "html",
    "content": "articles/stable/用ai打破部门墙.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai打破部门墙",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai时代的组织认同感-当我们成为-被算法定义的人",
    "title": "AI时代的组织认同感：当我们成为\"被算法定义的人\"",
    "summary": "你有多久没有认真回答过\"我是谁\"这个问题了？",
    "content_type": "html",
    "content": "articles/stable/ai时代的组织认同感-当我们成为-被算法定义的人.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai时代的组织认同感-当我们成为-被算法定义的人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-持续学习-ai的推动作用",
    "title": "持续学习：AI的推动作用",
    "summary": "在这个信息爆炸的时代，知识更新的速度远超以往任何时期。一个几年前还被认为是前沿的技术，今天可能已经成为入门基础。这种环境下，\"持续学习\"不再是一种选择，而...",
    "content_type": "html",
    "content": "articles/stable/持续学习-ai的推动作用.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-持续学习-ai的推动作用",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai知识库的建设与运营-企业智能化转型的基础设施",
    "title": "AI知识库的建设与运营：企业智能化转型的基础设施",
    "summary": "最近和几位HR负责人聊天，大家不约而同提到一个痛点：公司积累了大量培训资料、业务文档、经验案例，但需要用的时候总是找不到，找到了也不敢直接用，因为不知道是...",
    "content_type": "html",
    "content": "articles/stable/ai知识库的建设与运营-企业智能化转型的基础设施.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai知识库的建设与运营-企业智能化转型的基础设施",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做员工满意度调研-让真实的声音不再被淹没",
    "title": "用AI做员工满意度调研：让真实的声音不再被淹没",
    "summary": "传统的员工满意度调研，总是逃不出那几个熟悉的场景：年底发一份问卷，回收率勉强过半，员工在\"满意\"到\"非常满意\"之间打勾，HR整理数据写成报告，管理层看两眼...",
    "content_type": "html",
    "content": "articles/stable/用ai做员工满意度调研-让真实的声音不再被淹没.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做员工满意度调研-让真实的声音不再被淹没",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-招聘流程ai监控与优化",
    "title": "招聘流程AI监控与优化",
    "summary": "在数字化转型的浪潮中，企业招聘正在经历前所未有的变革。传统的人工筛选简历、电话沟通协调、线下面试安排等环节不仅耗时费力，还容易因人为因素导致标准不一、效率...",
    "content_type": "html",
    "content": "articles/stable/招聘流程ai监控与优化.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-招聘流程ai监控与优化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做学习路径规划-让每位员工的成长都有迹可循",
    "title": "用AI做学习路径规划：让每位员工的成长都有迹可循",
    "summary": "传统的企业培训往往是“课程堆砌”——员工被安排参加一堆看似相关却缺乏逻辑串联的培训项目，学完后依然不清楚自己到底需要补什么、向什么方向发展。学习路径的设计...",
    "content_type": "html",
    "content": "articles/stable/用ai做学习路径规划-让每位员工的成长都有迹可循.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做学习路径规划-让每位员工的成长都有迹可循",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-protect-old-employee",
    "title": "那个拒绝用AI的\"老员工\"，才是团队最该保护的人",
    "summary": "最近跟一个创业的朋友吃饭，他一脸无奈地说了一件事。",
    "content_type": "html",
    "content": "articles/stable/protect-old-employee.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-protect-old-employee",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-文化落地-ai帮忙监督",
    "title": "文化落地：AI帮忙监督",
    "summary": "你有没有遇到过这种情况：公司的价值观海报贴满了走廊，但员工在走廊里打电话的方式，和海报上的价值观完全不符；领导在台上讲\"客户第一\"，但客户投诉处理流程却需...",
    "content_type": "html",
    "content": "articles/stable/文化落地-ai帮忙监督.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-文化落地-ai帮忙监督",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai绩效教练-私人定制成长方案",
    "title": "AI绩效教练：私人定制成长方案",
    "summary": "核心观点：绩效面谈是\"事后补救\"，真正的成长需要\"每日教练\"。AI让每个员工都拥有一位24小时在线的私教——而且，这位私教从不敷衍。",
    "content_type": "html",
    "content": "articles/stable/ai绩效教练-私人定制成长方案.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai绩效教练-私人定制成长方案",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-团队沟通-ai分析情绪",
    "title": "团队沟通：AI分析情绪",
    "summary": "在现代团队协作中，沟通不仅仅是信息的传递，更是情感的交流。AI情绪分析技术正在革新我们理解和管理团队沟通的方式。",
    "content_type": "html",
    "content": "articles/stable/团队沟通-ai分析情绪.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-团队沟通-ai分析情绪",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-新员工入职-ai导师时代",
    "title": "新员工入职：AI导师时代",
    "summary": "你有没有遇到过这种情况：入职第一天，工牌还没捂热，就被拉进一个群，丢过来十几份文档，然后老员工扔下一句\"先看着，有问题再问\"——然后你发现，没人真的有时间...",
    "content_type": "html",
    "content": "articles/stable/新员工入职-ai导师时代.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-新员工入职-ai导师时代",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-AI时代心理安全感-为什么敢于说真话比以往更重要",
    "title": "AI时代\"心理安全感\"——为什么敢于说真话比以往任何时候都重要",
    "summary": "分类：stable（不变类）| 标签：心理安全感、组织文化、AI管理",
    "content_type": "html",
    "content": "articles/stable/AI时代心理安全感-为什么敢于说真话比以往更重要.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-AI时代心理安全感-为什么敢于说真话比以往更重要",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-mckinsey-为什么说-超级代理-将重塑工作场所",
    "title": "【情报解读】McKinsey：为什么说\"超级代理\"将重塑工作场所",
    "summary": "McKinsey发布的最新报告显示，全球绝大多数企业都在投资AI，但仅有1%的企业认为自己的AI应用达到成熟度。更有趣的发现是：员工对AI的接受度和准备度...",
    "content_type": "html",
    "content": "articles/stable/情报解读-mckinsey-为什么说-超级代理-将重塑工作场所.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-mckinsey-为什么说-超级代理-将重塑工作场所",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-ai时代-人类员工需要什么新技能",
    "title": "【情报解读】AI时代：人类员工需要什么新技能",
    "summary": "McKinsey最新研究显示，AI目前已能承担美国超过一半的工作时长。这一数据来自麦肯锡组织与人才绩效团队2026年4月30日发布的报告《The rise...",
    "content_type": "html",
    "content": "articles/stable/情报解读-ai时代-人类员工需要什么新技能.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-ai时代-人类员工需要什么新技能",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai入职培训的定制化可能",
    "title": "AI入职培训的定制化可能",
    "summary": "你有没有见过这种场景：新员工入职第一天，领到一本厚厚的员工手册，看完不知所云；参加三天的集中培训，内容全是通用技能，和自己实际要做的工作关系不大；一个月后...",
    "content_type": "html",
    "content": "articles/stable/ai入职培训的定制化可能.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai入职培训的定制化可能",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai打分比人工更公正-别闹了",
    "title": "AI打分比人工更公正？别闹了",
    "summary": "最近一家互联网大厂出了个事。年终绩效评定，公司全面启用AI评估系统，给每个员工打分。系统运行三个月后，研发团队整体评分普遍低于销售团队。技术总监不干了：“...",
    "content_type": "html",
    "content": "articles/stable/ai打分比人工更公正-别闹了.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai打分比人工更公正-别闹了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-老师傅的经验-ai比你先学会",
    "title": "老师傅的经验，AI比你先学会",
    "summary": "很多企业最值钱的东西，从来不在系统里，而是在老师的脑子里。",
    "content_type": "html",
    "content": "articles/stable/老师傅的经验-ai比你先学会.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-老师傅的经验-ai比你先学会",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-价值观传播-ai的方式",
    "title": "价值观传播：AI的方式",
    "summary": "你有没有遇到过这种情况：公司的价值观写在墙上、印在手册里、挂在年会上，但员工在日常工作中感受到的，却是另一套逻辑——口号是\"客户第一\"，但内部考核只看短期...",
    "content_type": "html",
    "content": "articles/stable/价值观传播-ai的方式.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-价值观传播-ai的方式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-AI辅助下的非正式沟通-当走廊相遇变成数据匹配",
    "title": "AI辅助下的\"非正式沟通\"——当走廊相遇变成数据匹配",
    "summary": "分类：stable（不变类）| 标签：非正式沟通、组织协作、AI辅助",
    "content_type": "html",
    "content": "articles/stable/AI辅助下的非正式沟通-当走廊相遇变成数据匹配.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-AI辅助下的非正式沟通-当走廊相遇变成数据匹配",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-ai重塑欧洲职场-技能转型比岗位替代更紧迫",
    "title": "【情报解读】AI重塑欧洲职场：技能转型比岗位替代更紧迫",
    "summary": "来源: McKinsey Featured Insights",
    "content_type": "html",
    "content": "articles/stable/情报解读-ai重塑欧洲职场-技能转型比岗位替代更紧迫.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-ai重塑欧洲职场-技能转型比岗位替代更紧迫",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做雇主品牌传播-让人才主动找上门",
    "title": "用AI做雇主品牌传播：让人才主动找上门",
    "summary": "在人才争夺战日益白热化的今天，雇主品牌已从“加分项”变成“必选项”。领英调研数据显示，75%的候选人会在了解公司雇主品牌后再决定是否投递简历，而品牌优秀的...",
    "content_type": "html",
    "content": "articles/stable/用ai做雇主品牌传播-让人才主动找上门.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做雇主品牌传播-让人才主动找上门",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-你的绩效报表已经够好看了-为什么ai还要多此一举",
    "title": "你的绩效报表已经够好看了，为什么AI还要多此一举？",
    "summary": "每年做绩效数据可视化，图表越来越漂亮，颜色越来越丰富，报表越来越精致。老板看了点头，员工看了无感。数据还是那个数据，只是换了个更好看的包装。",
    "content_type": "html",
    "content": "articles/stable/你的绩效报表已经够好看了-为什么ai还要多此一举.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-你的绩效报表已经够好看了-为什么ai还要多此一举",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai培训-个性化时代来了",
    "title": "AI培训：个性化时代来了",
    "summary": "传统的员工培训往往是“一刀切”——几十人、上百人坐在同一间教室里，听同样的课程，做同样的练习。然而，这种模式正在被AI技术彻底颠覆。AI驱动的个性化培训正...",
    "content_type": "html",
    "content": "articles/stable/ai培训-个性化时代来了.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai培训-个性化时代来了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-anti-empowerment",
    "title": "老板说要\"赋能\"，实际在\"卸能\"——你每天都在做的五件反激励事",
    "summary": "这句话我几乎每周都从老板嘴里听到。但往下执行的时候，大部分所谓的\"赋能\"，其实是卸能。",
    "content_type": "html",
    "content": "articles/stable/anti-empowerment.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-anti-empowerment",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "title": "培训预算年年涨，员工却抱怨\"学不到东西\"？是时候用AI重新定义岗位培训了",
    "summary": "AI诊断→动态路径→即时反馈→数据闭环。每年培训预算涨，员工却说'学不到东西'——不是钱花少了，是太'通用'了。AI让定制化培训从奢侈品变成每个HR都能落地的标配。",
    "content_type": "html",
    "content": "articles/stable/培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-98-考勤管理ai新方式",
    "title": "AI如何重新定义考勤管理——从'打卡机器'到'组织效率引擎'",
    "summary": "考勤管理的终点不是'管住人'，而是'释放人'。从TELUS每次节约40分钟的智能核算，到制造和零售行业的AI排班实践，再到德勤客户200+小时的月度节省——AI正在重写考勤的规则，从根上换了一套逻辑。",
    "content_type": "html",
    "content": "articles/stable/98-考勤管理ai新方式.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-98-考勤管理ai新方式",
    "created_at": "2026-06-01",
    "updated_at": "2026-06-22"
  },
  {
    "id": "stable-情报解读-openai与pwc合作-cfo办公室的ai变革",
    "title": "【情报解读】OpenAI与PwC合作：CFO办公室的AI变革",
    "summary": "OpenAI与普华永道于2026年5月4日宣布战略合作，共同开发面向CFO办公室的AI代理解决方案。这一合作标志着企业AI应用从边缘业务向核心管理职能的深...",
    "content_type": "html",
    "content": "articles/stable/情报解读-openai与pwc合作-cfo办公室的ai变革.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-openai与pwc合作-cfo办公室的ai变革",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai做的绩效面谈-员工真的能接受吗",
    "title": "AI做的绩效面谈，员工真的能接受吗？",
    "summary": "你有没有想过，有一天帮你做绩效面谈的，可能不是人？",
    "content_type": "html",
    "content": "articles/stable/ai做的绩效面谈-员工真的能接受吗.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai做的绩效面谈-员工真的能接受吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜",
    "title": "培训砸了几十万，怎么知道有没有用？AI让效果追踪不再靠猜",
    "summary": "做过培训的人都有这样的困惑：钱花了，课上了，学员也反馈\"挺好的\"——可回到岗位上，该不会的还是不会，绩效该提不上去还是提不上去。培训到底有没有用？没人说得清。",
    "content_type": "html",
    "content": "articles/stable/培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-游戏化学习-ai的新玩法",
    "title": "游戏化学习：AI的新玩法",
    "summary": "你上一次认真学习新技能是什么时候？翻开书看了两页，刷了十分钟手机，然后……就没有然后了。",
    "content_type": "html",
    "content": "articles/stable/游戏化学习-ai的新玩法.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-游戏化学习-ai的新玩法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学",
    "title": "培训砸了几十万，员工还是不会？AI让学习效果评估从\"玄学\"变\"科学\"",
    "summary": "每到年底做培训总结时，HR和林林总总的业务部门负责人都会面对同一个灵魂拷问：花了这么多钱和时间，员工到底学会了什么？",
    "content_type": "html",
    "content": "articles/stable/培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-还在让员工-看着学-ai实战演练让能力真正长在身上",
    "title": "还在让员工\\\"看着学\\\"？AI实战演练让能力真正长在身上",
    "summary": "培训做过无数遍，考核分数也不低，可一上真实战场就露怯——这是让无数HR和管理者头疼的顽疾。",
    "content_type": "html",
    "content": "articles/stable/还在让员工-看着学-ai实战演练让能力真正长在身上.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-还在让员工-看着学-ai实战演练让能力真正长在身上",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai时代的企业文化重塑-不是引入工具-而是重写规则",
    "title": "AI时代的企业文化重塑：不是引入工具，而是重写规则",
    "summary": "你有没有这种感觉：公司上了AI系统，员工却依然用老办法干活；花大价钱买了智能工具，大家却觉得是负担；试点项目明明很成功，推广时却处处碰壁。",
    "content_type": "html",
    "content": "articles/stable/ai时代的企业文化重塑-不是引入工具-而是重写规则.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai时代的企业文化重塑-不是引入工具-而是重写规则",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-还在用轮岗培养管理者-ai模拟管理场景才是新解法",
    "title": "还在用“轮岗”培养管理者？AI模拟管理场景才是新解法",
    "summary": "传统路径是：送去上课，学点理论，然后“在工作中成长”。可现实是，真正的管理能力——如何处理团队冲突、如何做艰难的绩效面谈、如何在资源有限时做决策——这些靠...",
    "content_type": "html",
    "content": "articles/stable/还在用轮岗培养管理者-ai模拟管理场景才是新解法.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-还在用轮岗培养管理者-ai模拟管理场景才是新解法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做技能差距分析",
    "title": "用AI做技能差距分析",
    "summary": "在人力资源管理和组织发展的工作中，技能差距分析是识别团队能力短板、制定培训计划的关键环节。传统方式依赖问卷、访谈和人工评估，不仅耗时耗力，还容易因主观判断...",
    "content_type": "html",
    "content": "articles/stable/用ai做技能差距分析.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做技能差距分析",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-导师制被ai重新定义",
    "title": "导师制被AI重新定义",
    "summary": "传统企业中，导师制往往依赖资深员工的时间与经验，存在匹配效率低、覆盖范围有限等问题。麦肯锡2026年发布的研究报告指出，AI正在从根本上重构导师制的运作模...",
    "content_type": "html",
    "content": "articles/stable/导师制被ai重新定义.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-导师制被ai重新定义",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-绩效体系被ai重构之后-为什么员工反而更焦虑了",
    "title": "绩效体系被AI重构之后，为什么员工反而更焦虑了？",
    "summary": "一家互联网公司的HR总监兴奋地向CEO汇报：“我们上线了全新的AI绩效系统！从目标设定到过程追踪，再到最终评估，全部自动化。员工每天的行为数据都会被实时采...",
    "content_type": "html",
    "content": "articles/stable/绩效体系被ai重构之后-为什么员工反而更焦虑了.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-绩效体系被ai重构之后-为什么员工反而更焦虑了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai危机预警系统-企业智能风险管理的核心基础设施",
    "title": "AI危机预警系统：企业智能风险管理的核心基础设施",
    "summary": "在当今快速变化的商业环境中，企业面临的危机类型日益复杂多样。从供应链中断、金融市场波动，到舆情危机与合规风险，传统的事后响应模式已难以满足企业稳健运营的需...",
    "content_type": "html",
    "content": "articles/stable/ai危机预警系统-企业智能风险管理的核心基础设施.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai危机预警系统-企业智能风险管理的核心基础设施",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-内部沟通-ai新模式",
    "title": "内部沟通：AI新模式",
    "summary": "你是否有过这样的体验：公司发布了一条重要通知，你是在三天后才从茶水间的闲聊中得知的？部门之间隔着一堵看不见的墙，明明可以协作的项目，因为信息不对称而各自为...",
    "content_type": "html",
    "content": "articles/stable/内部沟通-ai新模式.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-内部沟通-ai新模式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai做的绩效分析更准确-为什么员工反而更不满意",
    "title": "AI做的绩效分析更准确，为什么员工反而更不满意？",
    "summary": "公司花了几十万买了AI绩效分析系统，数据更全面了，打分更客观了，报告更详细了。结果呢？员工满意度反而下降了。",
    "content_type": "html",
    "content": "articles/stable/ai做的绩效分析更准确-为什么员工反而更不满意.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai做的绩效分析更准确-为什么员工反而更不满意",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做文化一致性检查",
    "title": "用AI做文化一致性检查",
    "summary": "你有没有见过这种场景：公司的价值观写得漂漂亮亮——\"诚信正直\"、\"客户至上\"、\"追求卓越\"，但走进日常业务，扑面而来的却是另一番景象——为了签单可以隐瞒产...",
    "content_type": "html",
    "content": "articles/stable/用ai做文化一致性检查.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做文化一致性检查",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-团队知识库-ai让经验传承",
    "title": "团队知识库：AI让经验传承",
    "summary": "每个团队都有这样的隐痛：某位老员工离职，他脑子里积攒了三年的项目经验、踩过的坑、谈判的技巧，一夜之间全部带走。新人来了从头摸索，老员工走了从头再来——组织...",
    "content_type": "html",
    "content": "articles/stable/团队知识库-ai让经验传承.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-团队知识库-ai让经验传承",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做任务分配和优先级",
    "title": "用AI做任务分配和优先级",
    "summary": "在团队协作中，任务分配不合理、优先级混乱是导致效率低下的常见原因。AI技术的引入，正在彻底改变这一局面。",
    "content_type": "html",
    "content": "articles/stable/用ai做任务分配和优先级.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做任务分配和优先级",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭",
    "title": "【情报解读】麦肯锡警告：CEO的AI转型窗口期正在关闭",
    "summary": "情报来源: McKinsey \"The AI assembly line: Strategic imperatives for CEOs\" (2026-0...",
    "content_type": "html",
    "content": "articles/stable/情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-training-burnout",
    "title": "为什么你团队的人越学越不想学？我发现了\"培训倦怠\"的真相",
    "summary": "他说他部门一年组织了80多场培训。每人平均参加30场。但年底调研，员工满意度倒数第一。",
    "content_type": "html",
    "content": "articles/stable/training-burnout.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-training-burnout",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai驱动的异步协作-打破时区壁垒-重塑团队效率",
    "title": "AI驱动的异步协作：打破时区壁垒，重塑团队效率",
    "summary": "全球化与远程办公的普及让异步协作成为越来越多团队的标配。然而，跨时区、跨文化的协作往往伴随着沟通延迟、信息断层和协作效率低下等问题。AI技术的介入，正在为...",
    "content_type": "html",
    "content": "articles/stable/ai驱动的异步协作-打破时区壁垒-重塑团队效率.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai驱动的异步协作-打破时区壁垒-重塑团队效率",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-花了大价钱上ai-怎么知道亏没亏",
    "title": "花了大价钱上AI，怎么知道亏没亏？",
    "summary": "你是不是也这样：年初豪掷几百万上了AI系统，年末汇报时却拿不出数据证明它值回票价。",
    "content_type": "html",
    "content": "articles/stable/花了大价钱上ai-怎么知道亏没亏.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-花了大价钱上ai-怎么知道亏没亏",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了",
    "title": "【情报解读】欧洲AI投资悖论：钱没少花，回报去哪了？",
    "summary": "情报来源: McKinsey QuantumBlack, 2026-05-04",
    "content_type": "html",
    "content": "articles/stable/情报解读-欧洲ai投资悖论-钱没少花-回报去哪了.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做团队健康诊断-让协作问题无所遁形",
    "title": "用AI做团队健康诊断：让协作问题无所遁形",
    "summary": "在现代企业管理中，团队健康度直接影响组织效能。传统诊断依赖主观问卷与管理者经验，往往滞后于问题爆发。人工智能技术的介入，让实时、客观、可预测的团队健康诊断...",
    "content_type": "html",
    "content": "articles/stable/用ai做团队健康诊断-让协作问题无所遁形.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做团队健康诊断-让协作问题无所遁形",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-feedback-density",
    "title": "我研究了50个\"卷王\"团队，发现他们不是最努力的，是最会设计反馈的",
    "summary": "有的团队，员工天天加班到凌晨，但效率越来越低。有的团队，员工下午六点准时走，业绩反而稳如老狗。",
    "content_type": "html",
    "content": "articles/stable/feedback-density.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-feedback-density",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai发现文化问题-让组织隐患从视而不见到提前预警",
    "title": "用AI发现文化问题：让组织隐患从“视而不见”到“提前预警”",
    "summary": "你有没有遇到过这种情况：团队明明运转正常，但某个项目突然失败时，你才发现协作链条早就出了问题；企业文化手册写得漂漂亮亮，但员工离职时的面谈却揭示出完全不同...",
    "content_type": "html",
    "content": "articles/stable/用ai发现文化问题-让组织隐患从视而不见到提前预警.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai发现文化问题-让组织隐患从视而不见到提前预警",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见",
    "title": "用AI做文化感知分析：让组织氛围从\"凭感觉\"变成\"看得见\"",
    "summary": "你有没有遇到过这种情况：团队士气明明在下降，但绩效考核却一片祥和；跨部门协作越来越难，但每次调研都显示\"沟通良好\"；员工嘴上说满意，但离职率却悄悄攀升。",
    "content_type": "html",
    "content": "articles/stable/用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "stable-ai预测员工离职风险的深度思考",
    "title": "AI预测员工离职风险的深度思考",
    "summary": "你是否想过这样一个问题：为什么等到员工递交辞职信的那一刻，你才发现自己被“突袭”了？",
    "content_type": "html",
    "content": "articles/stable/ai预测员工离职风险的深度思考.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai预测员工离职风险的深度思考",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-org-memory-officer",
    "title": "AI组织记忆官——让组织的经验不随人走的新角色",
    "summary": "我有个朋友在一家200人的公司做CTO。去年公司最资深的架构师离职了。",
    "content_type": "html",
    "content": "articles/created/ai-org-memory-officer.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-org-memory-officer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-change-facilitator",
    "title": "AI组织变革引导师——让组织拥抱变化的新角色",
    "summary": "去年一个客户花了800万上了一套AI供应链系统。三个月后，使用率17%。",
    "content_type": "html",
    "content": "articles/created/ai-change-facilitator.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-change-facilitator",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-efficiency-auditor",
    "title": "AI组织效率审计师——专门帮公司发现\"人+AI协同漏洞\"的新角色",
    "summary": "企业引入AI后，人和AI之间的协同产生了大量\"灰色地带\"——AI做了但人不知道的、人以为AI做了其实没做的、人不敢反驳AI判断的。AI组织效率审计师就是专...",
    "content_type": "html",
    "content": "articles/created/ai-efficiency-auditor.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-efficiency-auditor",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-org-diagnostician-career",
    "title": "AI组织诊断师——用数据给公司做体检的新职业",
    "summary": "去年年底，一家200人的科技公司CTO给我打了一个电话。",
    "content_type": "html",
    "content": "articles/created/ai-org-diagnostician-career.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-org-diagnostician-career",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-narrative-designer",
    "title": "AI组织叙事设计师——把公司故事讲给AI听的人",
    "summary": "AI能读懂数据，但读不懂\"为什么要做这件事\"。AI组织叙事设计师的工作，是把公司的使命、愿景、价值观、文化，翻译成AI能理解的语言，让AI做出的决策符合组...",
    "content_type": "html",
    "content": "articles/created/ai-narrative-designer.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-narrative-designer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-conflict-mediator",
    "title": "AI冲突调解员——用算法化解人际冲突",
    "summary": "一个HRD跟我说了件让她头疼的事：公司两个核心部门的负责人因为资源分配问题闹了半年。她试过各种办法——一对一谈话、组织团建、请外部教练——都没用。",
    "content_type": "html",
    "content": "articles/created/ai-conflict-mediator.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-conflict-mediator",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-conversation-designer",
    "title": "AI对话设计师——一个正在兴起的新职业",
    "summary": "你的AI助手说话好不好听，不是程序员决定的，是\"对话设计师\"决定的。这个2023年才冒头的新职业，正成为每家公司AI团队里最抢手的角色——年薪50-150...",
    "content_type": "html",
    "content": "articles/created/ai-conversation-designer.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-conversation-designer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-learning-designer",
    "title": "AI学习体验设计师——让学习像游戏一样上瘾",
    "summary": "我做过一个测试。让两组员工学同一套合规课程：A组用传统PPT+考试，B组用AI驱动的游戏化学习系统。",
    "content_type": "html",
    "content": "articles/created/ai-learning-designer.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-learning-designer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-training-coach",
    "title": "AI培训教练——帮员工学会\"用AI思考\"的人",
    "summary": "去年我给一家500强企业做培训，HR总监跟我说了一句话，我现在还记得。",
    "content_type": "html",
    "content": "articles/created/ai-training-coach.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-training-coach",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-reskilling-coach",
    "title": "AI再技能教练：帮员工找到AI时代的新位置",
    "summary": "岗位消失的速度快过员工再学习的速度。AI再技能教练不是培训师，而是职业转型导航员——用AI分析每个人的技能缺口和行业趋势，帮他们回答那个最焦虑的问题：\"下...",
    "content_type": "html",
    "content": "articles/created/ai-reskilling-coach.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-reskilling-coach",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-employee-experience-designer",
    "title": "AI员工体验设计师——让人在机器的效率世界里，还能好好工作",
    "summary": "AI把效率推到极致，工作越来越像\"系统操作\"。AI员工体验设计师就是那个保证人在系统里不会变成机器的人——设计工作流程、优化人机交互、保护人的主观体验。",
    "content_type": "html",
    "content": "articles/created/ai-employee-experience-designer.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-employee-experience-designer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-ethics-officer-new-career",
    "title": "AI伦理官：一个新职业的诞生",
    "summary": "\"你有没有想过，如果AI做了一个伤害用户的决定，谁来负责？\"",
    "content_type": "html",
    "content": "articles/created/created-ai-ethics-officer-new-career.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-ethics-officer-new-career",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-culture-translator",
    "title": "AI文化翻译官：在算法逻辑和人的价值观之间架一座桥",
    "summary": "她的名片上印着一个我从未见过的头衔：\"AI文化翻译官\"。",
    "content_type": "html",
    "content": "articles/created/ai-culture-translator.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-culture-translator",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-gamified-performance-tracking",
    "title": "游戏化绩效追踪系统：让员工主动看数据 - 0-1.team",
    "summary": "上个月去一家做跨境电商的公司做调研，HR主管李总打开后台给我看：\"你看，我们花了28万上的绩效系统，员工登录率只有12%。\"",
    "content_type": "html",
    "content": "articles/created/gamified-performance-tracking.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-gamified-performance-tracking",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-gamified-knowledge-extraction",
    "title": "游戏化知识萃取：把老员工的脑子\"榨干\" - 0-1.team",
    "summary": "上周三，我在一家制造企业做访谈。车间老师傅老陈，干了28年，手上有7个技术诀窍，全公司就他能搞定那个老设备的精度问题。",
    "content_type": "html",
    "content": "articles/created/gamified-knowledge-extraction.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-gamified-knowledge-extraction",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "created-ai-org-anthropologist",
    "title": "AI组织人类学家：翻译AI行为让人懂的新职业",
    "summary": "AI在组织中的行为模式像一个\"异域文化\"——它的逻辑和人类完全不同。AI组织人类学家不是技术专家，也不是HR，他们是研究AI在组织中行为模式，并把人机协作...",
    "content_type": "html",
    "content": "articles/created/ai-org-anthropologist.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-org-anthropologist",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-trust-deficit",
    "title": "别让你的\"AI效率\"变成团队的\"信任赤字\"",
    "summary": "我们公司内部测了一组AI工具，用了三个月。效率提升了30%，但员工之间的主动协作下降了18%。",
    "content_type": "html",
    "content": "articles/disrupted/ai-trust-deficit.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-deficit",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-31-ai-salary-fairness-human",
    "title": "AI能算出最佳薪酬方案，但员工说：我想要个人来谈 — 老邓游戏化",
    "summary": "陈岩在一家互联网公司做产品总监，去年绩效优异。调薪季到了，财务系统给他算出了一个数字——涨幅15%，理由是：同岗位市场P75分位，比他现在的薪酬高出18%...",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-31-ai-salary-fairness-human.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-31-ai-salary-fairness-human",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-06-08-ai-performance-review-collapse",
    "title": "AI比我干得好，为什么我反而被扣分？——绩效考核正在崩塌",
    "summary": "上周一个学员在群里发了一条消息，被所有人顶上去了。",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-review.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-06-08-ai-performance-review-collapse",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai发现团队中的隐形工作量",
    "title": "用AI发现团队中的隐形工作量",
    "summary": "在团队管理中，有一类工作始终难以被看见——它不体现在任务列表里，不记录在工时系统中，却真实消耗着成员的精力与时间。心理学家将这种现象称为\"隐形工作负荷\"。...",
    "content_type": "html",
    "content": "articles/disrupted/用ai发现团队中的隐形工作量.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai发现团队中的隐形工作量",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-战略规划-ai的辅助角色",
    "title": "战略规划：AI的辅助角色",
    "summary": "情报来源：McKinsey《Where AI will create value—and where it won't》(2026-04-29)",
    "content_type": "html",
    "content": "articles/disrupted/战略规划-ai的辅助角色.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-战略规划-ai的辅助角色",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai抓摸鱼-反而会让努力的人离开",
    "title": "用AI抓摸鱼，反而会让努力的人离开？",
    "summary": "很多老板都在想一个问题：员工有没有在摸鱼？",
    "content_type": "html",
    "content": "articles/disrupted/用ai抓摸鱼-反而会让努力的人离开.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai抓摸鱼-反而会让努力的人离开",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-绩效申诉让ai来裁-公平吗",
    "title": "绩效申诉让AI来裁，公平吗？",
    "summary": "你有没有遇到过这种情况：年终绩效被打了个C，找主管申诉，主管说“这是系统评的，我也没法改”。你心里一万个问号——一台服务器，凭什么决定我的命运？",
    "content_type": "html",
    "content": "articles/disrupted/绩效申诉让ai来裁-公平吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-绩效申诉让ai来裁-公平吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-health-diagnosis-blind-spot",
    "title": "AI组织健康诊断——数据全面，但忘了问\"你还好吗\"",
    "summary": "AI能监测组织的每一个指标：离职率、效率、协作频率、邮件响应速度……但它监测不了\"心\"。当组织健康变成数据游戏，真正的问题反而被掩盖了。",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-health-diagnosis-blind-spot.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-health-diagnosis-blind-spot",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-候选人体验-ai的个性化关怀",
    "title": "候选人体验：AI的个性化关怀",
    "summary": "摘要： 在数字化转型的浪潮中，人工智能正在深刻重塑招聘行业的格局。本文聚焦于AI如何为候选人提供个性化关怀，深入探讨智能匹配、沟通自动化、体验优化等维度，...",
    "content_type": "html",
    "content": "articles/disrupted/候选人体验-ai的个性化关怀.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-候选人体验-ai的个性化关怀",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-远程团队的ai协作新模式",
    "title": "远程团队的AI协作新模式",
    "summary": "你有没有遇到过这种情况：远程团队开会，一个人在说，另一个人在打字回复消息，剩下的十几个人全程沉默——会议结束了，什么结论都没有，下次开会还是同一批问题。",
    "content_type": "html",
    "content": "articles/disrupted/远程团队的ai协作新模式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-远程团队的ai协作新模式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-06-08-ai-scapegoat",
    "title": "员工把AI当\"甩锅工具\"——当AI做了决策，谁为结果负责？",
    "summary": "上周我参加一个企业的复盘会，听到一段让人哭笑不得的对话。",
    "content_type": "html",
    "content": "articles/disrupted/2026-06-08-ai-scapegoat.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-06-08-ai-scapegoat",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-chart-dies",
    "title": "组织架构图已死：AI让汇报关系实时变化",
    "summary": "传统组织架构图半年更新一次，AI驱动的工作分配让汇报关系每周都在变。不是架构没了，是架构从\"静态地图\"变成了\"动态导航\"。",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-chart-dies.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-chart-dies",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai时代需要什么新技能",
    "title": "AI时代需要什么新技能",
    "summary": "随着人工智能技术在工作场所的快速渗透，职场技能需求正在经历结构性重塑。麦肯锡在2026年4月发布的报告《人类与AI劳动力的崛起》指出，企业若继续依赖传统技...",
    "content_type": "html",
    "content": "articles/disrupted/ai时代需要什么新技能.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai时代需要什么新技能",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计",
    "title": "【情报解读】企业AI规模化落地的三大支柱：信任、治理与工作流设计",
    "summary": "情报来源: OpenAI \"How enterprises are scaling AI\" (2026-05-11)",
    "content_type": "html",
    "content": "articles/disrupted/情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-情报解读-企业ai规模化落地的三大支柱-信任-治理与工作流设计",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-30-resign-prediction-ethics",
    "title": "当AI能预测员工离职，要不要告诉他真相？ — 老邓游戏化",
    "summary": "李明的AI系统在周一早上弹出一条预警：「员工张伟，离职概率87.3%，剩余在岗时间约42天」。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-30-resign-prediction-ethics.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-30-resign-prediction-ethics",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-kpi-performance-management",
    "title": "算法驱动的绩效管理：当KPI由AI设定",
    "summary": "主管话没说完，小王已经打开了手机上一个App。",
    "content_type": "html",
    "content": "articles/disrupted/ai-kpi-performance-management.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-kpi-performance-management",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-虚拟助理入驻团队-ai时代的协作新范式",
    "title": "虚拟助理入驻团队：AI时代的协作新范式",
    "summary": "当AI不再只是工具，而是以\"同事\"身份加入协作网络，团队的工作模式正在被重新定义。麦肯锡在2025年的研究报告中提出\"超级代理\"（Superagency）...",
    "content_type": "html",
    "content": "articles/disrupted/虚拟助理入驻团队-ai时代的协作新范式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-虚拟助理入驻团队-ai时代的协作新范式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai会议纪要之后的协作变化",
    "title": "AI会议纪要之后的协作变化",
    "summary": "AI会议纪要工具的普及，正在深刻改变团队协作的方式。传统会议结束后，信息往往停留在参会者的记忆中，难以高效传递。而AI生成的会议纪要让所有人都能快速获取一...",
    "content_type": "html",
    "content": "articles/disrupted/ai会议纪要之后的协作变化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai会议纪要之后的协作变化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-translator",
    "title": "AI替代翻译员：每分钟翻译800字之后，人还能做什么？",
    "summary": "几个月前，一个做了八年翻译的朋友约我吃饭。",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-translator.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-translator",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-29-recruitment-instant-verify",
    "title": "招聘会不会变成\"能力即时验证\"？",
    "summary": "去年秋天，我帮一家创业公司招一个运营负责人。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-29-recruitment-instant-verify.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-29-recruitment-instant-verify",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-还在用-轮岗-培养管理者-ai模拟管理场景才是新解法",
    "title": "还在用“轮岗”培养管理者？AI模拟管理场景才是新解法",
    "summary": "传统路径是：送去上课，学点理论，然后“在工作中成长”。可现实是，真正的管理能力——如何处理团队冲突、如何做艰难的绩效面谈、如何在资源有限时做决策——这些靠...",
    "content_type": "html",
    "content": "articles/disrupted/还在用-轮岗-培养管理者-ai模拟管理场景才是新解法.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-还在用-轮岗-培养管理者-ai模拟管理场景才是新解法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-monitoring-trust-crisis",
    "title": "AI监控员工的一言一行，团队的信任感正在悄悄瓦解",
    "summary": "AI监控员工的一言一行，团队的信任感正在悄悄瓦解",
    "content_type": "html",
    "content": "articles/disrupted/ai-monitoring-trust-crisis.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-monitoring-trust-crisis",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-financial-auditor",
    "title": "AI财务审计员：100%覆盖之后，人还能做什么？",
    "summary": "传统财务审计抽样1-3%，靠经验猜哪儿有问题。AI来了，100%全量实时审计，异常交易无处遁形。审计员的角色从\"在一堆发票里找问题\"变成了\"解释AI找到的...",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-financial-auditor.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-financial-auditor",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-tool-proliferation",
    "title": "你公司内部在用多少个AI工具？我测了20家公司，答案让人害怕",
    "summary": "数了20家不同规模公司（从20人到5000人）内部目前在用的AI工具数量。",
    "content_type": "html",
    "content": "articles/disrupted/ai-tool-proliferation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-tool-proliferation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-flattens-reporting-chain",
    "title": "AI让\"汇报链\"变短——信息不再需要层层过滤",
    "summary": "传统组织的汇报链是\"信息过滤器\"——每过一层，细节丢失30%，观点偏移20%。AI让一线信息直达决策层，汇报链从5层变2层。但\"信息直通\"背后，中层管理者...",
    "content_type": "html",
    "content": "articles/disrupted/ai-flattens-reporting-chain.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-flattens-reporting-chain",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai打破部门墙",
    "title": "用AI打破部门墙",
    "summary": "你有没有遇到过这种情况：公司推一个跨部门项目，先花了两个月开会协调各部门的时间，又花了一个月让各方理解彼此的工作语言，好不容易开始合作了，发现各自的数据口...",
    "content_type": "html",
    "content": "articles/disrupted/用ai打破部门墙.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai打破部门墙",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-call-center-qa-v2",
    "title": "AI客服质检全面覆盖后，质检员的职业转型路径",
    "summary": "某大型呼叫中心用AI做100%质检后，质检员从\"找问题\"变成\"解问题\"——不再听录音打分，而是设计质检规则、分析系统性问题、辅导客服提升。岗位没消失，但技...",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-call-center-qa-v2.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-call-center-qa-v2",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的周会-为什么越开越累",
    "title": "你的周会，为什么越开越累？",
    "summary": "你有没有这种感觉：周一早上，邮件已经堆成山，突然弹出一个会议邀请——周会。你深吸一口气，准备好咖啡，准时进入会议室。然后，两个小时过去了，你心力交瘁，却想...",
    "content_type": "html",
    "content": "articles/disrupted/你的周会-为什么越开越累.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的周会-为什么越开越累",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai时代的组织认同感-当我们成为-被算法定义的人",
    "title": "AI时代的组织认同感：当我们成为\"被算法定义的人\"",
    "summary": "你有多久没有认真回答过\"我是谁\"这个问题了？",
    "content_type": "html",
    "content": "articles/disrupted/ai时代的组织认同感-当我们成为-被算法定义的人.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai时代的组织认同感-当我们成为-被算法定义的人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-法务合规-ai来帮忙",
    "title": "法务合规：AI来帮忙",
    "summary": "你有没有发现，公司的法务部门永远是加班最严重的团队之一？",
    "content_type": "html",
    "content": "articles/disrupted/法务合规-ai来帮忙.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-法务合规-ai来帮忙",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-traceability-officer",
    "title": "AI决策追溯官——当算法做决定，谁来签字负责？",
    "summary": "AI决策越来越快、越来越复杂，但一旦出错，追责链条就断了。\"决策追溯官\"这个新角色正在浮出水面——他们的工作不是写代码，而是给每个AI决策找到那个最终签字的人。",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-traceability-officer.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-decision-traceability-officer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-持续学习-ai的推动作用",
    "title": "持续学习：AI的推动作用",
    "summary": "在这个信息爆炸的时代，知识更新的速度远超以往任何时期。一个几年前还被认为是前沿的技术，今天可能已经成为入门基础。这种环境下，\"持续学习\"不再是一种选择，而...",
    "content_type": "html",
    "content": "articles/disrupted/持续学习-ai的推动作用.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-持续学习-ai的推动作用",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai做年度报告-新模式",
    "title": "AI做年度报告：新模式",
    "summary": "又到年底，你有没有经历过这样的崩溃时刻——",
    "content_type": "html",
    "content": "articles/disrupted/ai做年度报告-新模式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai做年度报告-新模式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-risk-officer-algorithm-accountability",
    "title": "AI风险官：当算法决策需要有人签字负责",
    "summary": "算法做出的决策越精准，谁承担后果的问题就越尖锐。AI风险官不是懂技术的人，是敢在AI的判断上签字的人。",
    "content_type": "html",
    "content": "articles/disrupted/ai-risk-officer-algorithm-accountability.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-risk-officer-algorithm-accountability",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai知识库的建设与运营-企业智能化转型的基础设施",
    "title": "AI知识库的建设与运营：企业智能化转型的基础设施",
    "summary": "最近和几位HR负责人聊天，大家不约而同提到一个痛点：公司积累了大量培训资料、业务文档、经验案例，但需要用的时候总是找不到，找到了也不敢直接用，因为不知道是...",
    "content_type": "html",
    "content": "articles/disrupted/ai知识库的建设与运营-企业智能化转型的基础设施.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai知识库的建设与运营-企业智能化转型的基础设施",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做员工满意度调研-让真实的声音不再被淹没",
    "title": "用AI做员工满意度调研：让真实的声音不再被淹没",
    "summary": "传统的员工满意度调研，总是逃不出那几个熟悉的场景：年底发一份问卷，回收率勉强过半，员工在\"满意\"到\"非常满意\"之间打勾，HR整理数据写成报告，管理层看两眼...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做员工满意度调研-让真实的声音不再被淹没.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做员工满意度调研-让真实的声音不再被淹没",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-meeting-cost-calculator",
    "title": "AI会议成本计算器：当每次开会都在烧钱",
    "summary": "📅 2026-06-15 · 👤 老邓 · 🏷️ AI、会议效率、组织成本",
    "content_type": "html",
    "content": "articles/disrupted/ai-meeting-cost-calculator.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-meeting-cost-calculator",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-manager-dashboard-addiction",
    "title": "AI管理者仪表盘依赖症：当管理变成了看数据而不是看人",
    "summary": "去年底，我帮一家电商企业做管理诊断。这家公司去年上了一个全面的AI管理仪表盘系统——每个人的工作时长、任务完成数、代码提交量（技术团队）、客户联系次数（销...",
    "content_type": "html",
    "content": "articles/disrupted/ai-manager-dashboard-addiction.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-manager-dashboard-addiction",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-AI让经验变成资产-老师傅的数字化重生",
    "title": "AI让\"经验\"变成\"资产\"——老师傅的数字化重生",
    "summary": "分类：disrupted（颠覆类）| 标签：经验传承、知识资产、AI数字化",
    "content_type": "html",
    "content": "articles/disrupted/AI让经验变成资产-老师傅的数字化重生.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI让经验变成资产-老师傅的数字化重生",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-招聘流程ai监控与优化",
    "title": "招聘流程AI监控与优化",
    "summary": "在数字化转型的浪潮中，企业招聘正在经历前所未有的变革。传统的人工筛选简历、电话沟通协调、线下面试安排等环节不仅耗时费力，还容易因人为因素导致标准不一、效率...",
    "content_type": "html",
    "content": "articles/disrupted/招聘流程ai监控与优化.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-招聘流程ai监控与优化",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-empowerment",
    "title": "AI赋能还是AI赋权——当机器开始做决策",
    "summary": "一个银行的CIO问我一个问题：「老邓，我们的AI风控系统拒绝了18%的贷款申请，拒批准确率92%。现在业务员来找我——那8%被误杀的好申请人，谁来捞回来？」",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-empowerment.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-decision-empowerment",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai筛选简历-hr的价值重估",
    "title": "AI筛选简历：HR的价值重估",
    "summary": "以前招聘季，HR最忙的时候是看简历。每天几百份简历，每份都要花几分钟扫一眼，看看学历、经历、跳槽频率、薪资预期。筛完一轮，符合条件的可能不到十分之一。这项...",
    "content_type": "html",
    "content": "articles/disrupted/ai筛选简历-hr的价值重估.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai筛选简历-hr的价值重估",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai识别商业机会",
    "title": "用AI识别商业机会",
    "summary": "在信息爆炸的时代，商业机会往往藏匿于海量数据的缝隙之中。传统的企业决策者依靠经验、直觉和有限的市场调研来识别机会，但这种方法在面对快速变化的市场环境时显得...",
    "content_type": "html",
    "content": "articles/disrupted/用ai识别商业机会.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai识别商业机会",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做学习路径规划-让每位员工的成长都有迹可循",
    "title": "用AI做学习路径规划：让每位员工的成长都有迹可循",
    "summary": "传统的企业培训往往是“课程堆砌”——员工被安排参加一堆看似相关却缺乏逻辑串联的培训项目，学完后依然不清楚自己到底需要补什么、向什么方向发展。学习路径的设计...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做学习路径规划-让每位员工的成长都有迹可循.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做学习路径规划-让每位员工的成长都有迹可循",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-员工关怀-ai新方式-从标准化服务到个性化温暖的跨越",
    "title": "员工关怀：AI新方式——从标准化服务到个性化温暖的跨越",
    "summary": "你有没有这种感觉：公司的员工关怀永远停留在过节发礼品、年度体检、团建聚餐这\"老三样\"；HR每天忙得团团转，员工却依然觉得缺乏归属感；明明福利预算年年涨，满...",
    "content_type": "html",
    "content": "articles/disrupted/员工关怀-ai新方式-从标准化服务到个性化温暖的跨越.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-员工关怀-ai新方式-从标准化服务到个性化温暖的跨越",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-31-ai-training-efficiency-paradox",
    "title": "AI把培训效率提升300%，但为什么学员学到的东西反而少了 — 老邓游戏化",
    "summary": "李总是一家大型保险公司的培训总监。去年他们上线了一套AI培训系统。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-31-ai-training-efficiency-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-31-ai-training-efficiency-paradox",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-战略复盘-你还在用五年前的方法",
    "title": "战略复盘，你还在用五年前的方法？",
    "summary": "每年做复盘，PPT改了十几版，数据填了几十页。团队累得半死，开完会该犯的错还是犯。",
    "content_type": "html",
    "content": "articles/disrupted/战略复盘-你还在用五年前的方法.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-战略复盘-你还在用五年前的方法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-29-decision-cycle-minute",
    "title": "决策周期被压缩到\"分钟级\"：快，就是新的护城河",
    "summary": "周三下午3点，我收到一条微信：「老邓，我们公司刚开了个会，决定把原本3个月的战略决策周期压缩到48小时。」",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-29-decision-cycle-minute.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-29-decision-cycle-minute",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-文化落地-ai帮忙监督",
    "title": "文化落地：AI帮忙监督",
    "summary": "你有没有遇到过这种情况：公司的价值观海报贴满了走廊，但员工在走廊里打电话的方式，和海报上的价值观完全不符；领导在台上讲\"客户第一\"，但客户投诉处理流程却需...",
    "content_type": "html",
    "content": "articles/disrupted/文化落地-ai帮忙监督.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-文化落地-ai帮忙监督",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-no-veteran-teams",
    "title": "我跟踪了10个\"AI原生团队\"，发现它们有个共同问题——没有\"老油条\"了",
    "summary": "那些被媒体捧上天的\"AI原生团队\"——清一色年轻人、全员用AI、效率翻倍——我研究了10个，发现它们有一个普遍问题：没有缓冲层了。",
    "content_type": "html",
    "content": "articles/disrupted/no-veteran-teams.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-no-veteran-teams",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai绩效教练-私人定制成长方案",
    "title": "AI绩效教练：私人定制成长方案",
    "summary": "核心观点：绩效面谈是\"事后补救\"，真正的成长需要\"每日教练\"。AI让每个员工都拥有一位24小时在线的私教——而且，这位私教从不敷衍。",
    "content_type": "html",
    "content": "articles/disrupted/ai绩效教练-私人定制成长方案.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai绩效教练-私人定制成长方案",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做客户反馈分析-企业洞察力的智能化升级",
    "title": "用AI做客户反馈分析：企业洞察力的智能化升级",
    "summary": "在数字化时代，客户反馈是企业优化产品和服务的重要依据。传统人工分析效率低下，难以应对海量数据带来的挑战。人工智能技术为企业提供了全新的解决方案——通过AI...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做客户反馈分析-企业洞察力的智能化升级.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做客户反馈分析-企业洞察力的智能化升级",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai背景调查靠谱吗",
    "title": "AI背景调查靠谱吗",
    "summary": "你有没有这种感觉：现在的AI越来越厉害了，查学历、查工作经历、查法院记录、查社交媒体——好像一个人的底细，AI分分钟就能扒得干干净净。",
    "content_type": "html",
    "content": "articles/disrupted/ai背景调查靠谱吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai背景调查靠谱吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做薪酬谈判支持-求职者的高效助力工具",
    "title": "用AI做薪酬谈判支持：求职者的高效助力工具",
    "summary": "薪酬谈判是求职过程中最关键的环节之一，却也是许多求职者最感压力的一步。如何在维护良好关系的前提下争取到理想的薪资待遇，往往让人举棋不定。随着人工智能技术的...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做薪酬谈判支持-求职者的高效助力工具.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做薪酬谈判支持-求职者的高效助力工具",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-团队沟通-ai分析情绪",
    "title": "团队沟通：AI分析情绪",
    "summary": "在现代团队协作中，沟通不仅仅是信息的传递，更是情感的交流。AI情绪分析技术正在革新我们理解和管理团队沟通的方式。",
    "content_type": "html",
    "content": "articles/disrupted/团队沟通-ai分析情绪.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-团队沟通-ai分析情绪",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-hr-predictive-firing",
    "title": "AI预测裁员：当算法比你先知道公司要裁谁",
    "summary": "AI通过分析绩效、项目参与度、沟通频率，预测谁会被裁。员工一旦知道被监控，开始演戏——该参加的活动参加、该发的消息发、该加班假装加班。系统能预测裁员，但预...",
    "content_type": "html",
    "content": "articles/disrupted/ai-hr-predictive-firing.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-hr-predictive-firing",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-trainer-fear",
    "title": "我问了30个AI培训师，他们最怕的不是失业，是这个",
    "summary": "几个月前，我在广州做了一场「AI时代的培训师生存指南」的分享，问台下的30多位培训师一个问题：",
    "content_type": "html",
    "content": "articles/disrupted/ai-trainer-fear.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-trainer-fear",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-战略会议-ai的新角色",
    "title": "战略会议：AI的新角色",
    "summary": "情报来源：McKinsey《What it takes to build genius at scale》(2026-04-29)",
    "content_type": "html",
    "content": "articles/disrupted/战略会议-ai的新角色.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-战略会议-ai的新角色",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-emotion-labor-management",
    "title": "当AI开始管理你的\"情绪劳动\" - 0-1.team",
    "summary": "\"张哥，你今天的情绪指标不太行啊，要给团队打个鸡血。\"",
    "content_type": "html",
    "content": "articles/disrupted/ai-emotion-labor-management.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-emotion-labor-management",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-performance-calibration-system-vs-human",
    "title": "AI绩效校准：当系统说这个人该升，人却说不该",
    "summary": "系统按数据校准，人按感觉校准。当两个校准结果不一致，暴露的不是谁对谁错，而是标准本身的混乱。",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-calibration-system-vs-human.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-performance-calibration-system-vs-human",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-06-08-ai-middle-manager-resistance",
    "title": "为什么越懂AI的中层管理者，越不愿意推动AI化？",
    "summary": "上个月一个做AI实施咨询的朋友跟我说了一个让我很惊讶的发现。",
    "content_type": "html",
    "content": "articles/disrupted/2026-06-08-ai-middle-manager-resistance.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-06-08-ai-middle-manager-resistance",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai市场预测可靠吗",
    "title": "AI市场预测可靠吗",
    "summary": "近年来，人工智能技术飞速发展，从华尔街到硅谷，从金融机构到初创企业，AI驱动的市场预测已成为一股不可忽视的潮流。高盛、摩根士丹利等顶级投行纷纷投入数十亿美...",
    "content_type": "html",
    "content": "articles/disrupted/ai市场预测可靠吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai市场预测可靠吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-paralegal",
    "title": "AI替代律师助理：合同审查从3天变成3分钟之后，人还能做什么？",
    "summary": "传统合同审查：律师助理花3天逐行比对，抽筋剥皮地找风险条款。AI上场后：80页的MSA（主服务协议）3分钟出完整审查报告。律师助理的\"手艺\"突然不值钱了。...",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-paralegal.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-paralegal",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-29-entry-level-jobs-disappear",
    "title": "初级岗位是否会大规模消失？",
    "summary": "上个月，一个做HR的朋友给我发了一条消息，配了个捂脸的表情：",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-29-entry-level-jobs-disappear.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-29-entry-level-jobs-disappear",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的考勤机-正在变成一台-谎话制造机",
    "title": "你的考勤机，正在变成一台\"谎话制造机\"。",
    "summary": "每个月，总有那么几个员工对着打卡机叹气。迟到了3分钟，系统记成旷工半天。请假流程跑三天，最后发现HR漏看了邮件。加班记录全靠手动统计，财务发工资时才发现对不上。",
    "content_type": "html",
    "content": "articles/disrupted/你的考勤机-正在变成一台-谎话制造机.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的考勤机-正在变成一台-谎话制造机",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-pressure-management",
    "title": "AI组织压强管理——当系统不断施压，弹性去哪了",
    "summary": "AI系统让组织的\"机器运转\"效率达到极致——任务自动分配、进度实时监控、效率数据一目了然。但组织里的\"人\"不是机器，当AI不停地加压，人的弹性被压垮了，系...",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-pressure-management.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-pressure-management",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做候选人匹配度分析-靠谱吗",
    "title": "用AI做候选人匹配度分析，靠谱吗？",
    "summary": "招聘季，你可能收到几百份简历。HR的办法通常是这样的：先筛关键词——本科、三年经验、Python、985。再让猎头推荐几份觉得\"不错\"的。然后约面试，聊一...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做候选人匹配度分析-靠谱吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做候选人匹配度分析-靠谱吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-process-rigidity-resilience",
    "title": "当流程变成AI驱动的铁律，组织的弹性去哪了",
    "summary": "当流程变成AI驱动的铁律，组织的弹性去哪了",
    "content_type": "html",
    "content": "articles/disrupted/ai-process-rigidity-resilience.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-process-rigidity-resilience",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-performance-evaluation",
    "title": "AI绩效评估来了——你的KPI不再是老板定的，是系统算的",
    "summary": "传统绩效评估的核心是\"老板给你打分\"——但AI已经能实时追踪每个员工的工作数据、产出质量、协作效率，比老板的主观评价准得多。当\"得分\"不再是秘密，绩效面谈...",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-evaluation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-performance-evaluation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-resign-prediction-why-stay",
    "title": "AI预测离职：数据能告诉你\"谁要走\"，但说不出\"为什么留下\"",
    "summary": "AI分析员工行为数据预测离职的准确率已经高达85%，但它说不清\"为什么这个人留下来了\"。而\"为什么留下\"才是组织最该关心的问题——因为留人的成本远比走人的...",
    "content_type": "html",
    "content": "articles/disrupted/ai-resign-prediction-why-stay.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-resign-prediction-why-stay",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-06-08-ai-love-letter",
    "title": "\"我给员工配了AI助手，但他们用来写情书\"——AI落地的真实荒诞",
    "summary": "上周一个做物流的老板在电话里跟我说了一件事，笑得我直拍桌子。",
    "content_type": "html",
    "content": "articles/disrupted/2026-06-08-ai-love-letter.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-06-08-ai-love-letter",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-新员工入职-ai导师时代",
    "title": "新员工入职：AI导师时代",
    "summary": "你有没有遇到过这种情况：入职第一天，工牌还没捂热，就被拉进一个群，丢过来十几份文档，然后老员工扔下一句\"先看着，有问题再问\"——然后你发现，没人真的有时间...",
    "content_type": "html",
    "content": "articles/disrupted/新员工入职-ai导师时代.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-新员工入职-ai导师时代",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-adoption-last-mile",
    "title": "AI项目的\"最后一公里\"困境——系统上线了，为什么没人用？",
    "summary": "我去年跟踪了12家企业的AI系统落地过程。结果让我很不安。",
    "content_type": "html",
    "content": "articles/disrupted/ai-adoption-last-mile.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-adoption-last-mile",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-开会还要本人到场-是不是太out了",
    "title": "开会还要本人到场，是不是太Out了？",
    "summary": "你早上九点有个会，下午两点有个会，晚上六点还有个会。三个会分布在不同楼层、不同大楼、不同城市。你算了一下，今天花在路上的时间加起来有两个小时。你坐在第三个...",
    "content_type": "html",
    "content": "articles/disrupted/开会还要本人到场-是不是太out了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-开会还要本人到场-是不是太out了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-31-ai-interview-human-trust",
    "title": "AI面试官淘汰了人工面试官，但候选人说：我要和真人聊 — 老邓游戏化",
    "summary": "初试是AI面试。屏幕那边，一个虚拟形象问她：\"请描述你遇到的最困难的工作场景，以及你是如何解决的。\"她回答了，AI评分：88分。系统自动推送她进入下一轮。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-31-ai-interview-human-trust.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-31-ai-interview-human-trust",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-annual-review-dead",
    "title": "AI让年度绩效面谈消失——实时反馈正在替代年度总结",
    "summary": "上周见了一个做制造业HR VP的朋友，姓王。十年老HR，带过千人团队。他跟我说了一个让我愣住的事。",
    "content_type": "html",
    "content": "articles/disrupted/ai-annual-review-dead.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-annual-review-dead",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-做预算-还要花一整月",
    "title": "做预算，还要花一整月？",
    "summary": "年底做预算，你是不是也这样：财务扔模板，销售填数字，HR估人头，最后老板拍脑袋？一圈下来，少则三周，多则一个月。等预算定下来，市场早就变了。",
    "content_type": "html",
    "content": "articles/disrupted/做预算-还要花一整月.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-做预算-还要花一整月",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-靠记忆做复盘-你的企业亏了多少",
    "title": "靠记忆做复盘，你的企业亏了多少？",
    "summary": "你有没有过这样的经历：开完一场复盘会，两周后回头问大家“上次说的action item完成了吗”，结果一半人已经忘了当时说了什么？",
    "content_type": "html",
    "content": "articles/disrupted/靠记忆做复盘-你的企业亏了多少.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-靠记忆做复盘-你的企业亏了多少",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-data-compliance-legal-risk",
    "title": "AI时代的数据命门：员工的每一次操作，都可能成为组织的法律风险",
    "summary": "AI时代的数据命门：员工的每一次操作，都可能成为组织的法律风险",
    "content_type": "html",
    "content": "articles/disrupted/ai-data-compliance-legal-risk.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-data-compliance-legal-risk",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-28-remote-team-invisible-clock",
    "title": "远程团队的\"隐形时钟\"：AI如何监控你的每一分钟",
    "summary": "周三晚上9点，我收到一条微信：\"老邓，你觉得用AI盯着远程团队，算不算不信任？\"",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-28-remote-team-invisible-clock.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-28-remote-team-invisible-clock",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-training-douyin",
    "title": "你的AI培训方案，员工正在用它刷抖音",
    "summary": "上周去一家企业做游戏化TTT的课前调研，HR总监跟我抱怨了一件事，让我笑得差点把咖啡喷出来。",
    "content_type": "html",
    "content": "articles/disrupted/ai-training-douyin.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-training-douyin",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-talent-review-data-vs-judgment",
    "title": "AI做人才盘点：数据全面，但判断去哪了？",
    "summary": "传统人才盘点靠人判断潜力，AI盘点靠数据预测。数据越全面，判断越\"精准\"，但\"判断\"这件事本身正在从人到算法转移。当AI说这个人\"潜力评分8.2\"时，谁来...",
    "content_type": "html",
    "content": "articles/disrupted/ai-talent-review-data-vs-judgment.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-talent-review-data-vs-judgment",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-freelancer-economy-employment",
    "title": "自由职业者经济 vs 传统雇佣：AI催生的新用工模式",
    "summary": "\"公司\"这个词，在未来5年可能要重新定义。",
    "content_type": "html",
    "content": "articles/disrupted/ai-freelancer-economy-employment.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-freelancer-economy-employment",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai入职培训的定制化可能",
    "title": "AI入职培训的定制化可能",
    "summary": "你有没有见过这种场景：新员工入职第一天，领到一本厚厚的员工手册，看完不知所云；参加三天的集中培训，内容全是通用技能，和自己实际要做的工作关系不大；一个月后...",
    "content_type": "html",
    "content": "articles/disrupted/ai入职培训的定制化可能.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai入职培训的定制化可能",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-dependency",
    "title": "AI决策依赖症：当团队习惯\"让AI决定\"后，人还会思考吗",
    "summary": "我有一个朋友，在一家零售企业做运营总监。他们公司去年上了AI补货系统。",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-dependency.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-decision-dependency",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-30-ai-project-failure-paradox",
    "title": "AI说这个项目99%会失败，但你还是得做 — 老邓游戏化",
    "summary": "王磊拿着AI出具的《项目可行性评估报告》，站在CEO办公室门口。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-30-ai-project-failure-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-30-ai-project-failure-paradox",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai打分比人工更公正-别闹了",
    "title": "AI打分比人工更公正？别闹了",
    "summary": "最近一家互联网大厂出了个事。年终绩效评定，公司全面启用AI评估系统，给每个员工打分。系统运行三个月后，研发团队整体评分普遍低于销售团队。技术总监不干了：“...",
    "content_type": "html",
    "content": "articles/disrupted/ai打分比人工更公正-别闹了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai打分比人工更公正-别闹了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-老师傅的经验-ai比你先学会",
    "title": "老师傅的经验，AI比你先学会",
    "summary": "很多企业最值钱的东西，从来不在系统里，而是在老师的脑子里。",
    "content_type": "html",
    "content": "articles/disrupted/老师傅的经验-ai比你先学会.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-老师傅的经验-ai比你先学会",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-28-gamified-knowledge-extraction",
    "title": "游戏化知识萃取：把老员工的脑子\"榨干\"",
    "summary": "他把手里的茶杯放下，叹了口气：\"教过啊，但是他们记不住，我也说不清楚。就是手感，你懂吗？就是到了那个位置，心里有数。\"",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-28-gamified-knowledge-extraction.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-28-gamified-knowledge-extraction",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai面试官来了-招聘官何去何从",
    "title": "AI面试官来了，招聘官何去何从",
    "summary": "你有没有这种感觉：忙了一天，筛了几十份简历，打了十几通电话，约了五个候选人面试——结果入职三个月，发现招错了人。",
    "content_type": "html",
    "content": "articles/disrupted/ai面试官来了-招聘官何去何从.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai面试官来了-招聘官何去何从",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-cross-department-collaboration",
    "title": "AI帮你跨部门协作？别高兴太早，真正的麻烦才刚刚开始",
    "summary": "AI帮你跨部门协作？别高兴太早，真正的麻烦才刚刚开始",
    "content_type": "html",
    "content": "articles/disrupted/ai-cross-department-collaboration.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-cross-department-collaboration",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-价值观传播-ai的方式",
    "title": "价值观传播：AI的方式",
    "summary": "你有没有遇到过这种情况：公司的价值观写在墙上、印在手册里、挂在年会上，但员工在日常工作中感受到的，却是另一套逻辑——口号是\"客户第一\"，但内部考核只看短期...",
    "content_type": "html",
    "content": "articles/disrupted/价值观传播-ai的方式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-价值观传播-ai的方式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai驱动的创新工作坊-重塑企业创意生成与战略落地流程",
    "title": "AI驱动的创新工作坊：重塑企业创意生成与战略落地流程",
    "summary": "在当今快速变化的商业环境中，创新能力已成为企业核心竞争力的关键要素。然而，许多企业在开展创新工作坊时面临一个共同的困境：传统模式下的创意生成效率低下，跨部...",
    "content_type": "html",
    "content": "articles/disrupted/ai驱动的创新工作坊-重塑企业创意生成与战略落地流程.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai驱动的创新工作坊-重塑企业创意生成与战略落地流程",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-data-entry-clerk",
    "title": "AI替代数据录入员：99%准确率之后，人还能做什么？",
    "summary": "上个月，印度班加罗尔，一个叫拉杰什的年轻人给我发了条私信。他打了三年零四个月的工，做的是\"数据录入员\"，在一家为美国保险公司做后台处理的外包公司。每天对着...",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-data-entry-clerk.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-data-entry-clerk",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-culture-fit-screening",
    "title": "AI文化匹配筛选：算法知道\"合不合适\"，但说不出\"为什么\"",
    "summary": "2025年秋天，我去了一个朋友的公司做顾问。这家公司做SaaS，400人，CTO姓魏。",
    "content_type": "html",
    "content": "articles/disrupted/ai-culture-fit-screening.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-culture-fit-screening",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做竞品分析-效率提升10倍的实战方法论",
    "title": "用AI做竞品分析：效率提升10倍的实战方法论",
    "summary": "在市场竞争日益激烈的今天，竞品分析已成为企业战略决策的核心环节。传统的竞品分析依赖人工搜集信息、反复对比数据，分析师往往需要花费数周时间才能完成一份像样的...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做竞品分析-效率提升10倍的实战方法论.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做竞品分析-效率提升10倍的实战方法论",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-collaboration-tax",
    "title": "AI内部协作税——当每个人都在跟AI\"私聊\"，团队沟通正在变少",
    "summary": "当每个人都在跟自己最趁手的AI工具\"私聊\"时，团队内的人与人沟通正在静默萎缩。个人效率的每一分提升，都在用团队协作成本买单。这笔税，叫AI协作税。",
    "content_type": "html",
    "content": "articles/disrupted/ai-collaboration-tax.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-collaboration-tax",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做雇主品牌传播-让人才主动找上门",
    "title": "用AI做雇主品牌传播：让人才主动找上门",
    "summary": "在人才争夺战日益白热化的今天，雇主品牌已从“加分项”变成“必选项”。领英调研数据显示，75%的候选人会在了解公司雇主品牌后再决定是否投递简历，而品牌优秀的...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做雇主品牌传播-让人才主动找上门.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做雇主品牌传播-让人才主动找上门",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-30-ai-resume-hr-disagreement",
    "title": "你的简历通过了AI筛选，但HR看了一眼就把你拒了 — 老邓游戏化",
    "summary": "陈婷的简历被AI打了92分——在所有2000份投递中排名前5%。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-30-ai-resume-hr-disagreement.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-30-ai-resume-hr-disagreement",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的绩效报表已经够好看了-为什么ai还要多此一举",
    "title": "你的绩效报表已经够好看了，为什么AI还要多此一举？",
    "summary": "每年做绩效数据可视化，图表越来越漂亮，颜色越来越丰富，报表越来越精致。老板看了点头，员工看了无感。数据还是那个数据，只是换了个更好看的包装。",
    "content_type": "html",
    "content": "articles/disrupted/你的绩效报表已经够好看了-为什么ai还要多此一举.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的绩效报表已经够好看了-为什么ai还要多此一举",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai数据洞悉-决策的新方式",
    "title": "AI数据洞悉：决策的新方式",
    "summary": "来源：McKinsey《Where AI will create value—and where it won't》(2026-04-29)",
    "content_type": "html",
    "content": "articles/disrupted/ai数据洞悉-决策的新方式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai数据洞悉-决策的新方式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai发现文化问题-让组织隐患从-视而不见-到-提前预警",
    "title": "用AI发现文化问题：让组织隐患从“视而不见”到“提前预警”",
    "summary": "你有没有遇到过这种情况：团队明明运转正常，但某个项目突然失败时，你才发现协作链条早就出了问题；企业文化手册写得漂漂亮亮，但员工离职时的面谈却揭示出完全不同...",
    "content_type": "html",
    "content": "articles/disrupted/用ai发现文化问题-让组织隐患从-视而不见-到-提前预警.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai发现文化问题-让组织隐患从-视而不见-到-提前预警",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-interviewer-fair-or-cold",
    "title": "AI面试官：比人类更公平，还是更冷酷？ - 0-1.team",
    "summary": "屏幕那头，张薇对着摄像头沉默了三秒。她知道，这句话不是人类问的。那是一行代码，一个算法，一个不会累、不会走神、不会因为你长得好看就多给两分的\"面试官\"。",
    "content_type": "html",
    "content": "articles/disrupted/ai-interviewer-fair-or-cold.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-interviewer-fair-or-cold",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai培训-个性化时代来了",
    "title": "AI培训：个性化时代来了",
    "summary": "传统的员工培训往往是“一刀切”——几十人、上百人坐在同一间教室里，听同样的课程，做同样的练习。然而，这种模式正在被AI技术彻底颠覆。AI驱动的个性化培训正...",
    "content_type": "html",
    "content": "articles/disrupted/ai培训-个性化时代来了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai培训-个性化时代来了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-mentorship-to-algorithm",
    "title": "AI让\"导师制\"变成\"算法匹配\"——经验传承的消亡",
    "summary": "AI能精准匹配\"谁会什么\"和\"谁需要学什么\"，但它匹配不了\"谁愿意教\"和\"谁愿意听\"。导师制的本质是关系，不是知识传递。当算法替代关系，经验传承就死了。",
    "content_type": "html",
    "content": "articles/disrupted/ai-mentorship-to-algorithm.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-mentorship-to-algorithm",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-06-08-ai-surveillance",
    "title": "你的团队正在被AI\"隐形监控\"——但真正的问题不是监控本身",
    "summary": "前阵子一个创业公司的CEO在群里问了一个问题：",
    "content_type": "html",
    "content": "articles/disrupted/2026-06-08-ai-surveillance.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-06-08-ai-surveillance",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "title": "培训预算年年涨，员工却抱怨\"学不到东西\"？是时候用AI重新定义岗位培训了",
    "summary": "每年HR部门都在培训上砸重金——外聘讲师、购买课程、组织工作坊……可年底调研时，员工依然摇头：\"这些内容和我的工作没什么关系。\"",
    "content_type": "html",
    "content": "articles/disrupted/培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-培训预算年年涨-员工却抱怨-学不到东西-是时候用ai重新定义岗位培训了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-data-ownership-dispute",
    "title": "当AI比你更懂你：个人数据所有权的新争端",
    "summary": "她打开招聘软件，首页推荐的全是她正在纠结要不要投的岗位；刷短视频，推送的全是她最近在想的事儿；就连外卖App，推荐的套餐都是她今天正想吃的那个。",
    "content_type": "html",
    "content": "articles/disrupted/ai-data-ownership-dispute.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-data-ownership-dispute",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-30-ai-slacking-detection",
    "title": "团队里有人悄悄摆烂，AI知道，你知道吗？ — 老邓游戏化",
    "summary": "张晨的AI系统在周三下午弹出第二条异常提示：「团队成员赵凯，本周有效工时环比下降47%，任务完成率从92%降至61%。」",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-30-ai-slacking-detection.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-30-ai-slacking-detection",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai时代的团队仪式感-让协作重新变得有温度",
    "title": "AI时代的团队仪式感：让协作重新变得有温度",
    "summary": "当晨会变成一条飞书消息，当项目庆功变成表情包刷屏，当年度回顾变成AI生成的数字报告——我们完成了一场效率革命，却也悄然失去了一些东西。",
    "content_type": "html",
    "content": "articles/disrupted/ai时代的团队仪式感-让协作重新变得有温度.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai时代的团队仪式感-让协作重新变得有温度",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-informal-communication-disappearing",
    "title": "AI让非正式沟通消失——茶水间八卦，比你想的重要",
    "summary": "AI让信息传递变得\"高效\"，所有沟通都被结构化、被记录、被归档。但组织的\"软信息\"——茶水间闲聊里的隐性知识、八卦里的组织风向、偶遇中的灵感火花——正在悄...",
    "content_type": "html",
    "content": "articles/disrupted/ai-informal-communication-disappearing.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-informal-communication-disappearing",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-knowledge-fragmentation",
    "title": "AI知识碎片化——当每个部门都有AI助手，公司的\"共同认知\"正在瓦解",
    "summary": "各部门引入AI助手后，效率提升了，但各部门AI生成的\"事实\"互不兼容。当每个部门都在跟自己的AI对话，组织的统一认知正在被AI悄然肢解。",
    "content_type": "html",
    "content": "articles/disrupted/ai-knowledge-fragmentation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-knowledge-fragmentation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-boundary-who-decides",
    "title": "当AI开始\"抢活干\"——谁来决定AI的边界？",
    "summary": "上周一个HR总监给我打了个电话，声音很低，像是怕被人听见。他说公司刚上线了一套AI面试系统，HR部门集体罢工了——不是明面上的，是暗地里的不配合。",
    "content_type": "html",
    "content": "articles/disrupted/ai-boundary-who-decides.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-boundary-who-decides",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-dual-front-ai",
    "title": "你的团队悄悄在\"双线作战\"——明线是工作，暗线是人类vsAI",
    "summary": "你给团队配了AI工具，结果不是效率提升了，而是内耗加剧了。",
    "content_type": "html",
    "content": "articles/disrupted/dual-front-ai.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-dual-front-ai",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的会议纪要-是人在写还是ai在写",
    "title": "你的会议纪要，是人在写还是AI在写？",
    "summary": "以前开完会，总有人主动或者被指派去写会议纪要。那个人往往很头疼：要回忆大家说了什么，要整理分歧和共识，要列出action items，还要发给所有人确认。...",
    "content_type": "html",
    "content": "articles/disrupted/你的会议纪要-是人在写还是ai在写.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的会议纪要-是人在写还是ai在写",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-28-gamified-performance-tracking",
    "title": "游戏化绩效追踪系统：让员工主动看数据",
    "summary": "上个月去一家做跨境电商的公司做调研，HR主管李总打开后台给我看：\"你看，我们花了28万上的绩效系统，员工登录率只有12%。\"",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-28-gamified-performance-tracking.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-28-gamified-performance-tracking",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的会议-正在被ai-偷听",
    "title": "你的会议，正在被AI\"偷听\"？",
    "summary": "当你知道会议室里有一个AI正在记录一切的时候，你说话会变得格外小心。那些在脑子里一闪而过的吐槽的话，那些随口而出对同事的抱怨，那些只在内部群里说的真话——...",
    "content_type": "html",
    "content": "articles/disrupted/你的会议-正在被ai-偷听.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的会议-正在被ai-偷听",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-middle-manager-data-porter",
    "title": "AI让中层变成\"数据搬运工\"——价值感消失的危机",
    "summary": "AI能自动生成报表、分析趋势、预测问题，中层管理者突然发现：自己80%的工作，系统都能做。当\"上传下达\"变成\"数据搬运\"，中层的价值感正在消失。",
    "content_type": "html",
    "content": "articles/disrupted/ai-middle-manager-data-porter.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-middle-manager-data-porter",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai做的绩效面谈-员工真的能接受吗",
    "title": "AI做的绩效面谈，员工真的能接受吗？",
    "summary": "你有没有想过，有一天帮你做绩效面谈的，可能不是人？",
    "content_type": "html",
    "content": "articles/disrupted/ai做的绩效面谈-员工真的能接受吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai做的绩效面谈-员工真的能接受吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-跨部门项目-ai做协调人",
    "title": "跨部门项目：AI做协调人",
    "summary": "在企业中，跨部门项目从来都不缺愿景——缺的是把愿景落地的协调能力。",
    "content_type": "html",
    "content": "articles/disrupted/跨部门项目-ai做协调人.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-跨部门项目-ai做协调人",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-yearly-plan-to-weekly-experiment",
    "title": "AI让\"年度计划\"变成\"周度实验\"——规划周期被压缩",
    "summary": "年度计划建立在\"市场可预测\"的假设上，AI时代这个假设崩塌了。从年度计划到周度实验，不是效率提升，是认知方式的重构。",
    "content_type": "html",
    "content": "articles/disrupted/ai-yearly-plan-to-weekly-experiment.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-yearly-plan-to-weekly-experiment",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的季度汇报-为什么还停在ppt时代",
    "title": "你的季度汇报，为什么还停在PPT时代？",
    "summary": "季度末，会议室。投影仪亮起，PPT翻到第15页。你打了个哈欠，偷偷看了下手机。台上的人在讲“同比增长3.2个百分点”，“渠道覆盖率提升至87%”，旁边的人...",
    "content_type": "html",
    "content": "articles/disrupted/你的季度汇报-为什么还停在ppt时代.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的季度汇报-为什么还停在ppt时代",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜",
    "title": "培训砸了几十万，怎么知道有没有用？AI让效果追踪不再靠猜",
    "summary": "做过培训的人都有这样的困惑：钱花了，课上了，学员也反馈\"挺好的\"——可回到岗位上，该不会的还是不会，绩效该提不上去还是提不上去。培训到底有没有用？没人说得清。",
    "content_type": "html",
    "content": "articles/disrupted/培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-培训砸了几十万-怎么知道有没有用-ai让效果追踪不再靠猜",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-diagnostician",
    "title": "AI组织诊断师来了——公司病了，系统比人先知道",
    "summary": "📅 2026-06-15 · 👤 老邓 · 🏷️ AI、组织诊断、数据分析、组织变革",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-diagnostician.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-diagnostician",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai帮你写jd-命中率更高了吗",
    "title": "AI帮你写JD，命中率更高了吗",
    "summary": "在人力资源领域，流传着这样一句话：“职位描述写错了，整场招聘就输了一半。” Job Description（职位描述，简称JD）看似只是一份文档，却决定了...",
    "content_type": "html",
    "content": "articles/disrupted/ai帮你写jd-命中率更高了吗.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai帮你写jd-命中率更高了吗",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-新业务靠直觉决策-ai反而更靠谱",
    "title": "新业务靠直觉决策，AI反而更靠谱？",
    "summary": "老板一句\"我觉得行\"，财务一份\"看起来很美\"的PPT，团队一腔热血——然后呢？",
    "content_type": "html",
    "content": "articles/disrupted/新业务靠直觉决策-ai反而更靠谱.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-新业务靠直觉决策-ai反而更靠谱",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-游戏化学习-ai的新玩法",
    "title": "游戏化学习：AI的新玩法",
    "summary": "你上一次认真学习新技能是什么时候？翻开书看了两页，刷了十分钟手机，然后……就没有然后了。",
    "content_type": "html",
    "content": "articles/disrupted/游戏化学习-ai的新玩法.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-游戏化学习-ai的新玩法",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-flattens-middle-management",
    "title": "中层管理者的\"圣旨\"失效了——AI正在架空中间层",
    "summary": "中层管理者最核心的职能是\"上传下达\"——上级的指令经过中层\"翻译\"后下传，一线的信息经过中层\"过滤\"后上达。但当AI可以直接接收任务、分配工作、跟踪进度时...",
    "content_type": "html",
    "content": "articles/disrupted/ai-flattens-middle-management.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-flattens-middle-management",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-70-战略复盘ai的新维度",
    "title": "70-战略复盘AI的新维度",
    "summary": "每年做复盘，PPT改了十几版，数据填了几十页。团队累得半死，开完会该犯的错还是犯。",
    "content_type": "html",
    "content": "articles/disrupted/70-战略复盘ai的新维度.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-70-战略复盘ai的新维度",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学",
    "title": "培训砸了几十万，员工还是不会？AI让学习效果评估从\"玄学\"变\"科学\"",
    "summary": "每到年底做培训总结时，HR和林林总总的业务部门负责人都会面对同一个灵魂拷问：花了这么多钱和时间，员工到底学会了什么？",
    "content_type": "html",
    "content": "articles/disrupted/培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-培训砸了几十万-员工还是不会-ai让学习效果评估从-玄学-变-科学",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai重塑协作工具-从效率提升到工作方式变革",
    "title": "AI重塑协作工具：从效率提升到工作方式变革",
    "summary": "协作工具的AI升级，不仅仅是功能的叠加，而是对团队工作模式的根本性重构。当文档可以主动思考、会议能够自动摘要、任务可以智能分派，协作的本质正在发生深刻变化。",
    "content_type": "html",
    "content": "articles/disrupted/ai重塑协作工具-从效率提升到工作方式变革.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai重塑协作工具-从效率提升到工作方式变革",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-gray-zone-decision",
    "title": "AI如何改变组织的\"灰色地带\"决策",
    "summary": "张总做了十五年总经理，最擅长的事就是处理这种\"但是\"。一个老客户的项目马上要截止，但预算流程还在走，按制度不能提前开工；一个新员工工作能力很强但入职不到半...",
    "content_type": "html",
    "content": "articles/disrupted/ai-gray-zone-decision.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-gray-zone-decision",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-zero-sum-game",
    "title": "你的团队正在\"AI内卷\"——效率提升背后的零和博弈",
    "summary": "上个月，我一个做电商运营的朋友说，他们公司上线了AI客服系统后，客服团队的人均处理量提升了3倍。我正要恭喜他，他补了一句：\"但每个人都在加班。\"",
    "content_type": "html",
    "content": "articles/disrupted/ai-zero-sum-game.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-zero-sum-game",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-31-ai-personal-assistant-isolation",
    "title": "AI给每个员工都配了\"私人秘书\"，为什么效率反而下降了 — 老邓游戏化",
    "summary": "不是公司统一配的那种——是大家自发的。员工A用Claude写周报，员工B用ChatGPT做数据分析，员工C用Gemini整理竞品信息，员工D用Kimi写客...",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-31-ai-personal-assistant-isolation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-31-ai-personal-assistant-isolation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-transparency-crisis",
    "title": "AI决策透明度危机——当算法说\"不\"，但说不出为什么",
    "summary": "AI能做决策，但解释不了决策。当算法说\"不\"，员工要的不是\"系统判定\"，而是\"为什么\"。透明度缺失正在成为AI时代组织信任的最大杀手。",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-transparency-crisis.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-decision-transparency-crisis",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-还在让员工-看着学-ai实战演练让能力真正长在身上",
    "title": "还在让员工\\\"看着学\\\"？AI实战演练让能力真正长在身上",
    "summary": "培训做过无数遍，考核分数也不低，可一上真实战场就露怯——这是让无数HR和管理者头疼的顽疾。",
    "content_type": "html",
    "content": "articles/disrupted/还在让员工-看着学-ai实战演练让能力真正长在身上.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-还在让员工-看着学-ai实战演练让能力真正长在身上",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai时代的企业文化重塑-不是引入工具-而是重写规则",
    "title": "AI时代的企业文化重塑：不是引入工具，而是重写规则",
    "summary": "你有没有这种感觉：公司上了AI系统，员工却依然用老办法干活；花大价钱买了智能工具，大家却觉得是负担；试点项目明明很成功，推广时却处处碰壁。",
    "content_type": "html",
    "content": "articles/disrupted/ai时代的企业文化重塑-不是引入工具-而是重写规则.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai时代的企业文化重塑-不是引入工具-而是重写规则",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-intuition-management-replaced",
    "title": "AI替代\"直觉管理\"——数据告诉你该怎么做，但直觉说不行",
    "summary": "数据驱动的决策越来越流行，但那些\"说不上为什么，但就是感觉不对\"的直觉判断——恰恰是管理者最珍贵的隐性能力。当组织越来越相信数据，管理者的\"直觉肌肉\"正在萎缩。",
    "content_type": "html",
    "content": "articles/disrupted/ai-intuition-management-replaced.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-intuition-management-replaced",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-architect-no-reporting-line",
    "title": "AI组织架构师来了——公司还需要固定汇报线吗",
    "summary": "当AI能实时调配资源和人员，固定的汇报线就像给高速公路画死车道——高效但死板。AI组织架构师不是画出组织图的人，是设计动态协作关系的人。",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-architect-no-reporting-line.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-architect-no-reporting-line",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-meeting-emotion-analysis",
    "title": "AI会议情绪分析：它知道你不开心，但不知道你为什么不开心",
    "summary": "AI可以实时分析会议中的语调、语速、面部表情，生成精确到秒的\"情绪热力图\"。但你很快就会遇到一个尴尬的问题：AI准确捕捉到了情绪，却完全不懂情绪背后的原因...",
    "content_type": "html",
    "content": "articles/disrupted/ai-meeting-emotion-analysis.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-meeting-emotion-analysis",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-efficiency-trap",
    "title": "\"AI让我更快，但没告诉我往哪里走\"——效率陷阱",
    "summary": "上周我一个学员给我发微信，说了一句话，让我躺在床上想了很久没睡着。",
    "content_type": "html",
    "content": "articles/disrupted/ai-efficiency-trap.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-efficiency-trap",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-晨会走过场-是谁的损失",
    "title": "晨会走过场，是谁的损失？",
    "summary": "每天早上九点，会议室里坐满了人。投影仪亮着，PPT翻到第N页，有人打着哈欠，有人看着手机，有人机械地点头。十五分钟后，晨会结束。所有人站起来，走出会议室该...",
    "content_type": "html",
    "content": "articles/disrupted/晨会走过场-是谁的损失.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-晨会走过场-是谁的损失",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-data-arena",
    "title": "AI把团队变成了\"数据角斗场\"——每个人都在跟自己的数据赛跑",
    "summary": "我最近做了一场实验：在一家200人的互联网公司里，让每个部门用AI做\"个人效率看板\"。",
    "content_type": "html",
    "content": "articles/disrupted/ai-data-arena.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-data-arena",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-28-ai-interviewer",
    "title": "AI面试官：比人类更公平，还是更冷酷？",
    "summary": "屏幕那头，张薇对着摄像头沉默了三秒。她知道，这句话不是人类问的。那是一行代码，一个算法，一个不会累、不会走神、不会因为你长得好看就多给两分的\"面试官\"。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-28-ai-interviewer.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-28-ai-interviewer",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做技能差距分析",
    "title": "用AI做技能差距分析",
    "summary": "在人力资源管理和组织发展的工作中，技能差距分析是识别团队能力短板、制定培训计划的关键环节。传统方式依赖问卷、访谈和人工评估，不仅耗时耗力，还容易因主观判断...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做技能差距分析.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做技能差距分析",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-diagnosis-boundary",
    "title": "AI比你更了解你自己——组织诊断的新边界",
    "summary": "上周一个CEO约我喝茶，他说了句让我想了很久的话：「老邓，你信不信，我们公司的AI系统比我自己更了解我的公司？」",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-diagnosis-boundary.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-org-diagnosis-boundary",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-导师制被ai重新定义",
    "title": "导师制被AI重新定义",
    "summary": "传统企业中，导师制往往依赖资深员工的时间与经验，存在匹配效率低、覆盖范围有限等问题。麦肯锡2026年发布的研究报告指出，AI正在从根本上重构导师制的运作模...",
    "content_type": "html",
    "content": "articles/disrupted/导师制被ai重新定义.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-导师制被ai重新定义",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-emotional-labor-algorithm",
    "title": "AI时代的\\u201c情绪劳动\\u201d——当算法开始评估你的表情",
    "summary": "一个做客服中心管理的朋友跟我说了一个让我后背发凉的事。",
    "content_type": "html",
    "content": "articles/disrupted/ai-emotional-labor-algorithm.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-emotional-labor-algorithm",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-29-generalist-replace-specialist",
    "title": "\"通才\"会不会取代\"专才\"？",
    "summary": "上周三，我和一个老教练吃饭。他做了十二年销售培训，专攻\"大客户成交\"，业内小有名气。但他一脸苦笑：「老邓，我最近焦虑得睡不着。」",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-29-generalist-replace-specialist.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-29-generalist-replace-specialist",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-recruitment-trap",
    "title": "AI招聘陷阱——当算法筛选简历，它筛掉的可能是你的最佳员工",
    "summary": "AI简历筛选系统越高效，越倾向于筛选出\"标准化\"的候选人，从而过滤掉了那些非传统路径但创造力极强的优秀人才。\"拟合度\"不等于\"胜任力\"——当算法替你决定谁...",
    "content_type": "html",
    "content": "articles/disrupted/ai-recruitment-trap.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-recruitment-trap",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-31-ai-okr-commitment-mismatch",
    "title": "AI写的OKR比人写得好100倍，可执行率反而下降了 — 老邓游戏化",
    "summary": "今年年初，老周公司做了一件他觉得\"很酷\"的事——用AI写OKR。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-31-ai-okr-commitment-mismatch.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-31-ai-okr-commitment-mismatch",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-绩效体系被ai重构之后-为什么员工反而更焦虑了",
    "title": "绩效体系被AI重构之后，为什么员工反而更焦虑了？",
    "summary": "一家互联网公司的HR总监兴奋地向CEO汇报：“我们上线了全新的AI绩效系统！从目标设定到过程追踪，再到最终评估，全部自动化。员工每天的行为数据都会被实时采...",
    "content_type": "html",
    "content": "articles/disrupted/绩效体系被ai重构之后-为什么员工反而更焦虑了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-绩效体系被ai重构之后-为什么员工反而更焦虑了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-68-战略执行监控ai视角",
    "title": "68-战略执行监控AI视角",
    "summary": "开完季度会，你信心满满。PPT上的进度条一片绿，OKR完成率87%，重点项目全部\"正常推进\"。",
    "content_type": "html",
    "content": "articles/disrupted/68-战略执行监控ai视角.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-68-战略执行监控ai视角",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai危机预警系统-企业智能风险管理的核心基础设施",
    "title": "AI危机预警系统：企业智能风险管理的核心基础设施",
    "summary": "在当今快速变化的商业环境中，企业面临的危机类型日益复杂多样。从供应链中断、金融市场波动，到舆情危机与合规风险，传统的事后响应模式已难以满足企业稳健运营的需...",
    "content_type": "html",
    "content": "articles/disrupted/ai危机预警系统-企业智能风险管理的核心基础设施.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai危机预警系统-企业智能风险管理的核心基础设施",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-内部沟通-ai新模式",
    "title": "内部沟通：AI新模式",
    "summary": "你是否有过这样的体验：公司发布了一条重要通知，你是在三天后才从茶水间的闲聊中得知的？部门之间隔着一堵看不见的墙，明明可以协作的项目，因为信息不对称而各自为...",
    "content_type": "html",
    "content": "articles/disrupted/内部沟通-ai新模式.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-内部沟通-ai新模式",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-kills-resume-screening",
    "title": "HR的简历初筛已死——AI看人比人准3倍之后",
    "summary": "HR最基础的工作——看简历、筛候选人，正在被AI全面替代。数据证明：AI筛选的候选人，入职后绩效比HR筛选的高出3倍。HR如果不转型，就只能看着自己的核心...",
    "content_type": "html",
    "content": "articles/disrupted/ai-kills-resume-screening.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-kills-resume-screening",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai面试中的bias问题-挑战-案例与应对策略",
    "title": "AI面试中的Bias问题：挑战、案例与应对策略",
    "summary": "随着人工智能技术在招聘领域的广泛应用，AI面试已成为众多企业筛选候选人的重要工具。从简历筛选到视频面试评估，AI系统正以前所未有的速度介入人才招聘的核心流...",
    "content_type": "html",
    "content": "articles/disrupted/ai面试中的bias问题-挑战-案例与应对策略.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai面试中的bias问题-挑战-案例与应对策略",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的战略执行监控-其实一直在骗你",
    "title": "你的战略执行监控，其实一直在骗你？",
    "summary": "开完季度会，你信心满满。PPT上的进度条一片绿，OKR完成率87%，重点项目全部\"正常推进\"。",
    "content_type": "html",
    "content": "articles/disrupted/你的战略执行监控-其实一直在骗你.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的战略执行监控-其实一直在骗你",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-28-ai-emotion-labor",
    "title": "当AI开始管理你的\"情绪劳动\"",
    "summary": "我盯着屏幕上的AI提示，愣了三秒。它说得对，我确实状态不好。但被一个程序指出\"情绪指标不达标\"——这感觉，像是被冰箱批评不够冷。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-28-ai-emotion-labor.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-28-ai-emotion-labor",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-surveillance-trust-gap",
    "title": "你的团队正在被AI\\u201c隐形监控\\u201d——但真正的问题不是监控本身",
    "summary": "前阵子去一家互联网公司做组织诊断，CTO很得意地给我演示他们新上的AI生产力分析系统。",
    "content_type": "html",
    "content": "articles/disrupted/ai-surveillance-trust-gap.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-surveillance-trust-gap",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai做的绩效分析更准确-为什么员工反而更不满意",
    "title": "AI做的绩效分析更准确，为什么员工反而更不满意？",
    "summary": "公司花了几十万买了AI绩效分析系统，数据更全面了，打分更客观了，报告更详细了。结果呢？员工满意度反而下降了。",
    "content_type": "html",
    "content": "articles/disrupted/ai做的绩效分析更准确-为什么员工反而更不满意.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai做的绩效分析更准确-为什么员工反而更不满意",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-29-resume-obsolete",
    "title": "简历会不会彻底失效？",
    "summary": "上周，一个刚毕业两年的小朋友加我微信，问了一个让我愣住的问题：",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-29-resume-obsolete.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-29-resume-obsolete",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-internal-talent-marketplace",
    "title": "AI内部人才市场：员工自由流动，团队稳定谁来保？",
    "summary": "2025年，一家做AI内部人才市场的SaaS公司火了。它的逻辑很漂亮：AI分析每个员工的技能、经验、绩效和兴趣，自动推荐公司内部最匹配的岗位。员工可以像刷...",
    "content_type": "html",
    "content": "articles/disrupted/ai-internal-talent-marketplace.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-internal-talent-marketplace",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做文化一致性检查",
    "title": "用AI做文化一致性检查",
    "summary": "你有没有见过这种场景：公司的价值观写得漂漂亮亮——\"诚信正直\"、\"客户至上\"、\"追求卓越\"，但走进日常业务，扑面而来的却是另一番景象——为了签单可以隐瞒产...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做文化一致性检查.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做文化一致性检查",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-remote-team-monitoring",
    "title": "远程团队的\"隐形时钟\"：AI如何监控你的每一分钟 - 0-1.team",
    "summary": "周三晚上9点，我收到一条微信：\"老邓，你觉得用AI盯着远程团队，算不算不信任？\"",
    "content_type": "html",
    "content": "articles/disrupted/ai-remote-team-monitoring.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-remote-team-monitoring",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-团队知识库-ai让经验传承",
    "title": "团队知识库：AI让经验传承",
    "summary": "每个团队都有这样的隐痛：某位老员工离职，他脑子里积攒了三年的项目经验、踩过的坑、谈判的技巧，一夜之间全部带走。新人来了从头摸索，老员工走了从头再来——组织...",
    "content_type": "html",
    "content": "articles/disrupted/团队知识库-ai让经验传承.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-团队知识库-ai让经验传承",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-algorithmic-management-efficiency-humanity",
    "title": "算法驱动的组织：当你的老板是AI，效率和人性怎么选",
    "summary": "算法驱动的组织：当你的老板是AI，效率和人性怎么选",
    "content_type": "html",
    "content": "articles/disrupted/algorithmic-management-efficiency-humanity.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-algorithmic-management-efficiency-humanity",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-microlearning-fragmentation",
    "title": "AI微学习碎片化：当知识被切成5分钟一口，深度思考去哪了？",
    "summary": "今年3月，我参加了一个企业的学习体系评审会。培训负责人姓刘，做了十年培训管理工作，以前在一家世界500强做学习发展经理。",
    "content_type": "html",
    "content": "articles/disrupted/ai-microlearning-fragmentation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-microlearning-fragmentation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-replaces-call-center-qa",
    "title": "AI客服质检员：100%覆盖之后，人还能做什么？",
    "summary": "传统客服质检员每天听3-5段录音，抽样率不到1%。AI来了，100%全量质检，实时反馈，还能预测哪些客户准备投诉。人呢？还在，但角色从\"找茬的\"变成了\"教练\"。",
    "content_type": "html",
    "content": "articles/disrupted/ai-replaces-call-center-qa.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-replaces-call-center-qa",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做任务分配和优先级",
    "title": "用AI做任务分配和优先级",
    "summary": "在团队协作中，任务分配不合理、优先级混乱是导致效率低下的常见原因。AI技术的引入，正在彻底改变这一局面。",
    "content_type": "html",
    "content": "articles/disrupted/用ai做任务分配和优先级.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做任务分配和优先级",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai驱动的敏捷决策",
    "title": "AI驱动的敏捷决策",
    "summary": "在当今快速变化的商业环境中，企业决策的速度与质量正在成为决定生死存亡的关键变量。传统依赖管理层经验直觉、层层汇报审批的决策模式，正面临前所未有的挑战。人工...",
    "content_type": "html",
    "content": "articles/disrupted/ai驱动的敏捷决策.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai驱动的敏捷决策",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭",
    "title": "【情报解读】麦肯锡警告：CEO的AI转型窗口期正在关闭",
    "summary": "情报来源: McKinsey \"The AI assembly line: Strategic imperatives for CEOs\" (2026-0...",
    "content_type": "html",
    "content": "articles/disrupted/情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-情报解读-麦肯锡警告-ceo的ai转型窗口期正在关闭",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai驱动的异步协作-打破时区壁垒-重塑团队效率",
    "title": "AI驱动的异步协作：打破时区壁垒，重塑团队效率",
    "summary": "全球化与远程办公的普及让异步协作成为越来越多团队的标配。然而，跨时区、跨文化的协作往往伴随着沟通延迟、信息断层和协作效率低下等问题。AI技术的介入，正在为...",
    "content_type": "html",
    "content": "articles/disrupted/ai驱动的异步协作-打破时区壁垒-重塑团队效率.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai驱动的异步协作-打破时区壁垒-重塑团队效率",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-花了大价钱上ai-怎么知道亏没亏",
    "title": "花了大价钱上AI，怎么知道亏没亏？",
    "summary": "你是不是也这样：年初豪掷几百万上了AI系统，年末汇报时却拿不出数据证明它值回票价。",
    "content_type": "html",
    "content": "articles/disrupted/花了大价钱上ai-怎么知道亏没亏.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-花了大价钱上ai-怎么知道亏没亏",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了",
    "title": "【情报解读】欧洲AI投资悖论：钱没少花，回报去哪了？",
    "summary": "情报来源: McKinsey QuantumBlack, 2026-05-04",
    "content_type": "html",
    "content": "articles/disrupted/情报解读-欧洲ai投资悖论-钱没少花-回报去哪了.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-情报解读-欧洲ai投资悖论-钱没少花-回报去哪了",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做团队健康诊断-让协作问题无所遁形",
    "title": "用AI做团队健康诊断：让协作问题无所遁形",
    "summary": "在现代企业管理中，团队健康度直接影响组织效能。传统诊断依赖主观问卷与管理者经验，往往滞后于问题爆发。人工智能技术的介入，让实时、客观、可预测的团队健康诊断...",
    "content_type": "html",
    "content": "articles/disrupted/用ai做团队健康诊断-让协作问题无所遁形.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做团队健康诊断-让协作问题无所遁形",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-meaning-crisis",
    "title": "\"AI效率提升50%，但谁来欣赏我的幽默感？\"——被忽视的工作意义危机",
    "summary": "我问一个做客服的朋友，他们公司上线AI客服机器人之后发生了什么。",
    "content_type": "html",
    "content": "articles/disrupted/ai-meaning-crisis.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-meaning-crisis",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-tool-usage-motivation",
    "title": "你的AI工具使用率不到20%？不是因为员工不想学，是激励错了",
    "summary": "一个做企业数字化落地的朋友告诉我一个数字，让我沉默了整整三秒钟。",
    "content_type": "html",
    "content": "articles/disrupted/ai-tool-usage-motivation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-tool-usage-motivation",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-年度绩效评价-为什么越来越像个笑话",
    "title": "年度绩效评价，为什么越来越像个笑话？",
    "summary": "你今年绩效被打C了。在此之前，你完全不知道。",
    "content_type": "html",
    "content": "articles/disrupted/年度绩效评价-为什么越来越像个笑话.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-年度绩效评价-为什么越来越像个笑话",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-recruitment-bias-algorithm-fairness",
    "title": "AI招聘偏见——算法公平性不是技术问题，是组织问题",
    "summary": "AI招聘系统筛掉的不是不合适的人，它筛掉的是\"不符合历史数据\"的人。而历史数据本身，就是偏见的合集。算法公平性的根不在代码里，在组织的用人观里。",
    "content_type": "html",
    "content": "articles/disrupted/ai-recruitment-bias-algorithm-fairness.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-recruitment-bias-algorithm-fairness",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-2026-05-30-ai-decision-atrophy",
    "title": "当AI能替你做95%的决定，你反而不知道该怎么选了 — 老邓游戏化",
    "summary": "刘鹏发现一个问题：他最近做决定越来越慢了。",
    "content_type": "html",
    "content": "articles/disrupted/2026-05-30-ai-decision-atrophy.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-2026-05-30-ai-decision-atrophy",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-skilled-quit",
    "title": "老板说\"每人都要学会用AI\"，结果最能干的那个先辞职了",
    "summary": "一家互联网公司的创始人在群里问我：老邓，我要求全员学AI工具，结果产品经理老张，干了6年的核心骨干，提离职了。",
    "content_type": "html",
    "content": "articles/disrupted/ai-skilled-quit.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-skilled-quit",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-efficiency-satisfaction",
    "title": "\"我们公司的AI效率提升20%，但员工满意度跌了40%\"",
    "summary": "上个月，一个做制造业数字化转型的老板请我吃饭。他一坐下就叹气：",
    "content_type": "html",
    "content": "articles/disrupted/ai-efficiency-satisfaction.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-efficiency-satisfaction",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见",
    "title": "用AI做文化感知分析：让组织氛围从\"凭感觉\"变成\"看得见\"",
    "summary": "你有没有遇到过这种情况：团队士气明明在下降，但绩效考核却一片祥和；跨部门协作越来越难，但每次调研都显示\"沟通良好\"；员工嘴上说满意，但离职率却悄悄攀升。",
    "content_type": "html",
    "content": "articles/disrupted/用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-用ai做文化感知分析-让组织氛围从-凭感觉-变成-看得见",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-interview-skills-gone",
    "title": "AI面试官淘汰的不只是简历，还有\\u201c面试技巧\\u201d",
    "summary": "上个月，一个做面试辅导的朋友跟我吃饭，脸色很难看。",
    "content_type": "html",
    "content": "articles/disrupted/ai-interview-skills-gone.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-interview-skills-gone",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai预测员工离职风险的深度思考",
    "title": "AI预测员工离职风险的深度思考",
    "summary": "你是否想过这样一个问题：为什么等到员工递交辞职信的那一刻，你才发现自己被“突袭”了？",
    "content_type": "html",
    "content": "articles/disrupted/ai预测员工离职风险的深度思考.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai预测员工离职风险的深度思考",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-interviewer-bias",
    "title": "AI面试官说\"你通过了\"，但他不是人类——谁来决定你配不配得到这份工作？",
    "summary": "不久前，一个做HR的朋友给我发了一张截图。一个候选人通过了AI初面，分数98。她看了AI的面试记录，发现一个问题都没答出来。",
    "content_type": "html",
    "content": "articles/disrupted/ai-interviewer-bias.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-interviewer-bias",
    "created_at": "2026-06-01",
    "updated_at": null
  },
  {
    "id": "disrupted-你的增长机会-ai比你更早发现",
    "title": "你的增长机会，AI比你更早发现",
    "summary": "看着报表，数据都在，但就是不知道下一个增长点在哪。",
    "content_type": "html",
    "content": "articles/disrupted/你的增长机会-ai比你更早发现.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-你的增长机会-ai比你更早发现",
    "created_at": "2026-06-01",
    "updated_at": null
  },
{
    "id": "disrupted-salary-system",
    "title": "AI时代的薪酬体系会被如何重塑？",
    "summary": "薪酬从黑箱变成透明，但人的价值更难定价",
    "content_type": "html",
    "content": "articles/AI时代薪酬体系会被如何重塑.html",
    "category_id": "disrupted",
    "tags": ["薪酬体系", "AI变革", "组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-salary-system-disrupted",
    "created_at": "2026-05-24",
    "updated_at": null
  },
{
    "id": "disrupted-cross-dept-wall",
    "title": "跨部门墙被AI打破后，组织怎么重新设计？",
    "summary": "部门墙不是被推倒的，是AI让它变得没意义",
    "content_type": "html",
    "content": "articles/跨部门墙被AI打破后组织怎么重新设计.html",
    "category_id": "disrupted",
    "tags": ["跨部门", "组织设计", "AI变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-cross-dept-wall-disrupted",
    "created_at": "2026-05-24",
    "updated_at": null
  },
{
    "id": "created-ai-creative-director",
    "title": "AI创意总监：用AI生成100个方案，但判断力在人",
    "summary": "AI能生成100个方案，但判断哪个值得做、哪个能落地、哪个会害死你的，只有人能做。",
    "content_type": "html",
    "content": "articles/created/created-ai-creative-director.html",
    "category_id": "created",
    "tags": ["AI", "创意", "判断力", "新职业"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-creative-director",
    "created_at": "2026-05-23",
    "updated_at": null
  },
{
    "id": "eliminated-attendance-management-exit",
    "title": "AI让'考勤管理'退出历史舞台——从'你迟到了'到'你完成了什么'",
    "summary": "考勤的本质是监督时间，AI让结果可追踪，监督过程的管理方式正在消失。",
    "content_type": "html",
    "content": "articles/eliminated/attendance-management-exit.html",
    "category_id": "eliminated",
    "tags": ["考勤", "AI管理", "消失"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-attendance-management-exit",
    "created_at": "2026-05-20",
    "updated_at": null
  },
{
    "id": "stable-team-cohesion-ai-era",
    "title": "AI时代的团队凝聚力——为什么'一起吃饭'比'高效协作'更重要",
    "summary": "AI可以优化协作效率，但团队凝聚力不是效率的副产品，而是关系的直接产物。",
    "content_type": "html",
    "content": "articles/stable/team-cohesion-ai-era.html",
    "category_id": "stable",
    "tags": ["团队凝聚力", "AI时代", "关系"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-team-cohesion-ai-era",
    "created_at": "2026-05-20",
    "updated_at": null
  },
{
    "id": "created-internal-ai-consultant",
    "title": "AI让'内部顾问'成为新职业——企业内部AI能力的共享中心",
    "summary": "AI工具买来了，但没人会用。企业需要新角色连接AI能力和业务需求。",
    "content_type": "html",
    "content": "articles/created/internal-ai-consultant.html",
    "category_id": "created",
    "tags": ["AI顾问", "新职业", "AI落地"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-internal-ai-consultant",
    "created_at": "2026-05-20",
    "updated_at": null
  },
{
    "id": "disrupted-customer-service-human-ai-relay",
    "title": "AI重写客户服务规则——不是AI替代人，是人机接力赛",
    "summary": "AI处理标准化问题，人处理情感与复杂判断。接力赛的核心是各司其职。",
    "content_type": "html",
    "content": "articles/disrupted/customer-service-human-ai-relay.html",
    "category_id": "disrupted",
    "tags": ["客户服务", "人机接力", "AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-customer-service-human-ai-relay",
    "created_at": "2026-05-20",
    "updated_at": null
  },
{
    "id": "disrupted-improvisational-leadership-ai-era",
    "title": "AI时代的即兴领导力——当计划不再有价值，什么才重要",
    "summary": "AI让市场环境变化太快，年度计划不如季度调整，大计划不如小实验。",
    "content_type": "html",
    "content": "articles/disrupted/improvisational-leadership-ai-era.html",
    "category_id": "disrupted",
    "tags": ["即兴领导力", "计划", "AI时代"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-improvisational-leadership-ai-era",
    "created_at": "2026-05-20",
    "updated_at": null
  },
{
    "id": "created-ai-human-collab-designer",
    "title": "AI人机协作设计师：不是让AI替代人，是让人和AI配合",
    "summary": "AI替代人，是效率思维；AI和人配合，是组织设计思维。人机协作设计师的工作，是设计人和AI怎么分工、怎么交接、怎么互信。",
    "content_type": "html",
    "content": "articles/created/created-ai-human-collab-designer.html",
    "category_id": "created",
    "tags": ["人机协作", "新职业", "组织设计"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-human-collab-designer",
    "created_at": "2026-05-15",
    "updated_at": null
  },
{
    "id": "created-ai-data-custodian",
    "title": "AI数据管家：当数据多到没人知道有什么",
    "summary": "每家公司都在囤数据，但没人知道有什么。AI数据管家不是管数据的人，是让数据被找到、被信任、被用对的人。",
    "content_type": "html",
    "content": "articles/created/created-ai-data-custodian.html",
    "category_id": "created",
    "tags": ["数据管理", "新职业", "AI治理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-data-custodian",
    "created_at": "2026-05-15",
    "updated_at": null
  },
{
    "id": "disrupted-ai-turnover-acting",
    "title": "AI预测离职：当员工开始演戏给系统看",
    "summary": "AI预测离职靠的是行为数据，但行为可以演。当员工学会演戏给系统看，预测的准确率就成了博弈的产物。",
    "content_type": "html",
    "content": "articles/disrupted/ai-turnover-acting.html",
    "category_id": "disrupted",
    "tags": ["AI离职预测", "行为博弈", "HR"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-turnover-acting",
    "created_at": "2026-05-15",
    "updated_at": null
  },
{
    "id": "disrupted-ai-scheduling-gaming",
    "title": "AI排班优化：当员工开始研究算法",
    "summary": "AI排班的初衷是公平高效，但员工一旦摸清算法，排班就变成了新一轮博弈。算法优化的不是排班，是人情世故。",
    "content_type": "html",
    "content": "articles/disrupted/ai-scheduling-gaming.html",
    "category_id": "disrupted",
    "tags": ["AI排班", "算法博弈", "职场"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-scheduling-gaming",
    "created_at": "2026-05-15",
    "updated_at": null
  },
{
    "id": "disrupted-ai-interview-arms-race",
    "title": "AI面试辅助：当候选人比HR更会用AI",
    "summary": "HR用AI筛选简历，候选人用AI优化简历；HR用AI面试，候选人用AI面试。这场军备竞赛，谁在赢？",
    "content_type": "html",
    "content": "articles/disrupted/ai-interview-arms-race.html",
    "category_id": "disrupted",
    "tags": ["AI招聘", "军备竞赛", "面试"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-interview-arms-race",
    "created_at": "2026-05-15",
    "updated_at": null
  },
{
    "id": "stable-ai-emotional-connection",
    "title": "AI再强，也替代不了真诚的情感连接",
    "summary": "AI能回答问题，但不能理解焦虑。AI看到的是文字，人看到的是人。AI越强，情感连接越值钱。",
    "content_type": "html",
    "content": "articles/stable/stable-ai-emotional-connection.html",
    "category_id": "stable",
    "tags": ["情感连接", "不可替代", "AI时代"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-emotional-connection",
    "created_at": "2026-05-14",
    "updated_at": null
  },
{
    "id": "created-ai-trust-officer",
    "title": "AI信任官：当公司需要一个翻译AI与人的人",
    "summary": "AI能做决策，但AI解释不了决策。当公司需要一个人把AI的逻辑翻译成客户听得懂的话，AI信任官这个新职业应运而生。",
    "content_type": "html",
    "content": "articles/created/created-ai-trust-officer.html",
    "category_id": "created",
    "tags": ["AI信任", "新职业", "人机协作"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-trust-officer",
    "created_at": "2026-05-14",
    "updated_at": null
  },
{
    "id": "created-ai-knowledge-architect",
    "title": "AI知识架构师：不是把资料喂给AI，是设计AI怎么吃",
    "summary": "AI只解决吃的问题，怎么吃还是得靠人。当知识管理从存储变成架构，AI知识架构师成为AI时代的关键新职业。",
    "content_type": "html",
    "content": "articles/created/created-ai-knowledge-architect.html",
    "category_id": "created",
    "tags": ["知识管理", "新职业", "AI架构"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-knowledge-architect",
    "created_at": "2026-05-14",
    "updated_at": null
  },
{
    "id": "disrupted-ai-recruitment-bias",
    "title": "AI简历筛选：当你被算法判定不适合",
    "summary": "AI招聘的本质，是把人类过去的选择变成未来无法逾越的门槛。当你被算法判定不适合，你连申辩的机会都没有。",
    "content_type": "html",
    "content": "articles/disrupted/ai-recruitment-bias.html",
    "category_id": "disrupted",
    "tags": ["AI招聘", "算法偏见", "求职"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-recruitment-bias",
    "created_at": "2026-05-14",
    "updated_at": null
  },
{
    "id": "disrupted-ai-performance-gaming",
    "title": "AI绩效打分：当员工开始玩系统",
    "summary": "当一个指标成为目标时，它就不再是一个好指标。AI绩效系统正在把员工变成游戏玩家，玩系统但不要被系统玩。",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-gaming.html",
    "category_id": "disrupted",
    "tags": ["AI绩效", "游戏化", "职场生存"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-performance-gaming",
    "created_at": "2026-05-14",
    "updated_at": null
  },
{
    "id": "created-ai-workflow-architect",
    "title": "AI工作流架构师：不是写代码，是设计人的工作方式",
    "summary": "AI工作流架构师需要业务理解、AI边界感知、变革管理三种能力",
    "content_type": "html",
    "content": "articles/created/created-ai-workflow-architect.html",
    "category_id": "created",
    "tags": ["AI工作流", "新职业", "组织设计"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-workflow-architect",
    "created_at": "2026-05-13",
    "updated_at": null
  },
{
    "id": "created-ai-ethics-officer",
    "title": "AI伦理官：当每个公司都需要一个\"AI良心\"",
    "summary": "AI伦理官不是'道德警察'，是'帮业务找到可行路径'的人",
    "content_type": "html",
    "content": "articles/created/created-ai-ethics-officer.html",
    "category_id": "created",
    "tags": ["AI伦理", "新职业", "组织治理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-ethics-officer",
    "created_at": "2026-05-13",
    "updated_at": null
  },
{
    "id": "disrupted-customer-service-human-edge",
    "title": "AI客服已能解决90%问题，剩下的10%为什么需要人？",
    "summary": "AI客服能处理'问题'，但处理不了'情绪'。那10%才是决定客户体验的关键",
    "content_type": "html",
    "content": "articles/disrupted/customer-service-human-edge.html",
    "category_id": "disrupted",
    "tags": ["客服", "AI边界", "人情味"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-customer-service-human-edge",
    "created_at": "2026-05-13",
    "updated_at": null
  },
{
    "id": "disrupted-salary-algorithm",
    "title": "AI定薪：算法说你不值这个价，你信吗？",
    "summary": "AI定薪把薪酬变成'判决'——系统给出建议，但最终决定是人做的",
    "content_type": "html",
    "content": "articles/disrupted/salary-algorithm.html",
    "category_id": "disrupted",
    "tags": ["薪酬", "AI决策", "公平性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-salary-algorithm",
    "created_at": "2026-05-13",
    "updated_at": null
  },
{
    "id": "disrupted-remote-work-surveillance",
    "title": "AI远程监控：当公司开始数你敲了多少次键盘",
    "summary": "监控的是动作还是结果？AI监控把'自驱'变成'应付'，把'自己人'变成'打工人'",
    "content_type": "html",
    "content": "articles/disrupted/remote-work-surveillance.html",
    "category_id": "disrupted",
    "tags": ["远程办公", "AI监控", "信任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-remote-work-surveillance",
    "created_at": "2026-05-13",
    "updated_at": null
  },
{
    "id": "created-ai-trainer-new-career",
    "title": "AI训练师是否会成为新职业：训练AI比训练人更难",
    "summary": "训练人你知道目标是什么，训练AI你连目标都不确定——AI训练的核心不是教技能，是定方向",
    "content_type": "html",
    "content": "articles/created/created-ai-trainer-new-career.html",
    "category_id": "created",
    "tags": ["AI训练师", "新职业", "技能培训", "AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-trainer-new-career",
    "created_at": "2026-05-12",
    "updated_at": null
  },
{
    "id": "created-prompt-engineer-longterm",
    "title": "提示词工程师是否长期存在：从稀缺技能到基础能力",
    "summary": "岗位可能5年内消失，但能力会变成基础技能——学技巧的人追着AI跑，学本质的人等AI追着他跑",
    "content_type": "html",
    "content": "articles/created/created-prompt-engineer-longterm.html",
    "category_id": "created",
    "tags": ["提示词工程师", "职业趋势", "AI能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-prompt-engineer-longterm",
    "created_at": "2026-05-12",
    "updated_at": null
  },
{
    "id": "created-ai-process-designer-role",
    "title": "AI流程设计师是什么角色：从流程优化到流程创造",
    "summary": "不是把AI融入流程，是用AI重新定义流程——工具会变，思维不会",
    "content_type": "html",
    "content": "articles/created/created-ai-process-designer-role.html",
    "category_id": "created",
    "tags": ["AI流程设计", "新职业", "工作流", "组织变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-process-designer-role",
    "created_at": "2026-05-12",
    "updated_at": null
  },
{
    "id": "disrupted-future-company-ai-experts",
    "title": "未来公司会不会只剩\"老板+AI+少数专家\"",
    "summary": "传统公司靠组织人创造价值，未来公司靠组织AI创造价值——中层不是被AI替代，是被AI绕过",
    "content_type": "html",
    "content": "articles/disrupted/future-company-ai-experts.html",
    "category_id": "disrupted",
    "tags": ["组织结构", "AI", "未来工作", "公司形态"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-future-company-ai-experts",
    "created_at": "2026-05-12",
    "updated_at": null
  },
{
    "id": "disrupted-department-to-task-system",
    "title": "部门制是否会被\"任务制\"彻底替代",
    "summary": "不是分工本身有问题，是静态分工有问题——AI让任务制真正可行，但部门制不会消失，只会进化",
    "content_type": "html",
    "content": "articles/disrupted/department-to-task-system.html",
    "category_id": "disrupted",
    "tags": ["组织结构", "部门制", "任务制", "AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-department-to-task-system",
    "created_at": "2026-05-12",
    "updated_at": null
  },
{
    "id": "eliminated-80-percent-reporting-invalid",
    "title": "为什么80%的汇报都是无效的",
    "summary": "老板要的不是信息，是判断。3000字换一个'收到'，说明汇报在回答错误的问题。",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-80-percent-reporting-invalid.html",
    "category_id": "eliminated",
    "tags": ["汇报", "效率", "AI", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-80-percent-reporting-invalid",
    "created_at": "2026-05-11",
    "updated_at": null
  },
{
    "id": "stable-manager-judgment-core",
    "title": "管理者的核心能力仍然是判断力：AI能算出最优解，但算不出该不该解",
    "summary": "AI能帮你算，但不能帮你选。计算可以外包，判断不能。",
    "content_type": "html",
    "content": "articles/stable/stable-manager-judgment-core.html",
    "category_id": "stable",
    "tags": ["管理能力", "判断力", "AI", "决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-manager-judgment-core",
    "created_at": "2026-05-11",
    "updated_at": null
  },
{
    "id": "stable-strategic-thinking-gap",
    "title": "战略思考不会被AI替代，但会被放大差距",
    "summary": "会思考的人用AI加速思考，不会思考的人用AI替代思考——差距会指数级拉大",
    "content_type": "html",
    "content": "articles/stable/stable-strategic-thinking-gap.html",
    "category_id": "stable",
    "tags": ["战略思考", "AI", "能力差距", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-strategic-thinking-gap",
    "created_at": "2026-05-11",
    "updated_at": null
  },
{
    "id": "created-ai-product-manager",
    "title": "AI产品经理：给不明确的需求找答案的人",
    "summary": "普通产品经理给明确需求找方案，AI产品经理给不明确需求找答案——核心能力是边界探索",
    "content_type": "html",
    "content": "articles/created/created-ai-product-manager.html",
    "category_id": "created",
    "tags": ["AI产品经理", "新职业", "产品管理", "AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-product-manager",
    "created_at": "2026-05-11",
    "updated_at": null
  },
{
    "id": "disrupted-middle-manager-danger",
    "title": "中层管理者是AI时代最危险的岗位吗",
    "summary": "不是AI淘汰你，是上面的和下面的同时压缩你——中层管理者的信息管道价值正在被AI绕过",
    "content_type": "html",
    "content": "articles/disrupted/middle-manager-danger.html",
    "category_id": "disrupted",
    "tags": ["中层管理者", "AI", "岗位变化", "组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-middle-manager-danger",
    "created_at": "2026-05-11",
    "updated_at": null
  },
{
    "id": "stable-realtime-feedback-ai",
    "title": "从年度绩效到实时反馈：快了，但真的好了吗",
    "summary": "系统追着人跑，但人还是不理——高频反馈如果没有好的指标设计，只会放大错误",
    "content_type": "html",
    "content": "articles/stable/stable-realtime-feedback-ai.html",
    "category_id": "stable",
    "tags": ["绩效管理", "实时反馈", "AI", "绩效"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-realtime-feedback-ai",
    "created_at": "2026-05-10",
    "updated_at": null
  },
{
    "id": "stable-mentorship-ai-era",
    "title": "导师制的最后一天：当知识不再是稀缺品",
    "summary": "一个做了十八年企业内训的培训师说：以前我是老师，他们是学生。现在更像是他们的裁判",
    "content_type": "html",
    "content": "articles/stable/mentorship-ai-era.html",
    "category_id": "stable",
    "tags": ["导师制", "AI", "培训", "知识管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-mentorship-ai-era",
    "created_at": "2026-05-10",
    "updated_at": null
  },
{
    "id": "stable-ai-skill-gap-analysis",
    "title": "AI技能差距分析：当所有人都知道该学什么的时候，差距反而更大",
    "summary": "AI能精准定位每个人的技能短板，但'知道该补什么'和'真的补上了'之间，隔着一道只有人能跨过去的鸿沟",
    "content_type": "html",
    "content": "articles/stable/stable-ai-skill-gap-analysis.html",
    "category_id": "stable",
    "tags": ["技能差距", "AI", "培训", "人才发展"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-skill-gap-analysis",
    "created_at": "2026-05-10",
    "updated_at": null
  },
{
    "id": "stable-ai-culture-reshape-v2",
    "title": "AI时代的企业文化重塑：系统推得动流程，推不动人心",
    "summary": "系统追着人跑，但人只是表演——AI能看到数据，但解决不了信任",
    "content_type": "html",
    "content": "articles/stable/stable-ai-culture-reshape-v2.html",
    "category_id": "stable",
    "tags": ["企业文化", "AI", "组织变革", "信任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-culture-reshape-v2",
    "created_at": "2026-05-10",
    "updated_at": null
  },
{
    "id": "stable-ai-cross-dept-coordinator",
    "title": "跨部门项目的AI协调人：算法能通知，但说服不了",
    "summary": "系统追着人跑，但人还是不理——AI解决了信息同步的效率，但解决不了利益对齐的问题",
    "content_type": "html",
    "content": "articles/stable/stable-ai-cross-dept-coordinator.html",
    "category_id": "stable",
    "tags": ["跨部门协作", "AI", "项目管理", "组织协调"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-cross-dept-coordinator",
    "created_at": "2026-05-10",
    "updated_at": null
  },
{
    "id": "eliminated-ai-interview-recruiter",
    "title": "AI面试官来了，招聘官何去何从",
    "summary": "一个做了12年招聘的HR总监说：我的工作就是确认这个人看起来顺不顺眼，那我值多少钱？",
    "content_type": "html",
    "content": "articles/eliminated/ai-interview-recruiter.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "招聘",
      "面试",
      "HR"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-interview-recruiter",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-org-power-structure-ai-era",
    "title": "AI时代，组织中权力结构的本质不会被改变",
    "summary": "AI能优化信息流转，但不能改变谁有最终拍板权——权力结构的本质是人的信任网络",
    "content_type": "html",
    "content": "articles/stable/stable-org-power-structure-ai-era.html",
    "category_id": "stable",
    "tags": ["AI", "权力结构", "组织", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-org-power-structure-ai-era",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-decision-centralization-vs-distribution",
    "title": "决策权集中vs分散，这个矛盾不会消失",
    "summary": "AI让'控制'更精准了，也让'适应'更快速了，但没有消除两者之间的张力",
    "content_type": "html",
    "content": "articles/stable/stable-decision-centralization-vs-distribution.html",
    "category_id": "stable",
    "tags": ["决策权", "组织", "AI", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-decision-centralization-vs-distribution",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-ai-execution-vs-responsibility",
    "title": "AI可以替代执行，但无法替代责任承担",
    "summary": "AI可以让效率翻倍，但永远无法为决策后果负责——责任的核心是'在乎'",
    "content_type": "html",
    "content": "articles/stable/stable-ai-execution-vs-responsibility.html",
    "category_id": "stable",
    "tags": ["AI", "责任承担", "管理", "组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-execution-vs-responsibility",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-kpi-realtime-transparent",
    "title": "KPI不会消失，只是变得更实时更透明",
    "summary": "实时透明不是问题，问题是KPI本身——把有缺陷的指标搬到线上，只是让缺陷暴露得更快",
    "content_type": "html",
    "content": "articles/stable/stable-kpi-realtime-transparent.html",
    "category_id": "stable",
    "tags": ["KPI", "AI", "绩效", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-kpi-realtime-transparent",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-management-goal-alignment",
    "title": "管理的本质仍然是目标对齐，不是工具升级",
    "summary": "工具能告诉你'发生了什么'，目标对齐告诉你'为什么发生'——后者才是真正的管理",
    "content_type": "html",
    "content": "articles/stable/stable-management-goal-alignment.html",
    "category_id": "stable",
    "tags": ["管理", "目标对齐", "AI", "组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-management-goal-alignment",
    "created_at": "2026-05-08",
    "updated_at": null
  },
{
    "id": "stable-ai-era-culture-reshape",
    "title": "AI时代的企业文化重塑：算法能改变文化吗",
    "summary": "AI改变不了企业文化，但改变了谁来承载文化——从管理者转向每个个体",
    "content_type": "html",
    "content": "articles/stable/stable-ai-era-culture-reshape.html",
    "category_id": "stable",
    "tags": ["AI", "企业文化", "组织", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-era-culture-reshape",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "stable-ai-era-incentive-mechanism",
    "title": "AI时代，激励机制为什么比技术更重要",
    "summary": "AI只是放大器，真正改变员工行为的是激励机制——你按哪个按钮，它就放大哪个方向",
    "content_type": "html",
    "content": "articles/stable/ai-era-incentive-mechanism.html",
    "category_id": "stable",
    "tags": ["AI", "激励机制", "管理", "组织变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-era-incentive-mechanism",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "stable-employee-satisfaction-ai",
    "title": "员工满意度调研：AI能收集数据，但理解需要人",
    "summary": "AI让员工满意度调研更容易做了，但让真正的理解更难了——因为员工开始学会说'正确的话'",
    "content_type": "html",
    "content": "articles/stable/stable-employee-satisfaction-ai.html",
    "category_id": "stable",
    "tags": ["员工满意度", "AI调研", "管理", "组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-employee-satisfaction-ai",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "stable-org-identity-ai-era",
    "title": "AI时代的组织认同感：归属感为什么算法给不了",
    "summary": "AI时代，组织认同感不是变得更难了，而是被重新定义了——从'属于组织'到'组织属于我们'",
    "content_type": "html",
    "content": "articles/stable/stable-org-identity-ai-era.html",
    "category_id": "stable",
    "tags": ["AI", "组织认同感", "归属感", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-org-identity-ai-era",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "disrupted-competitive-analysis-ai",
    "title": "用AI做竞品分析：从拍脑袋到数据驱动",
    "summary": "AI让竞品分析从'情报工作'变成'日常早餐'——关键不是分析结果，而是分析后的行动速度",
    "content_type": "html",
    "content": "articles/disrupted/competitive-analysis-ai.html",
    "category_id": "disrupted",
    "tags": ["竞品分析", "AI", "决策", "战略"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-competitive-analysis-ai",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "disrupted-agile-decision-ai",
    "title": "AI驱动的敏捷决策：当速度成为竞争优势",
    "summary": "AI时代，决策慢不再是因为信息不够，而是因为组织架构不允许快",
    "content_type": "html",
    "content": "articles/disrupted/agile-decision-ai.html",
    "category_id": "disrupted",
    "tags": ["敏捷决策", "AI", "组织", "管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-agile-decision-ai",
    "created_at": "2026-05-05",
    "updated_at": null
  },
{
    "id": "created-ai-org-architect",
    "title": "AI组织架构师：设计AI时代的网状组织",
    "summary": "组织不是变扁平，而是变得没有固定形状",
    "content_type": "html",
    "content": "articles/AI组织架构师-设计网状组织.html",
    "category_id": "created",
    "tags": ["组织设计", "AI", "新职业"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-architect"
 ,
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "created-ai-change-promoter",
    "title": "AI变革推动者：把AI落地从项目变成能力",
    "summary": "不是做AI项目，而是建AI能力",
    "content_type": "html",
    "content": "articles/AI变革推动者-把AI落地从项目变成能力.html",
    "category_id": "created",
    "tags": ["变革推动", "AI落地", "新职业"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-change-promoter"
 ,
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "created-ai-feedback-coach",
    "title": "AI反馈教练：用AI做实时反馈但不失去温度",
    "summary": "反馈的目的不是评价，是成长",
    "content_type": "html",
    "content": "articles/AI反馈教练-用AI做实时反馈但不失去温度.html",
    "category_id": "created",
    "tags": ["反馈", "AI教练", "新职业"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-feedback-coach"
 ,
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-remote-team-collaboration-ai",
    "title": "远程团队的协作机制：AI如何重构分布式协作",
    "summary": "远程协作的核心问题：信息同步、信任建立、决策效率",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-remote-team-collaboration-ai.html",
    "category_id": "eliminated",
    "tags": [
      "远程协作",
      "AI",
      "分布式团队"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-remote-team-collaboration",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-org-memory-digitalization",
    "title": "组织记忆的数字化：AI如何帮助组织不忘记经验教训",
    "summary": "AI如何数字化组织记忆",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-org-memory-digitalization.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "组织",
      "记忆"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-org-memory-digitalization",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-cost-reduction-not-layoff",
    "title": "降本增效不是裁员：算法组织的能力调用新思路",
    "summary": "算法组织的降本增效",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-cost-reduction-not-layoff.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "降本增效",
      "组织"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-cost-reduction-not-layoff",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-trainer-career-path",
    "title": "AI培训师的职业发展路径：从工具使用者到生态构建者",
    "summary": "AI培训师的职业演进",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-trainer-career-path.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "培训师",
      "职业"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-trainer-career-path",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-evaluation-fairness",
    "title": "评价系统的公平性：AI评价与人工评价的冲突与协同",
    "summary": "AI评价系统的公平性",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-evaluation-fairness.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "评价",
      "公平"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-evaluation-fairness",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-org-innovation-culture",
    "title": "AI与组织创新文化：算法会促进还是抑制创新",
    "summary": "AI时代的组织创新面临算法的挑战与机遇",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-org-innovation-culture.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "组织",
      "创新"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-org-innovation-culture",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-org-agility",
    "title": "AI与组织敏捷性：算法会让组织更僵化还是更灵活",
    "summary": "算法如何影响组织的敏捷性",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-org-agility.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "组织",
      "敏捷"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-org-agility",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-org-learning-acceleration",
    "title": "组织学习的AI加速：让组织不再重复交学费",
    "summary": "AI如何加速组织学习",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-org-learning-acceleration.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "组织",
      "学习"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-org-learning-acceleration",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-customer-service-efficiency",
    "title": "客服团队效率提升：AI增强而非替代人",
    "summary": "AI如何增强客服团队效率",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-customer-service-efficiency.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "客服",
      "效率"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-customer-service-efficiency",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-org-culture",
    "title": "AI与组织文化：算法能理解并改变组织文化吗",
    "summary": "算法对组织文化的理解与改造",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-org-culture.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "组织",
      "文化"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-org-culture",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-atm-three-in-one",
    "title": "ATM不是三件事是一件事：三层协同的底层逻辑",
    "summary": "ATM模型的协同效应",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-atm-three-in-one.html",
    "category_id": "eliminated",
    "tags": [
      "ATM",
      "组织",
      "协同"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-atm-three-in-one",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-standup-to-report-meeting",
    "title": "当站会变成汇报会：研发团队为什么越敏捷越累",
    "summary": "敏捷开发的反思",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-standup-to-report-meeting.html",
    "category_id": "eliminated",
    "tags": [
      "敏捷",
      "研发",
      "团队"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-standup-to-report-meeting",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "eliminated-ai-era-employer-brand",
    "title": "AI时代的雇主品牌：如何用技术吸引和留住人才",
    "summary": "算法时代的雇主品牌建设",
    "content_type": "html",
    "content": "articles/eliminated/eliminated-ai-era-employer-brand.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "雇主品牌",
      "人才"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-eliminated-ai-era-employer-brand",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-trust-organizational-efficiency",
    "title": "信任与组织效率：AI时代最硬的软实力",
    "summary": "系统告诉你什么时候该联系客户，但它不知道为什么客户愿意接你电话",
    "content_type": "html",
    "content": "articles/stable/trust-organizational-efficiency.html",
    "category_id": "stable",
    "tags": [
      "信任",
      "组织效率",
      "AI"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-trust-organizational-efficiency",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-ai-era-human-motivation",
    "title": "为什么AI越强，管理者越需要理解\"人性动机\"",
    "summary": "当算法读懂了行为，却读不懂动机——AI时代管理者的核心能力",
    "content_type": "html",
    "content": "articles/stable/ai-era-human-motivation.html",
    "category_id": "stable",
    "tags": [
      "AI",
      "人性动机",
      "管理",
      "组织"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-era-human-motivation",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-empathy-ai-boundary",
    "title": "同理心为什么AI学不会：管理中最稀缺的能力",
    "summary": "AI能识别你的表情，但无法感受你的痛苦",
    "content_type": "html",
    "content": "articles/stable/stable-empathy-ai-boundary.html",
    "category_id": "stable",
    "tags": [
      "同理心",
      "AI",
      "管理能力"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-empathy-ai-boundary",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-trust-building-ai",
    "title": "信任建立为什么无法被AI替代：人际关系的底层逻辑",
    "summary": "AI可以记录每一次沟通，但不能创造任何一次真正的连接",
    "content_type": "html",
    "content": "articles/stable/stable-trust-building-ai.html",
    "category_id": "stable",
    "tags": [
      "信任",
      "AI",
      "人际关系"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-trust-building-ai",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-employee-care-ai",
    "title": "员工关怀：AI能分析数据，但关怀需要人",
    "summary": "AI能看到数据，但关怀需要人去感受",
    "content_type": "html",
    "content": "articles/stable/stable-employee-care-ai.html",
    "category_id": "stable",
    "tags": [
      "员工关怀",
      "AI",
      "管理能力"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-employee-care-ai",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-learning-organization",
    "title": "学习组织：从「培训部门」到「全员共创」",
    "summary": "培训部门正在变成组织中最尴尬的部门",
    "content_type": "html",
    "content": "articles/stable/stable-learning-organization.html",
    "category_id": "stable",
    "tags": [
      "学习",
      "组织"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-learning-organization",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "stable-conflict-resolution-ai",
    "title": "冲突解决的AI辅助：算法能调解人，但调解不了关系",
    "summary": "AI能分析冲突的利益结构，但关系的修复需要人",
    "content_type": "html",
    "content": "articles/stable/stable-conflict-resolution-ai.html",
    "category_id": "stable",
    "tags": [
      "冲突解决",
      "AI",
      "管理能力"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-conflict-resolution-ai",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "created-ai-audit-explainability",
    "title": "AI审计与可解释性：算法黑箱如何打开",
    "summary": "AI的可解释性与审计",
    "content_type": "html",
    "content": "articles/created/created-ai-audit-explainability.html",
    "category_id": "created",
    "tags": [
      "AI",
      "审计",
      "可解释性"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-audit-explainability",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "created-ai-training-gamification",
    "title": "AI培训中的游戏化机制设计：让学习像打怪升级一样上瘾",
    "summary": "游戏化机制在AI培训中的应用",
    "content_type": "html",
    "content": "articles/created/created-ai-training-gamification.html",
    "category_id": "created",
    "tags": [
      "AI",
      "游戏化",
      "培训"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-created-ai-training-gamification",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "disrupted-ai-performance-review",
    "title": "AI绩效面谈：当面谈变成一种仪式，管理者怎么办",
    "summary": "绩效面谈的尴尬，不是谈得不好，而是双方都知道答案了",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-review.html",
    "category_id": "disrupted",
    "tags": [
      "AI",
      "绩效"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-performance-review",
    "created_at": "2026-05-04",
    "updated_at": null
  },
{
    "id": "disrupted-ai-meeting-review",
    "title": "AI会议复盘：不再靠记忆，让每次会议都有沉淀",
    "summary": "你开完一个两小时的会，出门第一件事是什么？",
    "content_type": "html",
    "content": "articles/disrupted/ai-meeting-review.html",
    "category_id": "disrupted",
    "tags": [
      "AI",
      "会议"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-stable-ai-era-human-motivation",
    "created_at": "2026-05-04",
    "updated_at": null
  },
  {
    "id": "disrupted-内部市场化-当资源分配不再靠审批-而是靠定价",
    "title": "内部市场化：当资源分配不再靠审批，而是靠定价",
    "summary": "•内部市场化：把组织内部的资源标上价格，让需求方和供给方自由交易\n•AI让内部市场化的交易成本降到了可以忽略不计\n•实操三步走：选试点→影子价格跑三个月→从配额制到预算制\n•安全合规、人才发展、企业文化这三件事绝对不能定价",
    "content_type": "html",
    "content": "articles/内部市场化-当资源分配不再靠审批-而是靠定价.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-内部市场化-当资源分配不再靠审批-而是靠定价",
    "created_at": "2026-06-23",
    "updated_at": null
  },
  {
    "id": "disrupted-AI时代的企业文化-算法管不了的-才是核心竞争力",
    "title": "AI时代的企业文化：算法管不了的，才是核心竞争力",
    "summary": "•员工满意度三个月内下降了23%，离职率上升了15%——你越是全方位监控，信任流失得越快\n•算法天然追求效率最大化，而创新天然需要冗余和浪费\n•三个建设原则：领导行为、保护不可量化、建立人工安全区\n•组织的核心竞争力，不是算法多强，而是算法管不了的那部分有多强",
    "content_type": "html",
    "content": "articles/disrupted/AI时代的企业文化-算法管不了的-才是核心竞争力.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-AI时代的企业文化-算法管不了的-才是核心竞争力",
    "created_at": "2026-06-24",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-assistant-team-collaboration-paradox",
    "title": "当每个员工都有AI助手：个人效率提升反而拉低了团队协作",
    "summary": "•AI让程序员写代码快2倍、销售写方案快3倍——但项目交付速度反而慢了\n•三大现象：信息共识在丢失、对齐变慢、知识传递断链\n•底层逻辑：AI工具个人化、信息冗余减少、信任从人转移到AI\n•三个解法：强制人工对齐节点、建立共享信息源纪律、有意识保留「低效」但关键的协作机制",
    "content_type": "html",
    "content": "articles/disrupted/ai-assistant-team-collaboration-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-ai-assistant-team-collaboration-paradox",
    "created_at": "2026-06-25",
    "updated_at": null
  },
  {
    "id": "disrupted-silent-resistance-ai",
    "title": "员工没反对AI，但就是不配合：算法组织最隐蔽的敌人是沉默抵抗",
    "summary": "•员工没掀桌子，但登录率从62%跌到28%——沉默抵抗比当面反对更致命\n•三种形态：数据投喂不足、流程绕行、冷漠敷衍\n•管理者看不见它，因为考核指标只看「覆盖率」不看「实际使用」\n•三个破法：上线前测阻力、设计绕行反馈按钮、找1分钟就赢的场景\n•沉默抵抗不是员工的问题，是系统设计没把「人的惰性」当成输入变量",
    "content_type": "html",
    "content": "articles/disrupted/silent-resistance-ai.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disrupted-silent-resistance-ai",
    "created_at": "2026-06-27",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-invisible-promotion-ceiling",
    "title": "AI时代的\"看不见的晋升天花板\"——当算法比你的老板更早知道你要升职",
    "summary": "•AI能通过协作网络密度、被提及率、决策咨询倾向三大隐性指标，比老板提前3-6个月预判晋升\n•传统人才盘点看不到这些数据，但组织在无声地\"投票\"\n•关注低预测率员工：不是能力不行，是信息流已经绕过了他们\n•管理者的任务：把隐性数据翻译成对话，而非直接当作判决书\n•真正的问题：AI知道而你不知道——信息不对称才是真正的天花板",
    "content_type": "html",
    "content": "articles/disrupted/ai-invisible-promotion-ceiling.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-invisible-promotion-ceiling",
    "created_at": "2026-06-30",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-training-efficiency-shame",
    "title": "AI把培训效率提了3倍，但员工偷偷告诉我：我越学越觉得自己没用",
    "summary": "•课程完成率提升280%的背后，13/18的员工说\"越学越觉得自己没用\"\n•AI摧毁了学习的私密性，让\"学不会\"变成无法隐藏的公开数据\n•完成率高的真相：员工在学习数据上表演，而非真正在学习\n•四个破法：学习与绩效解绑、进步速度代替排名、\"故意不会\"设计、推送\"你不需要学这些\"\n•效率提升×透明度上升×社交比较=自我价值感下降——AI培训系统的设计盲区",
    "content_type": "html",
    "content": "articles/disrupted/ai-training-efficiency-shame.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-training-efficiency-shame",
    "created_at": "2026-06-30",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-participation-gap",
    "title": "AI参与鸿沟：你的团队正分裂成两个世界——\"用AI的人\"和\"被AI用的人\"",
    "summary": "•AI活跃用户的意见被采纳率73%，非活跃用户仅31%——差距2.3倍，不是能力差距是声音差距\n•AI参与鸿沟比数字鸿沟更危险：AI能力的指数级增长让追赶者加速落后\n•根源不是技术，是心理安全感——\"不敢\"而非\"不会\"\n•三个修复方法：AI结对机制、AI分享环节周会化、AI产出去绩效化\n•最怕的不是有人在后面追不上，是前面的人越跑越远，后面的人直接停下来",
    "content_type": "html",
    "content": "articles/disrupted/ai-participation-gap.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-participation-gap",
    "created_at": "2026-06-30",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-perfect-match-diversity-collapse",
    "title": "AI把\"人岗匹配\"做到极致后，组织的多样性正在静默崩塌",
    "summary": "•AI人岗匹配的本质不是找\"适合\"的人，是复制\"和已经成功的人最像\"的人\n•哈佛研究：高多样性团队创新产出高19%，但AI优化函数里多样性不是核心指标\n•\"集体盲区\"：当所有人类似，遇到新问题就全部卡住——近亲繁殖式危机\n•三个动作：模型加入多样性权重、定期盲区审查、主动引入\"非最优\"候选人\n•最优化终点是趋同，趋同终点是脆弱——你是在培养团队还是在育种？",
    "content_type": "html",
    "content": "articles/disrupted/ai-perfect-match-diversity-collapse.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-perfect-match-diversity-collapse",
    "created_at": "2026-06-30",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-expression-cost-rising",
    "title": "AI让职场\"说话\"越来越贵——表达不当的成本正在指数级上升",
    "summary": "•AI沟通分析系统上线后，团队不同意见下降61%，项目延期率上升23%\n•员工开始用AI润色IM消息——不是效率提升，是表达成本从\"说真话\"变成\"写安全的话\"\n•AI无法区分\"有价值的反对\"和\"无意义的抱怨\"——因为需要上下文和意图判断\n•四个后果：集体沉默、边缘化反对者、合规表达代替真实表达、创新前提被切断\n•三个措施：明确AI分析边界、设\"无记录\"空间、AI标签必须经人工复核",
    "content_type": "html",
    "content": "articles/disrupted/ai-expression-cost-rising.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-expression-cost-rising",
    "created_at": "2026-06-30",
    "updated_at": null
  },
  {
    "id": "disrupted-informal-org-collapse-ai",
    "title": "\"茶水间的消亡\"——AI优化掉的那些\"非正式组织\"正在偷走组织的隐性能力",
    "summary": "•组织中60%-70%的信息流动发生在非正式渠道，AI系统正在系统性拆除交流场景\n•三大副作用：信任从人情变成流程依赖、信息从多通道变独木桥、隐性知识传递断裂\n•非正式组织承担信息传递、信任建立、心理安全缓冲等五大关键功能\n•三个解法：保留不被AI覆盖的空间、用AI识别非正式网络但不干预、把闲聊当投资\n•真正有韧性的人，知道哪些东西不必被优化",
    "content_type": "html",
    "content": "articles/disrupted/informal-org-collapse-ai.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-informal-org-collapse-ai",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "created-digital-hybrid-alternative-org",
    "title": "\"数字双胞胎组织\"正在诞生——AI给实体组织创造了一个会自我进化的数字副本",
    "summary": "•以真实组织全部数据构建可交互、可模拟、可推演的数字模型\n•三个层次：L1描述级（看见）、L2模拟级（实验）、L3推演级（AI主动建议）\n•GE组织重组预测准确率达到85%，西门子管理岗匹配周期缩短50%\n•新角色\"组织数字孪生工程师\"年薪60-120万\n•最大陷阱：你以为在优化组织，实际在优化数据；当参谋别当司令",
    "content_type": "html",
    "content": "articles/created/digital-hybrid-alternative-org.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-digital-hybrid-alternative-org",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-performative-employee-evaluation",
    "title": "AI评价系统正在制造\"表演型员工\"——当你的一切数据都被评估，人就开始\"表演数据\"",
    "summary": "•古德哈特定律在AI时代爆发：指标变目标就不再是好指标\n•MIT研究：AI绩效评估上线6个月后效率指标上升，但客户满意度下降21%，离职率上升15%\n•三种典型表演行为：数据刷手、安全演员、数据洁癖\n•AI无法识别表演因为AI不看\"是否自然\"只看数据模式是否达标\n•三个解法：设立\"反指标\"体系、保留人工复核机制、设立不被AI评估的零表演区",
    "content_type": "html",
    "content": "articles/disrupted/ai-performative-employee-evaluation.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-performative-employee-evaluation",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-creativity-homogenization-trap",
    "title": "\"AI加速了创意枯竭\"——当所有人用同一批AI工具，差异化从哪来？",
    "summary": "•大语言模型输出趋于训练数据的统计集中趋势，天然偏好安全平均的输出\n•德勤2025调研：用AI的知识工作者效率提升40%，但产出独特性降低30%\n•对内：不同项目组方案高度趋同；对外：竞品产出也越来越像\n•四个解法：喂自有数据、在输入环节制造差异、AI当副脑不主脑、每周无AI创意时间\n•AI能让所有人都变强，也能让所有人都变得一样强——走小路的人才是赢家",
    "content_type": "html",
    "content": "articles/disrupted/ai-creativity-homogenization-trap.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-creativity-homogenization-trap",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "created-org-immune-system-micro-trauma",
    "title": "组织免疫系统正在被AI重建——\"微创伤检测\"成为组织健康管理的新范式",
    "summary": "•组织微创伤：日常积累的小伤害（不公平绩效、被忽略的建议、公开责备）\n•三大检测维度：沟通模式异常、协作网络断裂、个体行为序列紊乱\n•300人公司案例：AI提前9个月发现跨部门信任恶化，传统调研做不到\n•组织免疫系统三大功能：检测、归因、响应（只做预警不直接干预）\n•有些对话必须由人来完成——AI告诉你该去问谁了，但你不能让它替你去问",
    "content_type": "html",
    "content": "articles/created/org-immune-system-micro-trauma.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-org-immune-system-micro-trauma",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-debt",
    "title": "AI时代的\"决策债务\"——今天用AI省下的思考，明天要连本带利还回来",
    "summary": "•决策债务分三种：认知债（思考能力退化）、解释债（说不清推理过程）、纠偏债（偏见被放大）\n•AI越准→管理者思考机会越少→能力退化→越依赖AI——恶性循环\n•伪确定性问题：AI的95%置信度不等于95%正确率，高数值麻痹了管理者的质疑\n•三个破法：盲判练习、解释笔记、压力测试\n•不是AI做错了，是AI做对了太多次——正确到让你以为不需要再学习了",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-debt.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-decision-debt",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-organizational-amnesia",
    "title": "AI时代的\"组织失忆症\"——当一切都被AI记录，反而什么也记不住了",
    "summary": "•记录能力增强百倍，但员工\"主动回想\"能力反而在下降\n•三个机制：记录≠记忆（跳过提取环节）、信息过载（搜索时间反增）、记录改变行为（只写安全的内容）\n•对照实验：AI组检索故障平均42分钟，人工组现场推理仅23分钟\n•三个解法：遗忘机制（90天归档）、叙事通道（无记录分享）、信任标签（五星验证体系）\n•存储不是记忆——被讲述的才是真正被记住的",
    "content_type": "html",
    "content": "articles/disrupted/ai-organizational-amnesia.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-organizational-amnesia",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "created-ai-smile-curve-middle-squeeze",
    "title": "AI微笑曲线——为什么AI让头部和尾部受益，却挤压了中间层",
    "summary": "•AI加速了组织价值分配的微笑曲线：头部（战略）和尾部（一线触点）得到杠杆，中间层（执行转化）被挤压\n•12家企业薪酬数据：研发总监涨15-20%，销售提成涨30-40%，项目经理仅3-5%\n•麦肯锡数据：中等技能岗位需求下降23%，高技能和低技能人际岗分别上升18%和9%\n•三条突围路径：向左走（参与决策形成）、向右走（深入一线场景）、走中间但变厚（从信息搬运到判断赋能）\n•微笑曲线是地图，不是宿命",
    "content_type": "html",
    "content": "articles/created/ai-smile-curve-middle-squeeze.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-smile-curve-middle-squeeze",
    "created_at": "2026-07-07",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-recruit-reverse-elimination",
    "title": "AI招聘的反向淘汰——当你最想要的候选人正在被你的AI筛掉",
    "summary": "•AI筛简历的精准度上升了，但团队意外惊喜的概率在归零\n•三个反向淘汰机制：路径依赖淘汰、非典型才能无视、拟合焦虑淘汰\n•MIT研究：AI招聘后顶尖绩效员工占比下降22%\n•三个破法：强制盲盒通道（10%）、每季度反向审计、训练AI识别潜力信号\n•真正的好组织不是能招到符合标准的人，而是能发现超越标准的人",
    "content_type": "html",
    "content": "articles/disrupted/ai-recruit-reverse-elimination.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-recruit-reverse-elimination",
    "created_at": "2026-07-08",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-visibility-paradox",
    "title": "AI时代的被看见算术——为什么透明度越高，不公平感反而越强",
    "summary": "•被看见算术公式：不公平感 =（看到的差距 × 无法改变的程度）÷ 理解的合理性\n•三个不公平陷阱：只看见结果不看见路径、只看见相对差距不看见绝对价值、只看见当前数据不看见成长轨迹\n•UBER/Lyft司机投诉：不是收入降低，而是相对地位感知变差\n•透明不等于公平，知道怎么赢才是公平\n•给差距配路径图、切换参照系、引入可理解性审计",
    "content_type": "html",
    "content": "articles/disrupted/ai-visibility-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-visibility-paradox",
    "created_at": "2026-07-08",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-parameter-management-decline",
    "title": "当管理变成调参数——AI时代最隐蔽的管理能力退化",
    "summary": "•管理者正在从管人管事变成调几个数——四项核心能力在偷偷退化\n•被偷走的能力：情境判断（只看面板不看现场）、人际洞察（靠情绪评分不靠观察）、创造性问题解决（只调参数不破框架）、经验传承（会查数但说不清道理）\n•Rita McGrath：管理技能的去技能化——领域越自动化，从业者核心能力越退化\n•三个对策：无系统日、调参数前三步思考、管理直觉库\n•管理是在模糊中找方向——AI永远替代不了那个瞬间，前提是你还在练习捕捉它",
    "content_type": "html",
    "content": "articles/disrupted/ai-parameter-management-decline.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-parameter-management-decline",
    "created_at": "2026-07-08",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-feedback-too-efficient",
    "title": "AI让反馈变得太高效，反而没人敢给反馈了",
    "summary": "AI反馈系统上线后反馈次数提升420%，但真诚度评分下降57%。\n反馈通货膨胀——反馈变为无限供应后每条反馈的边际价值不断下降。\n管理者在系统里不敢写真话——当面可以补救，系统里是永久记录。\n谷歌研究：AI反馈上线后，直接批评性反馈下降73%，无关痛痒正面反馈增长210%。\n解决方案：反馈分层设计——AI自动层/人机协作层/纯人反馈层。\n最值钱的反馈，从来不是系统催出来的，是敢于说真话的勇气。",
    "content_type": "html",
    "content": "articles/disrupted/ai-feedback-too-efficient.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-feedback-too-efficient",
    "created_at": "2026-07-09",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-strategic-restraint",
    "title": "AI时代，做不到才是组织的核心竞争力",
    "summary": "AI让能做的边界无限扩展，但该做的判断力没有跟上。\n教育公司用AI一周上了47条投放素材，转化率从2.1%降到0.3%。\n战略的本质不是做什么，是不做什么——乔布斯砍掉70%产品线。\n战略克制（Strategic Restraint）是AI时代的新稀缺能力。\n三个方法：不做清单、AI建议否决阈值、月度浪费复盘。\nAI可以做几乎任何事，但最稀缺的是不做什么的勇气和判断力。",
    "content_type": "html",
    "content": "articles/disrupted/ai-strategic-restraint.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-strategic-restraint",
    "created_at": "2026-07-09",
    "updated_at": null
  },
  {
    "id": "disrupted-ceo-ai-anxiety-contagion",
    "title": "CEO的AI焦虑正在传染给整个组织",
    "summary": "76%的CEO认为AI将改变商业模式，但只有23%有明确AI战略。\n三种焦虑症状：战略散焦、面子工程、仓促转型。\n三条传染管道：战略反复、资源挤压、文化信号。\n区分噪声焦虑和信号焦虑的三个指标。\n实操建议：焦虑日志、锚点项目、季度焦虑审计。\nCEO焦虑被正确翻译是战略，翻译错误是组织最大风险源。",
    "content_type": "html",
    "content": "articles/disrupted/ceo-ai-anxiety-contagion.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ceo-ai-anxiety-contagion",
    "created_at": "2026-07-09",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-standard-answer-employees",
    "title": "AI正在制造\"标准答案型员工\"——当独立思考变成系统漏洞",
    "summary": "•微软研究：重度AI使用者的独立问题解决能力得分比轻度使用者低34%\n•\"答对\"正在取代\"想对\"——结果都漂亮了，但看不到思考痕迹\n•认知外包陷阱：有了AI的标准答案后，大脑自动切换到\"答案接收模式\"\n•\"标准答案型员工\"让组织失去应变能力——导航失灵，全军迷路\n•三个解法：无AI思考时段、考核提问质量、AI盲测练习\n•标准答案很廉价，独特的思考才是组织真正的护城河",
    "content_type": "html",
    "content": "articles/disrupted/ai-standard-answer-employees.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-standard-answer-employees",
    "created_at": "2026-07-10",
    "updated_at": null
  },
  {
    "id": "stable-ai-communication-currency",
    "title": "AI时代，表达能力才是新的硬通货",
    "summary": "•AI提高了信息生产效率，但没有提高信息的\"被理解效率\"\n•AI培训中的发现：表达能力强的学员，AI工具使用效果普遍高出3到5倍\n•\"说不清楚\"的成本在AI时代急剧上升——AI需要精确输入\n•表达能力三层拆解：清晰度（说清是什么）、结构力（说清为什么）、影响力（让对方行动）\n•三个实操方法：30秒电梯演讲、AI做表达陪练、一句话复盘\n•AI不是表达能力的替代品，而是放大器",
    "content_type": "html",
    "content": "articles/stable/ai-communication-currency.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-communication-currency",
    "created_at": "2026-07-10",
    "updated_at": null
  },
  {
    "id": "created-ai-learn-from-failure",
    "title": "AI把组织变成了\"试错机器\"——但没人负责从错误中学习",
    "summary": "•AI让组织疯狂试错——每天自动跑300个A/B测试，但没人整理实验教会了我们什么\n•\"试错\"和\"从错误中学习\"是两件事——AI能做好前者，但做不了后者\n•92%的失败实验从未被分析过（斯坦福研究）\n•AI时代失败的归因变得模糊——设计、执行、分析都是AI，不知道谁的问题\n•三个解法：学习预算、失败知识库、学习复盘日\n•SaaS公司案例：建立学习机制后，AI实验成功率从19%提升到37%\n•每一个错误都是学费——别让它白交了",
    "content_type": "html",
    "content": "articles/created/ai-learn-from-failure.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-learn-from-failure",
    "created_at": "2026-07-10",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-attention-deficit",
    "title": "AI让组织患上了“注意力缺陷”——当每个部门都在追新工具",
    "summary": "•哥伦比亚大学实验：同时关注3个AI工具的团队，产出质量比只关注1个的低41%，耗时多60%\n•每个AI工具像一台老虎机——投了学习成本尝到甜头，但还没融入就被下一个吸引\n•78%企业同时部署3+AI项目，仅12%完全落地（麦肯锡）\n•三种隐性成本：学习迁移成本、协作摩擦成本、决策疲劳成本\n•三个解法：一个季度只干一件事、AI工具准入清单、给专注发奖金\n•组织的注意力是不可再生资源——少即是多，聚焦才是AI时代真正的竞争力",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-attention-deficit.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-attention-deficit",
    "created_at": "2026-07-11",
    "updated_at": null
  },
  {
    "id": "stable-ai-slow-is-fast",
    "title": "AI时代，“慢慢来”才是最高效率——当组织开始追求深度而非速度",
    "summary": "•物流公司快上AI排班→司机罢工→上线到稳定花了8个月（前3个月全在补坑）\n•互联网公司2周上AI助手→使用率从75%降到12%（信任快速崩塌）\n•制造企业花18个月落地AI排班，产能效率提升15%，员工满意度提升21%\n•“深度消化”(Deep Digestion)——技术+业务+人三者融合需要时间\n•三步法：问题定义(≥2周)→小范围验证(1-2月)→全量推广(3-6月)\n•快组织每换一次工具从零积累，深组织持续复利叠加\n•“你想快三个月，还是想赢五年？”",
    "content_type": "html",
    "content": "articles/stable/ai-slow-is-fast.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-slow-is-fast",
    "created_at": "2026-07-11",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-fake-growth-learning-plateau",
    "title": "AI制造的“虚假成长”——你的团队在加速学习，但能力曲线正在变平",
    "summary": "•MIT研究：AI组学习速度快3倍，但两周后知识保留率低了47%\n•“必要难度”(Desirable Difficulties)——越费力记住的，留得越深\n•“流畅性幻觉”(Fluency Illusion)——看懂≠学会\n•AI让“表演学习”变得太容易——10%的精力刷出100%的完成度\n•三个方法：间隔检索(1/3/7天延迟测试)、场景迁移测试、教学相长训练\n•“学习数据泡沫”——完成率、通过率与真实能力的相关性在崩塌\n•让学习重新“变难”，才是对员工真正的负责",
    "content_type": "html",
    "content": "articles/disrupted/ai-fake-growth-learning-plateau.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-fake-growth-learning-plateau",
    "created_at": "2026-07-11",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-headquarter-blindness",
    "title": "AI时代的\"总部幻觉\"——为什么一线的问题，AI报告里永远看不到",
    "summary": "•Gartner 2025年报告：72%部署AI仪表盘的企业，高管感知准确度反而下降31%\n•AI制造\"完美虚假\"——数据全面且漂亮，但掩盖了非结构化真相（团队氛围、精神离职、地下流程）\n•三个维度：数据采集盲人摸象（古德哈特定律）、平均化陷阱、决策反馈闭环断裂\n•四个破法：配反指标、建立一线现场信号采集、季度的AI审计+真人校验、训练AI识别沉默信号\n•最危险的管理者不是不看AI报告的人，而是只看AI报告的人",
    "content_type": "html",
    "content": "articles/disrupted/ai-headquarter-blindness.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-headquarter-blindness",
    "created_at": "2026-07-12",
    "updated_at": null
  },
  {
    "id": "stable-ai-happiness-paradox",
    "title": "AI时代的\"幸福悖论\"——为什么麻烦都解决了，人却更不开心了",
    "summary": "•BCG调研显示：使用AI最频繁的员工，工作成就感得分比中度使用者低27%，焦虑得分高18%\n•Microsoft Work Trend Index：73%员工说AI提升了效率，仅39%说提升了满意度\n•自我决定理论视角：AI偷走了胜任感（系统厉害不是你厉害）、增加了自主感焦虑、稀释了归属感\n•三个解法：保留\"手工区\"保护成就感、重新定义\"完成\"标准（表扬判断力而非效率）、设计\"无AI互动时间\"\n•效率是冷冰冰的加法，幸福感是暖洋洋的乘法",
    "content_type": "html",
    "content": "articles/stable/ai-happiness-paradox.html",
    "category_id": "stable",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-happiness-paradox",
    "created_at": "2026-07-12",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-question-value",
    "title": "AI时代的\"提问权\"正在被谁拿走——问出好问题，正在成为最稀缺的能力",
    "summary": "•世界经济论坛2026年报告：\"提问能力\"需求增速65%，\"基础执行技能\"需求持续下降\n•调研发现提问权已出现三个集中：向上集中（管理者独占好问题）、向少数人集中（10%的人提42个分析型问题/周，90%只提7个事务型）、向表达能力好的人集中\n•三个后果：认知断层加深、决策极化、被安排感增强引发离职潮\n•四个对策：把提问嵌入工作流、建立\"最佳问题\"共享机制、提供提问模板降低门槛、用提问能力替代执行能力做评估\n•一个人的成长速度≈他问问题的质量提升速度",
    "content_type": "html",
    "content": "articles/disrupted/ai-question-value.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-question-value",
    "created_at": "2026-07-12",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-competence-hollowing-out",
    "title": "AI时代的\"能力空心化\"——当组织用AI替代了所有\"苦活\"，人的底层能力正在塌陷",
    "summary": "•AI替代了那些\"苦活累活\"，而这些苦活累活恰恰是底层能力生长的土壤。\n•三种正在被AI掏空的核心能力：判断力（不再手动校验）、结构力（不再从头搭建）、直觉力（不再身体记忆）\n•组织层面三个阶段：AI取代苦活→能力断代→系统脆弱性爆发\n•BCG调研：67%的年轻使用AI频繁者表示\"没有AI我不确定能否独立完成核心工作\"\n•四个反效率对策：无AI日机制、新人禁AI期、手动校验环节、脱AI能力考核",
    "content_type": "html",
    "content": "articles/disrupted/ai-competence-hollowing-out.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-competence-hollowing-out",
    "created_at": "2026-07-14",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-invisible-labor",
    "title": "AI时代的\"隐性劳动\"——当AI只统计可量化的产出，哪些真正重要的工作正在被忽视",
    "summary": "•AI绩效系统给老员工打了3.2分（满分10），但他走了团队效率至少降30%\n•三种被AI系统无视的隐性劳动：防护型（让坏事不发生）、整合型（把碎片信息变成共识）、托举型（让别人的产出变好）\n•MIT研究：41%的隐性劳动时间被AI绩效系统完全忽略\n•AI让量化无处不在→隐性劳动在数据上\"不存在\"→3.2分的人真的走了\n•五个解法：防坑指数、求助热力图、保留30%人评权重、隐性贡献奖、管理者月度审计",
    "content_type": "html",
    "content": "articles/disrupted/ai-invisible-labor.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-invisible-labor",
    "created_at": "2026-07-14",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-time-illusion",
    "title": "AI时代的\"时间幻觉\"——当效率提升了300%，为什么我们的时间反而更不够用了",
    "summary": "•Microsoft Work Trend Index：58%的AI使用知识工作者表示每周工作时间反而增加了\n•三种时间幻觉：效率提升=工作减少（错，杰文斯悖论）、AI能帮你一心多用（错，认知切换成本）、多产出=更多价值（错，洞察密度变稀）\n•核心悖论：AI给了你一个永远追不上的加速度\n•三个硬道理：把省下来的时空出来、区分\"AI可做\"和\"AI该做\"、将深度工作作为核心指标\n•真正的效率不是单位时间做的事更多，是把单位时间花在更值得的事上",
    "content_type": "html",
    "content": "articles/disrupted/ai-time-illusion.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-time-illusion",
    "created_at": "2026-07-14",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-organization-nodules",
    "title": "AI时代的\"组织结节\"——当每个环节都被AI优化到极致，组织反而僵住了",
    "summary": "•最优化的局部之和，不等于最优化的整体——每个环节都被AI优化到极致，系统反而失去了弹性\n•三种被AI系统性消除的\"组织结节\"：人的冗余（备用人员被裁）、时间的冗余（缓冲时间被压缩）、信息的冗余（多余信息被过滤）\n•核心悖论：AI越强，组织越脆弱——一次供应链中断就能让整体系统坍塌\n•三根保险丝：每个关键岗位留一个\"闲着\"的人、AI排期加20%缓冲、每周一次跨域信息分享\n•真正的组织韧性不是把一件事做到100%，而是出了问题时有备选路径",
    "content_type": "html",
    "content": "articles/disrupted/ai-organization-nodules.html",
    "category_id": "disrupted",
    "tags": ["AI","组织结节","系统韧性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-organization-nodules",
    "created_at": "2026-07-15",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-error-learning-paradox",
    "title": "AI时代的\"纠错困境\"——当你不再犯错，你也就不再成长",
    "summary": "•认知科学：理想困难度——人需要在15%的时间里犯错才能保持最佳学习速度\n•三类正在消失的试错学习：判断力试错（审计新人靠点确认）、创造力试错（设计师失去独立审美）、人际互动试错（销售员失去临场反应能力）\n•核心判断：AI必须犯错，人才能学习——区分\"重复性低级错误\"（消除）和\"判断性高级试错\"（保留）\n•三条建议：无AI工作日、只预警不纠错、建立个人错误档案\n•AI帮你避免尴尬的同时，也帮你避开了成长",
    "content_type": "html",
    "content": "articles/disrupted/ai-error-learning-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI","试错学习","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-error-learning-paradox",
    "created_at": "2026-07-15",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-performance-gaming-paradox",
    "title": "AI时代的\"绩效博弈\"——当员工比AI更聪明地玩游戏",
    "summary": "•员工不是被AI管理了——他们在\"玩\"这个AI系统，就像玩家找游戏bug\n•古德哈特定律在AI时代加速：AI反馈太快+指标太精确→员工即时调整策略\n•三种典型博弈：选择性努力（只做有分的事）、时间博弈（卡考核周期）、合规表演（满足规则但不创造价值）\n•AI绩效上线3-6个月最危险——追踪12家企业，38%团队出现数据美化\n•对策：每个岗位最多3个指标、20%抽样人工复核、季度更新考核参数",
    "content_type": "html",
    "content": "articles/disrupted/ai-performance-gaming-paradox.html",
    "category_id": "disrupted",
    "tags": ["AI","绩效博弈","古德哈特定律"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-performance-gaming-paradox",
    "created_at": "2026-07-15",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-decision-parasite",
    "title": "AI时代的\"决策寄生虫\"——AI帮你做决定，但你的决策肌肉正在萎缩",
    "summary": "•认知卸载的本质——以前的工具卸载的是'执行'，AI卸载的是'判断'\n•判断力腐化循环：越依赖AI→判断机会越少→判断力越差→越依赖AI\n•MIT研究：用AI决策的团队离开AI后比不用AI的团队低了11%\n•三类被吞噬的决策能力：模糊决策、创新决策、责任决策\n•三根保险丝：盲判优先、无AI窗口、决策日志制度",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-parasite.html",
    "category_id": "disrupted",
    "tags": ["AI","判断力","决策依赖","认知卸载"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-decision-parasite",
    "created_at": "2026-07-16",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-growth-illusion",
    "title": "AI时代的\"增长幻觉\"——AI把\"做到\"的门槛降低了，但把\"想清楚\"的门槛提高了",
    "summary": "•AI大幅降低了执行门槛，但大大提高了方向判断的门槛\n•三层假象：产出≠成果、动作≠进步、存量增长≠增量创造\n•核心公式：需求明确度 × AI能力 = 产出质量\n•AI让你更快地犯错，而且犯更大的错\n•三个破法：想三遍再做、追踪有效产出率、反方向投资原则",
    "content_type": "html",
    "content": "articles/disrupted/ai-growth-illusion.html",
    "category_id": "disrupted",
    "tags": ["AI","增长幻觉","战略判断","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-growth-illusion",
    "created_at": "2026-07-16",
    "updated_at": null
  },
  {
    "id": "created-ai-intent-analyst",
    "title": "AI时代的\"意图分析师\"——当AI能执行任何命令，最贵的技能是\"你到底想要什么\"",
    "summary": "•AI时代价值重心从'怎么做'移到了'要什么'\n•三个典型意图模糊场景：手段当目标、跟风式需求、'更多'替代'更好'\n•意图分析师将成为未来3-5年的新职业\n•需求明确度 × AI能力 = 产出质量 公式\n•三个破法：五层为什么追问、需求质量指标、澄清能力训练",
    "content_type": "html",
    "content": "articles/created/ai-intent-analyst.html",
    "category_id": "created",
    "tags": ["AI","意图分析","新职业","需求管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-intent-analyst",
    "created_at": "2026-07-16",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-experience-polarization",
    "title": "AI时代的“经验两头化”——AI正在让强者愈强、弱者愈弱",
    "summary": "•AI是经验的加速器，不是经验的平替\n•实验：资深员工效率提升58%，新手仅提升8%\n•三条被AI挤占的学习路径\n•核心判断：AI正在加速经验分化\n•三个破法：AI经验桥、无AI实战日、成长型AI反馈",
    "content_type": "html",
    "content": "articles/disrupted/ai-experience-polarization.html",
    "category_id": "disrupted",
    "tags": ["AI","经验差距","技能分化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-experience-polarization",
    "created_at": "2026-07-17",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-efficiency-obesity",
    "title": "AI时代的“效率肥胖症”——每件小事都快了，但组织整体变慢了",
    "summary": "•微效率提升200%，宏观效率反而下降\n•“效率肥胖症”的三大症状\n•数据：单任务耗时缩短40%，任务量增加215%\n•核心悌论：局部最优之和导致整体次优\n•三个破法：任务合并率、时间单元锁定、“不做”清单",
    "content_type": "html",
    "content": "articles/disrupted/ai-efficiency-obesity.html",
    "category_id": "disrupted",
    "tags": ["AI","效率悌论","组织肥胖"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-efficiency-obesity",
    "created_at": "2026-07-17",
    "updated_at": null
  },
  {
    "id": "created-ai-collaboration-overload",
    "title": "AI时代的“协同过载”——当AI让协作太容易，沟通本身成了新瓶颈",
    "summary": "•协作的帕金森定律：工作膨胀到填满所有协作工具\n•数据：沟通增加340%，有效产出只增40%\n•三类“协作假象”\n•核心问题：发起成本降低了，处理成本没变\n•三个破法：异步优先、沟通ROI、静默时间",
    "content_type": "html",
    "content": "articles/created/ai-collaboration-overload.html",
    "category_id": "created",
    "tags": ["AI","协同过载","沟通成本"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-collaboration-overload",
    "created_at": "2026-07-17",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-evaluation-deflation",
    "title": "AI时代的\"评价通缩\"——当AI每秒产出一个方案，\"这个好不好\"正在变成最贵的判断",
    "summary": "•生产端通胀，评价端通缩：AI让产出暴增，判断力成新瓶颈\n•数据：设计师方案数量增4倍，\"通过率\"从60%骤降至18%\n•\"评价过载\"：当每天要判断100个方案，判断质量必然崩塌\n•核心机制：评价本身也是技能，不练就退化\n•三个破法：建立判断力训练机制、结构性减少决策频次、引入\"反直觉\"测试",
    "content_type": "html",
    "content": "articles/disrupted/ai-evaluation-deflation.html",
    "category_id": "disrupted",
    "tags": ["AI","评价通缩","判断力","决策质量"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-evaluation-deflation",
    "created_at": "2026-07-18",
    "updated_at": null
  },
  {
    "id": "stable-ai-anti-consensus-premium",
    "title": "AI时代的\"反共识溢价\"——为什么最值钱的想法，往往是AI不赞同的那个",
    "summary": "•AI的本质是\"共识引擎\"——输出的永远是最大概率的答案\n•核心判断：AI时代非共识思考的溢价更高了\n•数据：差异化方案的成功率是同质化方案的2.3倍\n•为什么组织会自然滑向\"AI共识陷阱\"\n•三个破法：异议配额制、AI魔鬼代言人、每周\"疯狂15分钟\"",
    "content_type": "html",
    "content": "articles/stable/ai-anti-consensus-premium.html",
    "category_id": "stable",
    "tags": ["AI","反共识","差异化","非共识溢价"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-anti-consensus-premium",
    "created_at": "2026-07-18",
    "updated_at": null
  },
  {
    "id": "created-ai-document-swamp",
    "title": "AI时代的\"文档沼泽\"——当AI让每句话都变成完美文档，没人再读任何文档",
    "summary": "•AI文档自动化让信息产出暴涨，但信息密度暴跌\n•数据：文档生成量增8倍，文档平均阅读时间降75%\n•\"格式精美，内容空洞\"——AI文档的通病\n•核心问题：自动化文档创造的不是知识，是\"知识表演\"\n•三个破法：强制三句话摘要、文档ROI追踪、阅读优先于写作",
    "content_type": "html",
    "content": "articles/created/ai-document-swamp.html",
    "category_id": "created",
    "tags": ["AI","文档沼泽","知识管理","信息过载"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-document-swamp",
    "created_at": "2026-07-18",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-opinion-polarization",
    "title": "AI时代的“意见极化”——当算法只给你看你想看的，团队的共识能力正在崩溃",
    "summary": "•每个部门的AI助手都在个性化筛选信息，三个月后大家看到的事实已经完全不同\n•AI让意见极化从过去的被动接收变成工作场景中主动制度化筛选\n•三层机制：信息源差异化→反馈回路固化→制度化认知鸿沟\n•AI越能准确满足你当下的信息需求，你就越看不到你应该看到的东西\n•三个破法：建共享事实层、做AI配置审计、安排认知对冲",
    "content_type": "html",
    "content": "articles/disrupted/ai-opinion-polarization.html",
    "category_id": "disrupted",
    "tags": ["AI","意见极化","信息茧房","共识崩溃","跨部门协作"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-opinion-polarization",
    "created_at": "2026-07-19",
    "updated_at": null
  },
  {
    "id": "eliminated-ai-imperfect-advantage",
    "title": "AI时代的“不完美优势”——为什么最优秀的团队不是最精准的，而是最会犯错的",
    "summary": "•AI把精准度推到极致后，团队的创新能力和发现新问题的能力反而大幅下降\n•AI优化的逻辑是减少偏差消除误差，创新需要的是引入偏差拥抱意外\n•对照实验：全AI优化组转化率提升22%，但保留10%人工随机组三个月后发现了两个新品类打法\n•最高精准度的团队，创新能力平均低37%\n•三件事：留30%随机性、建错误发现制度、设反AI预算",
    "content_type": "html",
    "content": "articles/eliminated/ai-imperfect-advantage.html",
    "category_id": "eliminated",
    "tags": ["AI","不完美优势","创新","精益求精陷阱","反AI预算"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-imperfect-advantage",
    "created_at": "2026-07-19",
    "updated_at": null
  },
  {
    "id": "created-ai-decision-entropy",
    "title": "AI时代的“决策熵增”——为什么每加一个AI工具，组织的混乱度就增加一分",
    "summary": "•每个AI工具消灭一种混乱的同时创造三种新混乱：信息噪音、决策冲突、责任模糊\n•工具数量与决策速度呈倒U型曲线：前3个提升40%，第8个以后开始下降\n•各AI工具隐性冲突：对同一项目给出互相矛盾的建议\n•员工平均每周花4.3小时协调AI冲突\n•三条治理原则：做减法、建AI指令协调层、定期做熵值检测",
    "content_type": "html",
    "content": "articles/created/ai-decision-entropy.html",
    "category_id": "created",
    "tags": ["AI","决策熵增","工具泛滥","AI治理","组织混乱"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-decision-entropy",
    "created_at": "2026-07-19",
    "updated_at": null
  },
  {
    "id": "created-ai-decision-assetization",
    "title": "AI时代的\"决策资产化\"——当每个决策都能被沉淀、定价和复用",
    "summary": "AI能不能把\"决策\"变成一种可沉淀、可定价、可复用的资产？本文提出三层框架——记录、估值、复用，揭示为什么未来公司的估值标准不再是客户数和收入，而是\"可复用的决策模型\"。",
    "content_type": "html",
    "content": "articles/created/ai-decision-assetization.html",
    "category_id": "created",
    "tags": ["AI","决策资产化","组织知识管理","隐性知识","组织效能"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-decision-assetization",
    "created_at": "2026-07-20",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-silent-knowledge-dividend",
    "title": "AI时代的\"隐性知识溢价\"——当AI能处理一切显性知识，藏在人脑里的东西反而更值钱了",
    "summary": "当所有显性知识都能被AI3秒回答，隐性知识的价值反而被放到最大。情境判断力、关系感知力、跨界联想力——这些AI学不会的东西，正在成为最稀缺的组织资产。",
    "content_type": "html",
    "content": "articles/disrupted/ai-silent-knowledge-dividend.html",
    "category_id": "disrupted",
    "tags": ["AI","隐性知识","知识管理","显性化陷阱","组织能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-silent-knowledge-dividend",
    "created_at": "2026-07-20",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-immune-overload",
    "title": "AI时代的\"组织免疫过载\"——当每个问题都被AI发现，组织反而不会呼吸了",
    "summary": "AI发现问题的速度远超解决问题——当问题清单变成瀑布，组织不是更好了，而是更焦虑了。用免疫系统类比，揭示AI时代最被低估的危机。",
    "content_type": "html",
    "content": "articles/disrupted/ai-immune-overload.html",
    "category_id": "disrupted",
    "tags": ["AI","免疫过载","问题噪声","选择性忽略","组织健康"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-immune-overload",
    "created_at": "2026-07-20",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-explanation-divide",
    "title": "AI时代的\"解释权鸿沟\"——AI时代正在把世界分成两种人：问\"为什么\"的人和等\"答案\"的人",
    "summary": "•AI时代正在把世界分成\"答案依赖型\"和\"解释权持有者\"两种人\n•95%的人信AI的分析，但只有22%能为自己的\"信\"负责\n•三层追问习惯：数据层、逻辑层、边界层\n•三类正在建立的解释权鸿沟：认知层、组织层、权力层\n•三个破法：建立追问习惯、设立解释权时刻、建立解释权日志",
    "content_type": "html",
    "content": "articles/disrupted/ai-explanation-divide.html",
    "category_id": "disrupted",
    "tags": ["AI","解释权","认知分化","批判性思维"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-explanation-divide",
    "created_at": "2026-07-21",
    "updated_at": null
  },
  {
    "id": "created-ai-morality-tax",
    "title": "AI时代的\"道德税\"——当AI能帮你做任何事，\"我不做\"反而成了最贵的决策",
    "summary": "•道德税：AI把效率差距拉大到让人坐立不安的程度后产生的道德选择成本\n•三类典型场景：定价困境、责任推诿、能力假装\n•组织层面：AI让\"不做\"的成本和\"做\"的道德成本两端都在增长\n•个人透明度原则：经得起追问就够\n•AI时代最稀缺的品质：知道什么事不该用AI做",
    "content_type": "html",
    "content": "articles/created/ai-morality-tax.html",
    "category_id": "created",
    "tags": ["AI","道德税","AI伦理","职业诚信"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-morality-tax",
    "created_at": "2026-07-21",
    "updated_at": null
  },
  {
    "id": "stable-ai-vision-hollowing",
    "title": "AI时代的\"愿景空心化\"——AI能完成所有\"怎么做\"，但\"往哪去\"正在成为组织的最大瓶颈",
    "summary": "•AI把执行效率推到了极致，但\"往哪去\"成了最被忽视的真问题\n•效率主义陷阱：AI不会纠正方向，只会加速你把错误方向走到极致\n•德鲁克区分：效率是把事做对，有效性是做对的事——AI放大前者，人必须守住后者\n•新竞争力公式：愿景清晰度×AI执行能力（乘法关系）\n•三个破法：愿景产能单独留时、每月方向校准会、个人\"不做清单\"",
    "content_type": "html",
    "content": "articles/stable/ai-vision-hollowing.html",
    "category_id": "stable",
    "tags": ["AI","愿景","战略方向","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-vision-hollowing",
    "created_at": "2026-07-21",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-hidden-contract",
    "title": "AI时代的\"隐藏合同\"——当算法开始决定你的职业命运，谁签过字？",
    "summary": "你入职时签的劳动合同上，没有一句话提到'公司会用AI评估你的表现'。但你的涨薪、晋升、去留，恰恰正在被一个你没签过字的「隐藏合同」所决定。MIT调查显示43%的企业用AI做绩效评估，只有12%明确告知员工。",
    "content_type": "html",
    "content": "articles/disrupted/ai-hidden-contract.html",
    "category_id": "disrupted",
    "tags": ["AI","隐藏合同","AI评估","员工信任","透明度"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hidden-contract",
    "created_at": "2026-07-22",
    "updated_at": null
  },
  {
    "id": "eliminated-ai-stop-using-skill",
    "title": "AI时代的\"停用能力\"——会用AI不难，敢停用AI才叫真本事",
    "summary": "我现在最头疼的不是团队不会用AI，而是他们不会不用AI。AI的启用成本在下降，但停用成本在指数增长。定时审查并停用低效AI工具的团队，人均产出增长22%；而那些装上就不管的团队，产出反而下降了。",
    "content_type": "html",
    "content": "articles/eliminated/ai-stop-using-skill.html",
    "category_id": "eliminated",
    "tags": ["AI","停用能力","工具依赖","决策勇气","组织效能"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-stop-using-skill",
    "created_at": "2026-07-22",
    "updated_at": null
  },
  {
    "id": "created-ai-org-babel",
    "title": "AI时代的\"组织巴别塔\"——当每个部门都在训练自己的AI，公司正在失去共同语言",
    "summary": "平均每家公司同时运行12.7个AI系统，各自的AI说不同的语言，彼此之间的认知鸿沟在迅速拉大。AI的专业化必然带来认知分化，统一的代价可能是专业性的牺牲——解决方案不是统一AI，而是给AI之间建一个'翻译层'。",
    "content_type": "html",
    "content": "articles/created/ai-org-babel.html",
    "category_id": "created",
    "tags": ["AI","组织巴别塔","认知孤岛","跨部门协作","AI治理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-babel",
    "created_at": "2026-07-22",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-newcomer-disconnect",
    "title": "AI时代的\"新人断联\"——AI让入职流程丝滑了，但新人和组织的连接断了",
    "summary": "•300人科技公司案例：AI入职后3个月留存率从85%降到62%\n•47%的新人第一周没和同事有过5分钟以上的非工作对话\n•三根被切断的连接线：人与人、人与文化、人与意义\n•本质：AI优化了效率但入职是建立关系的，不是系统配置\n•解决方案：保留\"被迫社交\"环节、设计连接缺口、文化体验流程化",
    "content_type": "html",
    "content": "articles/disrupted/ai-newcomer-disconnect.html",
    "category_id": "disrupted",
    "tags": ["AI","入职","组织连接","新人留存"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-newcomer-disconnect",
    "created_at": "2026-07-23",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-process-worship",
    "title": "AI时代的\"流程崇拜\"——当每件事都有标准流程，组织正在失去\"做人\"的能力",
    "summary": "•AI让流程全覆盖、自动执行、不可绕过——越完美越不允许例外\n•三个被流程崇拜杀死的能力：判断力、变通能力、人情味\n•\"流程盾牌\"现象：员工学会\"安全地不作为\"\n•混淆了确定性管理和不确定性管理——真正的竞争力是处理不确定性\n•方案：例外通道、判断力考核、非流程化空间、流程瘦身",
    "content_type": "html",
    "content": "articles/disrupted/ai-process-worship.html",
    "category_id": "disrupted",
    "tags": ["AI","流程管理","组织僵化","管理能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-process-worship",
    "created_at": "2026-07-23",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-execution-deficit",
    "title": "AI时代的\"执行力赤字\"——AI让规划变容易了，但\"动手干\"正在变成最稀缺的能力",
    "summary": "•规划的多巴胺替代了执行的痛苦：72%时间花在准备，仅28%在动手\n•校验循环替代了交付循环：AI让\"完美\"触手可及，\"差不多行了\"标准消失\n•选择的悖论：AI给无限选项，反而导致决策瘫痪\n•200人公司调研：人均4.3件未完成事项，74%因\"一直在准备\"\n•方案：AI回答截止时间、0.8版本原则、执行日制度",
    "content_type": "html",
    "content": "articles/disrupted/ai-execution-deficit.html",
    "category_id": "disrupted",
    "tags": ["AI","执行力","行动力","规划陷阱"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-execution-deficit",
    "created_at": "2026-07-23",
    "updated_at": null
  },
  {
    "id": "tension-ai-tacit-knowledge-paradox",
    "title": "AI时代的“沉默知识悖论”——显性知识越容易获取，隐性知识越值钱",
    "summary": "•银行15年客户经理的直觉案例：AI说“不该放贷”，人却说“这个人靠谱”\n•隐性知识三层次：判断力、连接力、直觉力——AI一个都替代不了\n•趋势：新手和老手差距在拉大，“AI面具”制造虚假能力，传承通道在收窄\n•本质：显性知识越廉价，隐性知识越昂贵——“说不清的能力”正在成为护城河\n•三条建议：跟师时间KPI化、踩坑标记系统、为老手创造例外处理舞台",
    "content_type": "html",
    "content": "articles/tension/ai-tacit-knowledge-paradox.html",
    "category_id": "tension",
    "tags": ["AI","隐性知识","组织能力","经验传承"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-tacit-knowledge-paradox",
    "created_at": "2026-07-24",
    "updated_at": null
  },
  {
    "id": "stable-ai-reverse-mentoring",
    "title": "AI时代的“反向培训”——当年轻员工教老员工用AI，传统“传帮带”正在被倒过来",
    "summary": "•27家企业调研：85%的AI培训实际执行者是部门里最年轻的员工\n•反向培训三重障碍：自尊心、语言屏障、组织激励缺失\n•“AI培训”改名为“AI技术茶话会”后参与率从15%升到67%\n•本质：几千年的“上教下”被AI颠覆，“谁都能教谁”才是新规则\n•方案：AI导师团、双向知识交换、“AI导师”职级通道",
    "content_type": "html",
    "content": "articles/stable/ai-reverse-mentoring.html",
    "category_id": "stable",
    "tags": ["AI","培训","反向培训","代际管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-reverse-mentoring",
    "created_at": "2026-07-24",
    "updated_at": null
  },
  {
    "id": "newroles-ai-second-brain-dependency",
    "title": "AI时代的“第二大脑依赖症”——当每个人都在外包思考，原始思考正在消失",
    "summary": "•哈佛研究类比：GPS让海马体缩小，AI作为“思维GPS”正在让独立思考能力退化\n•三种症状：空白页恐惧症、思路短路症、判断力外包症\n•斯坦福研究：AI依赖者独立写作质量明显低于不依赖AI的人\n•80%的人做创造性工作时第一反应是先问AI\n•新角色：“第一大脑维护师”——确保组织用AI但不失去独立思考能力",
    "content_type": "html",
    "content": "articles/newroles/ai-second-brain-dependency.html",
    "category_id": "newroles",
    "tags": ["AI","独立思考","认知退化","新角色"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-second-brain-dependency",
    "created_at": "2026-07-24",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-org-myopia",
    "title": "AI时代的\"组织近视症\"——当AI只优化眼前指标，组织正在失去看远的能力",
    "summary": "•年营收30亿制造企业案例：AI优化后效率飙升，但研发投入从5.2%降至2.8%，对手推出颠覆性产品\n•AI的天生偏好：可量化、短周期、高确定性——这不是缺陷，是设计原理\n•近视症三层结构：时间近视、局部近视、确定近视——第三层最危险\n•核心悖论：可见维度效率越高，不可见维度脆弱性越大\n•三个破法：逆向指标制衡、不可优化事项清单、不看报表的管理时间",
    "content_type": "html",
    "content": "articles/disrupted/ai-org-myopia.html",
    "category_id": "disrupted",
    "tags": ["AI","组织近视症","长期主义","AI优化","管理判断"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-myopia",
    "created_at": "2026-07-25",
    "updated_at": null
  },
  {
    "id": "created-ai-label-self-fulfilling",
    "title": "AI时代的\"标签自证\"——当AI给你打上标签，你就会变成那个标签写的人",
    "summary": "•罗森塔尔自证预言实验：被随机标记的\"未来之星\"IQ真的提高了\n•AI标签不是\"描述\"，是\"处方\"——它在定义你的同时正在改变你\n•三个真实案例：创新潜力一般、高离职风险、高潜力——标签改变了资源配置\n•自证预言加速器：AI贴标签→资源分配变化→行为改变→确认标签（几周而非几年）\n•三个破法：标签透明+员工异议权、标签柔软性（时效+置信度）、反标签资源分配机制",
    "content_type": "html",
    "content": "articles/created/ai-label-self-fulfilling.html",
    "category_id": "created",
    "tags": ["AI","标签自证","自证预言","AI偏见","人才管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-label-self-fulfilling",
    "created_at": "2026-07-25",
    "updated_at": null
  },
  {
    "id": "tension-ai-management-convenience-tax",
    "title": "AI时代的\"管理便利税\"——越方便的管理手段，越在悄悄掏空组织的内功",
    "summary": "•HRD的直觉不安：AI让工作轻松80%，但管理者对团队的真实感知在消失\n•核心定义：为了管理便利付出的\"管理深度\"的代价\n•三类便利税：理解的税（AI代劳了解人）、判断的税（AI代劳做判断）、关系的税（AI代劳沟通）\n•便利税是复利累积的，半年后你只认识数据，不认识人\n•三个退税方法：1/10无AI制度、非AI接触时间、年度关系审计",
    "content_type": "html",
    "content": "articles/tension/ai-management-convenience-tax.html",
    "category_id": "tension",
    "tags": ["AI","管理便利税","管理深度","人机协作","管理者能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-management-convenience-tax",
    "created_at": "2026-07-25",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-skill-commoditization",
    "title": "AI时代的\"能力货币化\"——当你的每个技能都能被独立定价和交易，组织的逻辑变了",
    "summary": "•成都设计师案例：有全职工作但收入中\"能力交易\"已超过工资，平台3700多人进入这种模式\n•核心定义：人的能力不再是岗位附属品，而是可独立定价、交易、拆解、组合的商品\n•正在摧毁三样东西：岗位基本单元、固定薪酬、全职雇佣的心理契约\n•正在创造三样东西：能力证券化、\"超个体\"（个人=微型公司）、液态团队\n•管理者的新角色：从\"管人\"变成\"编排能力\"",
    "content_type": "html",
    "content": "articles/disrupted/ai-skill-commoditization.html",
    "category_id": "disrupted",
    "tags": ["AI","能力货币化","液态组织","自由职业","组织变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-skill-commoditization",
    "created_at": "2026-07-26",
    "updated_at": null
  },
  {
    "id": "created-ai-org-darknet",
    "title": "AI时代的\"组织暗网\"——当正式沟通被AI监控，非正式沟通正在转入深度地下",
    "summary": "•跨部门KPI冲突案例：曾经在飞书激烈讨论40+条，现在转为一顿晚饭+私聊+咖啡角碰面\n•核心定义：正式沟通被AI监控后，成员自发建立的\"不被AI监控的地下沟通网络\"\n•三层暗网：微暗网（换个地方聊）、中暗网（加密沟通）、深暗网（共识沉默）\n•三大致命后果：决策质量下降、信任体系崩塌、新人无法融入\n•出路：把\"被监控感\"变\"被信任感\"，给暗网合法出口，承认看不见的沟通的价值",
    "content_type": "html",
    "content": "articles/created/ai-org-darknet.html",
    "category_id": "created",
    "tags": ["AI","组织暗网","非正式沟通","AI监控","信任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-darknet",
    "created_at": "2026-07-26",
    "updated_at": null
  },
  {
    "id": "tension-ai-outsourced-decision",
    "title": "AI时代的\"外包式决策\"病——你把决定权交给了AI，但没人告诉你你正在失去什么",
    "summary": "•沙盘实验对比：AI组轻松接受AI建议没想过\"但是\"，非AI组挣扎20分钟但训练了判断力\n•核心定义：管理者在理解决策问题前就把判断过程外包给AI，放弃了\"为什么\"的思考\n•外包三段论：AI帮我想→推理也外包→责任也外包（不对称归因陷阱）\n•真正代价：管理者的\"决策肌肉\"在萎缩，面对模糊决策的能力退化\n•治本方法：每次问AI前先写\"我现在的判断\"（直觉+已知+不确定）三句话",
    "content_type": "html",
    "content": "articles/tension/ai-outsourced-decision.html",
    "category_id": "tension",
    "tags": ["AI","外包式决策","决策能力","管理者能力","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-outsourced-decision",
    "created_at": "2026-07-26",
    "updated_at": null
  },
  {
    "id": "tension-ai-thought-tax",
    "title": "AI时代的\"思考税\"——当每次思考都有AI代劳，你的思考能力正在被悄悄收税",
    "summary": "·产品总监一周23次AI辅助决策的真相：一旦没AI，大部分无法独立完成\n·核心定义：每次让AI代劳思考，独立思考能力被悄悄扣除的隐性成本（税率渐进、无感、几乎无法退税）\n·三笔思考税：推理税（主动构建→被动校验）、问题税（提出精准问题能力下降）、质疑税（在AI完美答案包装下生锈）\n·交税最重的不是基层不是高层，是中层管理者（分析/方案/决策正好是AI最擅长的帮助领域）\n·三个退税方法：先想后问、每日纯脑力时间、每周无AI深度思考",
    "content_type": "html",
    "content": "articles/tension/ai-thought-tax.html",
    "category_id": "tension",
    "tags": ["AI","思考税","独立思考","中层管理者","AI依赖"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-thought-tax",
    "created_at": "2026-07-27",
    "updated_at": null
  },
  {
    "id": "newroles-ai-promise-dilution",
    "title": "AI时代的\"承诺稀释\"——当AI让所有\"答应\"都太容易，组织的信用体系正在崩坏",
    "summary": "·研发总监的吐槽：AI排期很高效，但AI答应的承诺没人认账了\n·核心定义：AI让答应太容易，但做不到的代价没有随之增加，承诺的效力被稀释\n·三类承诺稀释：AI代表你做承诺、承诺给了AI不是给了人、AI安排给你的承诺\n·连锁反应：承诺稀释→执行打折→追踪成本飙升→信任腐蚀（所有船都按自己航线走）\n·出路：AI可以记录但不能替人承诺，重要承诺必须人对人，承诺严肃性分级",
    "content_type": "html",
    "content": "articles/newroles/ai-promise-dilution.html",
    "category_id": "newroles",
    "tags": ["AI","承诺稀释","组织信用","协作效率","人机协作"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-promise-dilution",
    "created_at": "2026-07-27",
    "updated_at": null
  },
  {
    "id": "eliminated-ai-reverse-domestication",
    "title": "AI时代的\"反向驯化\"——你以为是你在训练AI，其实AI正在悄悄驯化你",
    "summary": "·亲身实验：半年后的邮件被朋友评价\"前半像真人写的，后半像AI写的\"\n·核心定义：你以为在训练AI适应你，实际你在悄悄调整自己的表达、思维、行为来适应AI\n·三个正反馈循环：表达AI友好化、思考结构化、模糊问题指令化\n·组织级反向驯化：沟通AI化、思维AI友好化、价值标准AI化（围绕AI舒适区运转）\n·三个破法：留AI禁区、练不AI友好的表达、每月自查\"这像是我写的还是AI写的\"",
    "content_type": "html",
    "content": "articles/eliminated/ai-reverse-domestication.html",
    "category_id": "eliminated",
    "tags": ["AI","反向驯化","独立思考","创造力","人机关系"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-reverse-domestication",
    "created_at": "2026-07-27",
    "updated_at": null
  },
  {
    "id": "tension-ai-emotion-inflation",
    "title": "AI时代的\"情绪通胀\"——当AI让情感表达太容易，情感货币正在贬值",
    "summary": "·管理咨询团队的真实案例：AI润色共情回复后，当事人感觉更冷了\n·核心定义：情感表达供应量被AI推高后，每份情感的实际\"购买力\"下降\n·三层结构：同情疲劳加速、真实情感溢价、情感表达军备竞赛\n·86%员工表达关心的频次在下降——因为\"怕表达得不够好\"\n·三个退税方法：非AI情感禁区、接受笨拙真诚、情感表达审计",
    "content_type": "html",
    "content": "articles/tension/ai-emotion-inflation.html",
    "category_id": "tension",
    "tags": ["AI","情绪通胀","情感表达","心理安全感","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-emotion-inflation",
    "created_at": "2026-07-28",
    "updated_at": null
  },
  {
    "id": "tension-ai-compliance-weaponization",
    "title": "AI时代的\"合规武器化\"——当AI把制度执行到极致，制度本身变成了权力工具",
    "summary": "·HR总监的痛：TOP3老员工因AI合规判定超标准住宿被扣分后提离职\n·核心定义：当AI消除一切人为缓冲，制度不再是工具而是权力武器\n·三步演化：制度从指南变天条、合规从底线变天花板、合规变人际博弈武器\n·12家企业数据：制度执行一致性从78%升到99.7%，公正满意度从71%降到43%\n·三个解法：例外通道、多方制定规则、AI意图判断能力",
    "content_type": "html",
    "content": "articles/tension/ai-compliance-weaponization.html",
    "category_id": "tension",
    "tags": ["AI","合规武器化","制度管理","组织公平","AI治理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compliance-weaponization",
    "created_at": "2026-07-28",
    "updated_at": null
  },
  {
    "id": "disrupted-ai-second-curve-blindspot",
    "title": "AI时代的\"第二曲线失明\"——当AI把现有业务优化到极致，组织看不到新机会了",
    "summary": "·15亿制造企业创始人的话：\"我现在忙到连想新业务的时间都没有了\"\n·核心定义：AI极端强化第一曲线，在结构上抑制第二曲线形成\n·三层失明：资源锁定（92%预算投第一曲线）、认知锁定（视野被优化信号绑架）、组织锁定（文化转向效率导向）\n·AI让现有业务效率提升的正反馈循环吸走所有注意力和资源\n·三个破法：不可优化预算（20%）、无指标时间、\"雷达\"岗位",
    "content_type": "html",
    "content": "articles/disrupted/ai-second-curve-blindspot.html",
    "category_id": "disrupted",
    "tags": ["AI","第二曲线","创新困境","组织锁定","AI治理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-second-curve-blindspot",
    "created_at": "2026-07-28",
    "updated_at": null
  },
  {
    "id": "tension-ai-authority-hollowing",
    "title": "AI时代的\"权威空心化\"——当AI比你更懂你的业务，你的权威建立在什么之上",
    "summary": "·技术总监的困惑：15年经验判断被AI花两小时推翻\n·管理权威三支柱(信息优势、经验优势、判断优势)被AI一根根拆解\n·信息优势已失：AI实时整合信息比管理者更全面\n·虚拟经验挤压：AI读过10万条踩坑记录，经验优势正在贬值\n·判断优势是最后阵地但也最脆弱——当AI预测对三次而人错一次，权威变成审核\n·三个致命后果：双重流程、执行中断、防御性表演\n·新权威AKA模型：校准力(Alignment)+解读力(Interpretation)+担当力(Accountability)",
    "content_type": "html",
    "content": "articles/tension/ai-authority-hollowing.html",
    "category_id": "tension",
    "tags": ["AI","权威空心化","管理权威","领导力","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-authority-hollowing",
    "created_at": "2026-07-29",
    "updated_at": null
  },
  {
    "id": "tension-ai-organizational-freezing",
    "title": "AI时代的\"组织速冻\"——当变化太快来不及适应，团队进入了\"应激冻结\"状态",
    "summary": "·科技公司CEO高调AI化：一口气上6个AI工具，团队两个月进入冻结状态\n·核心定义：变化速度超过适应能力，决策系统进入应激性冻结\n·三条诊断标准：决策潜伏期拉长、再确认成瘾、创新话语消失\n·三层冻结机制：认知过载→快捷键依赖、风险规避→不敢试错、目标游离→意义真空\n·67%管理者承认只看结论不看AI分析报告——从数据驱动变成结论盲从\n·三个解冻方案：认知空白时间、可控冒险基金、意义审计+还权",
    "content_type": "html",
    "content": "articles/tension/ai-organizational-freezing.html",
    "category_id": "tension",
    "tags": ["AI","组织速冻","认知过载","团队决策","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-organizational-freezing",
    "created_at": "2026-07-29",
    "updated_at": null
  },
  {
    "id": "tension-ai-skill-illusion",
    "title": "AI时代的\"技能幻觉\"——当培训平台显示你学了100小时，你的能力可能一点没涨",
    "summary": "·大厂培训数据：学习时长提升172%、完成率提升117%，但与绩效提升的相关性仅0.08\n·三层幻觉机制：消费错觉(看过了=学会了)、推荐泡沫(学想学的≠学需要的)、完成感陷阱(完成了≠成长了)\n·必要难度理论(Bjork)：学习时的难度越大，长期记忆效果越好\n·三个破解策略：从学时到学效、引入必要难度、建立技能验证闭环\n·实战结果：学习时长掉40%但能力提升反馈涨28%——从奖励完成行为到奖励能力变化",
    "content_type": "html",
    "content": "articles/tension/ai-skill-illusion.html",
    "category_id": "tension",
    "tags": ["AI","技能幻觉","培训效果","AI培训","组织学习"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-skill-illusion",
    "created_at": "2026-07-29",
    "updated_at": null
  },
  {
    "id": "ai-methodology-bubble",
    "title": "AI时代的“方法论泡沫”——当每个AI工具都在卖方法论，组织正在被框架淹没",
    "summary": "•当每个AI工具都自带一套方法论，组织正在经历“框架窒息”\n•方法论泡沫的三层结构：工具绑架、方法论冲突、方法论依赖症\n•一个真实案例：同一场周会，三套AI方法论轮番上阵，真正讨论业务不到20分钟\n•一主多辅原则：每个业务线最多用一个方法论类AI工具\n•好的AI工具让你减少框架来解决问题，坏的工具让你增加框架来配合它",
    "content_type": "html",
    "content": "articles/tension/ai-methodology-bubble.html",
    "category_id": "tension",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-methodology-bubble",
    "created_at": "2026-07-30",
    "updated_at": null
  },
  {
    "id": "ai-signal-noise-trap",
    "title": "AI时代的“信号噪声陷阱”——当AI把每个异常都标记出来，反而什么都看不见了",
    "summary": "•AI监测能力太强，一天生成347条告警，管理者却一条都不想看了\n•从“信息匮乏”到“信号过剩”的转型，管理者还在用旧思维\n•三个真实场景：绩效异常、舆情监控、项目预警中的“狼来了”效应\n•AI是完美的告警器，但它是糟糕的优先级排序器\n•核心判断：学会忽略比学会关注更难，但在AI时代更重要",
    "content_type": "html",
    "content": "articles/tension/ai-signal-noise-trap.html",
    "category_id": "tension",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-signal-noise-trap",
    "created_at": "2026-07-30",
    "updated_at": null
  },
  {
    "id": "ai-colleague-disappearing",
    "title": "AI时代的“同事关系”正在消失——当你的最佳协作者不是人",
    "summary": "•AI正在成为很多人心目中“最好的同事”\n•同事关系“空心化”：协作功能被替代，深层关系价值也在消失\n•三个正在被侵蚀的场景：问AI替代问同事、各自找AI替代一起解决问题、情绪外包给AI\n•组织必须主动设计“必须真人协作”的环节\n•AI是最好的同事，但最好的同事不应该是AI",
    "content_type": "html",
    "content": "articles/eliminated/ai-colleague-disappearing.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-colleague-disappearing",
    "created_at": "2026-07-30",
    "updated_at": null
  },
  {
    "id": "ai-error-conspiracy",
    "title": "AI时代的\"误差合谋\"——当你以为人和AI的偏见会互相抵消，它们正在互相放大",
    "summary": "•\"误差合谋\"的核心：人的偏见通过历史数据传给AI，AI再以\"科学化\"方式放大输出，形成自我强化闭环\n•三步传导：人的偏见→偏差数据→AI制造\"科学化\"偏见结论→人的偏见被进一步强化\n•三个真实场景：绩效评估的刻板印象放大器、人才选拔的路径依赖陷阱、协作评估的安静者惩罚\n•三种形态：数据偏见→算法偏见、框架偏见→结果偏见、互动偏见→自我实现的预言\n•打破方法：训练数据审计、反偏见测试用例、强制引入噪声、AI偏见红队",
    "content_type": "html",
    "content": "articles/tension/ai-error-conspiracy.html",
    "category_id": "tension",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-error-conspiracy",
    "created_at": "2026-07-31",
    "updated_at": null
  },
  {
    "id": "ai-decision-regret-right",
    "title": "AI时代的\"决策剩余\"消失——当判断变得太容易，优秀判断者的超额回报去哪了",
    "summary": "•\"决策剩余\"：因为你的判断比别人更准而获得的超额回报\n•AI消灭决策剩余的三种机制：判断力通胀、判断过程黑盒化、决策同质化\n•核心悖论：决策质量在上升，但个人决策能力在下降（做决策≠发展决策能力）\n•三类判断中，数据型判断的溢价正在消失，价值观判断的溢价在升值\n•守住决策剩余的四原则：裸判、非数据经验、过程考核、价值观溢价",
    "content_type": "html",
    "content": "articles/disrupted/ai-decision-regret-right.html",
    "category_id": "disrupted",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-decision-regret-right",
    "created_at": "2026-07-31",
    "updated_at": null
  },
  {
    "id": "ai-responsibility-quicksand",
    "title": "AI时代的\"责任流沙\"——当决策权被AI分担，责任也被稀释了",
    "summary": "•\"责任流沙\"：AI参与决策后，决策权被分担但责任无处附着，形成责任真空\n•问题比\"甩锅\"严重十倍：甩锅起码知道锅在哪，责任流沙让锅不见了\n•三个正在发生的场景：招聘AI背锅、AI定价的无人认领、AI项目失败的集体推卸\n•心理根源：\"责任转移本能\"——人本能地把责任让渡给看起来会思考的AI\n•对抗四步法：责任声明制度、复盘禁说AI、责任清单绑定自然人、负责人优先文化",
    "content_type": "html",
    "content": "articles/eliminated/ai-responsibility-quicksand.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-responsibility-quicksand",
    "created_at": "2026-07-31",
    "updated_at": null
  },
  {
    "id": "ai-loyalty-inflation",
    "title": "AI时代的\"忠诚度通胀\"——当AI让跳槽成本趋近于零，留人靠什么",
    "summary": "•\"忠诚度通胀\"：不是忠诚变贵了，是忠诚的\"购买力\"贬值了——旧留人筹码正在缩水\n•跳槽成本=信息成本+关系成本+学习成本，AI已击穿信息成本和学习成本\n•三大旧武器集体失灵：钱（薪酬透明化失去定价权）、晋升（层级压扁胡萝卜变短）、感情（连接虚拟化失去附着点）\n•留人三判断：给独特资源不给通用报酬、把晋升换成成长可见性、重建人跟人的连接\n•核心观点：忠诚是成本问题，要求员工忠诚，先给他一个\"不离开的理由\"",
    "content_type": "html",
    "content": "articles/tension/ai-loyalty-inflation.html",
    "category_id": "tension",
    "tags": ["AI","员工留存","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-loyalty-inflation",
    "created_at": "2026-08-01",
    "updated_at": null
  },
  {
    "id": "ai-hallucination-auditor",
    "title": "AI幻觉审查员——当AI一本正经地胡说八道，谁来为输出负责",
    "summary": "•AI幻觉根源：AI本质是\"预测下一个词\"而非\"查资料\"，追求\"像\"不是\"真\"，接入数据库只能减少不能根除\n•幻觉三个放大器：权威感包装、上下文污染、规模效应\n•幻觉审查员四层职责：事实核验（逐条溯源）、逻辑审计（追问推理链）、风险分级（按错误后果分绿黄红区）、反馈闭环\n•最适合转行的三类人：资深业务专家、调查记者/编辑、风控审计——都是\"怀疑能力\"强的人\n•落地三步走：先立红线规矩、再设兼职审查员、最后转正成团队",
    "content_type": "html",
    "content": "articles/newroles/ai-hallucination-auditor.html",
    "category_id": "newroles",
    "tags": ["AI","幻觉审查","新职业"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hallucination-auditor",
    "created_at": "2026-08-01",
    "updated_at": null
  },
  {
    "id": "ai-referral-culture-gone",
    "title": "AI时代的\"内推文化\"消亡——当算法比熟人更懂你，\"关系\"还值钱吗",
    "summary": "•内推本质是\"信任的传递\"，解决的是招聘里最贵的问题——信息不对称\n•算法瓦解内推的三个支点：行为数据更全面、匹配精度更客观、背书价值被去中介化\n•内推致命缺陷：用\"关系半径\"代替\"能力半径\"，圈子高度同质化\n•算法替代不了的：\"好不好共事\"的判断——隐性合作性，AI测不出来\n•改造方案：内推从\"入口\"挪到\"出口\"做最后一公里把关、给内推人信息权、把关系资产数据化",
    "content_type": "html",
    "content": "articles/eliminated/ai-referral-culture-gone.html",
    "category_id": "eliminated",
    "tags": ["AI","内推文化","招聘变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-referral-culture-gone",
    "created_at": "2026-08-01",
    "updated_at": null
  },
  {
    "id": "ai-flow-state-break",
    "title": "AI时代的\"心流断裂\"——效率越来越高，深度工作反而越来越难",
    "summary": "•心流断裂：AI把任务拆得更碎、响应更快，人越来越难进入沉浸连贯的深度思考\n•心流贵在\"进入成本\"——约20-30分钟预热，打断一次全部作废，一天被打断5次等于白烧2小时\n•三个掐断机制：交互从\"批量\"变\"实时\"、AI把\"输出\"提前把\"思考预热\"架空、多任务并行被零成本合法化\n•效率指标看不见它：浅层效率全线飘红，但独创性、架构质量、战略完整性在悄悄塌陷\n•三个抢回心流的做法：问AI从\"默认\"变\"预约\"、给深度工作设\"物理屏障\"、把\"无AI时段\"变成团队制度",
    "content_type": "html",
    "content": "articles/tension/ai-flow-state-break.html",
    "category_id": "tension",
    "tags": ["AI","心流","深度工作"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-flow-state-break",
    "created_at": "2026-08-02",
    "updated_at": null
  },
  {
    "id": "ai-draft-disappearing",
    "title": "AI时代的\"草稿思维\"消亡——当AI一键生成终稿，思考的过程去哪了",
    "summary": "•草稿思维是\"思考的脚手架\"：外化思考、允许试错、留下轨迹——写的过程就是想的过程\n•AI三个机制让草稿消失：终稿太便宜被一步到位、\"粗糙\"不可见只敢在成品上修补、思考过程失去记录\n•代价三层：个体能力被架空（思考能力是写出来的）、团队协作失去\"过程\"、组织创新失去\"念头土壤\"\n•AI只能替代\"想清楚之后的事\"，\"从无到有\"的能力是人类唯一不可替代的\n•抢救三招：先手写烂草稿再让AI介入、把AI当\"批改老师\"不当\"代写枪手\"、让\"过程\"重新变成可见资产",
    "content_type": "html",
    "content": "articles/eliminated/ai-draft-disappearing.html",
    "category_id": "eliminated",
    "tags": ["AI","草稿思维","深度思考"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-draft-disappearing",
    "created_at": "2026-08-02",
    "updated_at": null
  },
  {
    "id": "ai-boredom-tax",
    "title": "AI时代的\"无聊税\"——当AI填满每一分钟，谁在替你为灵感买单",
    "summary": "•无聊税：AI把发呆、等待、卡壳等\"无聊时间\"全填满，每填满一分钟就少一分灵感\n•神经科学：默认模式网络（DMN）在走神时启动，做跨领域连接——顿悟是\"无聊出来\"的不是\"想出来\"的\n•AI三个消灭无聊的机制：填满等待空隙、消灭\"卡住\"的时间、让\"留白\"在文化上不可接受\n•AI越强组织越需要无聊：差异化来自\"未知问题的发现\"，靠留白而非更努力\n•三个请回无聊的做法：每天\"强制无聊时段\"、卡住先发呆5分钟再问AI、把\"无聊权\"写进组织制度",
    "content_type": "html",
    "content": "articles/stable/ai-boredom-tax.html",
    "category_id": "stable",
    "tags": ["AI","无聊税","创造力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-boredom-tax",
    "created_at": "2026-08-02",
    "updated_at": null
  },
  {
    "id": "ai-perfection-outsourcing",
    "title": "AI时代的\"完美主义外包\"——当AI把产出改到完美，你反而不敢发出去了",
    "summary": "•完美主义外包：AI把\"改到完美\"的成本降到零，却把\"署名\"（敢不敢说这是我做的）的成本抬到极高\n•宜家效应：人对亲手做的东西评价更高——因为\"是我的\"所以值钱，署名感断裂后没人敢负责\n•三个机制：产出\"不是我的\"认同感断裂、免费完美拖垮交付速度、太完美没人敢签字\n•代价：全员\"保险式完美\"——平庸但挑不出错，同时失去速度和个性\n•三个破法：AI只改语法不改判断、三版封顶到点就发、保留\"人味签名\"",
    "content_type": "html",
    "content": "articles/tension/ai-perfection-outsourcing.html",
    "category_id": "tension",
    "tags": ["AI","完美主义","责任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-perfection-outsourcing",
    "created_at": "2026-08-03",
    "updated_at": null
  },
  {
    "id": "ai-complaint-tax",
    "title": "AI时代的\"吐槽税\"——当AI把问题解决得太快，组织的预警系统正在失聪",
    "summary": "•吐槽税：AI把\"解决问题\"变得太快太顺，组织悄悄失去\"吐槽\"这种最灵敏的预警信息\n•吐槽是免费的咨询报告：问题信号+情绪权重，情绪越强问题越真；没人吐槽不是变好了，是没人信了\n•三个静音机制：AI客服温柔拦截、吐槽书面化消灭情绪、内部吐槽渠道化死亡（沉默退出）\n•代价：显性冲突被消灭，隐性流失来收利息——报表好看≠组织健康\n•三个做法：吐槽上送线转人工、每周原话会、把吐槽率和吐槽转沉默率当反向KPI",
    "content_type": "html",
    "content": "articles/stable/ai-complaint-tax.html",
    "category_id": "stable",
    "tags": ["AI","吐槽","客户反馈"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-complaint-tax",
    "created_at": "2026-08-03",
    "updated_at": null
  },
  {
    "id": "ai-leave-shame",
    "title": "AI时代的\"请假羞耻\"——当AI能无缝顶替你，你反而不敢休息了",
    "summary": "•请假羞耻：AI让\"你不在场\"毫无代价，于是\"你需要休息\"反而变成需要辩护的\"多余\"\n•被需要的证据消失：以前\"我一走就乱套\"，现在AI把乱套概率降到零，只能用不休假证明自己有用\n•三个机制：无缝顶替失去证据、随时在线成默认让离线可疑、人被当\"AI备件\"\n•代价：全员假装不需要休息——休假时长降40%，核心团队因\"感觉不到被需要\"离开\n•解法：管理者带头休假+公开说\"人不是备件\"+休假演练制度；员工休假就真休、用回来后的增量对抗离开时的正常",
    "content_type": "html",
    "content": "articles/eliminated/ai-leave-shame.html",
    "category_id": "eliminated",
    "tags": ["AI","休假","不可替代性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-leave-shame",
    "created_at": "2026-08-03",
    "updated_at": null
  },
  {
    "id": "ai-effort-inflation",
    "title": "AI时代的\"努力通胀\"——当AI把产出变便宜，努力本身正在贬值",
    "summary": "AI时代的\"努力通胀\"——当AI让产出变便宜，努力本身正在贬值 上个月一个做电商的老板跟我吃饭，说了句让我琢磨很久的话：\"我的团队人均产出翻了一倍，但我越来越不知道该奖励谁了。\" 以前很简单——谁加班到深夜、谁把方案磨了三遍、谁周末还在盯数据，一眼就看得到，奖励给这些\"最努力的人\"准没错。现在呢？方案AI十分钟出一版，数据AI自动盯，大家到点下班，产出还都差不多。他问我：\"",
    "content_type": "html",
    "content": "articles/tension/ai-effort-inflation.html",
    "category_id": "tension",
    "tags": [
      "AI",
      "努力",
      "激励"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-effort-inflation",
    "created_at": "2026-08-04",
    "updated_at": null
  },
  {
    "id": "ai-first-draft-anchor",
    "title": "AI时代的\"第一稿锚定\"——当AI先开口，你的思考已经被钉死了",
    "summary": "AI时代的\"第一稿锚定\"——当AI先开口，你的思考已经被钉死了 起因是一件小事。上周我要给一家企业做游戏化方案，动笔前习惯性地让AI先出一版\"框架参考\"。AI三秒钟给了我一个结构：痛点分析、激励机制、落地路径、效果评估——四平八稳，看着没毛病。 然后我发现，接下来两个小时，我所有的思考都在这个框架里打转。我想加点东西，都是在这个骨架上\"添肉\"；我想换个角度，脑子会自动绕回它的四个模块。最后交出去的",
    "content_type": "html",
    "content": "articles/stable/ai-first-draft-anchor.html",
    "category_id": "stable",
    "tags": [
      "AI",
      "思考",
      "决策"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-first-draft-anchor",
    "created_at": "2026-08-04",
    "updated_at": null
  },
  {
    "id": "ai-secondhand-experience",
    "title": "AI时代的\"经验二手化\"——当经验都来自AI总结，没人再亲历过任何事",
    "summary": "AI时代的\"经验二手化\"——当经验都来自AI总结，没人再亲历过任何事 上周面试一个干了五年的运营主管，聊到一个具体的项目复盘，他讲得头头是道：渠道成本、转化漏斗、A/B测试、归因模型，逻辑严谨，术语精准。 他愣了一下，然后诚实地说：\"这个……我是看AI总结的复盘报告知道的。当时那个项目我其实没深度参与。\"",
    "content_type": "html",
    "content": "articles/eliminated/ai-secondhand-experience.html",
    "category_id": "eliminated",
    "tags": [
      "AI",
      "经验",
      "成长"
    ],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-secondhand-experience",
    "created_at": "2026-08-04",
    "updated_at": null
  },
  {
    "id": "ai-organizational-silence",
    "title": "AI时代的\"组织沉默\"——为什么团队里没人敢说真话",
    "summary": "AI时代组织沉默从\"不敢说\"变成\"不配说\"——当AI随时能给答案，员工先自我否定了自己的观点。三个机制：答案焦虑、表达耻感、沉默传染。代价是组织在\"表面高效\"幻觉里做错事。管理者要重新定义发言价值、带头说蠢话、把质疑AI变成被奖励的行为。保住那个敢说\"等等这不对\"的人，是组织最值钱的资产。",
    "content_type": "html",
    "content": "articles/stable/ai-organizational-silence.html",
    "category_id": "stable",
    "tags": ["组织沉默","AI","团队沟通"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-organizational-silence",
    "created_at": "2026-08-05",
    "updated_at": null
  },
  {
    "id": "ai-office-war",
    "title": "AI办公工具大混战：阿里腾讯字节集体押注，你的组织跟不跟？",
    "summary": "阿里整合千问办公、腾讯升级WorkBuddy、字节合并飞书豆包，三大巨头同时押注AI办公。本质不是工具升级而是办公权力的重新分配。AI办公真正改变的不是用什么工具，而是组织怎么运转。选平台先看自己最痛、小范围试点、先做数据安全体检、建立切换预案。跟不跟不是问题，怎么跟才是。基于热榜：阿里/腾讯/字节集体押注AI办公。",
    "content_type": "html",
    "content": "articles/disrupted/ai-office-war.html",
    "category_id": "disrupted",
    "tags": ["AI办公","组织效率","数字化转型"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-office-war",
    "created_at": "2026-08-05",
    "updated_at": null
  },
  {
    "id": "ai-workplace-feral",
    "title": "\"职场发疯文学\"为什么火了？AI时代，情绪成了最后的战场",
    "summary": "当AI把所有\"事\"都接管后，剩下的全是\"情绪活\"。AI不是让人更轻松，是把累从可量化的活儿搬到不可量化的情绪上。发疯是打工人夺回\"人味\"的方式。组织正在流失情绪这个最贵的隐性资产。管理者要承认情绪价值、建情绪下脚口、把情绪价值纳入考核。当AI把事都接走，谁能经营好情绪，谁就掌握AI时代真正的竞争力。基于热榜：《年会不能停！2》职场发疯文学。",
    "content_type": "html",
    "content": "articles/created/ai-workplace-feral.html",
    "category_id": "created",
    "tags": ["职场情绪","AI办公","激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-workplace-feral",
    "created_at": "2026-08-05",
    "updated_at": null
  },
  {
    "id": "ai-learning-drive",
    "title": "AI时代的学习驱动力——当知识获取太容易，什么还在推着人往前走",
    "summary": "44岁爸爸考研热帖背后，是AI时代组织学习驱动的核心之问：当知识像自来水一样随取随用，人为什么还要学习？AI让'知道'变得太容易，让'学得有意义'变得极难。组织学习驱动力正经历三层裂变：从'知道驱动'到'做到驱动'（建立能力自信）、从'外部激励'到'意义建构'（奖励应用而非完成）、从'个体学习'到'集体认知碰撞'（对抗组织学习独狼化）。搞不懂这三层转变的管理者，会花越来越多培训预算，养出越来越多'假装在学习'的员工。知道太便宜了，改变才贵。",
    "content_type": "html",
    "content": "articles/tension/ai-learning-drive.html",
    "category_id": "tension",
    "tags": ["学习驱动力","AI","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-learning-drive",
    "created_at": "2026-08-06",
    "updated_at": null
  },
  {
    "id": "ai-trust-deficit",
    "title": "AI时代的\"信任赤字\"——当算法给你最优解，你敢全信吗",
    "summary": "男子靠AI定制减肥方案45天暴瘦40斤差点送命——真正可怕的不是AI算错，是他把百分之百交给了算法，没人告诉他'停一下'。AI时代组织正进入'信任赤字'：AI答案越来越精准，人对它的信任却越来越虚弱。三重危机：从'信专家'到'信数据'中间少了人的判断（人对算法是'全有或全无'的二元信任）、组织信任的'通货膨胀'（决策靠算法导致信任肌肉系统性萎缩/GPS依赖症）、'敢不信AI'成了最稀缺能力。健康组织不是'AI说什么就做什么'，而是'AI说了之后人还能想一想、辩一辩、用判断力做决定'。别让AI的最优解变成组织最脆弱的一道防线。",
    "content_type": "html",
    "content": "articles/stable/ai-trust-deficit.html",
    "category_id": "stable",
    "tags": ["信任赤字","AI","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-deficit",
    "created_at": "2026-08-06",
    "updated_at": null
  },
  {
    "id": "order-collapse",
    "title": "AI时代的\"秩序型组织\"正在崩溃——为什么越听话的团队越脆弱",
    "summary": "过去二十年中国企业管理核心是把复杂事拆成SOP、把SOP变成考核指标，我们叫它'管理成熟度'。但AI最擅长的恰恰是执行标准流程——当执行力成为算法的出厂设置，以'秩序'为核心竞争力的组织正被从底层替代。三种坍塌：执行力溢价归零（团队被训练成只会走流程，流程外问题集体失能）、层级关系瓦解（中层的翻译信息价值被AI一键替代）、规则成了围墙（规则是沉淀的旧经验，抗拒新变化）。AI不是管理者的敌人，标准化才是。把标准化交给AI、把判断力留给人的组织，将从'秩序型'走向'弹性型'：按判断走、按任务网走、用轻原则替代重制度。",
    "content_type": "html",
    "content": "articles/disrupted/order-collapse.html",
    "category_id": "disrupted",
    "tags": ["秩序型组织","AI","组织变革"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-order-collapse",
    "created_at": "2026-08-06",
    "updated_at": null
  },
  {
    "id": "org-slim-trap",
    "title": "AI时代的\"组织瘦身陷阱\"——当汪峰公司用AI裁掉63%的人，剩下的397人反而快崩了",
    "summary": "某公司用AI把员工从1100人裁到397人，裁掉63%，看似降本增效，剩下的团队却快崩溃。核心反常识：组织不是机器，减法不等于精简。三大代价：'减人不减事'的组织幻觉（活没少，人少了）、被裁的人带走了隐性知识/关系链/组织记忆三样东西、幸存者综合征（剩下的397人不是更高效而是更害怕）。管理者要跳出只看效率单层，用三层次框架看：事、人、关系。AI瘦身省下的成本，可能正在用组织长期健康来支付。",
    "content_type": "html",
    "content": "articles/tension/org-slim-trap.html",
    "category_id": "tension",
    "tags": ["组织瘦身","AI","裁员","组织健康"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-org-slim-trap",
    "created_at": "2026-08-07",
    "updated_at": null
  },
  {
    "id": "decision-outsourcing",
    "title": "AI时代的\"决策外包\"——粉笔公告自曝决策失误那天，我算了一笔AI决策的隐形成本",
    "summary": "粉笔公告自曝决策失误、叠加AI灵魂人物离开Google，两件事放一起，看到AI时代最隐蔽的管理衰退——决策外包。你用AI省下每次决策的10分钟，正在失去的是'下一次决策还需要人'的底层能力。提出'决策肌肉'理论：判断力和肌肉一样用进废退，外包思考是最贵的活儿，换来流程顺滑，付出判断力的沉默折旧。深层是问责链条正在模糊。管理者要划清三类决策的AI介入边界，别让省下的10分钟吃掉组织的判断力。",
    "content_type": "html",
    "content": "articles/stable/decision-outsourcing.html",
    "category_id": "stable",
    "tags": ["决策外包","AI","判断力","管理衰退"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-decision-outsourcing",
    "created_at": "2026-08-07",
    "updated_at": null
  },
  {
    "id": "org-radar-paradox",
    "title": "AI时代的\"组织雷达悖论\"——当每个异常都被预警，组织反而不会呼吸了",
    "summary": "一家中型科技公司CHO花重金上了AI组织诊断系统，异常预警灵敏到能测出请假数据、沟通频率下降、工位空置，但组织反而更紧张、更不会'呼吸'了。这就是组织雷达悖论：预警越灵敏，组织越窒息。组织需要'运维噪声'和'缓冲空间'，不能把一切都当异常。AI组织诊断有三大失灵。解法不是建'组织监控力'，而是建'组织免疫力'——让组织能承受、消化、转译异常，而不是被每一个异常击穿。",
    "content_type": "html",
    "content": "articles/created/org-radar-paradox.html",
    "category_id": "created",
    "tags": ["组织诊断","AI","组织免疫力","组织健康"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-org-radar-paradox",
    "created_at": "2026-08-07",
    "updated_at": null
  },
  {
    "id": "sme-ai-efficiency",
    "title": "AI时代的\"中小企业效率红利\"——大厂抢AI人才，小厂怎么用AI抢效率",
    "summary": "今天刷到一条抖音热榜：「上半年中小企业稳步向好」。数据是好数据，但评论区几条留言扎了我的眼——\"我们厂连个会AI的人都没有\"\"大厂都在抢AI人才，我们拿什么跟人家拼\"。这话我太熟了。我接触过几十家中小企业老板，几乎每个人都有一模一样的焦虑：AI这场仗，是不是只有大公司打得起？我的答案是：恰恰相反。AI可能是中小企业历史上最大的一次\"弯道超车\"机会，但前提是——你得先放下\"抢人才\"的思维，换成\"抢效率\"的思维。",
    "content_type": "html",
    "content": "articles/tension/sme-ai-efficiency.html",
    "category_id": "tension",
    "tags": ["AI","中小企业","效率红利"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-sme-ai-efficiency",
    "created_at": "2026-08-08",
    "updated_at": null
  },
  {
    "id": "craft-devaluation",
    "title": "AI时代的\"手艺贬值\"恐慌——当手艺不再值钱，什么才值钱",
    "summary": "知乎上有个问题火了：\"跑了几天外卖发现，很多人原来是修手机的、修汽车的、修家电的技术人员，有手艺为什么要来跑外卖呢？\"三百多万热度，评论区一片唏嘘。我盯着这个问题想了很久。它表面在问\"为什么手艺人去跑外卖\"，其实在问一个更扎心的事：当一个时代的技术更迭太快，你赖以为生的\"手艺\"，到底还算不算数？这不是外卖行业的专属悲剧，这是一场正在发生在所有行业的\"手艺贬值\"——只不过这一次，拿着贬值通知书的，从修手机的换成了写文案的、画图的、甚至写代码的。",
    "content_type": "html",
    "content": "articles/eliminated/craft-devaluation.html",
    "category_id": "eliminated",
    "tags": ["AI","手艺贬值","职业技能"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-craft-devaluation",
    "created_at": "2026-08-08",
    "updated_at": null
  },
  {
    "id": "statistical-thinking",
    "title": "AI时代的\"统计思维\"回归——当AI让数据处理免费，判断力成了组织新的硬通货",
    "summary": "今天微博一条热搜让我眼前一亮：北大校友苏炜杰获称\"统计学界的诺贝尔奖\"——考普斯奖。颁奖词里他说，\"人工智能将让数据更加丰富、更具价值，统计学也将愈发重要\"。很多人当新闻看了，但这对管理者藏着AI时代组织变革最关键的信号：数据处理已经免费了，会\"解读数据、判断数据\"的人，正在变成组织最贵的资产。昔日稀缺的是\"拿到结果\"的能力，现在稀缺的是\"知道该要什么结果、以及这个结果是否可信\"的能力——前者AI包了，后者只能靠人。",
    "content_type": "html",
    "content": "articles/created/statistical-thinking.html",
    "category_id": "created",
    "tags": ["AI","统计思维","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-statistical-thinking",
    "created_at": "2026-08-08",
    "updated_at": null
  },
  {
    "id": "ai-xinqi-inflation",
    "title": "AI时代的\"心气通胀\"——当AI让一切变得太容易，团队的心气反而消失了",
    "summary": "知乎热榜上，曾经的奥运冠军排名暴跌，媒体反复谈一个词——\"她心气没了\"。我盯着这个词想了很久，因为它不只属于运动员。AI把活全接了、目标全达成了，可那股子\"我要赢\"的劲儿悄没声地没了。我把这现象叫\"心气通胀\"——效率在涨、士气在通胀，真正能扛事的人正在变少。当所有人用同一批AI，心气就是你和对手之间最后那堵墙。",
    "content_type": "html",
    "content": "articles/stable/ai-xinqi-inflation.html",
    "category_id": "stable",
    "tags": ["AI","心气","组织动力","士气"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-xinqi-inflation",
    "created_at": "2026-08-09",
    "updated_at": null
  },
  {
    "id": "ai-slow-capability",
    "title": "AI时代的\"慢能力\"——当所有事都能AI秒回，组织里最稀缺的是\"愿意慢慢想\"的人",
    "summary": "抖音上\"用慢充旅行治愈自己\"很火，但这种\"慢\"的渴望正在从生活蔓延到职场。AI把所有事都变\"快\"了，可越是这样，越有一种被时代悄悄淘汰的能力正在从组织里消失——我把它叫\"慢能力\"。被AI淘汰的不是\"慢活\"，是\"愿意慢慢想的人\"。在AI把所有事都变成秒回的时代，真正让你跑赢的，是那批还愿意慢慢想的人。",
    "content_type": "html",
    "content": "articles/eliminated/ai-slow-capability.html",
    "category_id": "eliminated",
    "tags": ["AI","慢能力","深度思考","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-slow-capability",
    "created_at": "2026-08-09",
    "updated_at": null
  },
  {
    "id": "ai-mistake-notebook",
    "title": "AI时代的\"错题本\"正在消失——当AI帮你把错误都修正掉，组织失去了最值钱的学习素材",
    "summary": "我小时候有本错题本，记满了做错的题，那是学习最快的方式。现在我想说一个AI时代正在悄悄发生的悲剧：组织的\"错题本\"正在消失。不是没人整理了，是AI把\"错\"这个环节直接帮你修掉了。组织学东西靠的是\"犯错—复盘—改进\"闭环，AI把这个闭环的第一个环节掐断了。在AI把\"不犯错\"当成标配的时代，主动留住错误、从错误里学习，正在升级为组织的新稀缺资产。",
    "content_type": "html",
    "content": "articles/created/ai-mistake-notebook.html",
    "category_id": "created",
    "tags": ["AI","错题本","组织学习","复盘"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-mistake-notebook",
    "created_at": "2026-08-09",
    "updated_at": null
  },
  {
    "id": "ai-professional-divide",
    "title": "AI时代的\"专业分化\"：为什么分裂正在撕裂组织",
    "summary": "知乎热搜\"为什么程序员拥抱AI而音乐人抗拒AI\"背后，是AI时代正在撕裂组织的'专业分化'。根子不在AI，在'专业性认同'——不同职业对AI的恐惧与拥抱，本质是对自己'不可被替代性'的判断。真正的战场在同一个组织内部：拥抱AI的人和抗拒AI的人开始互相鄙视、信息隔离。这种分裂比技术本身更危险。破局的唯一路径：别谈技术，谈价值——重新定义每个岗位在AI时代的贡献。",
    "content_type": "html",
    "content": "articles/tension/ai-professional-divide.html",
    "category_id": "tension",
    "tags": ["专业分化","AI","组织撕裂"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-professional-divide",
    "created_at": "2026-08-10",
    "updated_at": null
  },
  {
    "id": "ai-ability-checklist",
    "title": "AI时代的\"能力清单\"——当每个人都被AI赋能，组织需要重新定义\"会什么\"",
    "summary": "热搜\"建议每个人都用AI做的三件事\"背后，是被AI拉平的根本不是能力，而是'技能'。技能可以外包给AI，能力不能。一则真实案例：两个人都在用AI，结果天差地别。AI真正的分水岭，是不依赖AI的核心能力清单——判断力、提问力、整合力、责任感。组织要重新定义的不是工具，是'会什么'——别再用'会用AI'当标准，那只会拉平所有人。",
    "content_type": "html",
    "content": "articles/created/ai-ability-checklist.html",
    "category_id": "created",
    "tags": ["能力清单","AI","人才标准"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ability-checklist",
    "created_at": "2026-08-10",
    "updated_at": null
  },
  {
    "id": "ai-training-failure",
    "title": "AI时代的\"培训失效\"：为什么企业培训越做越没人来",
    "summary": "当AI能让任何知识一分钟免费可得，企业培训的价值锚点'传递你不知道的知识'就消失了。旧培训三根支柱在断裂：知识差（断了）、纪律约束（锈了）、认证价值（空了）。培训真正卖给企业的从来不是知识，而是行为改变+认知升级+群体能量这三个AI给不了的东西。培训要走向第二曲线：从知识课到行为场、从一次性到项目制、从内容输出到机制设计（游戏化）。AI淘汰的不是培训师，是只会讲知识的培训师。",
    "content_type": "html",
    "content": "articles/disrupted/ai-training-failure.html",
    "category_id": "disrupted",
    "tags": ["培训失效","AI","游戏化","行为改变"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-training-failure",
    "created_at": "2026-08-10",
    "updated_at": null
  },
  {
    "id": "ai-org-stop-loss",
    "title": "AI时代的「组织止损决策」——当AI告诉你该赚的钱，你却不该赚了",
    "summary": "于东来关闭年赚1亿的门店引发热议。AI能算出利润最大化，但算不出「有些钱不能赚」。AI越强，组织越不会说不——因为每个项目AI都说「还能赚钱」。真正的护城河，是知道不该做什么的判断力。",
    "content_type": "html",
    "content": "articles/created/ai-org-stop-loss.html",
    "category_id": "created",
    "tags": ["AI","组织决策","止损","价值观"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-stop-loss",
    "created_at": "2026-08-11",
    "updated_at": null
  },
  {
    "id": "ai-org-warning-failure",
    "title": "AI时代的「组织预警失灵」——为什么数据满格，决定还是晚了",
    "summary": "雪佛兰暂停在华新车销售、月销5万的车卖不动——数据一定早就在系统里了。但预警系统和行动系统是两套东西：AI把决策的「信息成本」降到零，但把「心理成本」提到天花板。组织差距不再是「谁先看到问题」，而是「谁先承认问题并动手解决」。",
    "content_type": "html",
    "content": "articles/tension/ai-org-warning-failure.html",
    "category_id": "tension",
    "tags": ["AI","组织预警","决策延迟","勇气"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-warning-failure",
    "created_at": "2026-08-11",
    "updated_at": null
  },
  {
    "id": "ai-gray-judgment",
    "title": "AI时代的「灰度判断力」——当AI让管理变成参数调节，判断力去哪了",
    "summary": "管理者开始用AI的语气说话。但真正的管理从来不是非黑即白。任正非说：清晰的方向是在混沌中产生的。AI追求消除灰度，但灰度才是判断力的土壤。AI越强，人的决策肌肉越弱——像一直用导航的人失去认路能力。",
    "content_type": "html",
    "content": "articles/tension/ai-gray-judgment.html",
    "category_id": "tension",
    "tags": ["AI","判断力","灰度管理","管理者能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-gray-judgment",
    "created_at": "2026-08-11",
    "updated_at": null
  },
  {
    "id": "ai-ability-tax-refund",
    "title": "AI时代的「能力退税」——当产出变容易，「做出来」这件事正在大幅贬值",
    "summary": "AI不是抢走你的工作，而是让「会做」这件事从资产变成了水电。你当年为掌握某门手艺多付出的努力溢价，正在被AI一笔一笔清算。最危险的，是你还在、title还在，但你的本事在一天天贬值。",
    "content_type": "html",
    "content": "articles/tension/ai-ability-tax-refund.html",
    "category_id": "tension",
    "tags": ["AI","能力贬值","价值重构","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ability-tax-refund",
    "created_at": "2026-08-13",
    "updated_at": null
  },
  {
    "id": "ai-org-metabolism",
    "title": "AI时代的「组织代谢病」——当系统让一切「稳定运行」，组织正在失去自我更新能力",
    "summary": "AI把组织优化到极致稳定，稳定到它再也无法改变。老业务被续命、新人进不来、创新被合理化掉——一个不会代谢的组织，正在从巅峰滑向僵死。",
    "content_type": "html",
    "content": "articles/stable/ai-org-metabolism.html",
    "category_id": "stable",
    "tags": ["AI","组织更新","新陈代谢","主动淘汰"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-org-metabolism",
    "created_at": "2026-08-13",
    "updated_at": null
  },
  {
    "id": "ai-exp-depreciation",
    "title": "AI时代的「经验贬值速度」——当技能半衰期越来越短，你学的每一门本事都在加速过期",
    "summary": "今天熬夜学会的新工具，几个月后可能就过时了。AI时代最残酷的，不是「技不如人」，而是「你刚学会，它就过时了」。学习从投资变成消费，越学越焦虑。",
    "content_type": "html",
    "content": "articles/eliminated/ai-exp-depreciation.html",
    "category_id": "eliminated",
    "tags": ["AI","技能半衰期","学习焦虑","元能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-exp-depreciation",
    "created_at": "2026-08-13",
    "updated_at": null
  },
  {
    "id": "ai-pricing-anxiety",
    "title": "AI时代的\"定价焦虑\"——当算力按峰谷收费，组织的隐性成本暴露了",
    "summary": "AI越便宜，组织的决策成本反而越贵。峰谷定价不是价格问题，是组织问题：它逼你看清自己是不是一个\"算力散户\"。三层成本：显性（账单）、机会（调度窗口）、决策（无脑用积累的浪费）。解法是让AI从免费赋能工具变成需要被经营的资产——看清、调度、定价。",
    "content_type": "html",
    "content": "articles/tension/ai-pricing-anxiety.html",
    "category_id": "tension",
    "tags": ["AI","算力","定价","成本管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-pricing-anxiety",
    "created_at": "2026-08-14",
    "updated_at": null
  },
  {
    "id": "ai-tool-iteration-stall",
    "title": "AI时代的\"工具失速\"——当工具更新速度跑赢了组织的消化速度",
    "summary": "技术更新是指数级的，组织消化是线性的，落差就是\"工具失速\"。三个代价：沉没成本堆积、工具割裂、学习动力被透支。最怕的不是跟不上，而是不想跟了。解法是踩自己的节奏：设更新窗口期、区分先用和练熟、把稳定当竞争壁垒。",
    "content_type": "html",
    "content": "articles/eliminated/ai-tool-iteration-stall.html",
    "category_id": "eliminated",
    "tags": ["AI","工具迭代","组织学习","消化能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-tool-iteration-stall",
    "created_at": "2026-08-14",
    "updated_at": null
  },
  {
    "id": "ai-creative-deflation",
    "title": "AI时代的\"创意通缩\"——当内容生产变便宜，创意本身正在贬值",
    "summary": "内容生产变便宜了，但创意（决定生产什么的判断）反而更值钱。AI打平了\"生产\"，让合格变成地板、平庸一文不值。护城河从\"能产出\"移位到\"敢取舍、有品味、有立场\"。不贬值的三样：判断力、品味、真诚。别跟AI比生产，跟它比判断。",
    "content_type": "html",
    "content": "articles/created/ai-creative-deflation.html",
    "category_id": "created",
    "tags": ["AI","创意","判断力","内容生产"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-creative-deflation",
    "created_at": "2026-08-14",
    "updated_at": null
  },
  {
    "id": "ai-merit-identification",
    "title": "AI时代的\"功劳鉴定\"危机——当你只用产出定义员工，\"淘汰懒人\"正在淘汰掉你的未来",
    "summary": "当AI能伪造一切\"功劳\"，你分得清谁在创造价值吗？用旧尺子裁员，裁掉的是未来。",
    "content_type": "html",
    "content": "articles/tension/ai-merit-identification.html",
    "category_id": "tension",
    "tags": ["AI","绩效","组织","激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-merit-identification",
    "created_at": "2026-08-15",
    "updated_at": null
  },
  {
    "id": "ai-flagship-product",
    "title": "AI时代的\"拳头产品病\"——当组织靠老产品躺赚30年，AI反而加速了它的衰亡",
    "summary": "拳头产品是奖状不是护身符。AI时代淘汰的不是产品落后的公司，是丧失了迭代能力的公司。",
    "content_type": "html",
    "content": "articles/eliminated/ai-flagship-product.html",
    "category_id": "eliminated",
    "tags": ["AI","创新","组织","战略"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-flagship-product",
    "created_at": "2026-08-15",
    "updated_at": null
  },
  {
    "id": "ai-contribution-architect",
    "title": "AI时代的\"贡献架构师\"——一个帮公司重新定义'谁在创造价值'的新角色",
    "summary": "当AI能伪造一切产出，那个最贵的岗位是能说清楚\"什么才算贡献\"的人。",
    "content_type": "html",
    "content": "articles/created/ai-contribution-architect.html",
    "category_id": "created",
    "tags": ["AI","新职业","组织","价值"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-contribution-architect",
    "created_at": "2026-08-15",
    "updated_at": null
  },
  {
    "id": "ai-order-taking-crisis",
    "title": "AI时代的\"接单能力\"危机——当AI能稳定干长活，管理者最该担心的不是效率",
    "summary": "DeepSeek-V4-Pro让Agent从\"写得好的人\"变成\"能接任务的人\"。当AI终于不掉链子，只会\"接活\"不会\"担责\"的中层正被平权，组织必须把\"能接活\"从晋升标准里划掉。",
    "content_type": "html",
    "content": "articles/tension/ai-order-taking-crisis.html",
    "category_id": "tension",
    "tags": ["AI","管理者","担责","接单能力","DeepSeek"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-order-taking-crisis",
    "created_at": "2026-08-16",
    "updated_at": null
  },
  {
    "id": "ai-queue-premium",
    "title": "AI时代的\"排队溢价\"——胖东来28个收银口排长龙，藏着AI替代不了的东西",
    "summary": "当所有商家用AI把体验做到极快，那个愿意慢一点、把你当人看的反而成了稀缺品。胖东来排的不是队，是\"被认真对待\"的人情味——AI替代不了的护城河。",
    "content_type": "html",
    "content": "articles/stable/ai-queue-premium.html",
    "category_id": "stable",
    "tags": ["AI","效率","人情味","服务","胖东来"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-queue-premium",
    "created_at": "2026-08-16",
    "updated_at": null
  },
  {
    "id": "ai-task-followthrough",
    "title": "AI时代的\"任务手尾\"正在消失——当Agent能全程执行，谁负责\"收干净\"",
    "summary": "AI能从头干到尾，但\"干完\"和\"干净\"是两回事。当组织只奖励交付速度、不为\"手尾质量\"付钱，丢掉的不是几个岗位，而是整个组织的长期免疫系统。",
    "content_type": "html",
    "content": "articles/eliminated/ai-task-followthrough.html",
    "category_id": "eliminated",
    "tags": ["AI","任务手尾","收尾","Agent","组织免疫"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-task-followthrough",
    "created_at": "2026-08-16",
    "updated_at": null
  },
  {
    "id": "ai-compute-pricing-power",
    "title": "AI时代的\"算力定价权\"——DeepSeek涨价背后，组织最该算清的一笔账",
    "summary": "DeepSeek正式涨价上了热搜，全网在算成本。但真正该焦虑的不是算力账单，而是从没想明白\"AI到底值多少钱\"的组织。算力便宜时，定价权在厂商；AI成为核心生产工具后，定价权转向那些\"算着用AI\"的组织。三笔账，帮你把AI从信仰变回工具。",
    "content_type": "html",
    "content": "articles/tension/ai-compute-pricing-power.html",
    "category_id": "tension",
    "tags": ["AI","算力","成本","DeepSeek","定价权"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compute-pricing-power",
    "created_at": "2026-08-17",
    "updated_at": null
  },
  {
    "id": "ai-antifragile-rent",
    "title": "AI时代的\"反脆弱租金\"——胖东来不涨商户租，藏着组织最抗AI的能力",
    "summary": "胖东来被房东涨租逼走，却从不涨自己商户的租金。这种\"故意吃亏\"藏着AI最学不会的组织能力：反脆弱租金——主动放弃短期确定性收益，购买长期抗冲击能力。AI能算清\"看得见的账\"，算不了信任、忠诚、韧性这些\"看不见的账\"。",
    "content_type": "html",
    "content": "articles/stable/ai-antifragile-rent.html",
    "category_id": "stable",
    "tags": ["AI","胖东来","韧性","留白","反脆弱"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-antifragile-rent",
    "created_at": "2026-08-17",
    "updated_at": null
  },
  {
    "id": "ai-explanation-tax",
    "title": "AI时代的\"解释税\"——当算法替你做了决定，你连\"为什么\"都说不出口了",
    "summary": "AI最擅长给答案，却最不擅长给理由。当管理者习惯\"AI说行就行\"，一种隐蔽的能力正在被收税：思考和解释的能力。三笔欠账（对上、对下、对己）掏空管理者的号召力。把AI当顾问、先想后问、翻译复述，三步夺回解释权。",
    "content_type": "html",
    "content": "articles/eliminated/ai-explanation-tax.html",
    "category_id": "eliminated",
    "tags": ["AI","判断力","解释权","管理者","思考"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-explanation-tax",
    "created_at": "2026-08-17",
    "updated_at": null
  },
  {
    "id": "ai-creator-exodus",
    "title": "AI时代的\"创作者停更潮\"——当AI让内容生产太容易，为什么反而没人写了",
    "summary": "微博热搜\"大批AI博主停更了\"，老邓看到的不是流量红利尽了，而是AI让产出不再稀缺、意义感塌陷。组织里的\"内容空心化\"，才是AI时代最隐蔽的危机。",
    "content_type": "html",
    "content": "articles/tension/ai-creator-exodus.html",
    "category_id": "tension",
    "tags": ["AI","意义感","组织管理","内容"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-creator-exodus",
    "created_at": "2026-08-18",
    "updated_at": null
  },
  {
    "id": "ai-team-building-paradox",
    "title": "AI时代的\"团建悖论\"——当AI替代所有事务，组织的\"人味\"反而成了风险",
    "summary": "热搜\"公司组织无人岛游玩被罚11万\"背后，是一场组织人味危机：AI优化掉了日常的关系缝隙，组织被迫把\"凝聚\"挤压到猎奇的仪式里，越用力越翻车。",
    "content_type": "html",
    "content": "articles/eliminated/ai-team-building-paradox.html",
    "category_id": "eliminated",
    "tags": ["AI","团队","团建","关系经营"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-team-building-paradox",
    "created_at": "2026-08-18",
    "updated_at": null
  },
  {
    "id": "ai-learning-director",
    "title": "给培训师的一封信：AI时代的\"学习导演\"，教的不是知识，是\"判断\"",
    "summary": "AI把所有标准答案都变便宜了，培训师靠\"信息差\"吃饭的路已经堵死。真正涨价的，是只有人能教的\"判断力\"。从知识传授者到学习导演，这一步迈过去只会更值钱。",
    "content_type": "html",
    "content": "articles/stable/ai-learning-director.html",
    "category_id": "stable",
    "tags": ["AI","培训","游戏化","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-learning-director",
    "created_at": "2026-08-18",
    "updated_at": null
  },
  {
    "id": "ai-preparation-ocd",
    "title": "AI时代的\"准备洁癖\"——越准备越不动手，组织正在集体拖延",
    "summary": "微博热搜\"做事千万不要有状态洁癖\"戳中了AI时代最隐蔽的管理陷阱：AI让准备成本归零，人反而可以无限\"再来一版\"，永远在准备、永远没开始。\n•状态洁癖的本质是对\"不完美\"的恐惧，而非懒\n•AI让准备工作从\"昂贵\"变\"免费\"，免费的东西最让人上瘾\n•真实失败反馈的价值，超过一百份完美预案\n•三个破法：分清必须准备vs逃避准备、出最小可行动版本、给准备设硬死线\n•AI时代最贵的不是数据，是\"先动手\"这一下",
    "content_type": "html",
    "content": "articles/tension/ai-preparation-ocd.html",
    "category_id": "tension",
    "tags": ["AI","执行力","组织效率","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-preparation-ocd",
    "created_at": "2026-08-19",
    "updated_at": null
  },
  {
    "id": "ai-personal-ip-inflation",
    "title": "AI时代的\"个人IP通胀\"——反诈老陈停更挣生活费背后，影响力变现的隐性危机",
    "summary": "微博热搜\"反诈老陈宣布停更7天挣生活费\"，一个现象级民警IP为生活费停更。背后是一场个人IP的通胀：内容供应被AI打穿，每个IP分到的注意力被无限稀释。\n•AI没有杀死个人IP，只是把\"影响力\"变成了廉价通货\n•粉丝数没掉但变现断崖下跌，信任浓度被冲淡\n•扛得住AI的三类护城河：结果型、关系型、判断型\n•最容易贬值的：信息搬运型、人设表演型\n•别再把\"涨粉\"当护城河",
    "content_type": "html",
    "content": "articles/eliminated/ai-personal-ip-inflation.html",
    "category_id": "eliminated",
    "tags": ["AI","个人IP","流量","变现"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-personal-ip-inflation",
    "created_at": "2026-08-19",
    "updated_at": null
  },
  {
    "id": "ai-sparring-training",
    "title": "AI时代的\"陪练型培训\"——当知识变便宜，帮学员\"练出手感\"才是培训师的新活路",
    "summary": "纯粹靠\"讲知识\"的培训师越来越危险，但换个活法会迎来新红利——陪练型培训。\n•AI已把\"知识传授\"这一关打穿，信息差归零\n•学员缺的不是知识，是能力；能力只能靠\"练\"\n•知识付费在坍塌，但\"陪练\"在涨价（健身私教逻辑）\n•陪练三层手感：练判断、练表达、练临场\n•三个转型动作：砍一半讲、做沉默观察者、设计有压力的实战模拟\n•AI淘汰的不是培训师，是\"只会讲不会带\"的讲师",
    "content_type": "html",
    "content": "articles/stable/ai-sparring-training.html",
    "category_id": "stable",
    "tags": ["AI","培训","游戏化","TTT"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-sparring-training",
    "created_at": "2026-08-19",
    "updated_at": null
  },
  {
    "id": "ai-performance-fabrication",
    "title": "AI时代的\"考核造假\"——当指标压垮员工，AI正在放大表演式数据",
    "summary": "银行员工自掏一万充存款指标，暴露了AI时代绩效管理的危险信号：当系统实时计量、排名、张榜，逼着人\"做数据\"的冲动比以往更强。古德哈特定律被AI放大十倍——越计量越失真。",
    "content_type": "html",
    "content": "articles/tension/ai-performance-fabrication.html",
    "category_id": "tension",
    "tags": ["AI","绩效","考核","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-performance-fabrication",
    "created_at": "2026-08-21",
    "updated_at": null
  },
  {
    "id": "ai-hidden-knowledge-completion",
    "title": "AI时代的\"认知补全\"——AI能补全你对世界的盲区，却补不全组织的隐性经验",
    "summary": "抖音\"AI补全了长辈的未知\"刷屏，戳中一个更冷的真相：AI能补全显性知识，却补不全组织最值钱的隐性经验。AI越强，人越懒得沉淀，“老油条”的经验正在静默流失。",
    "content_type": "html",
    "content": "articles/stable/ai-hidden-knowledge-completion.html",
    "category_id": "stable",
    "tags": ["AI","隐性知识","组织记忆","经验传承"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hidden-knowledge-completion",
    "created_at": "2026-08-21",
    "updated_at": null
  },
  {
    "id": "ai-ensemble-judgment",
    "title": "AI时代的\"独断困境\"——当每个人都信自己的AI，组织的共同判断从哪来",
    "summary": "AI让每个人都握着自己那份\"完美答案\"，开会从\"吵想法\"变成\"各说各的AI\"。独断困境正在稀释组织的共识能力，重建“共同判断”成了AI时代管理者最值钱的手艺。",
    "content_type": "html",
    "content": "articles/created/ai-ensemble-judgment.html",
    "category_id": "created",
    "tags": ["AI","决策","共识","组织沟通"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ensemble-judgment",
    "created_at": "2026-08-21",
    "updated_at": null
  },
  {
    "id": "ai-review-inflation",
    "title": "AI时代的\"复盘通胀\"——每次复盘都有AI代劳，\"学没学到\"反而没人追问了",
    "summary": "AI让复盘变得前所未有的完整，纪要齐全、数据齐备。但复盘产量暴增的同时，价值在悄悄贬值——复盘的目的是消化而不是记录。",
    "content_type": "html",
    "content": "articles/tension/ai-review-inflation.html",
    "category_id": "tension",
    "tags": ["AI","复盘","组织学习","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-review-inflation",
    "created_at": "2026-08-22",
    "updated_at": null
  },
  {
    "id": "ai-veto-vacuum",
    "title": "AI时代的\"否决权真空\"——AI方案一个比一个漂亮，却没人有资格说\"这个不行\"",
    "summary": "AI让提案供过于求，却让最关键的否决能力出现真空。敢于说\"不\"的判断力，成了AI时代组织最稀缺的硬通货。",
    "content_type": "html",
    "content": "articles/stable/ai-veto-vacuum.html",
    "category_id": "stable",
    "tags": ["AI","决策","判断力","责任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-veto-vacuum",
    "created_at": "2026-08-22",
    "updated_at": null
  },
  {
    "id": "ai-mentor-break",
    "title": "AI时代的\"导师断代\"——当新人请教AI而不是请教老师傅，\"人传人\"的经验链条断了",
    "summary": "新人遇到问题先问AI而不问老师傅，隐性知识这条\"人传人\"的传承链条正在悄悄断掉。经验最终还是要从活人流到活人手里。",
    "content_type": "html",
    "content": "articles/eliminated/ai-mentor-break.html",
    "category_id": "eliminated",
    "tags": ["AI","隐性知识","导师制","经验传承"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-mentor-break",
    "created_at": "2026-08-22",
    "updated_at": null
  },
  {
    "id": "ai-compute-rhythm",
    "title": "AI时代的\"算力作息\"——当AI成本也讲峰谷，24小时待命的组织开始重新做人",
    "summary": "DeepSeek周末统一按低谷价收费，AI第一次有了像人一样的\"作息\"。当算力成本开始分峰谷，组织该重新学会错峰与休息。",
    "content_type": "html",
    "content": "articles/created/ai-compute-rhythm.html",
    "category_id": "created",
    "tags": ["AI","算力","组织效率","成本管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compute-rhythm",
    "created_at": "2026-08-23",
    "updated_at": null
  },
  {
    "id": "ai-competition-illusion",
    "title": "AI时代的\"参赛错觉\"——机器人跑赢了宣传，却跑输了落地，组织别光顾着秀肌肉",
    "summary": "宇树机器人100米垫底戳中AI落地的真相：展示价值和实用价值是两码事。别光让AI跑得好看，先让它跑得起来、跑得值。",
    "content_type": "html",
    "content": "articles/stable/ai-competition-illusion.html",
    "category_id": "stable",
    "tags": ["AI","落地","组织管理","机器人"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-competition-illusion",
    "created_at": "2026-08-23",
    "updated_at": null
  },
  {
    "id": "ai-asking-ability-deflation",
    "title": "AI时代的\"答题能力\"贬值——当答案人人可得，组织该培训的是\"问对问题\"",
    "summary": "AI把答案打成白菜价，把提问抬成硬通货。培训的价值从\"传授答案\"转向\"练提问\"，会问对问题才是AI时代最稀缺的能力。",
    "content_type": "html",
    "content": "articles/tension/ai-asking-ability-deflation.html",
    "category_id": "tension",
    "tags": ["AI","提问","培训","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-asking-ability-deflation",
    "created_at": "2026-08-23",
    "updated_at": null
  },
  {
    "id": "ai-alert-distortion",
    "title": "AI时代的\"预警失真\"——警报响得越勤，组织越听不见真危机",
    "summary": "微博\"长宁地震预警误报\"戳中一个组织管理痛点：AI预警系统越灵敏，假警报越多，人越听不见真危机。灵敏度和可信度是两码事，破解要靠分级、公开误报率、保留人的最后一道关。",
    "content_type": "html",
    "content": "articles/stable/ai-alert-distortion.html",
    "category_id": "stable",
    "tags": ["AI","预警","风险管理","组织决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-alert-distortion",
    "created_at": "2026-08-24",
    "updated_at": null
  },
  {
    "id": "ai-human-screws",
    "title": "AI时代的\"人肉螺丝\"——硕士被裁打螺丝，警醒的是所有\"可被替代的学历\"",
    "summary": "微博\"被裁硕士生一天打五六千个螺丝\"戳中学历贬值的真相：AI贬值的不是读书无用，而是只靠知识储备吃饭的那部分能力。培训的价值正从\"传授答案\"转向\"训练判断\"。",
    "content_type": "html",
    "content": "articles/tension/ai-human-screws.html",
    "category_id": "tension",
    "tags": ["AI","学历贬值","培训转型","人才发展"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-human-screws",
    "created_at": "2026-08-24",
    "updated_at": null
  },
  {
    "id": "ai-trust-harvest",
    "title": "AI时代的\"信任收割\"——当AI让骗局更精致，组织的独立思考正在变成稀缺品",
    "summary": "知乎\"男子省吃俭用20年攒789万6天被骗空\"揭示：攒钱靠自动，被骗靠被接管。AI一边让骗局更精致，一边让人丧失独立判断。判断力越外包越萎缩，独立思考成了AI时代最稀缺的能力。",
    "content_type": "html",
    "content": "articles/eliminated/ai-trust-harvest.html",
    "category_id": "eliminated",
    "tags": ["AI","判断力","独立思考","组织认知"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-harvest",
    "created_at": "2026-08-24",
    "updated_at": null
  },
  {
    "id": "ai-accountability-punishment",
    "title": "AI时代的\"担当惩罚\"——为什么敢主动负责的人，正在悄悄消失",
    "summary": "微博知乎双榜\"帮扶老人遭索赔店主不担责\"戳中一个组织管理痛点：主动担责的人收益被稀释、风险被放大，沉默的人风险为零。AI把\"担当的代价\"变成一眼可见的数字，反而精准淘汰最敢负责的人。",
    "content_type": "html",
    "content": "articles/eliminated/ai-accountability-punishment.html",
    "category_id": "eliminated",
    "tags": ["AI","担当","激励机制","组织文化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-accountability-punishment",
    "created_at": "2026-08-25",
    "updated_at": null
  },
  {
    "id": "ai-energy-stratification",
    "title": "AI时代的\"精力分层\"——当绩效只看产出，组织的\"续航型人才\"正在被误杀",
    "summary": "微博\"发现高精力和高体力是两种人群\"戳中一个人才管理盲区：精力分爆发力和续航力两种，但KPI只认爆发力。AI替代了\"机械的稳定\"，却让管理者误以为\"有判断的稳定\"也没用了。",
    "content_type": "html",
    "content": "articles/stable/ai-energy-stratification.html",
    "category_id": "stable",
    "tags": ["AI","人才盘点","精力管理","组织韧性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-energy-stratification",
    "created_at": "2026-08-25",
    "updated_at": null
  },
  {
    "id": "ai-gamification-self-indulgence",
    "title": "游戏化的\"自嗨陷阱\"——750万影游一周解散，给所有\"形式游戏化\"敲响警钟",
    "summary": "知乎\"750万影游《恶校游戏》好评93%却一周解散\"戳中游戏化行业的致命问题：作品认可不等于商业成立，形式自嗨不等于激活动机。企业游戏化正在犯一模一样的病。",
    "content_type": "html",
    "content": "articles/tension/ai-gamification-self-indulgence.html",
    "category_id": "tension",
    "tags": ["AI","游戏化","激励机制","自嗨陷阱"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-gamification-self-indulgence",
    "created_at": "2026-08-25",
    "updated_at": null
  },
  {
    "id": "new-hire-trust-breach",
    "title": "AI时代的\"入职即劝退\"——当企业批量解约应届生，雇主的信用正在透支",
    "summary": "知乎热榜\"星宇股份批量劝退107名应届生\"戳中雇主信任的命门：当AI让企业觉得人很容易补充，就越不珍惜人，把应届生长期价值当季度成本砍掉。算法能算出谁匹配，算不出谁愿意相信你。",
    "content_type": "html",
    "content": "articles/eliminated/new-hire-trust-breach.html",
    "category_id": "eliminated",
    "tags": ["AI","招聘","雇主品牌","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-new-hire-trust-breach",
    "created_at": "2026-08-26",
    "updated_at": null
  },
  {
    "id": "nostalgia-card-failed",
    "title": "AI时代的\"情怀牌失灵\"——游戏怀旧服塌房，给企业游戏化的\"复古激励\"敲响警钟",
    "summary": "知乎热榜《英雄联盟》怀旧服上线即塌房\"情怀牌不灵\"，揭开企业激励的同类病：靠过去的荣誉、回忆、情感惯性驱动当下的行为，正随着AI让经验贬值、人员流动加快而失效。真正的激励指向现在和未来，不是身后。",
    "content_type": "html",
    "content": "articles/tension/nostalgia-card-failed.html",
    "category_id": "tension",
    "tags": ["AI","游戏化","激励机制","组织文化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-nostalgia-card-failed",
    "created_at": "2026-08-26",
    "updated_at": null
  },
  {
    "id": "teen-ai-arbitrage",
    "title": "AI时代的\"少年套利\"——当13岁孩子靠AI三天赚1.8万，组织的学习曲线正在被倒逼",
    "summary": "微博热搜\"13岁上海女孩靠AI三天赚1.8万\"暴露一个规律：当工具门槛极低，经验最少、包袱也最少的年轻人反而最快变现。组织若不放下\"我经验多我该当老师\"的架子，只会被AI倒逼着走。",
    "content_type": "html",
    "content": "articles/created/teen-ai-arbitrage.html",
    "category_id": "created",
    "tags": ["AI","学习","组织变革","人才"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-teen-ai-arbitrage",
    "created_at": "2026-08-26",
    "updated_at": null
  },
  {
    "id": "ai-risk-arrogance",
    "title": "AI时代的\"风险傲慢\"——比尔盖茨写12页长文警告AI风险，为什么多数组织还在装睡",
    "summary": "微博热搜\"比尔盖茨发12页长文警告AI风险\"暴露一个组织病：红利太诱人、从众心理、风险被外包，让组织对近在眼前的AI风险集体麻痹。破局靠风险清单、人工刹车、小步验证——正视风险，才能更稳吃红利。",
    "content_type": "html",
    "content": "articles/tension/ai-risk-arrogance.html",
    "category_id": "tension",
    "tags": ["AI","风险","组织管理","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-risk-arrogance",
    "created_at": "2026-08-27",
    "updated_at": null
  },
  {
    "id": "avoidance-management",
    "title": "AI时代的\"避责式管理\"——办事大厅空岗被拍后禁带手机，组织正在学会\"用规则规避问题\"",
    "summary": "微博热搜\"办事大厅被拍空岗后禁群众带手机进入\"揭示蔓延的管理病：真问题解决成本高，就选择让问题\"不被看见\"。AI时代这病会变本加厉——规则与算法成了最方便的避责挡箭牌。破局：奖励暴露真问题、现场核查AI报表、责任落到具体人。",
    "content_type": "html",
    "content": "articles/stable/avoidance-management.html",
    "category_id": "stable",
    "tags": ["AI","管理","组织文化","信任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-avoidance-management",
    "created_at": "2026-08-27",
    "updated_at": null
  },
  {
    "id": "performance-surplus",
    "title": "AI时代的\"性能过剩\"——当Anthropic最强模型Fable 5遇冷，你的组织还在为用不上的算力买单",
    "summary": "知乎热榜\"Anthropic最强模型Fable 5遇冷，AI行业是否高估更强模型价值\"戳中组织问题：采购AI不看需求只看'最强'，为用不到的性能付钱。破局：写清业务痛点、用'够用就行'倒逼验证、让业务负责人对'为什么需要这么强'签字。",
    "content_type": "html",
    "content": "articles/eliminated/performance-surplus.html",
    "category_id": "eliminated",
    "tags": ["AI","效率","组织","降本"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-performance-surplus",
    "created_at": "2026-08-27",
    "updated_at": null
  },
  {
    "id": "relay-paradox-fresh-grads",
    "title": "AI时代的\"接盘悖论\"——常州为星宇离职学生办专场招聘会，地方能接住一代人的职业断层吗",
    "summary": "微博热搜\"常州为星宇离职学生办专场招聘会\"暴露一个组织病：AI和大厂联手把应届生当可批量替换的耗材，地方靠一场招聘会只能'接人'接不了一代人的职业断层。破局靠把应届生当资产种树、给足离职体面、建人才缓冲池——会用AI省成本是本事，愿意为一代人成长买单才是企业走远的底气。",
    "content_type": "html",
    "content": "articles/stable/relay-paradox-fresh-grads.html",
    "category_id": "stable",
    "tags": ["AI","应届生","雇主责任","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-relay-paradox-fresh-grads",
    "created_at": "2026-08-29",
    "updated_at": null
  },
  {
    "id": "ai-cost-illusion",
    "title": "AI时代的\"降本幻觉\"——房贷月供省635元的喜悦背后，组织用AI\"省下的账\"到底真不真",
    "summary": "微博热搜\"100万房贷月供可减少635元\"的确定性快感，正像组织看到AI省下人力成本时的喜悦——可AI降本往往只有第一年确定。会降本的组织算总账：算全成本看净额、追踪省下的时间去向、设验证周期、警惕为降本而降本。省下的是死钱，投回去才是活钱。",
    "content_type": "html",
    "content": "articles/tension/ai-cost-illusion.html",
    "category_id": "tension",
    "tags": ["AI","降本","成本管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-cost-illusion",
    "created_at": "2026-08-29",
    "updated_at": null
  },
  {
    "id": "disaster-style-collaboration",
    "title": "AI时代的\"救灾式协同\"——西藏泥石流救援按秒计时，组织的跨部门响应能力才是真护城河",
    "summary": "西藏吉隆泥石流救援按秒计时的跨部门大协作，藏着组织的四块肌肉：指挥清晰、信息实时、能力机动、风险前置。当AI把可复制的东西都变便宜，'应对不确定性的响应速度'成了真护城河。把指挥权定清、让信息共享常态化、建能力机动池、留风险预判哨位，平时练好才经得起突发。",
    "content_type": "html",
    "content": "articles/created/disaster-style-collaboration.html",
    "category_id": "created",
    "tags": ["AI","协同","组织能力","危机管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-disaster-style-collaboration",
    "created_at": "2026-08-29",
    "updated_at": null
  },
  {
    "id": "ai-empowerment-anxiety",
    "title": "AI时代的\"赋能焦虑\"——当人人都在谈赋能，组织真正该赋能的是什么",
    "summary": "微博热搜\"AI赋能新电商发展\"背后藏着一个误区：很多组织把\"授工具\"当成了\"赋能\"。工具是借来的，能力是长出来的。AI时代组织真正该赋能的是判断力和创造力，而不是让员工更依赖工具。破局：从授工具转向赋能力，分场景集中发力，把判断力创造力放进赋能清单。",
    "content_type": "html",
    "content": "articles/tension/ai-empowerment-anxiety.html",
    "category_id": "tension",
    "tags": ["AI","赋能","组织管理","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-empowerment-anxiety",
    "created_at": "2026-08-30",
    "updated_at": null
  },
  {
    "id": "ai-textbook-anxiety",
    "title": "AI时代的\"教材更替焦虑\"——当知识像教材一样不断换版，组织的学习体系怎么跟上",
    "summary": "知乎热榜\"全国中小学新教材将全部替换\"暴露组织学习的错位：教材是慢变量可以系统换版，AI技能是快变量必须永续更新。越认真做\"标准教材\"越跟不上。破局：把教材改成活文档、用实战任务替代集中考试培训、重点培养\"学会学习\"的能力。",
    "content_type": "html",
    "content": "articles/created/ai-textbook-anxiety.html",
    "category_id": "created",
    "tags": ["AI","学习","培训","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-textbook-anxiety",
    "created_at": "2026-08-30",
    "updated_at": null
  },
  {
    "id": "ai-blank-space-ability",
    "title": "AI时代的\"留白能力\"——当AI填满每一格时间，组织反而要学会故意空着",
    "summary": "很多团队引入AI后效率上去了，创造力判断力却悄悄下降。因为组织把员工时间填得太满，系统性杀死了产生新想法的空间。AI省下来的时间不是用来填更多活的，是用来留白产生判断和创造。破局：把留白写进制度、用深度问题替代密集任务、容忍看似没产出的思考时间。",
    "content_type": "html",
    "content": "articles/stable/ai-blank-space-ability.html",
    "category_id": "stable",
    "tags": ["AI","创造力","判断力","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-blank-space-ability",
    "created_at": "2026-08-30",
    "updated_at": null
  },
  {
    "id": "ai-token-threshold",
    "title": "AI时代的\"Token门槛\"——当算力决定谁来干活，组织的公平靠什么兜底",
    "summary": "知乎热榜七百万热度的\"没Token就退学\"背后，是AI时代一道新的资源门槛。算力成为新时代生产资料，组织里的\"有Token者\"和\"没Token者\"正在分裂成两个物种，而管理者往往用Token差异给员工能力打分。拆门槛的关键，是把算力当基础设施、把资源差异从绩效剥离。",
    "content_type": "html",
    "content": "articles/tension/ai-token-threshold.html",
    "category_id": "tension",
    "tags": ["AI","算力门槛","组织公平","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-token-threshold",
    "created_at": "2026-08-31",
    "updated_at": null
  },
  {
    "id": "ai-group-chat-bubble",
    "title": "AI时代的\"群聊泡沫\"——845个工作群逼走一个女孩，AI救不了的信息过载",
    "summary": "微博热搜\"女孩被踢出845个工作群\"背后，是组织沟通的通胀陷阱。工具让发消息成本趋近于零，人人都无限拉群@人，信息从稀缺品变成过剩品。AI不是解药反而可能让泡沫更鼓——它降低了生产消息的门槛，却没降低接收消息的负担。",
    "content_type": "html",
    "content": "articles/eliminated/ai-group-chat-bubble.html",
    "category_id": "eliminated",
    "tags": ["AI","信息过载","组织沟通","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-group-chat-bubble",
    "created_at": "2026-08-31",
    "updated_at": null
  },
  {
    "id": "ai-cost-cutting-addiction",
    "title": "AI时代的\"节流成瘾\"——当组织学会用AI省下每一分钱，增长这门手艺正在失传",
    "summary": "AI让\"省钱\"变得又快又爽，组织集体患上节流成瘾，把\"省\"从手段变成了目的。可省有天花板，增长没有；省和增练的是两套完全不同的能力。一个节流成瘾的组织，会慢慢丧失做增长的资格。",
    "content_type": "html",
    "content": "articles/stable/ai-cost-cutting-addiction.html",
    "category_id": "stable",
    "tags": ["AI","降本增效","增长","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-cost-cutting-addiction",
    "created_at": "2026-08-31",
    "updated_at": null
  },
  {
    "id": "ai-memory-outsourcing",
    "title": "AI时代的\"记忆外包\"——当组织把所有经验都交给AI，谁还记得为什么",
    "summary": "OpenAI的Codex取消上下文压缩换外部记忆，背后是组织正在悄悄患上\"记忆外包\"病。能被外部记忆存下的永远是what和how，存不下why——判断、权衡和放弃。记忆被移出人脑那一刻，组织就从会思考的活体退化成只会查库的档案柜，纠错能力被连根挖掉。",
    "content_type": "html",
    "content": "articles/tension/ai-memory-outsourcing.html",
    "category_id": "tension",
    "tags": ["AI","组织记忆","判断力","知识管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-memory-outsourcing",
    "created_at": "2026-09-01",
    "updated_at": null
  },
  {
    "id": "ai-loss-inertia",
    "title": "AI时代的\"亏损惯性\"——三大航都在亏，为什么你还敢指望AI能救你",
    "summary": "三大航上半年合计亏八十多亿上热榜，我想说的不是票务和油价，而是\"亏损惯性\"——缺的不是钱和资源，是推翻旧路径的勇气。深陷惯性的组织会把AI拿去做更高效的旧事，用最先进的工具把最过时的生意做得更亏。AI救不了不想换打法的组织。",
    "content_type": "html",
    "content": "articles/eliminated/ai-loss-inertia.html",
    "category_id": "eliminated",
    "tags": ["AI","组织转型","亏损惯性","战略"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-loss-inertia",
    "created_at": "2026-09-01",
    "updated_at": null
  },
  {
    "id": "ai-gacha-incentive",
    "title": "AI时代的\"氪金激励\"——当组织靠不断加码才能留住员工，游戏早晚会崩",
    "summary": "知乎热榜问手游为何陷入\"不氪就没法舒服玩\"的死循环，我却看到大量组织患同样的病——靠不断加码的外部奖励买动力。AI恰好把这条氪金路越修越窄：稀缺技能变便宜、加码不可持续、激励稀缺性被抹平。真正该做的是回归内在动力，让AI释放人的高价值劳动。",
    "content_type": "html",
    "content": "articles/stable/ai-gacha-incentive.html",
    "category_id": "stable",
    "tags": ["AI","激励","游戏化","内在动力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-gacha-incentive",
    "created_at": "2026-09-01",
    "updated_at": null
  },
  {
    "id": "ai-both-tax",
    "title": "AI时代的\"既要又要税\"",
    "summary": "微博热搜\"凭什么既要工作又要做家务\"，戳中的不只是家庭分工，还有AI时代极普遍的组织病\"既要又要税\"——老板给员工装AI说效率高了该轻松，转头却用\"你不是有AI吗\"当筹码，要人一个人扛下所有AI替代不了的人情、兜底与协调。效率归组织，内耗归个人；账单迟早爆在组织自己头上。",
    "content_type": "html",
    "content": "articles/tension/ai-both-tax.html",
    "category_id": "tension",
    "tags": ["AI","AI组织管理","员工负担","隐性劳动"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-both-tax",
    "created_at": "2026-09-03",
    "updated_at": null
  },
  {
    "id": "ai-loss-most-fatal",
    "title": "AI时代，组织失去哪种人最致命",
    "summary": "知乎热榜吵了两千年\"楚汉争霸失去谁对刘邦最致命\"，我把它搬到今天的公司——当AI抹平执行、能力变便宜，过去最贵的\"韩信型执行者\"正在贬值，最便宜的\"张良型判断者\"成了组织命门。可惜多数老板仍按旧尺子裁人：裁光张良留满韩信，高效地做着错事。",
    "content_type": "html",
    "content": "articles/stable/ai-loss-most-fatal.html",
    "category_id": "stable",
    "tags": ["AI","AI组织管理","关键人才","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-loss-most-fatal",
    "created_at": "2026-09-03",
    "updated_at": null
  },
  {
    "id": "ai-outsider-manager-exit",
    "title": "AI时代的\"外行经理\"退场",
    "summary": "那些学历光鲜、跨行业空降、对业务一知半解却靠信息差和资源通道吃饭的\"外行经理\"，正在被AI亲手终结。AI抹平了信息差、把判断变贵之后，他只传话不判断的\"中间管理层油膜\"两头落空——装懂的成本变高，真懂的回报变大，价值主义正在回归。",
    "content_type": "html",
    "content": "articles/eliminated/ai-outsider-manager-exit.html",
    "category_id": "eliminated",
    "tags": ["AI","AI组织管理","管理者","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-outsider-manager-exit",
    "created_at": "2026-09-03",
    "updated_at": null
  },
  {
    "id": "ai-staffing-bankruptcy",
    "title": "AI时代的\"编制思维\"破产",
    "summary": "GPT-6正式发布炸了全网，我却在担心一件更深的旧东西：组织的\"编制思维\"。当AI让一个人+一堆agent能顶一个小团队，组织还按\"人头数=战斗力\"配预算、定晋升、画汇报线，就会配多了养闲人、配少了卡死顶梁柱。编制不会一夜消失，但\"人头越多越强\"的旧信仰该破产了——钱要跟着\"能力当量\"走，而不是跟着人头走。",
    "content_type": "html",
    "content": "articles/eliminated/ai-staffing-bankruptcy.html",
    "category_id": "eliminated",
    "tags": ["AI","AI组织管理","组织架构","资源配置"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-staffing-bankruptcy",
    "created_at": "2026-09-04",
    "updated_at": null
  },
  {
    "id": "ai-practice-reversed",
    "title": "AI时代的\"用进废退\"反了",
    "summary": "从小信到大的一条定律\"用进废退\"，遇上AI后在组织里悄悄反了。真正的危险不是不会用AI，而是用AI代劳了\"本该亲手做\"的动作——写作、拆解、决策这些练底层能力的苦功夫全被外包，表层技能人人会且快速贬值，底层能力却因常年不练而萎缩。AI可以替你跑，但跑不替你长肌肉。",
    "content_type": "html",
    "content": "articles/tension/ai-practice-reversed.html",
    "category_id": "tension",
    "tags": ["AI","AI组织管理","能力成长","组织学习"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-practice-reversed",
    "created_at": "2026-09-04",
    "updated_at": null
  },
  {
    "id": "ai-genius-illusion",
    "title": "AI时代，别赌\"天才力挽狂澜\"",
    "summary": "抖音热榜挂着\"AI圈来了位天才\"上千万播放，我却替那些看得心痒的老板捏把汗。组织持续赢靠的不是一两个天才，而是让普通人做出不普通结果的系统。赌\"救世主员工\"的是用不可控的运气替代本可系统化建设的组织能力——AI时代单干门槛极低，真有天才凭什么来给你打工？与其赌奇迹，不如把系统、主场、协作三块地基夯实。",
    "content_type": "html",
    "content": "articles/stable/ai-genius-illusion.html",
    "category_id": "stable",
    "tags": ["AI","AI组织管理","人才观","领导力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-genius-illusion",
    "created_at": "2026-09-04",
    "updated_at": null
  },
  {
    "id": "ai-certificate-inflation",
    "title": "AI时代的\"证书通胀\"——当一张认证能被炒到两千块，组织凭什么信一纸证明",
    "summary": "知乎热榜\"王者荣耀高校认证被炒到两千元\"的背后，是AI时代一场\"证书通胀\"。AI让\"证明\"和\"能力\"之间的相关性崩了：当能力可以随时外挂、知识随手生成，一次性静态证书正在飞速贬值。可太多组织还把证当硬尺子，招错人、吓跑真高手、养出刷证文化。破局在于组织从\"看符号\"走向\"看过程、看作品、看现场\"——用真实且扛得住追问的能力证据，替代一纸通胀的证明。",
    "content_type": "html",
    "content": "articles/tension/ai-certificate-inflation.html",
    "category_id": "tension",
    "tags": ["AI","证书通胀","招聘","学历焦虑"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-certificate-inflation",
    "created_at": "2026-09-05",
    "updated_at": null
  },
  {
    "id": "ai-copycat-race",
    "title": "AI时代的\"搬运工内卷\"——当组织能一键抄走对手，凭什么不被替代",
    "summary": "抖音热榜\"各省文旅都成搬运工\"(九百多万热度)背后，是AI时代所有靠\"抄得快\"活着的组织的集体焦虑。AI把模仿门槛铲平了：凡是能被写成SOP、喂给工具复制的东西，对手都能一键抄走你，还能比你快。可复制的优势正在被AI全部归零，真护城河只剩AI抄不走的判断、信任和现场感。组织要从\"复制热门的速度\"转向\"定义下一个别人要抄的方向\"。",
    "content_type": "html",
    "content": "articles/stable/ai-copycat-race.html",
    "category_id": "stable",
    "tags": ["AI","差异化","搬运工","护城河"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-copycat-race",
    "created_at": "2026-09-05",
    "updated_at": null
  },
  {
    "id": "ai-demo-report-retired",
    "title": "AI时代的\"汇报表演\"退场——当AI能生成完美PPT，管理者凭什么还靠\"讲得好\"上位",
    "summary": "当AI一分钟就能生成挑不出毛病的PPT、把报告润色到无懈可击，靠\"汇报好看\"上位的那套打法就没了土壤。AI把汇报里\"关于包装\"的部分全自动化，汇报不再是稀缺的\"能力信号\"。真正让管理者立足的，正从\"讲得好不好\"转向AI帮不了的部分——\"干得真不真、扛不扛得住追问\"。组织该把信任从\"会场\"搬回\"现场\"。",
    "content_type": "html",
    "content": "articles/eliminated/ai-demo-report-retired.html",
    "category_id": "eliminated",
    "tags": ["AI","汇报表演","绩效评估","真功夫"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-demo-report-retired",
    "created_at": "2026-09-05",
    "updated_at": null
  },
  {
    "id": "ai-motivation-stage-shift",
    "title": "AI时代的\"激励分层\"失效——治\"小学靠吼、大学靠钱\"那套，在AI组织里全失灵了",
    "summary": "从微博热榜\"小学靠吼初中靠忍高中靠哄大学靠钱\"切入：这套按资历分层的激励配方，底层默认\"能力、心气、贡献跟资历强相关\"。AI让能力和贡献不再跟资历挂钩，一个入职三个月的新人配AI工作流就能产出老员工熬三年才有的东西，于是\"新人靠吼、老人靠哄靠钱\"失去了准星。激励失灵不是钱不够，是你看错了此刻站在你面前的是谁。组织该把激励的锚从\"资历图层\"换成\"此刻状态与此刻真实贡献\"，用游戏化的动态反馈循环代替单方向的吼/哄/发钱。",
    "content_type": "html",
    "content": "articles/stable/ai-motivation-stage-shift.html",
    "category_id": "stable",
    "tags": ["AI","激励","激励分层","游戏化","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-motivation-stage-shift",
    "created_at": "2026-09-06",
    "updated_at": null
  },
  {
    "id": "ai-major-course-retreat",
    "title": "AI时代的\"主科\"退位——当\"取消英语主科\"都能上热搜，组织的培训清单该动刀了",
    "summary": "从微博热榜\"取消英语主科利弊\"切入：教育在吵要不要取消英语，组织在装睡地问为什么培训没效果。本质是一门课配不配当主科，看它是训练稀缺的底层能力，还是只教一个随时能被AI替代的\"接口\"。会做报表、翻译、操作某系统这类接口型技能被AI一键代劳后，还当全员主科花大量学时就是浪费。组织该给培训清单做\"接口/能力\"体检：接口降级为工具速查，把预算重投到AI时代真新主科（判断力、提问、定义问题、现场力），并用游戏化数据让课表革命自然发生。",
    "content_type": "html",
    "content": "articles/created/ai-major-course-retreat.html",
    "category_id": "created",
    "tags": ["AI","培训","学习","课表革命","组织学习"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-major-course-retreat",
    "created_at": "2026-09-06",
    "updated_at": null
  },
  {
    "id": "ai-slogan-words-retreat",
    "title": "AI时代的\"口号空转\"——当组织把\"尊师重教\"挂成标语，喊一万遍也长不出真本事",
    "summary": "从抖音热榜教育部\"尊师重教不能只是词语口号\"切入：口号本质是低成本的价值表态，过去因为查证成本极高所以有用。AI把人的真实行为变成可记录、可对比、随时可戳穿的数据，言行不一的落差藏不住了，口号从低成本保险变成高风险负债。只会喊口号的组织会付出三笔代价：价值口号被AI实时打脸、最优秀员工用脚投票、真本事退场表演家上位。破局是把价值从\"喊在嘴上\"落到\"做在系统里\"：口号拆成可检验行为、评价尺子换成真实行为数据、把核心价值观变成管理者的硬指标。",
    "content_type": "html",
    "content": "articles/eliminated/ai-slogan-words-retreat.html",
    "category_id": "eliminated",
    "tags": ["AI","组织文化","口号","游戏化","价值观落地"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-slogan-words-retreat",
    "created_at": "2026-09-06",
    "updated_at": null
  },
  {
    "id": "ai-pretend-work",
    "title": "AI时代的\"假装上班\"——当失效能无声无息，多少人正在图书馆演一整天",
    "summary": "从微博热榜\"失业者假装上班挤满图书馆\"切入：失业最痛的不是钱断，是\"我是谁\"这个锚被抽走——人领的不只是工资，还有身份、秩序、意义三样。AI让失业变得\"无声\"：岗位被流程悄悄包走、不裁不补不声张，很多人还\"在职\"但真活已全被AI做完被架空。假装上班是心理与身份危机的笨办法，管理者的责任不在嘲笑，而在学会体面地送人走——先开口的人占主动，冷冰冰的裁法买不回留下九成的信任。",
    "content_type": "html",
    "content": "articles/tension/ai-pretend-work.html",
    "category_id": "tension",
    "tags": ["AI","假装上班","组织身份","体面裁员"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-pretend-work",
    "created_at": "2026-09-08",
    "updated_at": null
  },
  {
    "id": "ai-why-not-fake-work",
    "title": "AI时代，凭什么让员工不想\"假装上班\"？——从盯梢打卡到意义供给",
    "summary": "承接\"假装上班\"主题，讲给还在工位上、但已悄悄在\"假装\"的在职者与管理者。本质是一个人开始装，是因为工作不再\"养\"他——钱、成长、意义三样长期断供就\"挂机\"。盯梢打卡在AI时代彻底失灵，因为AI让\"产出\"好观察又易造假，甚至产生\"逆向淘汰\"：越会装的人越能借AI包装自己，组织在奖励\"会装\"惩罚\"肯干\"。破局是从\"管投入\"转向\"喂意义\"：给真实影响换尺子、把AI省下的时间分配明白、把人该做的有人味儿的活郑重交还、给边缘岗位重建存在感。",
    "content_type": "html",
    "content": "articles/stable/ai-why-not-fake-work.html",
    "category_id": "stable",
    "tags": ["AI","内在动机","意义感","员工激励","游戏化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-why-not-fake-work",
    "created_at": "2026-09-08",
    "updated_at": null
  },
  {
    "id": "ai-quiet-departure-warning",
    "title": "AI时代的\"隐形离职\"预警——假装上班不是懒，是离职前的最后通牒",
    "summary": "从\"工位上的假装上班\"给管理者提个醒：假装上班不是态度问题，是结果——它是\"心理离职\"跑到终点的样子，前面还有热情熄灭、投入收缩、沉默抗议的漫长过程。几乎没有真·突然离职，信号早在几个月前发过，只是被当成\"他最近状态不好\"。AI时代更难识别，因为AI把投入度、产出痕迹这些旧产能信号全包装漂亮、替\"假装者\"打了掩护；真信号藏在AI盖不住的地方：成长感消失、主动性收缩、情绪关系撤离、回避未来、对肯定无感。破局：列预离职信号清单、做\"离职前的离职访谈\"、让HR转型成\"组织关系预警官\"。",
    "content_type": "html",
    "content": "articles/created/ai-quiet-departure-warning.html",
    "category_id": "created",
    "tags": ["AI","隐形离职","组织预警","HR转型","离职访谈"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-quiet-departure-warning",
    "created_at": "2026-09-08",
    "updated_at": null
  },
  {
    "id": "ai-application-desert",
    "title": "AI时代的\"应用荒漠\"——模型一个比一个强，为什么你的组织一个都用不起来",
    "summary": "从知乎热榜\"都说GPT-6-Astra很强，有没有实际点的应用案例\"切入：强模型、好产品、组织能用是三件毫不相干的事。很多人默认\"模型强=工具好=组织一定能用起来\"是错的——组织缺的不是更强的大模型，是那条把\"强能力\"改造成\"岗位真能用\"的接缝。三道塌方：买模型不买岗位改造、用测试分冒充可用性、趁模型更新快干脆选择等。破法是从追最强模型转向造一条够得着的接缝：从最痛岗位切入、配业务×AI翻译官、给\"用起来\"设考核。",
    "content_type": "html",
    "content": "articles/tension/ai-application-desert.html",
    "category_id": "tension",
    "tags": ["AI","应用荒漠","AI落地","岗位改造"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-application-desert",
    "created_at": "2026-09-09",
    "updated_at": null
  },
  {
    "id": "ai-async-shift-schedule",
    "title": "AI时代，\"错峰\"的迟到——组织的作息还停在\"同步宇宙\"",
    "summary": "从微博热榜\"双休不一定是休周六周日\"切入：AI已把很多工作异步化了，可多数组织的作息还停在工业时代那套\"人人都得同时在场\"的同步宇宙里。作息从来不只是时间表，是组织权力的排列方式。AI能异步任务，异步不了权力。同步的舒适在AI时代正在变成三笔隐形代价：用同时在场掩盖没想清楚、假装同步制造表演在场、把差异化节奏当异类。破法是异步为骨、同步为魂：同步清单缩到最少、用内核时段替代全员全时、盯产出不盯在场、仪式改成自愿的同步。",
    "content_type": "html",
    "content": "articles/stable/ai-async-shift-schedule.html",
    "category_id": "stable",
    "tags": ["AI","异步协作","作息","错峰"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-async-shift-schedule",
    "created_at": "2026-09-09",
    "updated_at": null
  },
  {
    "id": "ai-hard-problem-accountant",
    "title": "AI时代的\"攻坚算账人\"——当AI真能解千年难题，组织缺的是给\"值得解的难题\"定价的人",
    "summary": "从微博热榜\"OpenAI宣布攻克千禧年难题\"切入一个被忽略的事实：AI最擅长解定义清楚的难题，可组织里80%耗人的是说不清该不该解的小破题。于是出现攻坚错配——把最强能力用在最难最远的题上，近处天天漏血却没人管值不值得用AI。组织真正的瓶颈从不是能解多少题，而是把资源浪费在多少根本不该解的题上。所以现在最贵的是能判别哪道题值得解的\"攻坚算账人\"：给问题分级定价、看守硬骨头的人味、把解题和算账绑在一起。",
    "content_type": "html",
    "content": "articles/created/ai-hard-problem-accountant.html",
    "category_id": "created",
    "tags": ["AI","攻坚算账人","难题定价","新角色"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hard-problem-accountant",
    "created_at": "2026-09-09",
    "updated_at": null
  },
  {
    "id": "ai-beyond-resume",
    "title": "AI时代的\"简历之外\"——当第一学历被AI抹平，组织还靠什么认人",
    "summary": "从微博热榜\"我国从来没有第一学历这个概念\"和知乎\"星宇股份90%劳务派遣\"切入：AI把简历从\"高成本证据\"变成了\"文案\"——既好造假、又难分辨，组织认人的坐标系塌了。三道裂缝：AI筛简历偏爱光鲜履历反而筛掉AI补不上的人、身份标签与能力脱钩、AI面试催生\"过面试\"表演产业。破法：用真活替代真简历、问未来不问过去、把身份门槛换成能力门槛。",
    "content_type": "html",
    "content": "articles/tension/ai-beyond-resume.html",
    "category_id": "tension",
    "tags": ["AI","招聘","简历之外","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-beyond-resume",
    "created_at": "2026-09-14",
    "updated_at": null
  },
  {
    "id": "ai-shift-scheduling-illusion",
    "title": "AI时代的\"排班幻觉\"——上5休1上5休3上3休7，为什么越调越乱",
    "summary": "从微博热榜\"上5休1上5休3上3休7上3休1\"调休方案切入：排班的本质不是填满工位，是把一群会累、需要连续性的活人安排进有节奏的时间。AI排班只优化可计算的效率，把\"人的节奏感\"当噪声滤掉，于是得到数学满分、体验崩溃的排班表。三道代价：碎片化休息恢复不了精力、组织节奏被打散隐藏协作成本、剥夺可预期性侵蚀主动性。破法：连续休息设硬约束、排班表要人记得住、保留团队同时在场锚点。",
    "content_type": "html",
    "content": "articles/stable/ai-shift-scheduling-illusion.html",
    "category_id": "stable",
    "tags": ["AI","智能排班","组织节奏","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-shift-scheduling-illusion",
    "created_at": "2026-09-14",
    "updated_at": null
  },
  {
    "id": "ai-apprentice-employment",
    "title": "AI时代的\"学员制用工\"——从\"招进来用\"到\"招进来练\"，组织在换什么",
    "summary": "从知乎热榜\"于东来称胖东来再招员工都是学员性质、合同四年不续签\"切入：当AI让\"熟练\"变廉价，组织买\"现成能力\"的性价比崩塌，于是转向买\"可塑的过程\"——招进来不再为立刻用，而为练出AI练不出的判断力与适应力。三重变化：人从资源变成有期限的作品、招人标准从\"会什么\"变成\"能长多快\"、培训从福利变成主业务。破法：写死能力交付清单、把练配在真战场上、对练完就走提前设预案。",
    "content_type": "html",
    "content": "articles/created/ai-apprentice-employment.html",
    "category_id": "created",
    "tags": ["AI","学员制用工","人才培养","游戏化培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-apprentice-employment",
    "created_at": "2026-09-14",
    "updated_at": null
  },
  {
    "id": "ai-employment-retreat",
    "title": "AI时代的\"雇佣退场\"——当2亿人不再属于任何一家公司",
    "summary": "从微博热榜\"我国灵活就业人员规模已超过2亿人\"切入：雇佣制\"用固定成本换稳定协作\"的底层逻辑，被AI按需调用的经济账算掉了——组织从\"拥有一支队伍\"转向\"调用一批能力\"。三重代价：失去沉淀容器、管理从带人退化成对接、2亿人独自承担风险。破法：把沉淀与雇佣解绑、给管理者加关系质量指标、对核心能力保留重雇佣。",
    "content_type": "html",
    "content": "articles/tension/ai-employment-retreat.html",
    "category_id": "tension",
    "tags": ["AI","灵活就业","雇佣关系","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-employment-retreat",
    "created_at": "2026-09-15",
    "updated_at": null
  },
  {
    "id": "ai-risk-footnote",
    "title": "AI时代的\"风险脚注\"——当发出警告的人先被边缘化",
    "summary": "从知乎热榜\"Anthropic研究员辞职示警AI可能十年内毁灭人类\"切入：真正值得盯的不是预言准不准，而是一个最懂风险的人居然要用辞职才能发声。组织对风险失明的根本原因不是认知问题而是结构问题——看见风险的人没有能安全说话的位置。三重后果：坏消息被美化、说真话的人用辞职来说、组织失去刹车。破法：把提风险写进岗位职责、风险分级、给踩刹车的人正向回报。",
    "content_type": "html",
    "content": "articles/stable/ai-risk-footnote.html",
    "category_id": "stable",
    "tags": ["AI","风险管理","组织决策","心理安全感"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-risk-footnote",
    "created_at": "2026-09-15",
    "updated_at": null
  },
  {
    "id": "ai-permission-blackhole",
    "title": "AI时代的\"权限黑洞\"——17小时删掉89TB，没人拦得住",
    "summary": "从知乎热榜\"程序员为干私活腾空间17小时删光公司89TB数据获刑五年十个月\"切入：真正失控的不是个人，是让破坏持续17小时无人拦截的组织。权限黑洞=破坏力与管控力的剪刀差，AI让单个操作破坏力指数级上升，管控还停在\"信任即授权\"的旧逻辑。三重反噬：用不信任设计管控罚的是老实人、最懂系统的人成最大单点风险、恢复能力远比以为的弱。破法：双人确认、实时告警、权限保质期、演练恢复。",
    "content_type": "html",
    "content": "articles/eliminated/ai-permission-blackhole.html",
    "category_id": "eliminated",
    "tags": ["AI","权限管理","数据安全","风控"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-permission-blackhole",
    "created_at": "2026-09-15",
    "updated_at": null
  },
  {
    "id": "ai-unsexy-work",
    "title": "AI时代的\"去包装化\"——用AI裁了70多人，利润就上去了",
    "summary": "从微博热榜\"用AI裁了70多人利润就上去了\"切入：AI压缩的是\"可包装\"岗位——能定义、能分工、能验收的执行性工作。裁掉这些人短期成本降了、利润上去了，但被一起裁掉的往往还有组织\"把事情整合成结果\"的能力。三重代价：整合者被优化、说服型岗位消失导致组织失去主张能力、责任真空使风险敞口变大。破法：做岗位\"可包装度\"盘点、把整合力当核心能力投资、裁人前先问\"这个人走了哪件事没人干\"、AI参与的决策必须明确签字人。",
    "content_type": "html",
    "content": "articles/tension/ai-unsexy-work.html",
    "category_id": "tension",
    "tags": ["AI","组织能力","降本增效","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-unsexy-work",
    "created_at": "2026-09-16",
    "updated_at": null
  },
  {
    "id": "ai-criteria-hollowing",
    "title": "AI时代的\"标准空心化\"——当番茄AI文占比74.5%",
    "summary": "从知乎热榜\"番茄AI文占比74.5%，起点仅10%\"切入：评价体系的真正功能不是划线，而是区分。AI把\"达标\"的边际成本压到近乎为零，任何可被批量满足的标准都会瞬间空心化——尺子还在，但量不出差异了。三重后果：激励体系失效努力变得没有意义、组织\"认人\"能力崩塌退回靠印象和关系判断、员工反向学聪明开始生产达标而非生产价值。破法：标准从\"是否达标\"换成\"是否产生改变\"、引入AI无法满足的过程与责任维度、用相对差异考核、给每条标准设有效期。",
    "content_type": "html",
    "content": "articles/eliminated/ai-criteria-hollowing.html",
    "category_id": "eliminated",
    "tags": ["AI","评价体系","标准","激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-criteria-hollowing",
    "created_at": "2026-09-16",
    "updated_at": null
  },
  {
    "id": "ai-waiting-loss",
    "title": "AI时代的\"等待成本\"——下属总推一下动一下",
    "summary": "从知乎热榜\"下属总是推一下动一下，缺乏主动性，管理者该从哪些方面提升管理能力\"切入：主动性不是品德，是被制度算出来的行为。员工不动是因为算了三笔账——做了没好处、做了有风险、不做没代价，其中\"不做没代价\"是真正病根。AI让等待变得更便宜：等待有了\"AI遮羞布\"（用AI生成看似完整的东西交差，问题一点没动）、执行力贬值使主动性更难被识别、管理者自己也在等AI给判断。破法：让不做的代价可见、考核加\"主动发起\"栏、给主动犯错划安全边界、警惕AI遮羞布、管理者带头不外包判断。",
    "content_type": "html",
    "content": "articles/created/ai-waiting-loss.html",
    "category_id": "created",
    "tags": ["AI","主动性","管理机制","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-waiting-loss",
    "created_at": "2026-09-16",
    "updated_at": null
  },
  {
    "id": "ai-ai-summer-camp-failed",
    "title": "AI时代的\"外接大脑退场\"——从\"AI夏令营9.9元\"到\"判断力才是护城河\"",
    "summary": "从微博热榜\"9.9元AI夏令营家长抢着报名\"切入：AI淘汰的不是学习，而是以记忆和搬运为核心的\"外接大脑\"式学习。当知道变得免费，知识清单式培养、标准答案式评价、储存型职业安全感三样东西正在被淘汰，判断力才是护城河。",
    "content_type": "html",
    "content": "articles/eliminated/ai-ai-summer-camp-failed.html",
    "category_id": "eliminated",
    "tags": ["AI","判断力","培训转型","组织能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ai-summer-camp-failed",
    "created_at": "2026-09-17",
    "updated_at": null
  },
  {
    "id": "ai-loop-economy",
    "title": "AI时代的\"闭环能力\"——蜜雪冰城半年赚27亿，很多公司却连一件事都做不完整",
    "summary": "从微博热榜\"蜜雪冰城半年净赚27亿\"切入：AI把单点交付压到极便宜，于是组织瓶颈从\"做得出来\"移到\"做得完整\"。能闭环的组织AI是加速器，不能闭环的组织AI是混乱放大器。闭环=定靶、卡点、收尾、复盘四段。",
    "content_type": "html",
    "content": "articles/created/ai-loop-economy.html",
    "category_id": "created",
    "tags": ["AI","组织效率","闭环","管理能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-loop-economy",
    "created_at": "2026-09-17",
    "updated_at": null
  },
  {
    "id": "ai-startup-cost",
    "title": "AI时代的\"上手成本\"——147所大学开AI专业，组织却卡在\"怎么开始\"",
    "summary": "从抖音/微博热榜\"147所高校新增人工智能专业\"切入：组织AI困境不是能力成本问题，是\"上手成本\"问题。选择成本被AI放大、没有现成SOP可抄、试错责任无处安放，导致组织永远停在准备阶段。破法：把开始变便宜、变安全。",
    "content_type": "html",
    "content": "articles/tension/ai-startup-cost.html",
    "category_id": "tension",
    "tags": ["AI","组织变革","落地","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-startup-cost",
    "created_at": "2026-09-17",
    "updated_at": null
  },
  {
    "id": "ai-responsibility-alibi",
    "title": "AI时代的\"责任外挂\"——机器人出事故，为什么挨罚的还是人",
    "summary": "从热榜\"机器人比赛现场失控伤人、追责追到人\"切入：机器没有责任账户，不能被追、不能被罚、也不会因被罚而改变行为，责任必然回流到活人身上。组织若不主动重建责任分配，责任会自动淤积到最靠近现场、最没有议价权的人身上。破法：给AI环节标人类责任人、建不可逆操作清单、责任与授权同步下发、复盘只问设计不问态度。",
    "content_type": "html",
    "content": "articles/eliminated/ai-responsibility-alibi.html",
    "category_id": "eliminated",
    "tags": ["AI", "组织效率", "工作设计", "决策权"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-responsibility-alibi",
    "created_at": "2026-09-18",
    "updated_at": null
  },
  {
    "id": "ai-personal-brand-devaluation",
    "title": "AI时代的\"个人品牌贬值\"——张一鸣身家千亿，为什么普通人的名字越来越不值钱",
    "summary": "从热榜\"张一鸣身家破1050亿美元成亚洲首富\"切入：个人的\"名字\"正在两端剧烈分化——顶层名字越来越值钱，中层名字越来越不值钱。AI把\"作品稀缺性来自能力稀缺性且绑定于个人\"这个前提打破了。破法：判断过程显性化、积累不可复制样本库、主动署名担责、重定义自己的产品。",
    "content_type": "html",
    "content": "articles/tension/ai-personal-brand-devaluation.html",
    "category_id": "tension",
    "tags": ["AI", "品牌", "组织能力", "职业发展"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-personal-brand-devaluation",
    "created_at": "2026-09-18",
    "updated_at": null
  },
  {
    "id": "ai-novelty-debt",
    "title": "AI时代的\"新鲜感负债\"——为什么年轻人越来越难被激励",
    "summary": "从热榜\"别用旧样本劝年轻人勇敢\"切入：新鲜感不是激励而是刺激——刺激效用递减，真正激励会自我强化。组织不断借刺激维持短期热情，利息是激励成本越滚越高。AI时代信息过载抬高了刺激阈值、让\"有趣\"贬值。破法：把激励系统从刺激引擎换成意义引擎（自主、胜任、联结），拉长激励周期。",
    "content_type": "html",
    "content": "articles/created/ai-novelty-debt.html",
    "category_id": "created",
    "tags": ["AI", "组织效率", "韧性", "游戏化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-novelty-debt",
    "created_at": "2026-09-18",
    "updated_at": null
  },
  {
    "id": "ai-code-streaking",
    "title": "AI时代的\"代码裸奔\"——你把公司的底裤交给了谁",
    "summary": "从知乎热榜\"智谱ZCode被质疑静默上传全量Git操作\"切入：把核心资产交给黑箱工具不是信任问题，是架构问题。组织需要的是可核查的数据流向，而不是\"大厂应该没问题\"的直觉。",
    "content_type": "html",
    "content": "articles/eliminated/ai-code-streaking.html",
    "category_id": "eliminated",
    "tags": ["AI","组织效率","数据安全","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-code-streaking",
    "created_at": "2026-09-19",
    "updated_at": null
  },
  {
    "id": "ai-job-vanishing-silence",
    "title": "AI时代的\"岗位消失静默期\"——小偷去哪了",
    "summary": "从微博热榜\"中国的小偷为何断崖式下降\"切入：技术替代岗位的本质是场景蒸发，而不是明确裁员。岗位在无人讨论中安静消失，这段静默期没有任何警报，却是唯一的可干预窗口。",
    "content_type": "html",
    "content": "articles/stable/ai-job-vanishing-silence.html",
    "category_id": "stable",
    "tags": ["AI","组织效率","职业发展","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-job-vanishing-silence",
    "created_at": "2026-09-19",
    "updated_at": null
  },
  {
    "id": "ai-fullscore-inflation",
    "title": "AI时代的\"满分通胀\"——考核标准为什么越抬越高",
    "summary": "从抖音热榜\"创大要打百分了\"切入：AI垫高所有人的绝对产出，组织的合格线被拖着不断上移，员工付出增长的努力却换回没变的评价。破法是放弃绝对分数，转向相对成长。",
    "content_type": "html",
    "content": "articles/tension/ai-fullscore-inflation.html",
    "category_id": "tension",
    "tags": ["AI","组织效率","绩效管理","游戏化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-fullscore-inflation",
    "created_at": "2026-09-19",
    "updated_at": null
  },
  {
    "id": "ai-strategy-reorg-loyalty",
    "title": "AI时代的\"战略重锤\"——组织架构为什么越来越像一块随时可拆的乐高",
    "summary": "从知乎热榜\"字节将飞书并入豆包，张一鸣称史上最大押注\"切入：组织架构的稳定性由战略的确定性决定。战略变成豪赌，架构就从大楼变成随时可重拼的乐高。独立BU成奢侈品、组织忠诚是单向的、重组速度即竞争力——被重锤砸到的人，最该绑在能力和关系上，而不是部门和title上。",
    "content_type": "html",
    "content": "articles/tension/ai-strategy-reorg-loyalty.html",
    "category_id": "tension",
    "tags": ["AI","组织架构","战略","管理","重组"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-strategy-reorg-loyalty",
    "created_at": "2026-09-20",
    "updated_at": null
  },
  {
    "id": "ai-not-working-skill-decay",
    "title": "AI时代的\"能力静默流失\"——长期不工作的人，失去的不是工资",
    "summary": "从微博热榜\"长期不工作的人会失去什么\"切入：能力不是银行存款而是河流，工作就是那条下雨的河道。AI时代\"做事\"的价值不只是产出，更是维持并训练判断力。长期不工作会悄悄拿走三样东西：被现实打脸的机会、处理麻烦的肌肉、被需要的感觉。组织要做的，是给员工持续\"练手\"的真实场景。",
    "content_type": "html",
    "content": "articles/stable/ai-not-working-skill-decay.html",
    "category_id": "stable",
    "tags": ["AI","能力","职业发展","培训","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-not-working-skill-decay",
    "created_at": "2026-09-20",
    "updated_at": null
  },
  {
    "id": "ai-perk-inflation",
    "title": "AI时代的\"福利通胀\"——当发月饼变成了公司的心事",
    "summary": "从抖音热榜\"你们公司发月饼了吗\"切入：福利一旦变成比较项，就注定越堆越贵、越贵越没用。AI让标准福利毫无门槛、信息透明放大比较、组织焦虑靠加福利止血，三台引擎共同加速通胀。破法是用三类非通胀型福利替代加量竞赛：专属感、成长型、被看见。福利不是成本，是激励信号的载体。",
    "content_type": "html",
    "content": "articles/created/ai-perk-inflation.html",
    "category_id": "created",
    "tags": ["AI","激励","福利","游戏化","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-perk-inflation",
    "created_at": "2026-09-20",
    "updated_at": null
  },
  {
    "id": "ai-classroom-no-phone",
    "title": "AI时代的\"注意力托管\"——当大学开始收手机，组织该收什么",
    "summary": "从知乎热榜\"多所高校推进无手机课堂\"切入：注意力不是被手机抢走的，是被\"不值得\"赶走的。手机只是逃生出口，收手机是堵，设计注意力才是疏。AI时代内容零成本，\"坐在这里听\"的理由被抽空；三种更高明做法：把内容变不可替代、把\"听\"换成\"做\"、给注意力一个\"值得\"的回报。组织真正该收的不是手机，是浪费注意力的环节。",
    "content_type": "html",
    "content": "articles/stable/ai-classroom-no-phone.html",
    "category_id": "stable",
    "tags": ["AI","培训","注意力","学习设计","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-classroom-no-phone",
    "created_at": "2026-09-21",
    "updated_at": null
  },
  {
    "id": "ai-sunk-cost-trap",
    "title": "AI时代的\"沉没成本\"——当AI帮不了你的是\"何时认输\"",
    "summary": "从知乎热榜\"河南40岁数学老师自费300万拍电影票房仅2.4万\"切入：人停不下来，不是因为看不清该停，而是\"再往前一步\"的成本被AI削到近乎为零。AI最擅长把已在做的事做得更好，却永远不会告诉你此事不该做。三种对抗方式：预设退出条件而非继续理由、把沉没成本从决策桌拿走、让AI执行而让制度叫停。判断力最稀缺的时刻是决定何时结束。",
    "content_type": "html",
    "content": "articles/tension/ai-sunk-cost-trap.html",
    "category_id": "tension",
    "tags": ["AI","决策","沉没成本","管理","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-sunk-cost-trap",
    "created_at": "2026-09-21",
    "updated_at": null
  },
  {
    "id": "ai-creativity-depreciation",
    "title": "AI时代的\"创意折旧\"——你拍的东西AI一天能做100个，还值多少钱",
    "summary": "从微博热榜\"iPhone18ProMax 1T翻车\"切入：堆参数堆不出好东西，堆产出也堆不出价值。一件东西值多少钱，取决于它有多难被复制。AI把\"可生成\"的产出价格打到地板，组织还在按产出量考核，等于系统性奖励数量、惩罚判断。三种不折旧资产：判断力、信任与关系、专属的现场。能被生成的都会贬值，不能被盗走的才会升值。",
    "content_type": "html",
    "content": "articles/created/ai-creativity-depreciation.html",
    "category_id": "created",
    "tags": ["AI","创意","内容","价值创造","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-creativity-depreciation",
    "created_at": "2026-09-21",
    "updated_at": null
  },
  {
    "id": "ai-teacher-role",
    "title": "AI时代的\"知识交付\"退场——AI或可替代教师，那\"班主任\"为什么替代不了",
    "summary": "从微博热榜\"AI或可替代教师只需一个班主任\"切入：被AI替代的不是教师，而是\"知识交付\"这一层。组织培训要重估的是陪伴、练习与信任这些AI给不了的部分。",
    "content_type": "html",
    "content": "articles/stable/ai-teacher-role.html",
    "category_id": "stable",
    "tags": ["AI","培训","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-teacher-role",
    "created_at": "2026-09-22",
    "updated_at": null
  },
  {
    "id": "ai-data-asset",
    "title": "AI时代的\"数据产权\"——当数据开始发身份证，组织最该盘点的资产换人了",
    "summary": "从抖音热榜\"首批数据产权身份证发放\"切入：AI把能力变成公共品，唯一能拉开差距的是别人拿不到的独有数据。组织应像经营资产一样经营数据。",
    "content_type": "html",
    "content": "articles/created/ai-data-asset.html",
    "category_id": "created",
    "tags": ["AI","数据资产","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-data-asset",
    "created_at": "2026-09-22",
    "updated_at": null
  },
  {
    "id": "ai-authenticity-premium",
    "title": "AI时代的\"人设崩塌\"——雷军澄清早餐被骂装，组织的\"表演\"该收场了",
    "summary": "从微博热榜\"雷军澄清早餐被骂装\"切入：AI能批量生成完美形象，于是完美贬值、真实升值。组织靠表演建立的信任成本越来越高，可信才是领导力第一指标。",
    "content_type": "html",
    "content": "articles/tension/ai-authenticity-premium.html",
    "category_id": "tension",
    "tags": ["AI","领导力","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-authenticity-premium",
    "created_at": "2026-09-22",
    "updated_at": null
  },
  {
    "id": "ai-reunion-tax",
    "title": "AI时代的\"团圆税\"——当中秋节可以不回家，组织里的\"一起\"正在消失",
    "summary": "从微博热榜\"今年中秋节我就不回家了\"切入：当\"在一起\"从必须变成可选，组织就会在效率算盘上第一个砍掉它。但隐性知识、弱关系、共同语境，都长在那些算不清账的\"一起\"里。",
    "content_type": "html",
    "content": "articles/tension/ai-reunion-tax.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","远程协作","隐性知识"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-reunion-tax",
    "created_at": "2026-09-23",
    "updated_at": null
  },
  {
    "id": "ai-high-risk-list-trap",
    "title": "AI时代的\"高危名单\"陷阱——73%的风险，都长在你没盯的地方",
    "summary": "从知乎热榜钟南山团队研究\"73%肺癌来自非高危人群\"切入：任何\"重点盯防\"的系统同时是\"系统性忽视\"的系统。组织用AI做盘点、监控、预警时，最大的漏网之鱼往往不在高危名单里。",
    "content_type": "html",
    "content": "articles/eliminated/ai-high-risk-list-trap.html",
    "category_id": "eliminated",
    "tags": ["AI","组织管理","风险管理","人才盘点"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-high-risk-list-trap",
    "created_at": "2026-09-23",
    "updated_at": null
  },
  {
    "id": "ai-ladder-gone",
    "title": "AI时代的\"阶梯消失\"——当AI一个人干完高中低三层的活，新人爬不上来了",
    "summary": "AI让一个工具包揽初稿、把关和决策，组织里\"从低到高\"的爬升阶梯被抽掉了中间几级。当没人再从基础活里练出判断力，组织的接班梯队正在静默崩塌。",
    "content_type": "html",
    "content": "articles/created/ai-ladder-gone.html",
    "category_id": "created",
    "tags": ["AI","组织管理","人才梯队","成长路径"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ladder-gone",
    "created_at": "2026-09-23",
    "updated_at": null
  },
  {
    "id": "ai-credential-dividend",
    "title": "AI时代的\"学历红利\"——2.7亿高学历人口，为什么企业还是招不到人",
    "summary": "学历供给创下新高，企业却依然招不到人；问题不在学历总量，而在学历信号与真实能力的脱钩。AI让\"证书能证明什么\"这件事被重新定价：会背知识不再稀缺，能验收结果才稀缺。三个可落地的动作：把招聘标准从学历改为任务样本、把培训从教知识改为校准判断、把晋升从年限改为可验证产出。",
    "content_type": "html",
    "content": "articles/tension/ai-credential-dividend.html",
    "category_id": "tension",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-credential-dividend",
    "created_at": "2026-09-24",
    "updated_at": null
  },
  {
    "id": "ai-product-sunset",
    "title": "AI时代的\"边缘产品\"——连做个AI的公司，都留不住自己的产品",
    "summary": "做AI的公司自己也在砍产品，说明问题不在\"要不要用AI\"，而在\"谁会为一个产品持续负责\"。AI把研发成本压到极低，反而让产品数量爆炸、没人负责到底。组织真正缺的是产品退役机制和长期owner。三个判断：能不能说清这个产品为谁解决什么、有没有人对它的未来负责、退役的标准是否事先写死。",
    "content_type": "html",
    "content": "articles/eliminated/ai-product-sunset.html",
    "category_id": "eliminated",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-product-sunset",
    "created_at": "2026-09-24",
    "updated_at": null
  },
  {
    "id": "ai-acceptance-ability",
    "title": "AI时代的\"验收能力\"——比会干活更值钱的，是能看出活干得对不对",
    "summary": "AI把\"干活\"这件事的门槛打平了，稀缺的变成了\"验收\"：能不能看出结果对不对、值不值、能不能上线。验收能力不在流程里，在判断标准里。三个可训练的动作：写死验收标准再开工、对AI产出做抽检而不是全信、把每次返工的原因记成清单沉淀下来。",
    "content_type": "html",
    "content": "articles/created/ai-acceptance-ability.html",
    "category_id": "created",
    "tags": ["AI"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-acceptance-ability",
    "created_at": "2026-09-24",
    "updated_at": null
  },
  {
    "id": "created-ai-skill-shell",
    "title": "AI时代的\"技能空壳\"——当\"还有必要学古法编程吗\"成为热榜问题",
    "summary": "从知乎热榜\"大学生还有必要学古法编程吗\"切入：AI削平的是一门技能的完整坡度，让人人都能用到技能，却长不出技能。组织以为省了培训，其实砍掉了能力生长的唯一路径。",
    "content_type": "html",
    "content": "articles/created/ai-skill-shell.html",
    "category_id": "created",
    "tags": ["AI","技能","组织能力","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-skill-shell",
    "created_at": "2026-09-25",
    "updated_at": null
  },
  {
    "id": "stable-ai-friction-toll",
    "title": "AI时代的\"摩擦税\"——当开门都要先看一段广告",
    "summary": "从知乎热榜\"小区门禁App开门先看广告\"切入：技术进步的红利若分配不当，不会变成人人更省事，而是把摩擦转移到最末端的人身上。组织上AI，往往是一线多了一道过关环节。",
    "content_type": "html",
    "content": "articles/stable/ai-friction-toll.html",
    "category_id": "stable",
    "tags": ["AI","组织效率","流程","一线"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-friction-toll",
    "created_at": "2026-09-25",
    "updated_at": null
  },
  {
    "id": "tension-ai-champion-legacy",
    "title": "AI时代的\"冠军遗产\"——国乒36年首丢金牌，给所有靠老本吃饭的组织敲响警钟",
    "summary": "从国乒男团36年来首次无缘亚运金牌切入：任何组织的长期优势靠的不是荣誉簿，而是一代代人攒下的隐性能力。AI让显性能力更易复制，也让隐性能力更易被忽视。",
    "content_type": "html",
    "content": "articles/tension/ai-champion-legacy.html",
    "category_id": "tension",
    "tags": ["AI","组织优势","经验传承","领导力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-champion-legacy",
    "created_at": "2026-09-25",
    "updated_at": null
  },
  {
    "id": "created-ai-tolerance-ability",
    "title": "AI时代的\"耐受度\"——当\"把不喜欢的事做好\"变成热榜问题",
    "summary": "从知乎热榜\"把自己并不喜欢的事情做好，是否算一种重要能力\"切入：AI降低了\"做喜欢的事\"的成本，同时抬高了\"把不喜欢的事做好\"的价格。组织最稀缺的，是愿意且能够把没人愿干的活干漂亮的耐受度。",
    "content_type": "html",
    "content": "articles/created/ai-tolerance-ability.html",
    "category_id": "created",
    "tags": ["AI","组织管理","耐受度","人才"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-tolerance-ability",
    "created_at": "2026-09-26",
    "updated_at": null
  },
  {
    "id": "tension-ai-redundancy-fear",
    "title": "AI时代的\"冗余恐惧\"——当\"砍掉打酱油的院系\"成为热榜问题",
    "summary": "从知乎热榜\"为什么清华不把打酱油的院系砍掉\"切入：AI让组织有能力精确优化掉一切\"不产出\"的东西，砍掉的其实是抗风险的冗余。优化到极致，就是脆弱到极致。",
    "content_type": "html",
    "content": "articles/tension/ai-redundancy-fear.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","冗余","韧性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-redundancy-fear",
    "created_at": "2026-09-26",
    "updated_at": null
  },
  {
    "id": "stable-ai-visibility-deficit",
    "title": "AI时代的\"可见性赤字\"——当守护型的工作，系统看不见",
    "summary": "从知乎热榜\"护士倒在工作岗位仍无法认定工伤\"切入：AI让组织评价体系全面转向可量化产出，那些守护型、预防型的工作因为\"没出事\"而永远算不出功劳，正在被系统性低估。",
    "content_type": "html",
    "content": "articles/stable/ai-visibility-deficit.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","可见性","绩效"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-visibility-deficit",
    "created_at": "2026-09-26",
    "updated_at": null
  },
  {
    "id": "created-ai-invisible-threshold",
    "title": "AI时代的\"隐形门槛\"——河南技校生入职北大，学历的门槛正在被重写",
    "summary": "从微博热榜\"河南一技校101名毕业生入职北大\"切入：AI正在把学历这个静态标签贬值，把可验证的实操能力重新推回价值中心。门槛没有降低，它从纸上搬到了手上。",
    "content_type": "html",
    "content": "articles/created/ai-invisible-threshold.html",
    "category_id": "created",
    "tags": ["AI","组织管理","学历","能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-invisible-threshold",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "tension-ai-rigid-chain",
    "title": "AI时代的\"刚链失效\"——甘肃163名矿工胜诉，仲裁机制和算法管理同病相怜",
    "summary": "从甘肃163名矿工因超过时效被驳回切入：当规则被AI固化到不留一丝弹性，越是依赖AI精确执行制度的组织，越可能沦为责任推诿的机器。谁都没错的组织，恰恰最容易出大事。",
    "content_type": "html",
    "content": "articles/tension/ai-rigid-chain.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","制度","责任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-rigid-chain",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "stable-ai-context-ability",
    "title": "AI时代的\"语境能力\"——15岁初中生考进985，AI替代不了的那点东西",
    "summary": "从15岁初中生考入985切入：AI能加速知识的获取，却加速不了语境能力的养成。组织里最抗AI的，是那些把知识长进真实场景里的人——知道是知识，懂了是语境。",
    "content_type": "html",
    "content": "articles/stable/ai-context-ability.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","语境","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-context-ability",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "created-ai-trust-deficit",
    "title": "AI时代的\"信任赤字\"——中美元首谈AI风险管控，组织内部却在\"降级沟通\"",
    "summary": "从知乎热榜'中美同意建立AI对话沟通渠道'切入：AI时代，组织最大的风险不是技术失控，而是信任失控。当算力能让每个人独立跑出答案，组织最稀缺的反而是把共识建在信任之上。",
    "content_type": "html",
    "content": "articles/created/ai-trust-deficit.html",
    "category_id": "created",
    "tags": ["AI","信任","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-deficit",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "tension-ai-cognitive-overreach",
    "title": "AI时代的\"认知越权\"——特斯拉一个月降价两次，组织正把用户当数据",
    "summary": "从百度热榜'特斯拉一个月降价两次惹怒新车主'切入：当AI让数据驱动做到极致，组织容易把用户从'人'降级成'变量'。技术负责精确，人负责体面，越权即失控。",
    "content_type": "html",
    "content": "articles/tension/ai-cognitive-overreach.html",
    "category_id": "tension",
    "tags": ["AI","边界","客户体验"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-cognitive-overreach",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "stable-ai-ability-mismatch",
    "title": "AI时代，\"让本科生做回本科生\"为什么成了热榜问题",
    "summary": "从知乎热榜'让本科生做回本科生'切入：AI时代学历与实际能力的错配正在加剧。组织该重新评估的，不是学历标签，而是每个岗位真正需要的能力层级。",
    "content_type": "html",
    "content": "articles/stable/ai-ability-mismatch.html",
    "category_id": "stable",
    "tags": ["AI","能力","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ability-mismatch",
    "created_at": "2026-09-27",
    "updated_at": null
  },
  {
    "id": "tension-ai-hidden-holding-cost",
    "title": "AI时代的\"持有成本盲区\"——电车买得起修不起，你的AI也是",
    "summary": "从微博热榜'电车买得起修不起'切入：AI就像电车，买的时候谁都觉得便宜，真正贵的是持有它之后——算力账单、维护成本、返工损耗、被锁定的切换代价。组织只算了采购价，没算持有账。",
    "content_type": "html",
    "content": "articles/tension/ai-hidden-holding-cost.html",
    "category_id": "tension",
    "tags": ["AI","组织成本","持有成本","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hidden-holding-cost",
    "created_at": "2026-09-28",
    "updated_at": null
  },
  {
    "id": "stable-ai-default-trust-deficit",
    "title": "AI时代的\"默认信任赤字\"——一家公司20多年不打卡，凭什么",
    "summary": "从今日头条热榜'崔培军：公司20多年不打卡不考勤'切入：AI让监控变得极度便宜，组织默认假设'人不值得信任'。而高效组织的默认假设恰恰相反——信任是设计出来的效率工程，不是监控出来的纪律。",
    "content_type": "html",
    "content": "articles/stable/ai-default-trust-deficit.html",
    "category_id": "stable",
    "tags": ["AI","组织信任","管理","监督"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-default-trust-deficit",
    "created_at": "2026-09-28",
    "updated_at": null
  },
  {
    "id": "created-ai-ability-spot",
    "title": "AI时代的\"能力现货\"——101名技校生入职北大，文凭正在被现货能力替代",
    "summary": "从知乎热榜'一技校101名毕业生入职北大、大二就被预订'切入：当AI让知识获取和验证都变得即时，组织招人开始从'看文凭期货'转向'买能力现货'。学历证明输入，现货能力证明输出，AI正在重估两者的定价。",
    "content_type": "html",
    "content": "articles/created/ai-ability-spot.html",
    "category_id": "created",
    "tags": ["AI","招聘","识人","能力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ability-spot",
    "created_at": "2026-09-28",
    "updated_at": null
  },
  {
    "id": "ai-teammate-slot",
    "title": "AI时代的\"同事名额\"——当AI能干80%的活，你还为剩下20%留人吗",
    "summary": "从知乎热榜'毫无人性关怀的大厂却总致力于打造充满人性光辉的产品'切入：AI把80%的活接走后，组织为了效率会砍掉'同事名额'，但被砍掉的恰恰是产品里那点'人味'的来源。同事名额正在变成被精算的稀缺资源，而它其实是产品人味的原材料供应商。",
    "content_type": "html",
    "content": "articles/created/ai-teammate-slot.html",
    "category_id": "created",
    "tags": ["AI","组织","人味","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-teammate-slot",
    "created_at": "2026-09-29",
    "updated_at": null
  },
  {
    "id": "ai-trust-dividend",
    "title": "AI时代的\"信任红利\"——携程600元团建经费，比算法排班高明在哪",
    "summary": "从知乎/百度热榜'携程推无理由事假，员工休1天团队得600元团建经费'切入：这套机制的高明不在于发钱，而在于它默认信任员工，并把信任变成了可结算的资产。AI让监控变得免费，信任反而成了唯一还稀缺的管理资源。",
    "content_type": "html",
    "content": "articles/stable/ai-trust-dividend.html",
    "category_id": "stable",
    "tags": ["AI","信任","组织","激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-dividend",
    "created_at": "2026-09-29",
    "updated_at": null
  },
  {
    "id": "ai-context-wage-premium",
    "title": "AI时代的\"语境工资\"——上海那份3000元路费的账，AI替不了",
    "summary": "从知乎热榜'杭州女子每月花3000元跨省2小时去上海上班'切入：她的账本质是AI时代的新工资构成——语境工资。算法算得出交通差价，算不出她在现场的连接、机会与身份感。当执行变得廉价，'在场'就是新的硬通货。",
    "content_type": "html",
    "content": "articles/eliminated/ai-context-wage-premium.html",
    "category_id": "eliminated",
    "tags": ["AI","组织","职场","语境"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-context-wage-premium",
    "created_at": "2026-09-29",
    "updated_at": null
  },
  {
    "id": "created-ai-thinking-name",
    "title": "AI时代的\"思考署名\"——你的名字，还配得上你的观点吗",
    "summary": "从知乎热榜'江苏高考满分记叙文《衬衫的价格为9镑15便士》'切入：AI能瞬间生成同款金句和故事，语言被无限量产之后，组织里'谁真的想过这件事'反而成了稀缺资产。",
    "content_type": "html",
    "content": "articles/created/ai-thinking-credit.html",
    "category_id": "created",
    "tags": ["AI","组织","思考","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-thinking-credit",
    "created_at": "2026-09-30",
    "updated_at": null
  },
  {
    "id": "stable-ai-positioning-premium",
    "title": "AI时代的\"定位红利\"——罗福莉22级，年轻人为什么跑去大兴安岭",
    "summary": "从知乎热榜'罗福莉晋升小米22级'与'年轻人花一万二买房去大兴安岭隐居'双双上榜切入：AI抹平了执行差距，竞争维度从'谁做得好'整体上移到'谁站对了位置'，定位能力成了新的溢价来源。",
    "content_type": "html",
    "content": "articles/stable/ai-positioning-premium.html",
    "category_id": "stable",
    "tags": ["AI","组织","定位","人才"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-positioning-premium",
    "created_at": "2026-09-30",
    "updated_at": null
  },
  {
    "id": "tension-ai-name-record",
    "title": "AI时代的人名歧义——三起热搜背后，系统开始分不清你是谁",
    "summary": "从'邓亚萍评输球别找借口''那英片段演唱争论''网红脸难以辨认'等热榜切入：当AI批量生产同质内容与身份，系统和个人都越来越难分清'这是谁做的、谁该负责'，组织必须重设'命名与归责'的机制。",
    "content_type": "html",
    "content": "articles/tension/ai-name-ambiguity.html",
    "category_id": "tension",
    "tags": ["AI","组织","身份","问责"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-name-ambiguity",
    "created_at": "2026-09-30",
    "updated_at": null
  },
  {
    "id": "created-ai-rest-premium",
    "title": "AI时代的\"休息溢价\"——胖东来每周双休上热搜，藏着效率的另一面",
    "summary": "从微博热搜'胖东来员工明年3月起每周双休'切入：当AI把执行效率推到极致，唯一无法被压缩的稀缺资源变成了'人的恢复时间'，休息正在从福利变成组织的战略资产。",
    "content_type": "html",
    "content": "articles/created/ai-rest-premium.html",
    "category_id": "created",
    "tags": ["AI","组织","效率","激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-rest-premium",
    "created_at": "2026-10-01",
    "updated_at": null
  },
  {
    "id": "tension-ai-human-single-point",
    "title": "AI时代的\"人肉单点故障\"——迪拜航空驾驶舱冲突，暴露了系统最脆弱的一环",
    "summary": "从知乎热榜'迪拜航空客机驾驶舱冲突、飞行员被刺伤'切入：在高度自动化的系统里，人反而成了最不可控的单点故障。AI时代组织把流程做到极致之后，最大的风险恰恰藏在'人'这个环节。",
    "content_type": "html",
    "content": "articles/tension/ai-human-single-point.html",
    "category_id": "tension",
    "tags": ["AI","组织","风险","韧性"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-human-single-point",
    "created_at": "2026-10-01",
    "updated_at": null
  },
  {
    "id": "stable-ai-sync-tax",
    "title": "AI时代的\"同步税\"——国庆人从众背后，组织还在为'同时在线'买单",
    "summary": "从国庆假期'人从众'与12306'买不到票被迫买长乘短'切入：过度集中的同步协作正在成为组织的新税负。AI让异步协作成为可能之后，还坚持让所有人同时到场的组织，正在白白交税。",
    "content_type": "html",
    "content": "articles/stable/ai-sync-tax.html",
    "category_id": "stable",
    "tags": ["AI","组织","协作","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-sync-tax",
    "created_at": "2026-10-01",
    "updated_at": null
  },
  {
    "id": "ai-trust-shelf-life",
    "title": "AI时代的\"信任半衰期\"——盒马银鳕鱼上热搜，一条负面能摧毁十年口碑",
    "summary": "从微博热搜'盒马银鳕鱼汞中毒、多平台下架儿童装银鳕鱼'切入：当AI把生产、客服、传播的执行成本全部压低，组织暴露的不是效率问题，而是信任的脆弱——建立以年计，摧毁以小时计，AI时代最稀缺的资产是'出错之后我知道找谁'。",
    "content_type": "html",
    "content": "articles/tension/ai-trust-shelf-life.html",
    "category_id": "tension",
    "tags": ["AI","组织","信任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trust-shelf-life",
    "created_at": "2026-10-02",
    "updated_at": null
  },
  {
    "id": "ai-queue-attrition",
    "title": "AI时代的\"排队内耗\"——高速等5小时充电，暴露了集中式供给的死穴",
    "summary": "从微博热搜'高速等5小时充电车主发声''高速充电充至80%被迫离场'切入：当资源被集中到单点、所有人被同步到一个时刻，系统必然内耗。AI解决了执行效率，却解决不了供给结构，甚至会把上游提交量激增、下游更堵。",
    "content_type": "html",
    "content": "articles/eliminated/ai-queue-attrition.html",
    "category_id": "eliminated",
    "tags": ["AI","组织","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-queue-attrition",
    "created_at": "2026-10-02",
    "updated_at": null
  },
  {
    "id": "ai-holistic-accountability",
    "title": "AI时代的\"整体责任缺位\"——当每件事都被拆成KPI，没人对\"整体\"负责",
    "summary": "AI让每个环节都能被拆解、量化、优化，于是组织效率节节攀升，却出现了最危险的空缺：每个局部都达标，没有人对'整体'负责。局部最优、全局最差正在成为AI时代的默认结局，解法是给'整体'指定一个能叫出名字的责任人。",
    "content_type": "html",
    "content": "articles/created/ai-holistic-accountability.html",
    "category_id": "created",
    "tags": ["AI","组织","责任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-holistic-accountability",
    "created_at": "2026-10-02",
    "updated_at": null
  },
  {
    "id": "ai-traffic-window",
    "title": "AI时代的\"流量窗口期\"——莫氏鸡煲从180人裁到30人，爆红为什么留不住？",
    "summary": "从知乎热榜'莫氏鸡煲总店员工从180人减至30多人，上座率仅六成'切入：180人不是扩张，而是用编制去接一时流量的脉冲，属于典型超配。AI让'抓峰值'更容易、退潮更快，反而把这一陷阱挖得更深。真正该做的，是用弹性资源接峰值、区分流量现金与流量资产、把窗口期当验证期。",
    "content_type": "html",
    "content": "articles/tension/ai-traffic-window.html",
    "category_id": "tension",
    "tags": ["AI","流量","组织","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-traffic-window",
    "created_at": "2026-10-03",
    "updated_at": null
  },
  {
    "id": "ai-content-arbitrage",
    "title": "AI时代的\"内容套利\"——AI短剧国内火、国外凉，差的到底是什么？",
    "summary": "从知乎热榜'AI短剧国内如火如荼，国外却没发展起来'切入：AI短剧在国内跑通，靠的是供给、需求、平台三重套利窗口，而非技术领先；国外套不动，是因为套利窗口根本不存在。同理，企业上AI能不能成不是技术选择题，而是环境匹配题。",
    "content_type": "html",
    "content": "articles/created/ai-content-arbitrage.html",
    "category_id": "created",
    "tags": ["AI","内容","套利","组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-content-arbitrage",
    "created_at": "2026-10-03",
    "updated_at": null
  },
  {
    "id": "ai-standard-answer-dependency",
    "title": "AI时代的\"标准答案依赖\"——当组织只会抄最优解，创新就死了",
    "summary": "AI给出的'最优解'本质上是对过去的归纳，擅长把80分做到95分，却不擅长0到1。当组织把AI当标准答案批发商，会陷入'问AI→答案窄化→判断力退化→失去看见不一样的能力'的退化链条。AI越普及，反共识的判断越值钱。",
    "content_type": "html",
    "content": "articles/tension/ai-standard-answer-dependency.html",
    "category_id": "tension",
    "tags": ["AI","创新","判断力","组织"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-standard-answer-dependency",
    "created_at": "2026-10-03",
    "updated_at": null
  },
  {
    "id": "ai-job-folding",
    "title": "AI时代的\"岗位折叠\"——李飞飞说十年后只剩两类劳动，中间的人去哪了？",
    "summary": "从微博热搜『李飞飞称十年后只剩两类劳动』切入：AI冲击的从来不是职业标签，而是劳动的三种类型——判断型、照护型、加工型。真正被折掉的是最庞大的中产岗位形态『加工型劳动』。中间层不是被淘汰，是从来没被训练过怎么站到两边。",
    "content_type": "html",
    "content": "articles/tension/ai-job-folding.html",
    "category_id": "tension",
    "tags": ["AI","岗位折叠","组织变革","中层"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-job-folding",
    "created_at": "2026-10-04",
    "updated_at": null
  },
  {
    "id": "ai-inner-friction-bias",
    "title": "AI时代的\"内耗鄙视链\"——组织奖励\"万能先生\"，正在惩罚真正的深度思考者",
    "summary": "从微博热搜『内耗小姐和万能先生』切入：『万能先生』的本质是加工型劳动的冠军，而加工型正是AI的主战场，所以AI越强『万能』越贬值。『内耗』往往是判断型劳动的原材料——权衡、质疑、敏感、不敷衍。组织用旧尺子量新人，正在淘汰最后还愿意较真的人。",
    "content_type": "html",
    "content": "articles/tension/ai-inner-friction-bias.html",
    "category_id": "tension",
    "tags": ["AI","判断力","绩效评价","组织文化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-inner-friction-bias",
    "created_at": "2026-10-04",
    "updated_at": null
  },
  {
    "id": "ai-last-mile",
    "title": "AI时代的\"最后一公里\"能力——当所有人都能拿到方案，为什么还是只有少数人做成事",
    "summary": "一个实验：五人用AI做同一方案，相似度超80%，三个月后只有一个落地。AI抹平的不是能力差距，而是『拿到方案』的差距。竞争战场整体后移到『最后一公里』——说服、启动、纠偏、收尾。AI降低的是做事的智力门槛，没降低需要人独自承担的心理门槛。",
    "content_type": "html",
    "content": "articles/stable/ai-last-mile.html",
    "category_id": "stable",
    "tags": ["AI","执行力","闭环","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-last-mile",
    "created_at": "2026-10-04",
    "updated_at": null
  },
  {
    "id": "ai-retrenchment-narrative",
    "title": "AI时代的\"收缩理性\"——当\"留住现金流最重要\"成为共识，组织正在悄悄放弃什么",
    "summary": "从微博热搜「未来几年能留住现金流最重要」切入：当'守住现金流'从应急口号变成最高准则，组织会顺手砍掉学习能力、判断力、信任——而这三样恰恰是AI时代唯一的护城河。AI最擅长优化可量化、短期可验证的东西，却会系统性标记掉长期能力资产。收缩不是错，错的是用收缩的理由，砍掉扩张时的能力储备。",
    "content_type": "html",
    "content": "articles/tension/ai-retrenchment-narrative.html",
    "category_id": "tension",
    "tags": ["AI","现金流","组织能力","降本增效"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-retrenchment-narrative",
    "created_at": "2026-10-06",
    "updated_at": null
  },
  {
    "id": "ai-rental-mindset",
    "title": "AI时代的\"租用思维\"——当你把核心能力也租出去，组织还剩什么",
    "summary": "从知乎热榜「腾讯70亿美元租用甲骨文海外算力」切入：租用思维正从基础设施蔓延到流程和能力层，导致组织空心化。租工具合理，租能力是自残——你会失去错误中的学习、判断的依据、议价的底气。判断标准只有一条：如果它明天消失/涨价/变差，你还能不能活？能活就租，不能活就必须自建。",
    "content_type": "html",
    "content": "articles/tension/ai-rental-mindset.html",
    "category_id": "tension",
    "tags": ["AI","核心能力","外包","组织空心化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-rental-mindset",
    "created_at": "2026-10-06",
    "updated_at": null
  },
  {
    "id": "ai-independent-event-illusion",
    "title": "AI时代的\"独立事件幻觉\"——当决策者用概率骗自己",
    "summary": "从知乎热榜「连续抛硬币十次正面，第十一次选反面更聪明吗」切入：组织里没有真正的独立事件——每次决策都改变下一次决策的土壤（现金、信心、预期、对手反应）。AI用独立事件的算法处理高度相关的组织现实，输出干净的'独立概率'，掩盖肮脏的相关性。破解方法：把'独立判断'改回'序列判断'。",
    "content_type": "html",
    "content": "articles/stable/ai-independent-event-illusion.html",
    "category_id": "stable",
    "tags": ["AI","决策","概率","序列思维"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-independent-event-illusion",
    "created_at": "2026-10-06",
    "updated_at": null
  },
  {
    "id": "ai-delivery-drift",
    "title": "AI时代的\"交付漂移\"——当14道菜上错7道，组织却完全没有察觉",
    "summary": "从微博热搜「2599元一桌的婚宴14道主菜上错7道」切入：真正离谱的不是上错菜，而是五个环节几十个人没有一个人在上桌前发现错误。当交付被拆成AI流水线，每个环节都局部正确、却没人对整体负责，这就是「交付漂移」——又快又静，无声无息。破解的核心是设置一个从头到尾通读交付物的「整体负责人」。",
    "content_type": "html",
    "content": "articles/tension/ai-delivery-drift.html",
    "category_id": "tension",
    "tags": ["AI","交付质量","流程管理","整体责任"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-delivery-drift",
    "created_at": "2026-10-07",
    "updated_at": null
  },
  {
    "id": "ai-compounding-anxiety",
    "title": "AI时代的\"复利焦虑\"——当\"年轻时错过复利\"成为热搜，组织正在用错复利的公式",
    "summary": "从微博热搜第一「最危险的是年轻时错过复利」切入：多数人理解的是理财复利，而真正决定命运的是能力复利。AI把知识复利的利率压到接近零，却放大了判断复利。但大多数组织的激励体系还在为知识复利付费——奖励资历而非修正。复利的本金不是时间，是每一次修正。",
    "content_type": "html",
    "content": "articles/tension/ai-compounding-anxiety.html",
    "category_id": "tension",
    "tags": ["AI","复利","判断力","激励机制"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compounding-anxiety",
    "created_at": "2026-10-07",
    "updated_at": null
  },
  {
    "id": "ai-accountability-vacuum",
    "title": "AI时代的\"问责真空\"——当C罗自请重罚，组织里却找不出一个该签字的人",
    "summary": "从C罗离队风波自请重罚切入：「我是队长，这反而应该成为加重处罚的因素」。反观组织，AI正在制造「问责真空」——数据→AI→中层→高层→员工，决策链被拉长，每一环都能说「我只是执行/参考」，责任被稀释到无人认领。破解之道：人机责任分工表、最后责任人制度、让主动担责变成加分项。",
    "content_type": "html",
    "content": "articles/created/ai-accountability-vacuum.html",
    "category_id": "created",
    "tags": ["AI","责任","问责","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-accountability-vacuum",
    "created_at": "2026-10-07",
    "updated_at": null
  },
  {
    "id": "ai-underwriting-cost",
    "title": "AI时代的\"兜底成本\"——规则越做越完美，为什么组织反而越来越贵？",
    "summary": "从微博热搜「女子仅退款9斤蜜薯」切入：为防住一个钻空子的人，组织要付出远超事件本身数倍的代价，此为「兜底成本」。AI让补规则的成本趋近于零，组织因此补上了瘾——不再权衡「值不值得补」，而是条件反射地「都补上」，导致「兜底通胀」：审批变多、流程变长、老实人被当骗子审查。破解之道：加规则前强制回答三问——买单的人是谁、边际收益是否递减、能否用信任+事后追责替代事前审查。",
    "content_type": "html",
    "content": "articles/tension/ai-underwriting-cost.html",
    "category_id": "tension",
    "tags": ["AI","规则","管理成本","效率","风控"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-underwriting-cost",
    "created_at": "2026-10-10",
    "updated_at": null
  },
  {
    "id": "ai-numbness-bonus",
    "title": "AI时代的\"钝感红利\"——当敏感成了负债，组织最缺的是\"扛得住\"的人",
    "summary": "从微博热搜「钝感力太强当年全是神回复」切入：AI时代信息过载、反馈过度及时，「敏感」从优点变成负债，「钝感」反而成了稀缺的组织红利。三种场景：实时反馈让员工情绪坐过山车、一点风吹草动就想太多、对新工具的FOMO焦虑导致学不动。核心观点：这是能力配置问题而非优劣问题——决策者要敏感，执行者要钝感，很多组织把配置搞反了。解法：降噪分级、定义可忽略信号清单、保护慢慢来的人、把情绪稳定写进能力评估。",
    "content_type": "html",
    "content": "articles/created/ai-numbness-bonus.html",
    "category_id": "created",
    "tags": ["AI","钝感力","注意力管理","组织能力","心理安全感"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-numbness-bonus",
    "created_at": "2026-10-10",
    "updated_at": null
  },
  {
    "id": "ai-responsibility-shift",
    "title": "AI时代的\"责任转嫁\"——当学校让家长轮值晚自习，组织的边界正在模糊",
    "summary": "从知乎热榜第一「武汉中学要求家长到校轮值延时晚自习」切入：学校把核心职责（看管学生）转嫁给家长，而组织正在用几乎一样的话术，把责任转嫁给员工、客户、系统——理由往往是「赋能」「智能化」。三种企业版转嫁：把培养责任转给员工自己、把服务质量责任转给客户、把决策责任转给系统。转嫁的成本永不消失，只是被延迟转移给链条上最没议价权的一方。解法：责任边界盘点四步法，守住「能外包流程，但不能外包责任」的底线。",
    "content_type": "html",
    "content": "articles/eliminated/ai-responsibility-shift.html",
    "category_id": "eliminated",
    "tags": ["AI","责任","组织边界","管理","赋能"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-responsibility-shift",
    "created_at": "2026-10-10",
    "updated_at": null
  },
  {
    "id": "ai-information-explosion",
    "title": "AI时代的“信息过载”——热搜天天爆炸，你的组织为什么越来越糊涂？",
    "summary": "从微博热搜「AI把数学干废了」切入：热搜天天爆炸，组织却越来越糊涂。信息过载的本质不是信息太多，而是「过滤」这件工作消失了——AI让过滤层被打破却没建新的。三个症状：会议变长、报告越多共识越少、追热点偏主线。破解：把过滤从隐性工作变成显性责任，给组织重新装一副降噪耳机。",
    "content_type": "html",
    "content": "articles/tension/ai-information-explosion.html",
    "category_id": "tension",
    "tags": ["AI","信息过载","决策","组织效率","注意力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-information-overload",
    "created_at": "2026-10-11",
    "updated_at": null
  },
  {
    "id": "ai-basic-literacy-lifeline",
    "title": "AI时代的“基本功红利”——当信息差被抹平，谁还得靠真本事吃饭？",
    "summary": "从微博热搜「大二专科生称靠切片三年赚七百万」切入：切片门槛早已为零，头部仍能三年七百万，差在选片判断力、标题手感与持续迭代意志——这些不是知识，是基本功。AI抹平的是「你知道什么」，放大的是「你会判断什么」。组织该抢的不是「会用AI的人」，而是把基本功练扎实再用AI放大它的人。",
    "content_type": "html",
    "content": "articles/created/ai-basic-literacy-lifeline.html",
    "category_id": "created",
    "tags": ["AI","基本功","判断力","人才","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-basic-literacy-lifeline",
    "created_at": "2026-10-11",
    "updated_at": null
  },
  {
    "id": "ai-rebuild-capability",
    "title": "AI时代的“重建能力”——当系统崩了，你还修得回来吗？",
    "summary": "从知乎热榜软银云平台勒索攻击案例切入：225封勒索信，运维找7小时没发现，只顾重启。本质是组织把「运行」和「重建」搞混了——AI让运行太容易，重建太陌生，组织的「重建肌肉」在静默退化。崩溃时刻的能力AI替不了。破解：定期断AI演练、复盘问原理、让新人修烂摊子。",
    "content_type": "html",
    "content": "articles/tension/ai-rebuild-capability.html",
    "category_id": "tension",
    "tags": ["AI","组织韧性","重建能力","风险","效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-rebuild-capability",
    "created_at": "2026-10-11",
    "updated_at": null
  },
  {
    "id": "ai-rule-flexibility",
    "title": "AI时代的\"规则弹性\"——当规则和人情打架，组织该站哪边？",
    "summary": "从知乎热榜#1儿科医生抢救重伤患儿被投诉插队切入：规则的价值不是让每个人满意，而是让系统预期稳定。AI能执行刚性规则却无权裁量，组织真正的解法是在规则里预埋\"合法的弹性\"，并给守规则的人撑腰。",
    "content_type": "html",
    "content": "articles/tension/ai-rule-flexibility.html",
    "category_id": "tension",
    "tags": ["AI","规则","组织管理","人情","制度"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-rule-flexibility",
    "created_at": "2026-10-12",
    "updated_at": null
  },
  {
    "id": "ai-retail-investor-anxiety",
    "title": "AI时代的\"散户焦虑\"——当一个人靠AI年赚642亿，普通人还有机会吗？",
    "summary": "从知乎热榜「46岁数学家靠AI炒股年赚642亿」切入：AI是放大器，放大的是你本来就有的判断力。红利不属于最早用AI的人，属于最配得上AI的人。普通人的机会在半山腰，不在山顶。",
    "content_type": "html",
    "content": "articles/eliminated/ai-retail-investor-anxiety.html",
    "category_id": "eliminated",
    "tags": ["AI","判断力","能力放大","职场","机会"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-retail-investor-anxiety",
    "created_at": "2026-10-12",
    "updated_at": null
  },
  {
    "id": "ai-trail-compliance",
    "title": "AI时代的\"痕迹合规\"——当一切都留痕，组织反而失去了真本事",
    "summary": "从微博热搜「投资1.2亿仅建5个棚」+知乎热榜「国庆排7天班1天没去被开除判合法」切入：AI让留痕成本趋近于零，组织用\"留痕的勤奋\"替代\"干活的诚实\"。解法是把考核重心从痕迹拉回结果。",
    "content_type": "html",
    "content": "articles/tension/ai-trail-compliance.html",
    "category_id": "tension",
    "tags": ["AI","合规","绩效","结果导向","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-trail-compliance",
    "created_at": "2026-10-12",
    "updated_at": null
  },
  {
    "id": "tension-ai-blackbox-authority",
    "title": "AI时代的\"黑箱权威\"——当答案有效但没人懂，组织该不该信",
    "summary": "陶哲轩的\"黑盒AI治癌药\"思想实验引发争议。当AI给出的方案有效但没人懂，组织到底是信还是不信？本质是：组织迷信的从来不是理解，而是权威——AI正在成为那个不许被质疑的新权威。",
    "content_type": "html",
    "content": "articles/tension/ai-blackbox-authority.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","决策","黑箱权威","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-blackbox-authority",
    "created_at": "2026-10-13",
    "updated_at": null
  },
  {
    "id": "eliminated-ai-contract-threshold",
    "title": "AI时代的\"签约门槛\"——当AI拉低了生产门槛，组织反而抬高了准入价",
    "summary": "番茄小说新签约规则：赚满3000元或写满30万字才签约。这揭示了一个趋势——AI把生产门槛降到零，但把\"被选中\"的门槛抬到极高。真正比拼的，不再是产量，而是可被验证、被信任的资格。",
    "content_type": "html",
    "content": "articles/eliminated/ai-contract-threshold.html",
    "category_id": "eliminated",
    "tags": ["AI","内容创作","准入门槛","竞争力","被选中"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-contract-threshold",
    "created_at": "2026-10-13",
    "updated_at": null
  },
  {
    "id": "stable-ai-hidden-support-cost",
    "title": "AI时代的\"隐性投入\"——冠军台前的光，是团队账单上的钱",
    "summary": "郑钦文团队一天花五万多块上了热搜。真正该警醒的是：成果是显性的，投入是隐性的。AI让台前显得更轻更省，也让组织更容易忽略台下那笔被隐藏的支撑成本。",
    "content_type": "html",
    "content": "articles/stable/ai-hidden-support-cost.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","隐性成本","支撑系统","人才"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-hidden-support-cost",
    "created_at": "2026-10-13",
    "updated_at": null
  },
  {
    "id": "ai-content-degradation",
    "title": "AI时代的\"内容降智\"——当生产太便宜，组织开始批量生产垃圾",
    "summary": "红果短剧降智上了热搜。背后是AI时代最危险的病：当生产边际成本趋近于零，组织会本能地生产垃圾——不是因为它想，而是因为考核只数数量、不看质量。",
    "content_type": "html",
    "content": "articles/tension/ai-content-degradation.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","内容质量","考核机制","注意力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-content-degradation",
    "created_at": "2026-10-14",
    "updated_at": null
  },
  {
    "id": "ai-compliance-absurdity",
    "title": "AI时代的\"合规荒谬\"——当规则执行到极致，常识反而被开除",
    "summary": "1.9元汽水被举报成收礼上了知乎热榜。当AI能把制度执行到毫无缝隙，合规会一步步吃掉合理，组织只剩下正确，不再有正常。",
    "content_type": "html",
    "content": "articles/eliminated/ai-compliance-absurdity.html",
    "category_id": "eliminated",
    "tags": ["AI","组织管理","制度设计","合规","常识"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compliance-absurdity",
    "created_at": "2026-10-14",
    "updated_at": null
  },
  {
    "id": "ai-compute-quota",
    "title": "AI时代的\"算力配额\"——当能力可以按量分配，组织开始重新分层",
    "summary": "赛力斯起诉AI造谣者索赔百万。当AI能力可以按量分配，组织会围绕\"谁能调用多少算力\"重新分层——过去分成看职位，现在分成看配额。",
    "content_type": "html",
    "content": "articles/stable/ai-compute-quota.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","资源配置","算力","组织公平"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compute-quota",
    "created_at": "2026-10-14",
    "updated_at": null
  },
  {
    "id": "ai-success-oversupply",
    "title": "AI时代的\"成功过载\"——当人人都能当主角，组织反而找不到方向",
    "summary": "14岁少年用AI做号月入百万，92%的班主任却不愿干了。当个人成功变得前所未有地容易，组织的留人逻辑正在失效——凭什么要待在你这里？",
    "content_type": "html",
    "content": "articles/created/ai-success-oversupply.html",
    "category_id": "created",
    "tags": ["AI","组织管理","个人IP","留人","激励机制"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-success-oversupply",
    "created_at": "2026-10-17",
    "updated_at": null
  },
  {
    "id": "ai-longterm-career",
    "title": "AI时代的\"长线职业\"贬值——当经验不再累积，组织在赌什么",
    "summary": "伊藤美诚被日本队划掉，92%的在岗班主任想走。当经验不再自动复利，长线岗位成了高成本陷阱——组织用\"调用\"思维用人，正在透支下一代人。",
    "content_type": "html",
    "content": "articles/tension/ai-longterm-career.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","职业发展","经验传承","人才培养"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-longterm-career",
    "created_at": "2026-10-17",
    "updated_at": null
  },
  {
    "id": "ai-infinite-input",
    "title": "AI时代的\"无限输入\"——当答案唾手可得，组织缺的是\"会问\"的人",
    "summary": "机器人猥亵案疑为远程操控，本质只是执行输入。AI也一样：输入什么就执行什么。当执行变廉价，组织真正稀缺的是把业务问题翻译成好问题的能力。",
    "content_type": "html",
    "content": "articles/stable/ai-infinite-input.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","判断力","提问能力","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-infinite-input",
    "created_at": "2026-10-17",
    "updated_at": null
  },
  {
    "id": "ai-digital-whitespace",
    "title": "AI时代的\"数字留白\"——当天赋被AI算光，创新靠什么",
    "summary": "闰秒取消、越来越多人不接陌生电话、模型按周迭代——三件事指向同一个真相：精确越来越多，偶然越来越少。AI把输入放大十倍，人的消化速度却没变。留白，才是创新的唯一产地。",
    "content_type": "html",
    "content": "articles/stable/ai-digital-whitespace.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","创新","留白","协作"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-digital-whitespace",
    "created_at": "2026-10-18",
    "updated_at": null
  },
  {
    "id": "ai-credential-hoarding",
    "title": "AI时代的\"认证囤积\"——4000块生活费换成一张证书，组织在买什么",
    "summary": "妈妈把儿子生活费从4000降到2000逼考证书，九千人抢一个事业编。当'证明'比'能力'便宜，组织就只会买证明。可AI时代，凭证是通货，能力才是资产——通货会通胀，资产才保值。",
    "content_type": "html",
    "content": "articles/tension/ai-credential-hoarding.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","选人","培训","认证"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-credential-hoarding",
    "created_at": "2026-10-18",
    "updated_at": null
  },
  {
    "id": "ai-stability-tax",
    "title": "AI时代的\"稳定税\"——九千人抢一个岗位，代价在谁身上",
    "summary": "一个事业编岗位9000人报名，录取率1:9000。稳定不是免费的，它只是把账单递给了别人。AI把执行能力打到接近零，'占位'这件事正在失效——越追稳定的人，越容易失去稳定。",
    "content_type": "html",
    "content": "articles/eliminated/ai-stability-tax.html",
    "category_id": "eliminated",
    "tags": ["AI","组织管理","稳定","组织设计","激励机制"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-stability-tax",
    "created_at": "2026-10-18",
    "updated_at": null
  },
  {
    "id": "ai-control-premium",
    "title": "AI时代的\"控制权溢价\"——当AI什么都能干，最贵的反而是\"不许它干\"",
    "summary": "AI时代几乎所有能力都在贬值，唯一稀缺的是取舍。组织如果不在关键环节划出\"不许AI介入\"的线，就会变成一模一样的高效空壳。定价、阈值、人的情绪、培养晋升——这四道线必须守住。",
    "content_type": "html",
    "content": "articles/created/ai-control-premium.html",
    "category_id": "created",
    "tags": ["AI","组织管理","控制权","组织设计","决策"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-control-premium",
    "created_at": "2026-10-19",
    "updated_at": null
  },
  {
    "id": "ai-generational-depreciation",
    "title": "AI时代的\"代际折旧\"——AI第一个干掉的是老板的判断",
    "summary": "老板过去的核心竞争力是信息早、经验多、踩坑狠，这三样在AI面前同时贬值。判断力的新来源只剩三个：提出好问题、真实体感、敢承担后果。给管理者的5步续命法。",
    "content_type": "html",
    "content": "articles/tension/ai-generational-depreciation.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","管理层","判断力","领导力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-generational-depreciation",
    "created_at": "2026-10-19",
    "updated_at": null
  },
  {
    "id": "ai-handover-blackhole",
    "title": "AI时代的\"接手黑洞\"——你替同事扛的活，为什么回来成了罪证",
    "summary": "同事请假你接手，她回来却挑刺。这不是人品问题，是结构问题：你无意中证明了她的工作可以没有她。AI让知识提取成本塌了，交接从上岗美德变成一次可替代性的公开测量。",
    "content_type": "html",
    "content": "articles/eliminated/ai-handover-blackhole.html",
    "category_id": "eliminated",
    "tags": ["AI","组织管理","知识管理","交接","激励机制"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-handover-blackhole",
    "created_at": "2026-10-19",
    "updated_at": null
  },
  {
    "id": "ai-visibility-substitution",
    "title": "AI时代的\"可见性替代\"——小天才手表被质疑封闭社交，职场正在上演同一幕",
    "summary": "小天才手表用\"碰一碰\"把社交变成了可统计的数据。企业里也在发生同样的事：用协同工具的消息量替代真实协作，用学习时长替代真实成长，用情绪报告替代真实关系。看不见的东西，正在被看见的东西挤掉。",
    "content_type": "html",
    "content": "articles/tension/ai-visibility-substitution.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","指标","可观测性","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-visibility-substitution",
    "created_at": "2026-10-20",
    "updated_at": null
  },
  {
    "id": "ai-isolation-premium",
    "title": "AI时代的\"孤立溢价\"——当越来越多人不接陌生电话，组织正在失去它最便宜的资源",
    "summary": "AI把对外触达的成本压到零，于是所有人的防御成本涨到无限，陌生人之间的第一次接触几乎被封死。企业为此付出的钱从没进过财报，而组织的连接能力正在被悄悄改写。",
    "content_type": "html",
    "content": "articles/stable/ai-isolation-premium.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","连接","触达","招聘"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-isolation-premium",
    "created_at": "2026-10-20",
    "updated_at": null
  },
  {
    "id": "ai-turnover-arbitrage",
    "title": "AI时代的\"人员流动掠夺\"——应届生干满一年就跳，不是他们的问题",
    "summary": "招培成本在第2-3年才回收，人在第12-14个月就走了。AI让熟练工既更容易培养也更容易被挖，把这个缺口撕得更大。想留住人，先要把\"三年后会怎样\"说清楚。",
    "content_type": "html",
    "content": "articles/eliminated/ai-turnover-arbitrage.html",
    "category_id": "eliminated",
    "tags": ["AI","组织管理","人才","培养","留存"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-turnover-arbitrage",
    "created_at": "2026-10-20",
    "updated_at": null
  },
  {
    "id": "ai-cognition-debt",
    "title": "AI时代的\"认知负债\"——食堂做了1000人的饭，却不知道米饭该怎么做",
    "summary": "张雪公开求助怎么把1000人的米饭做好吃，暴露的不是食堂问题，是组织的认知负债：借来效率、抵押理解。AI让这笔债借得更快、更隐蔽、还的时候更痛。",
    "content_type": "html",
    "content": "articles/stable/ai-cognition-debt.html",
    "category_id": "stable",
    "tags": ["AI","组织能力","判断力","认知负债"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-cognition-debt",
    "created_at": "2026-10-22",
    "updated_at": null
  },
  {
    "id": "ai-compensation-escape",
    "title": "AI时代的\"赔偿逃生\"——宝马裁8000人给65万欧，为什么钱解决不了组织问题",
    "summary": "65万欧元补偿买的不是良心，是加速费。裁员是外科手术，转岗是康复训练，只做手术不做康复，病人看着轻了其实废了。",
    "content_type": "html",
    "content": "articles/eliminated/ai-compensation-escape.html",
    "category_id": "eliminated",
    "tags": ["AI","裁员","组织转型","人力成本"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-compensation-escape",
    "created_at": "2026-10-22",
    "updated_at": null
  },
  {
    "id": "ai-paper-trace",
    "title": "AI时代的\"过程留痕\"——用AI写论文会有痕迹，组织里那些真正的痕迹在哪",
    "summary": "AI痕迹的本质是过程真空。组织最讽刺的是：该留的思考过程一片空白，不该留的监视动作全部留档。留痕方向反了，等于白留。",
    "content_type": "html",
    "content": "articles/created/ai-paper-trace.html",
    "category_id": "created",
    "tags": ["AI","过程留痕","判断力","组织学习"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-paper-trace",
    "created_at": "2026-10-22",
    "updated_at": null
  },
  {
    "id": "ai-ability-asset",
    "title": "AI时代的\"能力资产化\"——两女生投150万开酒吧倒闭，钱买得走资产，买不走能力",
    "summary": "150万开一家无烟酒吧，倒闭后清算的是桌椅和装修，弄丢的是选址、定价、留人的判断力。AI把能力从人身上剥下来变成可调用资产，对组织是降本，对个人是脱钩。张力就在这。",
    "content_type": "html",
    "content": "articles/tension/ai-ability-asset.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ability-asset",
    "created_at": "2026-10-23",
    "updated_at": null
  },
  {
    "id": "ai-api-reliability",
    "title": "AI时代的\"外挂依赖\"——美股科技股一夜大跌，你的组织有多少能力挂在别人的服务器上",
    "summary": "一场美股科技股大跌，本质是\"算力这门生意开始被质疑\"。而大量公司的AI能力，就挂在别人的API上。断一天，你的业务还能跑吗？这是组织韧性的新考题。",
    "content_type": "html",
    "content": "articles/tension/ai-api-reliability.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-api-reliability",
    "created_at": "2026-10-23",
    "updated_at": null
  },
  {
    "id": "ai-tacit-test-standard",
    "title": "AI时代的\"标准溢出\"——大学老师说不出口的那句抱歉，暴露了组织最尴尬的一层",
    "summary": "一位高校老师发文说\"无力教学生新知识\"。这不是谦虚，是标准跑到了前面。当标准更新速度快过培训速度，组织里就出现一个没人负责的夹层：标准是他执行的，能力是他缺的。",
    "content_type": "html",
    "content": "articles/stable/ai-tacit-test-standard.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-tacit-test-standard",
    "created_at": "2026-10-23",
    "updated_at": null
  },
  {
    "id": "ai-base-role-collapse",
    "title": "AI时代的\"岗位置换\"——AI短剧公司几乎不需要基础岗，那些被省掉的岗位去哪了",
    "summary": "微博热搜\"AI短剧公司几乎不需要基础岗\"。砍掉基础岗省的不只是成本，还有能力的练习场、协作的接口和容错空间。被省掉的判断去了哪，才是真问题。",
    "content_type": "html",
    "content": "articles/tension/ai-base-role-collapse.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-base-role-collapse",
    "created_at": "2026-10-24",
    "updated_at": null
  },
  {
    "id": "ai-scarcity-shift",
    "title": "AI时代的\"稀缺转移\"——黄金跌破860、股价和意义一起贬值，什么才是真稀缺",
    "summary": "黄金跌破860、月薪两万但毫无意义同日上热榜。组织过去靠稳定、收入、成长路径留人，这三样稀缺性都被AI稀释了。新的稀缺是判断、注意力、意义和真实关系。",
    "content_type": "html",
    "content": "articles/stable/ai-scarcity-shift.html",
    "category_id": "stable",
    "tags": ["AI","组织管理","人员激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-scarcity-shift",
    "created_at": "2026-10-24",
    "updated_at": null
  },
  {
    "id": "ai-score-inflation",
    "title": "AI时代的\"评分通胀\"——4.8分的网红餐厅更容易踩雷，你的绩效打分也在同一个坑里",
    "summary": "知乎热榜\"为什么4.8分网红餐厅更容易踩雷\"。评价维度单一+被评价方可以影响结果=通胀。AI把通胀速度拉满，解法是引入刷不动的维度。",
    "content_type": "html",
    "content": "articles/created/ai-score-inflation.html",
    "category_id": "created",
    "tags": ["AI","绩效管理","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-score-inflation",
    "created_at": "2026-10-24",
    "updated_at": null
  },
  {
    "id": "ai-slop-filter-gone",
    "title": "AI时代的\"门槛塌陷\"——Steam人人做游戏，人人喊打",
    "summary": "知乎热榜\"Steam新品节被指AI游戏过多，全民做游戏浪潮刚开始就人人喊打\"。门槛塌陷不是产能提升，是准入判断被交付量淹没。加标准无效，因为标准本身就是AI的说明书。",
    "content_type": "html",
    "content": "articles/tension/ai-slop-filter-gone.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","判断力"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-slop-filter-gone",
    "created_at": "2026-10-25",
    "updated_at": null
  },
  {
    "id": "ai-colleague-silent-failure",
    "title": "AI时代的\"同事沉默\"——诺奖得主说AGI两年内到，你最该管的却是那个不吭声的人",
    "summary": "知乎热榜\"Hassabis称AGI最快2年内到来\"+\"病人转院被司机丢弃致死\"。AI把没做好的东西做得看起来做好了，组织的失效因此变安静。三种沉默：不敢说、不知道要说、不觉得是自己的事。",
    "content_type": "html",
    "content": "articles/eliminated/ai-colleague-silent-failure.html",
    "category_id": "eliminated",
    "tags": ["AI","组织效率","责任机制"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-colleague-silent-failure",
    "created_at": "2026-10-25",
    "updated_at": null
  },
  {
    "id": "ai-invisible-apprentice-path",
    "title": "AI时代的\"学徒消失\"——17岁天才少年离场，组织却再也养不出下一个",
    "summary": "知乎热榜\"17岁天才少年陈广宇离开月之暗面赴美\"。AI抽走的不是重复劳动，是从粗糙到熟练那一整段练习层。组织开始买人不养人，中层因此断档。解法是把中间台阶造回来。",
    "content_type": "html",
    "content": "articles/created/ai-invisible-apprentice-path.html",
    "category_id": "created",
    "tags": ["AI","人才培养","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-invisible-apprentice-path",
    "created_at": "2026-10-25",
    "updated_at": null
  },
  {
    "id": "ai-process-audit",
    "title": "AI时代的\"过程审计\"——头发能被索赔46万，你公司的流程却一条都查不清",
    "summary": "知乎热榜\"理发时突发疾病死亡，店员施救反被索赔46万，法院一二审驳回\"。法院能判，是因为过程查得清。AI能生成看起来正确的结果，结果信号被污染，唯一还带信息的只剩过程。过程记录不是给老板看的，是给干活的人留的。",
    "content_type": "html",
    "content": "articles/tension/ai-process-audit.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","过程记录"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-process-audit",
    "created_at": "2026-10-26",
    "updated_at": null
  },
  {
    "id": "ai-interface-role",
    "title": "AI时代的\"接口人\"——为什么被优化最狠的，是当年最会协调的那个",
    "summary": "接口人的活是三件事拼起来的：信息搬运、格式转换、关系润滑。前两件AI已经做得更好，第三件AI一点也干不了。问题是很多接口人八成时间在前两件，有价值的两成从没时间做。升级路径：搬运者 → 翻译者 → 规则设计者。",
    "content_type": "html",
    "content": "articles/eliminated/ai-interface-role.html",
    "category_id": "eliminated",
    "tags": ["AI","岗位","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-interface-role",
    "created_at": "2026-10-26",
    "updated_at": null
  },
  {
    "id": "ai-average-dilution",
    "title": "AI时代的\"稀释\"——129441元的平均数，和你在公司里的位置",
    "summary": "知乎热榜\"31省份去年平均工资出炉，全国城镇非私营单位平均工资129441元\"。平均数在极端偏斜分布下失去解释力，同样的失效正在团队绩效里发生。用P90/P50/P10分位替代平均分，看不见分布就管不住头部。",
    "content_type": "html",
    "content": "articles/created/ai-average-dilution.html",
    "category_id": "created",
    "tags": ["AI","绩效","人才"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-average-dilution",
    "created_at": "2026-10-26",
    "updated_at": null
  },
  {
    "id": "ai-optional-exit",
    "title": "AI时代的\"自愿离职\"——6万人可以走，为什么留下的人更难受",
    "summary": "从知乎热榜\"微软向约60000名员工开放自愿离职方案\"切入：自愿离职不是体面，是把定价权和风险同时交还给个人，结果一定是逆向选择——最清楚自己市场价值的人先走。留下的人经历庆幸、重估、降速三步，而AI时代效率恰恰藏在\"没人要求但该做\"的部分。管理者三个动作：列不能走的20人、把留任价值说成人话、给离开的人一套不丢脸的说法。",
    "content_type": "html",
    "content": "articles/eliminated/ai-optional-exit.html",
    "category_id": "eliminated",
    "tags": ["AI","裁员","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-optional-exit",
    "created_at": "2026-10-28",
    "updated_at": null
  },
  {
    "id": "ai-arbitration-evidence",
    "title": "AI时代的\"证据缺口\"——领导一句话让你走人，你拿什么证明",
    "summary": "从知乎热榜\"领导叫我走人不用来上班了，我录音了\"切入：一个人干了三年，被一句话打发掉，能拿出的全部证据是一段录音，这是组织的失败。三种裁法中间那层最黑（有决定、没文件、没补偿）。AI把记录变多了，但所有权和解释权仍全在公司手里，员工比以往更依赖组织善意。自查四问 + 员工三条自保动作。",
    "content_type": "html",
    "content": "articles/tension/ai-arbitration-evidence.html",
    "category_id": "tension",
    "tags": ["AI","劳动关系","管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-arbitration-evidence",
    "created_at": "2026-10-28",
    "updated_at": null
  },
  {
    "id": "ai-learning-loop",
    "title": "AI时代的\"学习闭环\"——健身两年完全没效果，你的培训也是",
    "summary": "从知乎热榜\"健身两年多，完全没有效果\"切入：真正的问题是没有反馈回路。企业培训同理——唯一被测量的是满意度（现场体验），不是行为改变。AI让内容变便宜，却让闭环更难：输入端极度繁荣，验证端原地踏步。好教练做四件事：测基线、定可验证目标、给过程反馈、管持续性——正是培训最缺的。游戏化的本质不是娱乐，是把反馈做得足够密、足够快、足够具体。",
    "content_type": "html",
    "content": "articles/created/ai-learning-loop.html",
    "category_id": "created",
    "tags": ["AI","培训","游戏化"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-learning-loop",
    "created_at": "2026-10-28",
    "updated_at": null
  },
  {
    "id": "ai-raise-trap",
    "title": "AI时代的\"降薪留人\"——涨薪20%的承诺，为什么救不了组织的效率",
    "summary": "知乎热榜\"张雪校招承诺入职一年涨薪20%\"。涨薪只作用在\"意愿\"层，效率瓶颈在\"方向\"和\"反馈\"两层。涨薪能买到一年的忠诚，买不到三年的投入——人才会为路径留下来。",
    "content_type": "html",
    "content": "articles/created/ai-raise-trap.html",
    "category_id": "created",
    "tags": ["AI","人员激励","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-raise-trap",
    "created_at": "2026-10-29",
    "updated_at": null
  },
  {
    "id": "ai-success-workshop",
    "title": "AI时代的\"成功车间\"——首部AI院线电影票房遇冷，你的AI试点也在同一个坑里",
    "summary": "知乎热榜\"首部AI院线电影票房遇冷\"。上映前三连板、观众不买单：工序全对，产品无人。三种成功车间：知识库、报告自动化、培训课件。立项三问能挡掉大半无用工程。",
    "content_type": "html",
    "content": "articles/tension/ai-success-workshop.html",
    "category_id": "tension",
    "tags": ["AI","组织效率","项目评估"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-success-workshop",
    "created_at": "2026-10-29",
    "updated_at": null
  },
  {
    "id": "ai-pricing-power",
    "title": "AI时代的\"定价能力\"——国内汽车供应商为什么越过越难，你的部门也在同一条链上",
    "summary": "知乎热榜\"国内汽车供应商为什么这么难\"。账期和压价都是现象，本质是从\"共同定义者\"退化成\"按图加工者\"。AI把标准工序价格打到趋零，分化线在定义规格还是执行规格。",
    "content_type": "html",
    "content": "articles/stable/ai-pricing-power.html",
    "category_id": "stable",
    "tags": ["AI","商业模式","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-pricing-power",
    "created_at": "2026-10-29",
    "updated_at": null
  },
  {
    "id": "ai-exception-pricing",
    "title": "AI时代的\"例外处理\"——宜家开始收门票，你的团队还在免费加班",
    "summary": "知乎热榜\"宜家、霸王茶姬试点消费入座\"。当资源长期免费开放，它会被最不需要它的人占满。团队里的免费知识支持、免费协调、免费加班同构。AI拿走常规活后，剩下全是例外，谁在给例外定价？",
    "content_type": "html",
    "content": "articles/stable/ai-exception-pricing.html",
    "category_id": "stable",
    "tags": ["AI","组织效率","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-exception-pricing",
    "created_at": "2026-10-31",
    "updated_at": null
  },
  {
    "id": "ai-apprentice-process",
    "title": "AI时代的\"学徒工序\"——四年时间不会自动变成能力",
    "summary": "知乎热榜\"用四年codex会不会拉开差距\"。AI把\"天数\"和\"水平\"之间的等号划掉了。产出变快了，认知没跟上。先猜后验、保留AI跳不过去的工序，才是判断力唯一的生长点。",
    "content_type": "html",
    "content": "articles/tension/ai-apprentice-process.html",
    "category_id": "tension",
    "tags": ["AI","成长与学习","培训"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-apprentice-process",
    "created_at": "2026-10-31",
    "updated_at": null
  },
  {
    "id": "ai-pause-right",
    "title": "AI时代的\"暂停权\"——DeepSeek说它去吃饭了，你的团队敢不敢说",
    "summary": "知乎热榜\"DeepSeek为什么说我去吃饭了\"。一个AI被允许说\"我现在不在线\"，而你的团队没人敢。无暂停的组织要付质量账、人才账、判断账。AI让发起成本归零后，暂停权成了最被低估的组织权限。",
    "content_type": "html",
    "content": "articles/created/ai-pause-right.html",
    "category_id": "created",
    "tags": ["AI","组织效率","人员激励"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-pause-right",
    "created_at": "2026-10-31",
    "updated_at": null
  },
  {
    "id": "ai-robot-security",
    "title": "AI时代的\"机器人保安\"——一台抵五个，省下的不是人力是判断",
    "summary": "知乎热榜\"江苏物业引进巡逻机器人，一台抵5个保安\"。技术不会平均减少工作，只会把工作往上推一层。两家物业上同一台机器人，一家漏了真事件，一家告警降七成——差别在有没有人负责把AI管准。",
    "content_type": "html",
    "content": "articles/tension/ai-robot-security.html",
    "category_id": "tension",
    "tags": ["AI","组织效率","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-robot-security",
    "created_at": "2026-11-02",
    "updated_at": null
  },
  {
    "id": "ai-recovery-budget",
    "title": "AI时代的\"头等舱规则\"——老板坐后面是美德，公司坐后面是灾难",
    "summary": "知乎热榜\"飞行超5小时全员必须头等舱，老板单独坐头等舱很low\"。头等舱不是福利是恢复成本。照搬会翻车的三种方式，和AI时代真正该学的：把可见的辛苦换成可定价的负荷。",
    "content_type": "html",
    "content": "articles/stable/ai-recovery-budget.html",
    "category_id": "stable",
    "tags": ["AI","人员激励","组织管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-recovery-budget",
    "created_at": "2026-11-02",
    "updated_at": null
  },
  {
    "id": "ai-open-attribution",
    "title": "AI时代的\"开放署名\"——OpenAI捐500万不要署名，你的知识库还在锁权限",
    "summary": "知乎热榜\"OpenAI放弃一切学术署名并捐500万美元\"。署名不是荣誉制度是产权制度。企业知识库没人上传，四个理由全是产权问题。AI时代的知识治理核心从归属权转向维护责任。",
    "content_type": "html",
    "content": "articles/created/ai-open-attribution.html",
    "category_id": "created",
    "tags": ["AI","组织效率","知识管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-open-attribution",
    "created_at": "2026-11-02",
    "updated_at": null
  },
  {
    "id": "ai-title-inflation",
    "title": "AI时代的\"头衔通胀\"——10元快剪打爆\"设计总监\"，你的团队也在给自己的名字注水",
    "summary": "知乎热榜第一：10元快剪暴打全国的\"设计总监\"。头衔通胀是价值验证失灵的并发症——你没法证明自己做得好，就只能证明自己\"叫得好\"。AI正在给这件事踩油门：可交付物成本塌了，头衔的证据链跟着塌了。解法是把岗位命名权从职级体系转回交付结果，并缩短验证周期。",
    "content_type": "html",
    "content": "articles/tension/ai-title-inflation.html",
    "category_id": "tension",
    "tags": ["AI","组织管理","组织张力","头衔通胀"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-title-inflation",
    "created_at": "2026-11-03",
    "updated_at": null
  },
  {
    "id": "ai-mirror-test",
    "title": "AI时代的\"照镜子\"——十元快剪测试：把AI挡在门外，你的组织还剩几分",
    "summary": "10元快剪赢的底层逻辑是一分钟就能照镜子的生意，而AI时代大部分组织的验证周期被无限推长。做一个狠测试：假设明天AI全部停摆，你的组织还能交付什么？停掉AI，能力混合体瞬间分层，最可怕的是\"被AI悄悄替换掉却没人承认的判断\"。短期拼用得顺，长期拼离得开。",
    "content_type": "html",
    "content": "articles/eliminated/ai-mirror-test.html",
    "category_id": "eliminated",
    "tags": ["AI","组织能力","人机分工"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-mirror-test",
    "created_at": "2026-11-03",
    "updated_at": null
  },
  {
    "id": "ai-verification-cycle",
    "title": "AI时代的\"两人一果\"——鸿蒙智行均价40万却卖不动，你的高绩效团队也是这种结构",
    "summary": "10月销量榜：鸿蒙智行交付33537辆同比近腰斩，但全系均价仍超40万。高单价、低产出、强个体——这正是很多\"高绩效团队\"的画像：两人共担一个结果，责任被平均、单产被拉低、AI来了最先崩。解法是共担改段担：唯一签字人、拆分判断段与执行段、考核从协同度改成独立交付数。",
    "content_type": "html",
    "content": "articles/created/ai-verification-cycle.html",
    "category_id": "created",
    "tags": ["AI","组织效率","责任结构","绩效管理"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-verification-cycle",
    "created_at": "2026-11-03",
    "updated_at": null
  },
  {
    "id": "ai-ai-loop-closure",
    "title": "AI时代的「人机对账」——清华UCL毕业生被骗几十万，说明人已经看不懂机器了",
    "summary": "账不是一次转走的，是陆续转出的：几十次操作、十几次确认，为什么一次都没拦住？不是受害者太笨，是对账机制在AI时代整套失灵。三段式对账，补上最后一道人工签字。",
    "content_type": "html",
    "content": "articles/stable/ai-ai-loop-closure.html",
    "category_id": "stable",
    "tags": ["AI","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ai-loop-closure",
    "created_at": "2026-11-04",
    "updated_at": null
  },
  {
    "id": "ai-ai-head-up-rate",
    "title": "AI时代的「抬头率」——南大用摄像头统计抬头率，你的培训现场还在证明什么",
    "summary": "抬头率、出勤率、学时统计：企业培训正在用最工业化的指标证明自己有效。但能统计的都是注意力，不是改变。三个动作，把培训考核从到场改到交付。",
    "content_type": "html",
    "content": "articles/tension/ai-ai-head-up-rate.html",
    "category_id": "tension",
    "tags": ["AI","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ai-head-up-rate",
    "created_at": "2026-11-04",
    "updated_at": null
  },
  {
    "id": "ai-ai-external-anchor",
    "title": "AI时代的「外部锚点」——超级月亮刷屏，说明组织只认外部判断",
    "summary": "月亮还是那个月亮，只是近了点。组织的评价体系也一样：人没变，标准变了，所有人立刻改口。持续靠外部定价的组织，永远长不出自主判断。",
    "content_type": "html",
    "content": "articles/created/ai-ai-external-anchor.html",
    "category_id": "created",
    "tags": ["AI","组织效率"],
    "view_count": 0,
    "status": "published",
    "source": "original",
    "cover_image": null,
    "course_id": "course-ai-ai-external-anchor",
    "created_at": "2026-11-04",
    "updated_at": null
  },
];
